const municipalities = {
  type: 'FeatureCollection',
  features: [
    {
      type: 'Feature',
      geometry: {
        type: 'Polygon',
        coordinates: [
          [
            [31.189004478000072, -27.454314525999962],
            [31.087359943000024, -27.519769937999968],
            [31.048419943000056, -27.62223993799995],
            [30.95817994300006, -27.618759937999982],
            [30.66423994300004, -27.679150062999952],
            [30.60214006800004, -27.93359993799993],
            [30.68444006800007, -27.971089938999967],
            [30.612789943000053, -28.035199938999938],
            [30.68689994300007, -28.129299938999964],
            [30.863909943000067, -28.11683993899993],
            [30.950359943000024, -28.143590063999966],
            [30.994189943000038, -27.99660993899994],
            [31.142089944000077, -28.033129938999934],
            [31.30768994400006, -28.03732993899996],
            [31.345099944000026, -27.970090063999976],
            [31.488839944000063, -27.85770993799997],
            [31.51141294400003, -27.83823406299996],
            [31.51992994400007, -27.670030062999956],
            [31.297369944000025, -27.511700062999978],
            [31.254949944000032, -27.581740062999984],
            [31.171449944000074, -27.563989937999963],
            [31.189004478000072, -27.454314525999962],
          ],
        ],
      },
      properties: {
        Shape_Leng: 4.39729408511,
        Shape_Area: 0.39512038915,
        ADM3_EN: 'Abaqulusi',
        ADM3_PCODE: 'ZA5263',
        ADM3_REF: '',
        ADM3ALT1EN: '',
        ADM3ALT2EN: '',
        ADM2_EN: 'Zululand',
        ADM2_PCODE: 'ZA526',
        ADM1_EN: 'KwaZulu-Natal',
        ADM1_PCODE: 'ZA5',
        ADM0_EN: 'South Africa',
        ADM0_PCODE: 'ZA',
        date: '2018-12-27T00:00:00.000Z',
        validOn: '2020-11-09T00:00:00.000Z',
        validTo: '1899-11-30T00:00:00.000Z',
        ADM1_ID: 'KZN',
        ADM2_ID: 'DC26',
        ADM3_ID: 'KZN263',
      },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Polygon',
        coordinates: [
          [
            [29.99042994200005, -28.18492993899997],
            [29.814084154000057, -28.215034868999965],
            [29.72759994200004, -28.12564993899997],
            [29.663289934000034, -28.14202004499998],
            [29.619765027000028, -28.241219959999967],
            [29.50992004400007, -28.26543993699994],
            [29.375559977000023, -28.37210997099993],
            [29.519459942000026, -28.471819938999943],
            [29.56564994200005, -28.570809938999957],
            [29.567449942000053, -28.665359938999984],
            [29.669979942000055, -28.74715993899997],
            [29.761249942000063, -28.737949938999975],
            [29.88163006700006, -28.669499938999934],
            [29.99502994200003, -28.642819938999935],
            [30.043330067000056, -28.70574993899993],
            [30.144079943000065, -28.745679938999956],
            [30.267529943000056, -28.731019938999964],
            [30.220729943000038, -28.57331993899993],
            [30.337770068000054, -28.47392006399997],
            [30.23359494300007, -28.408709938999948],
            [29.97679394200003, -28.239587938999932],
            [29.99042994200005, -28.18492993899997],
          ],
        ],
      },
      properties: {
        Shape_Leng: 4.21362958962,
        Shape_Area: 0.346830991921,
        ADM3_EN: 'Alfred Duma',
        ADM3_PCODE: 'ZA5238',
        ADM3_REF: '',
        ADM3ALT1EN: '',
        ADM3ALT2EN: '',
        ADM2_EN: 'Uthukela',
        ADM2_PCODE: 'ZA523',
        ADM1_EN: 'KwaZulu-Natal',
        ADM1_PCODE: 'ZA5',
        ADM0_EN: 'South Africa',
        ADM0_PCODE: 'ZA',
        date: '2018-12-27T00:00:00.000Z',
        validOn: '2020-11-09T00:00:00.000Z',
        validTo: '1899-11-30T00:00:00.000Z',
        ADM1_ID: 'KZN',
        ADM2_ID: 'DC23',
        ADM3_ID: 'KZN238',
      },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Polygon',
        coordinates: [
          [
            [27.758832939000058, -32.331968064999955],
            [27.64370824200006, -32.278592110999966],
            [27.60068758700004, -32.21345436599995],
            [27.507879998000078, -32.230749996999975],
            [27.451350003000073, -32.35220999699993],
            [27.16072999900007, -32.23849999799995],
            [27.010920000000056, -32.22249999999997],
            [26.775780000000054, -32.333279999999945],
            [26.86515000000003, -32.51154999999994],
            [27.036430000000053, -32.56634999999994],
            [27.004514998000047, -32.60509500099994],
            [27.017230002000076, -32.785150001999966],
            [27.15761029300006, -32.83846006899995],
            [27.230619997000076, -32.71738999599995],
            [27.297439997000026, -32.676680000999966],
            [27.45610000100004, -32.78162999799997],
            [27.67416999900007, -32.83434999999997],
            [27.78268999900007, -32.74894000399996],
            [27.677970001000062, -32.66043999699997],
            [27.787990002000072, -32.52757000199995],
            [27.893980003000024, -32.45614999999998],
            [27.758832939000058, -32.331968064999955],
          ],
        ],
      },
      properties: {
        Shape_Leng: 6.07733717801,
        Shape_Area: 0.43233394425,
        ADM3_EN: 'Amahlathi',
        ADM3_PCODE: 'ZA2124',
        ADM3_REF: '',
        ADM3ALT1EN: '',
        ADM3ALT2EN: '',
        ADM2_EN: 'Amathole',
        ADM2_PCODE: 'ZA212',
        ADM1_EN: 'Eastern Cape',
        ADM1_PCODE: 'ZA2',
        ADM0_EN: 'South Africa',
        ADM0_PCODE: 'ZA',
        date: '2018-12-27T00:00:00.000Z',
        validOn: '2020-11-09T00:00:00.000Z',
        validTo: '1899-11-30T00:00:00.000Z',
        ADM1_ID: 'EC',
        ADM2_ID: 'DC12',
        ADM3_ID: 'EC124',
      },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Polygon',
        coordinates: [
          [
            [31.56120207300006, -23.226929905999953],
            [31.173540115000037, -23.350185393999936],
            [31.143371582000043, -23.531866073999936],
            [31.078299997000045, -23.64602999999994],
            [30.759670003000053, -23.697349990999953],
            [30.624930001000052, -23.596700001999977],
            [30.525589999000033, -23.727099995999936],
            [30.585719999000048, -23.84737000299998],
            [30.557380004000038, -23.94147999599994],
            [30.480120000000056, -23.980880010999954],
            [30.675509997000063, -24.14592999699994],
            [30.77604999700003, -24.092389998999977],
            [30.940210000000036, -24.053039998999964],
            [31.012669998000035, -24.12941999399993],
            [31.063430002000075, -24.091459998999937],
            [31.19425000800004, -24.03114999899998],
            [31.252280003000067, -24.09773000299998],
            [31.428049998000063, -24.054499999999962],
            [31.594699999000056, -24.05636999799998],
            [31.767479998000056, -23.98461999999995],
            [31.883834663000073, -23.984594453999932],
            [31.76918000300003, -23.88779999999997],
            [31.697390004000056, -23.721889992999934],
            [31.69054999900004, -23.629440002999957],
            [31.561020000000042, -23.481959996999933],
            [31.56120207300006, -23.226929905999953],
          ],
        ],
      },
      properties: {
        Shape_Leng: 5.14889832895,
        Shape_Area: 0.663424716371,
        ADM3_EN: 'Ba-Phalaborwa',
        ADM3_PCODE: 'ZA9334',
        ADM3_REF: '',
        ADM3ALT1EN: '',
        ADM3ALT2EN: '',
        ADM2_EN: 'Mopani',
        ADM2_PCODE: 'ZA933',
        ADM1_EN: 'Limpopo',
        ADM1_PCODE: 'ZA9',
        ADM0_EN: 'South Africa',
        ADM0_PCODE: 'ZA',
        date: '2018-12-27T00:00:00.000Z',
        validOn: '2020-11-09T00:00:00.000Z',
        validTo: '1899-11-30T00:00:00.000Z',
        ADM1_ID: 'LIM',
        ADM2_ID: 'DC33',
        ADM3_ID: 'LIM334',
      },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Polygon',
        coordinates: [
          [
            [24.152459995000072, -31.78860999799997],
            [24.070940002000043, -31.807089996999935],
            [24.028519997000046, -31.730170000999976],
            [23.878630002000023, -31.833680004999962],
            [23.715130000000045, -31.64704000399996],
            [23.496109997000076, -31.702689998999972],
            [23.30242000000004, -31.730149998999934],
            [23.23036999900006, -31.87569000299993],
            [23.139449995000064, -31.951539998999976],
            [22.858970002000035, -31.818289999999934],
            [22.776880000000062, -31.85690999999997],
            [22.73510000500005, -31.79937999599997],
            [22.578340001000072, -31.80551000099996],
            [22.619070003000047, -31.72465000099993],
            [22.312290002000054, -31.58346000199998],
            [22.20401000000004, -31.76403000199997],
            [22.166599999000027, -31.893089998999983],
            [22.07133000300007, -31.939299996999978],
            [22.094980004000035, -32.00105999899995],
            [22.016439990000038, -32.11425999499994],
            [21.995920002000048, -32.20298000399998],
            [21.855109998000046, -32.275509994999936],
            [21.691649995000034, -32.24857000199995],
            [21.64457999800004, -32.20871000099993],
            [21.536010000000033, -32.22922000999995],
            [21.561809999000047, -32.314730001999976],
            [21.303010011000026, -32.402440001999935],
            [21.188309998000022, -32.50304999499997],
            [21.35224000100004, -32.65772999899997],
            [21.426580004000073, -32.66712999799995],
            [21.432109997000055, -32.75672999699998],
            [21.479760003000024, -32.78659999699994],
            [21.691180001000077, -32.71439000099997],
            [21.760430003000067, -32.65843999899994],
            [21.945939999000075, -32.609800003999965],
            [22.033419997000067, -32.55492999799998],
            [22.065019996000046, -32.71055999699996],
            [22.191380000000038, -32.79061000099995],
            [22.30132999700004, -32.73991000199993],
            [22.38400000000007, -32.87083000599995],
            [22.66463999800004, -32.92879999599995],
            [22.78315000200007, -32.93059999899998],
            [22.83540000100004, -33.03773999999993],
            [22.934090000000026, -33.02165999899995],
            [23.007439997000063, -32.872819998999944],
            [23.149329996000063, -32.766739997999935],
            [23.37862000100006, -32.82501999599998],
            [23.30130999800008, -32.65178999899996],
            [23.288155001000064, -32.55120999799993],
            [23.221610003000023, -32.42503999999997],
            [23.40985000200004, -32.38919999899997],
            [23.448959998000078, -32.323269997999944],
            [23.66514999900005, -32.344229997999946],
            [23.670450002000052, -32.23767000399994],
            [23.79785000100003, -32.19407000299998],
            [23.892299997000066, -32.25494999599994],
            [24.100129996000078, -32.16399999999993],
            [24.140870001000053, -32.01170999799996],
            [24.222410000000025, -31.95564000099995],
            [24.164199997000026, -31.902410002999943],
            [24.152459995000072, -31.78860999799997],
          ],
        ],
      },
      properties: {
        Shape_Leng: 10.868744672,
        Shape_Area: 2.09794452472,
        ADM3_EN: 'Beaufort West',
        ADM3_PCODE: 'ZA1053',
        ADM3_REF: '',
        ADM3ALT1EN: '',
        ADM3ALT2EN: '',
        ADM2_EN: 'Central Karoo',
        ADM2_PCODE: 'ZA105',
        ADM1_EN: 'Western Cape',
        ADM1_PCODE: 'ZA1',
        ADM0_EN: 'South Africa',
        ADM0_PCODE: 'ZA',
        date: '2018-12-27T00:00:00.000Z',
        validOn: '2020-11-09T00:00:00.000Z',
        validTo: '1899-11-30T00:00:00.000Z',
        ADM1_ID: 'WC',
        ADM2_ID: 'DC5',
        ADM3_ID: 'WC053',
      },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Polygon',
        coordinates: [
          [
            [28.713779997000074, -24.95362000199998],
            [28.65762999800006, -24.837700001999963],
            [28.50488000000007, -24.87354000299996],
            [28.36611800000003, -24.78649399699998],
            [28.29210999700007, -24.795669997999937],
            [28.09486000000004, -24.63025999699994],
            [27.996049999000036, -24.63843000199995],
            [27.89511999700005, -24.582679994999978],
            [27.87066400300006, -24.768357996999953],
            [27.830980001000057, -24.849409999999978],
            [27.977860003000046, -24.90102000199994],
            [27.983559998000032, -24.957849997999972],
            [28.25975999700006, -25.050449999999955],
            [28.13571999900006, -25.20563999799998],
            [28.246270001000028, -25.212855003999948],
            [28.298160001000042, -25.310370001999956],
            [28.503590001000077, -25.30883999899993],
            [28.513280004000023, -25.256149998999945],
            [28.659309999000072, -25.234780000999933],
            [28.651569996000035, -25.142899996999972],
            [28.536829999000076, -25.152549990999944],
            [28.461599997000064, -25.20147999699998],
            [28.379259999000055, -25.155299998999965],
            [28.473739998000042, -25.08931999899994],
            [28.634289996000064, -25.058240001999934],
            [28.605540003000044, -25.003799997999977],
            [28.713779997000074, -24.95362000199998],
          ],
        ],
      },
      properties: {
        Shape_Leng: 4.27772273723,
        Shape_Area: 0.304489585877,
        ADM3_EN: 'Bela-Bela',
        ADM3_PCODE: 'ZA9366',
        ADM3_REF: '',
        ADM3ALT1EN: '',
        ADM3ALT2EN: '',
        ADM2_EN: 'Waterberg',
        ADM2_PCODE: 'ZA936',
        ADM1_EN: 'Limpopo',
        ADM1_PCODE: 'ZA9',
        ADM0_EN: 'South Africa',
        ADM0_PCODE: 'ZA',
        date: '2018-12-27T00:00:00.000Z',
        validOn: '2020-11-09T00:00:00.000Z',
        validTo: '1899-11-30T00:00:00.000Z',
        ADM1_ID: 'LIM',
        ADM2_ID: 'DC36',
        ADM3_ID: 'LIM366',
      },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Polygon',
        coordinates: [
          [
            [19.18442999900003, -32.82707000199997],
            [19.09860999700004, -32.879119996999975],
            [19.03567000000004, -32.848870001999956],
            [19.007160003000024, -32.71618999599997],
            [18.848940000000027, -32.52178999699993],
            [18.724900002000027, -32.56648999899994],
            [18.642719998000075, -32.45601999899998],
            [18.398829998000053, -32.42551000299994],
            [18.334489998000038, -32.44294999899995],
            [18.279430002000026, -32.63322999799993],
            [18.124805002000073, -32.77778499999994],
            [18.29260000100004, -32.96199000399997],
            [18.511344003000033, -32.94604598799998],
            [18.59600000100005, -32.90072000899994],
            [18.72658000200005, -32.95053000099995],
            [18.807800003000068, -33.03002000199996],
            [18.844649998000023, -33.11732000099994],
            [18.939005000000066, -33.19638999799997],
            [19.072419997000054, -33.127659997999956],
            [19.172990000000027, -33.09192000199994],
            [19.153710001000036, -32.98403999899995],
            [19.18442999900003, -32.82707000199997],
          ],
        ],
      },
      properties: {
        Shape_Leng: 3.92385096421,
        Shape_Area: 0.424212681232,
        ADM3_EN: 'Bergrivier',
        ADM3_PCODE: 'ZA1013',
        ADM3_REF: '',
        ADM3ALT1EN: '',
        ADM3ALT2EN: '',
        ADM2_EN: 'West Coast',
        ADM2_PCODE: 'ZA101',
        ADM1_EN: 'Western Cape',
        ADM1_PCODE: 'ZA1',
        ADM0_EN: 'South Africa',
        ADM0_PCODE: 'ZA',
        date: '2018-12-27T00:00:00.000Z',
        validOn: '2020-11-09T00:00:00.000Z',
        validTo: '1899-11-30T00:00:00.000Z',
        ADM1_ID: 'WC',
        ADM2_ID: 'DC1',
        ADM3_ID: 'WC013',
      },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Polygon',
        coordinates: [
          [
            [32.662844617000076, -27.79470825599998],
            [32.52307608000007, -27.77544761699994],
            [32.52578322800008, -27.68469506599996],
            [32.41573307700003, -27.661980149999977],
            [32.33728794500007, -27.753563062999945],
            [32.031879944000025, -27.92858006299997],
            [31.94805994400008, -28.013130063999938],
            [31.81923994400006, -28.038040063999972],
            [31.807360069000026, -28.216039938999984],
            [31.733409944000073, -28.218509938999944],
            [31.70206494400003, -28.371455063999974],
            [31.811069944000053, -28.431680938999932],
            [31.96252994400004, -28.406219938999982],
            [31.981432944000062, -28.35041993899995],
            [32.02841994400006, -28.220219938999946],
            [32.12099994400006, -28.117189938999957],
            [32.26751994500006, -28.145899938999946],
            [32.339399945000025, -28.098979938999946],
            [32.614832748000026, -28.133148029999973],
            [32.662844617000076, -27.79470825599998],
          ],
        ],
      },
      properties: {
        Shape_Leng: 4.33142434077,
        Shape_Area: 0.318083698937,
        ADM3_EN: 'Big Five Hlabisa',
        ADM3_PCODE: 'ZA5276',
        ADM3_REF: '',
        ADM3ALT1EN: '',
        ADM3ALT2EN: '',
        ADM2_EN: 'Umkhanyakude',
        ADM2_PCODE: 'ZA527',
        ADM1_EN: 'KwaZulu-Natal',
        ADM1_PCODE: 'ZA5',
        ADM0_EN: 'South Africa',
        ADM0_PCODE: 'ZA',
        date: '2018-12-27T00:00:00.000Z',
        validOn: '2020-11-09T00:00:00.000Z',
        validTo: '1899-11-30T00:00:00.000Z',
        ADM1_ID: 'KZN',
        ADM2_ID: 'DC27',
        ADM3_ID: 'KZN276',
      },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Polygon',
        coordinates: [
          [
            [23.647020000000055, -33.98055999999997],
            [23.65522999800004, -33.88738999699996],
            [23.517920004000075, -33.78562000299996],
            [23.395039996000037, -33.79263999899996],
            [23.33441000600004, -33.85656000299997],
            [23.22901000300004, -33.87834999699993],
            [23.168739996000056, -34.006250001999945],
            [23.164119998000047, -34.08305000099995],
            [23.37552000000005, -34.09816000099994],
            [23.437879998000028, -34.00864000299998],
            [23.647020000000055, -33.98055999999997],
          ],
        ],
      },
      properties: {
        Shape_Leng: 2.0076796642,
        Shape_Area: 0.0967202447037,
        ADM3_EN: 'Bitou',
        ADM3_PCODE: 'ZA1047',
        ADM3_REF: '',
        ADM3ALT1EN: '',
        ADM3ALT2EN: '',
        ADM2_EN: 'Eden',
        ADM2_PCODE: 'ZA104',
        ADM1_EN: 'Western Cape',
        ADM1_PCODE: 'ZA1',
        ADM0_EN: 'South Africa',
        ADM0_PCODE: 'ZA',
        date: '2018-12-27T00:00:00.000Z',
        validOn: '2020-11-09T00:00:00.000Z',
        validTo: '1899-11-30T00:00:00.000Z',
        ADM1_ID: 'WC',
        ADM2_ID: 'DC4',
        ADM3_ID: 'WC047',
      },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Polygon',
        coordinates: [
          [
            [28.92327896200004, -22.457035037999958],
            [28.710359999000048, -22.514749999999935],
            [28.639279999000053, -22.558710007999935],
            [28.342640001000063, -22.57372000099997],
            [28.209670001000063, -22.66446000199994],
            [28.096936971000048, -22.811053028999936],
            [28.147640000000024, -22.916039999999953],
            [28.234560000000045, -22.96703999999994],
            [28.22434000000004, -23.04932999999994],
            [28.33707000000004, -23.12283999999994],
            [28.32009000000005, -23.204019999999957],
            [28.413290000000075, -23.351669999999956],
            [28.47404000000006, -23.31218999999993],
            [28.595938052000065, -23.40472805199994],
            [28.73576997200007, -23.330910030999974],
            [28.795609971000033, -23.416060028999937],
            [28.969249811000054, -23.59783252699998],
            [29.066478751000034, -23.554339891999973],
            [29.082059956000023, -23.299960044999978],
            [29.157239969000045, -23.318800003999968],
            [29.267809965000026, -23.238640029999942],
            [29.251730000000066, -23.107069999999965],
            [29.31015000000008, -23.07379999999995],
            [29.246350000000064, -22.93838999999997],
            [29.166969942000037, -22.91779005899997],
            [29.244899942000075, -22.735260058999927],
            [29.20935997500004, -22.66278004299994],
            [29.16587994200006, -22.553120057999934],
            [29.107339942000067, -22.539250057999936],
            [28.979110066000032, -22.581130058999975],
            [28.92327896200004, -22.457035037999958],
          ],
        ],
      },
      properties: {
        Shape_Leng: 4.90441990922,
        Shape_Area: 0.840050717844,
        ADM3_EN: 'Blouberg',
        ADM3_PCODE: 'ZA9351',
        ADM3_REF: '',
        ADM3ALT1EN: '',
        ADM3ALT2EN: '',
        ADM2_EN: 'Capricorn',
        ADM2_PCODE: 'ZA935',
        ADM1_EN: 'Limpopo',
        ADM1_PCODE: 'ZA9',
        ADM0_EN: 'South Africa',
        ADM0_PCODE: 'ZA',
        date: '2018-12-27T00:00:00.000Z',
        validOn: '2020-11-09T00:00:00.000Z',
        validTo: '1899-11-30T00:00:00.000Z',
        ADM1_ID: 'LIM',
        ADM2_ID: 'DC35',
        ADM3_ID: 'LIM351',
      },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Polygon',
        coordinates: [
          [
            [25.887309997000045, -32.48680000199994],
            [25.785559999000043, -32.53790000099997],
            [25.65508199800007, -32.50690700299998],
            [25.534059996000053, -32.394469998999966],
            [25.167560003000062, -32.328709999999944],
            [25.128310002000035, -32.291099997999936],
            [24.949610000000064, -32.241180001999965],
            [24.795180001000062, -32.40922999899993],
            [24.76141000100006, -32.377580000999956],
            [24.589819996000074, -32.44383999799993],
            [24.545329996000078, -32.56204000199995],
            [24.45657920800005, -32.64081954999995],
            [24.41367999600004, -32.73698000299993],
            [24.691030004000027, -32.69167999699994],
            [24.910831407000046, -32.74323000299995],
            [25.08741000200007, -32.87103000199994],
            [25.077050000000042, -33.00292999699997],
            [25.113699999000062, -33.11572000199993],
            [25.173969998000075, -33.119599996999966],
            [25.178260000000023, -33.251679999999965],
            [25.450720002000025, -33.283530000999974],
            [25.78963999800004, -33.28451999899994],
            [25.98793999700007, -33.306610002999946],
            [25.948189998000032, -33.17266000199993],
            [26.135669990000054, -32.96016999699998],
            [26.274939998000036, -32.93697999899996],
            [26.179510003000075, -32.76344000199998],
            [26.06595999900003, -32.78693000099997],
            [26.047619999000062, -32.63280000299994],
            [26.08084000100007, -32.54658000199993],
            [25.939830003000054, -32.53871999699993],
            [25.887309997000045, -32.48680000199994],
          ],
        ],
      },
      properties: {
        Shape_Leng: 6.68079306227,
        Shape_Area: 1.06532653682,
        ADM3_EN: 'Blue Crane Route',
        ADM3_PCODE: 'ZA2102',
        ADM3_REF: '',
        ADM3ALT1EN: '',
        ADM3ALT2EN: '',
        ADM2_EN: 'Cacadu',
        ADM2_PCODE: 'ZA210',
        ADM1_EN: 'Eastern Cape',
        ADM1_PCODE: 'ZA2',
        ADM0_EN: 'South Africa',
        ADM0_PCODE: 'ZA',
        date: '2018-12-27T00:00:00.000Z',
        validOn: '2020-11-09T00:00:00.000Z',
        validTo: '1899-11-30T00:00:00.000Z',
        ADM1_ID: 'EC',
        ADM2_ID: 'DC10',
        ADM3_ID: 'EC102',
      },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Polygon',
        coordinates: [
          [
            [20.336220000000026, -33.48781999099998],
            [20.368039999000075, -33.36626999999993],
            [20.209170001000075, -33.379799996999964],
            [20.257969999000068, -33.18844999099997],
            [20.202179999000066, -33.17010999799993],
            [20.013769999000033, -33.23878800399996],
            [19.972039997000024, -33.316779990999976],
            [19.830580000000054, -33.37942000199996],
            [19.58069000200004, -33.36452000399993],
            [19.537909998000032, -33.426440000999946],
            [19.405300003000036, -33.480509998999935],
            [19.378590001000077, -33.61909000399993],
            [19.23946999800006, -33.558840000999965],
            [19.107040003000066, -33.54113999699996],
            [19.101960000000076, -33.606760005999945],
            [19.183989998000072, -33.715390001999936],
            [19.21404900600004, -33.857067995999955],
            [19.24380000000008, -33.89744999699997],
            [19.455799998000032, -33.99987999999996],
            [19.506889998000077, -33.97169999999994],
            [19.532279998000035, -33.878429998999934],
            [19.681389998000043, -33.79936999999995],
            [19.69963000100006, -33.63793000199996],
            [19.637590002000024, -33.536550001999956],
            [19.91710001100006, -33.51927000099994],
            [19.992483868000022, -33.556838168999946],
            [20.24153099700004, -33.53804599699998],
            [20.336220000000026, -33.48781999099998],
          ],
        ],
      },
      properties: {
        Shape_Leng: 4.67369766316,
        Shape_Area: 0.37230814157,
        ADM3_EN: 'Breede Valley',
        ADM3_PCODE: 'ZA1025',
        ADM3_REF: '',
        ADM3ALT1EN: '',
        ADM3ALT2EN: '',
        ADM2_EN: 'Cape Winelands',
        ADM2_PCODE: 'ZA102',
        ADM1_EN: 'Western Cape',
        ADM1_PCODE: 'ZA1',
        ADM0_EN: 'South Africa',
        ADM0_PCODE: 'ZA',
        date: '2018-12-27T00:00:00.000Z',
        validOn: '2020-11-09T00:00:00.000Z',
        validTo: '1899-11-30T00:00:00.000Z',
        ADM1_ID: 'WC',
        ADM2_ID: 'DC2',
        ADM3_ID: 'WC025',
      },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Polygon',
        coordinates: [
          [
            [27.78268999900007, -32.74894000399996],
            [27.67416999900007, -32.83434999999997],
            [27.45610000100004, -32.78162999799997],
            [27.297439997000026, -32.676680000999966],
            [27.230619997000076, -32.71738999599995],
            [27.15761029300006, -32.83846006899995],
            [27.217910004000032, -32.89013000099993],
            [27.29586428300007, -33.02417272899993],
            [27.34307485200003, -32.96295413499996],
            [27.503910002000055, -32.995219996999936],
            [27.44417001100004, -33.07976000599996],
            [27.360132943000053, -33.12994728399997],
            [27.49182999900006, -33.28203999799996],
            [27.72796999800005, -33.12144000099994],
            [27.919659999000032, -33.02961000399995],
            [28.075529994000078, -32.907794999999965],
            [27.991459946000077, -32.85556183399996],
            [27.95717783400005, -32.75833922499993],
            [27.882910001000027, -32.78550000299998],
            [27.78268999900007, -32.74894000399996],
          ],
        ],
      },
      properties: {
        Shape_Leng: 4.47912020356,
        Shape_Area: 0.265206611467,
        ADM3_EN: 'Buffalo City',
        ADM3_PCODE: 'ZA2920',
        ADM3_REF: '',
        ADM3ALT1EN: '',
        ADM3ALT2EN: '',
        ADM2_EN: 'Buffalo City',
        ADM2_PCODE: 'ZA292',
        ADM1_EN: 'Eastern Cape',
        ADM1_PCODE: 'ZA2',
        ADM0_EN: 'South Africa',
        ADM0_PCODE: 'ZA',
        date: '2018-12-27T00:00:00.000Z',
        validOn: '2020-11-09T00:00:00.000Z',
        validTo: '1899-11-30T00:00:00.000Z',
        ADM1_ID: 'EC',
        ADM2_ID: 'BUF',
        ADM3_ID: 'BUF',
      },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Polygon',
        coordinates: [
          [
            [31.883834663000073, -23.984594453999932],
            [31.767479998000056, -23.98461999999995],
            [31.594699999000056, -24.05636999799998],
            [31.428049998000063, -24.054499999999962],
            [31.252280003000067, -24.09773000299998],
            [31.19425000800004, -24.03114999899998],
            [31.063430002000075, -24.091459998999937],
            [31.05602000500005, -24.32188999699997],
            [31.159969998000065, -24.37557000199996],
            [31.25366000200006, -24.499120000999937],
            [31.226180011000054, -24.556010001999937],
            [30.95931999900006, -24.582070000999977],
            [30.871709999000075, -24.538500002999967],
            [30.919410003000053, -24.80515999599993],
            [31.00542000300004, -24.83701999599998],
            [31.025230003000047, -25.030099993999954],
            [31.14072748700005, -24.98202324199997],
            [31.24930000300003, -25.018360137999935],
            [31.317630768000072, -24.96453094499998],
            [31.564248501000066, -24.96042203299993],
            [31.61089389600005, -24.98924693999993],
            [31.71690900200008, -24.954299998999943],
            [31.823160001000076, -25.06190799999996],
            [32.031979997000064, -25.18309499999998],
            [31.998270003000073, -24.68974000199995],
            [32.01309999800003, -24.45458999999994],
            [31.987129998000057, -24.30219999999997],
            [31.908010003000072, -24.182429998999964],
            [31.883834663000073, -23.984594453999932],
          ],
        ],
      },
      properties: {
        Shape_Leng: 5.76300773365,
        Shape_Area: 0.913264033036,
        ADM3_EN: 'Bushbuckridge',
        ADM3_PCODE: 'ZA8325',
        ADM3_REF: '',
        ADM3ALT1EN: '',
        ADM3ALT2EN: '',
        ADM2_EN: 'Ehlanzeni',
        ADM2_PCODE: 'ZA832',
        ADM1_EN: 'Mpumalanga',
        ADM1_PCODE: 'ZA8',
        ADM0_EN: 'South Africa',
        ADM0_PCODE: 'ZA',
        date: '2018-12-27T00:00:00.000Z',
        validOn: '2020-11-09T00:00:00.000Z',
        validTo: '1899-11-30T00:00:00.000Z',
        ADM1_ID: 'MP',
        ADM2_ID: 'DC32',
        ADM3_ID: 'MP325',
      },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Polygon',
        coordinates: [
          [
            [20.871390005000023, -34.45243999999997],
            [20.53172999900005, -34.360520002999976],
            [20.391979997000078, -34.426290000999984],
            [20.244850000000042, -34.288889998999935],
            [20.065529998000045, -34.24126999599997],
            [19.880430000000047, -34.22010999999998],
            [19.845399997000072, -34.280439996999974],
            [19.641055394000034, -34.372031739999954],
            [19.624219995000033, -34.41871999999995],
            [19.713349996000034, -34.46856000199995],
            [19.724737004000076, -34.767248998999946],
            [19.87223000000006, -34.76589999999993],
            [19.989179998000054, -34.83337000299997],
            [20.079780001000074, -34.73651000199993],
            [20.232589997000048, -34.68962000399995],
            [20.258840002000056, -34.63828999899994],
            [20.407240002000037, -34.56343000199996],
            [20.47609000400007, -34.492329997999946],
            [20.691119999000023, -34.45026999999993],
            [20.871390005000023, -34.45243999999997],
          ],
        ],
      },
      properties: {
        Shape_Leng: 4.21828460927,
        Shape_Area: 0.340653303702,
        ADM3_EN: 'Cape Agulhas',
        ADM3_PCODE: 'ZA1033',
        ADM3_REF: '',
        ADM3ALT1EN: '',
        ADM3ALT2EN: '',
        ADM2_EN: 'Overberg',
        ADM2_PCODE: 'ZA103',
        ADM1_EN: 'Western Cape',
        ADM1_PCODE: 'ZA1',
        ADM0_EN: 'South Africa',
        ADM0_PCODE: 'ZA',
        date: '2018-12-27T00:00:00.000Z',
        validOn: '2020-11-09T00:00:00.000Z',
        validTo: '1899-11-30T00:00:00.000Z',
        ADM1_ID: 'WC',
        ADM2_ID: 'DC3',
        ADM3_ID: 'WC033',
      },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Polygon',
        coordinates: [
          [
            [19.02622000100007, -31.876639998999963],
            [18.875510003000045, -31.85241999599998],
            [18.740900001000057, -31.878890001999935],
            [18.62286000000006, -31.95634000299998],
            [18.56123999700003, -31.87885999899993],
            [18.451599999000052, -31.84381999699997],
            [18.411920003000034, -31.94558999999998],
            [18.29026699700006, -32.00665299999997],
            [18.342220002000033, -32.265699998999935],
            [18.314230000000066, -32.31651999999997],
            [18.334489998000038, -32.44294999899995],
            [18.398829998000053, -32.42551000299994],
            [18.642719998000075, -32.45601999899998],
            [18.724900002000027, -32.56648999899994],
            [18.848940000000027, -32.52178999699993],
            [19.007160003000024, -32.71618999599997],
            [19.03567000000004, -32.848870001999956],
            [19.09860999700004, -32.879119996999975],
            [19.18442999900003, -32.82707000199997],
            [19.204800001000024, -32.71113998799996],
            [19.142990000000054, -32.62143999799997],
            [19.159169999000028, -32.57193000099994],
            [19.419019998000067, -32.622319999999945],
            [19.48680500300003, -32.56543999599995],
            [19.496370003000038, -32.47481999799993],
            [19.409080002000053, -32.29007999799995],
            [19.49150000000003, -32.25237000599998],
            [19.515190005000022, -32.11519999999996],
            [19.395849996000038, -32.01511000299996],
            [19.02622000100007, -31.876639998999963],
          ],
        ],
      },
      properties: {
        Shape_Leng: 5.40975343298,
        Shape_Area: 0.766332514038,
        ADM3_EN: 'Cederberg',
        ADM3_PCODE: 'ZA1012',
        ADM3_REF: '',
        ADM3ALT1EN: '',
        ADM3ALT2EN: '',
        ADM2_EN: 'West Coast',
        ADM2_PCODE: 'ZA101',
        ADM1_EN: 'Western Cape',
        ADM1_PCODE: 'ZA1',
        ADM0_EN: 'South Africa',
        ADM0_PCODE: 'ZA',
        date: '2018-12-27T00:00:00.000Z',
        validOn: '2020-11-09T00:00:00.000Z',
        validTo: '1899-11-30T00:00:00.000Z',
        ADM1_ID: 'WC',
        ADM2_ID: 'DC1',
        ADM3_ID: 'WC012',
      },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Polygon',
        coordinates: [
          [
            [30.64662999500007, -25.71242000899997],
            [30.61119000900004, -25.719020000999933],
            [30.381149996000033, -25.886899995999954],
            [30.299050002000058, -25.92637999699997],
            [30.21375000200004, -25.804019998999934],
            [29.943750004000037, -25.905660000999944],
            [29.86179000100003, -25.862450002999935],
            [29.876959998000075, -25.965210001999935],
            [29.811059999000065, -26.105299998999953],
            [29.80468999800007, -26.189510002999953],
            [29.96906000200005, -26.243360000999928],
            [30.06185499700007, -26.209603000999948],
            [30.209469999000078, -26.220130001999962],
            [30.35802000500007, -26.17068999999998],
            [30.493890002000057, -26.23303999999996],
            [30.592760000000055, -26.207990002999964],
            [30.624160003000043, -26.25877000299994],
            [30.755520997000076, -26.332773003999932],
            [30.698690012000043, -26.444570002999967],
            [30.717919996000035, -26.48579000099994],
            [30.800260002000073, -26.504059998999935],
            [30.831010003000074, -26.41117000099996],
            [30.96143799600003, -26.261731999999938],
            [31.11275000200004, -25.98256999599994],
            [31.12657000300004, -25.92114999699993],
            [30.849860000000035, -25.92634000399994],
            [30.773649999000042, -25.86193999099993],
            [30.732650001000025, -25.741350001999933],
            [30.64662999500007, -25.71242000899997],
          ],
        ],
      },
      properties: {
        Shape_Leng: 4.78641197884,
        Shape_Area: 0.501449272837,
        ADM3_EN: 'Chief Albert Luthuli',
        ADM3_PCODE: 'ZA8301',
        ADM3_REF: '',
        ADM3ALT1EN: '',
        ADM3ALT2EN: '',
        ADM2_EN: 'Gert Sibande',
        ADM2_PCODE: 'ZA830',
        ADM1_EN: 'Mpumalanga',
        ADM1_PCODE: 'ZA8',
        ADM0_EN: 'South Africa',
        ADM0_PCODE: 'ZA',
        date: '2018-12-27T00:00:00.000Z',
        validOn: '2020-11-09T00:00:00.000Z',
        validTo: '1899-11-30T00:00:00.000Z',
        ADM1_ID: 'MP',
        ADM2_ID: 'DC30',
        ADM3_ID: 'MP301',
      },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Polygon',
        coordinates: [
          [
            [18.787539997000067, -33.637630000999934],
            [18.73673001000003, -33.68703000199997],
            [18.627000000000066, -33.624589999999955],
            [18.57642000000004, -33.53147999699996],
            [18.455458003000047, -33.47127600399995],
            [18.343040006000024, -33.570630000999984],
            [18.437959998000053, -33.69256000399997],
            [18.488699997000026, -33.851910002999944],
            [18.398259997000025, -33.90088000199995],
            [18.31063000200004, -34.04329000299998],
            [18.35694999900005, -34.11038000299993],
            [18.40219999800007, -34.309650002999945],
            [18.475430001000063, -34.23044999799998],
            [18.426410003000058, -34.17718999699997],
            [18.46909000100004, -34.109140010999965],
            [18.69465999700003, -34.07210999999995],
            [18.813380004000066, -34.10132999699994],
            [18.845815000000073, -34.26959000299996],
            [18.930709386000046, -34.203527863999966],
            [18.98713112300004, -34.03526966299995],
            [18.955299998000044, -34.010110001999976],
            [18.790210003000027, -34.05287999999996],
            [18.729180020000058, -33.96747639199998],
            [18.75287000000003, -33.834419999999966],
            [18.79257000100006, -33.81921000199998],
            [18.787539997000067, -33.637630000999934],
          ],
        ],
      },
      properties: {
        Shape_Leng: 5.21091428108,
        Shape_Area: 0.23836569493,
        ADM3_EN: 'City of Cape Town',
        ADM3_PCODE: 'ZA1910',
        ADM3_REF: '',
        ADM3ALT1EN: '',
        ADM3ALT2EN: '',
        ADM2_EN: 'City of Cape Town',
        ADM2_PCODE: 'ZA191',
        ADM1_EN: 'Western Cape',
        ADM1_PCODE: 'ZA1',
        ADM0_EN: 'South Africa',
        ADM0_PCODE: 'ZA',
        date: '2018-12-27T00:00:00.000Z',
        validOn: '2020-11-09T00:00:00.000Z',
        validTo: '1899-11-30T00:00:00.000Z',
        ADM1_ID: 'WC',
        ADM2_ID: 'CPT',
        ADM3_ID: 'CPT',
      },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Polygon',
        coordinates: [
          [
            [28.181050000000027, -25.91954999799998],
            [28.110230001000048, -25.944910010999934],
            [27.932119998000076, -25.916300000999968],
            [27.912640002000046, -26.02820999599993],
            [27.84964000000008, -26.06238001099996],
            [27.77199000300004, -26.21320999699998],
            [27.71826999700005, -26.198929998999972],
            [27.743799996000064, -26.28722000199997],
            [27.811589997000056, -26.36447500299994],
            [27.76128999900004, -26.419150000999934],
            [27.759710004000056, -26.48386998799998],
            [27.887210001000028, -26.526250000999937],
            [27.869074999000077, -26.44480099799995],
            [27.912229996000065, -26.35894999599998],
            [28.067101999000045, -26.34194000399998],
            [28.122851998000044, -26.247929002999967],
            [28.112739996000073, -26.167779997999958],
            [28.184829997000065, -26.089259998999978],
            [28.158183001000054, -26.038249999999948],
            [28.181050000000027, -25.91954999799998],
          ],
        ],
      },
      properties: {
        Shape_Leng: 3.03514725283,
        Shape_Area: 0.148520781689,
        ADM3_EN: 'City of Johannesburg',
        ADM3_PCODE: 'ZA7980',
        ADM3_REF: '',
        ADM3ALT1EN: '',
        ADM3ALT2EN: '',
        ADM2_EN: 'City of Johannesburg',
        ADM2_PCODE: 'ZA798',
        ADM1_EN: 'Gauteng',
        ADM1_PCODE: 'ZA7',
        ADM0_EN: 'South Africa',
        ADM0_PCODE: 'ZA',
        date: '2018-12-27T00:00:00.000Z',
        validOn: '2020-11-09T00:00:00.000Z',
        validTo: '1899-11-30T00:00:00.000Z',
        ADM1_ID: 'GT',
        ADM2_ID: 'JHB',
        ADM3_ID: 'JHB',
      },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Polygon',
        coordinates: [
          [
            [26.45990999600008, -26.483499998999946],
            [26.384739999000033, -26.499899997999933],
            [26.248110002000033, -26.58731999899993],
            [26.27236000000005, -26.691440000999933],
            [26.11505999900004, -26.77104999599993],
            [26.07676000200007, -26.862330004999933],
            [26.190640002000066, -26.908319997999968],
            [26.419900003000066, -27.171359996999968],
            [26.521619999000052, -27.104389999999967],
            [26.621069997000063, -27.00272000299998],
            [26.866440002000047, -26.91906000299997],
            [26.89799000200003, -26.828930002999982],
            [26.79416000300006, -26.767229998999937],
            [26.783010000000047, -26.611090003999948],
            [26.704759999000032, -26.612480000999938],
            [26.63119000100005, -26.515979998999967],
            [26.45990999600008, -26.483499998999946],
          ],
        ],
      },
      properties: {
        Shape_Leng: 3.00433408533,
        Shape_Area: 0.327009232813,
        ADM3_EN: 'City of Matlosana',
        ADM3_PCODE: 'ZA6403',
        ADM3_REF: '',
        ADM3ALT1EN: '',
        ADM3ALT2EN: '',
        ADM2_EN: 'Dr Kenneth Kaunda',
        ADM2_PCODE: 'ZA640',
        ADM1_EN: 'North West',
        ADM1_PCODE: 'ZA6',
        ADM0_EN: 'South Africa',
        ADM0_PCODE: 'ZA',
        date: '2018-12-27T00:00:00.000Z',
        validOn: '2020-11-09T00:00:00.000Z',
        validTo: '1899-11-30T00:00:00.000Z',
        ADM1_ID: 'NW',
        ADM2_ID: 'DC40',
        ADM3_ID: 'NW403',
      },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Polygon',
        coordinates: [
          [
            [28.739590001000067, -25.28853000099997],
            [28.77541000000008, -25.18377000299995],
            [28.74458899700005, -25.10961200099996],
            [28.651569996000035, -25.142899996999972],
            [28.659309999000072, -25.234780000999933],
            [28.513280004000023, -25.256149998999945],
            [28.503590001000077, -25.30883999899993],
            [28.298160001000042, -25.310370001999956],
            [28.298060004000035, -25.33933999599998],
            [28.04473000400003, -25.401739994999957],
            [27.970759997000073, -25.362949989999947],
            [27.945639996000068, -25.40670000299997],
            [28.03595000400003, -25.470589996999934],
            [27.95763000100004, -25.59261999699993],
            [27.960169997000037, -25.815989996999974],
            [27.898200001000077, -25.859740003999946],
            [27.932119998000076, -25.916300000999968],
            [28.110230001000048, -25.944910010999934],
            [28.181050000000027, -25.91954999799998],
            [28.407189997000046, -25.924090001999957],
            [28.50305499700005, -26.063800002999983],
            [28.578939997000077, -26.059590002999983],
            [28.632260004000045, -25.970779996999966],
            [28.793860004000067, -26.004569999999944],
            [28.885049996000077, -25.974399997999967],
            [28.94107000200006, -25.877290002999928],
            [28.938169999000024, -25.823284995999927],
            [29.00829000300007, -25.66057000099994],
            [28.851780003000044, -25.501809999999978],
            [28.846950004000064, -25.68242000099997],
            [28.683779997000045, -25.67537999999996],
            [28.625750002000075, -25.52304999599994],
            [28.62257999800005, -25.33364999899993],
            [28.739590001000067, -25.28853000099997],
          ],
        ],
      },
      properties: {
        Shape_Leng: 6.35664241972,
        Shape_Area: 0.566199331059,
        ADM3_EN: 'City of Tshwane',
        ADM3_PCODE: 'ZA7990',
        ADM3_REF: '',
        ADM3ALT1EN: '',
        ADM3ALT2EN: '',
        ADM2_EN: 'City of Tshwane',
        ADM2_PCODE: 'ZA799',
        ADM1_EN: 'Gauteng',
        ADM1_PCODE: 'ZA7',
        ADM0_EN: 'South Africa',
        ADM0_PCODE: 'ZA',
        date: '2018-12-27T00:00:00.000Z',
        validOn: '2020-11-09T00:00:00.000Z',
        validTo: '1899-11-30T00:00:00.000Z',
        ADM1_ID: 'GT',
        ADM2_ID: 'TSH',
        ADM3_ID: 'TSH',
      },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Polygon',
        coordinates: [
          [
            [31.561423243000036, -23.224282794999965],
            [31.563599990000057, -23.19822999799993],
            [31.344896727000048, -22.534532147999982],
            [31.17854309100005, -22.672002791999944],
            [31.070337296000048, -22.802122115999964],
            [31.013439178000056, -22.72781944199994],
            [30.88948059100005, -22.71283912699994],
            [30.721125296000025, -22.846444064999957],
            [30.658123518000025, -22.941118959999983],
            [30.505397414000072, -23.00142527299994],
            [30.410079943000028, -23.09472005899994],
            [30.23791194300003, -23.12428205899994],
            [30.189781400000072, -23.158214874999942],
            [30.245272930000056, -23.253729017999945],
            [30.151606737000066, -23.31379967999993],
            [30.268560962000038, -23.324409040999967],
            [30.29401998000003, -23.385680021999974],
            [30.36914997300005, -23.310160027999927],
            [30.334979974000078, -23.249440032999928],
            [30.487569971000028, -23.244240030999947],
            [30.562659973000052, -23.17569003099993],
            [30.652229971000054, -23.157420025999954],
            [30.728049972000065, -23.072310030999972],
            [30.966876984000066, -23.174127578999958],
            [31.15665817300004, -23.188066482999943],
            [31.20694541900008, -23.219594954999934],
            [31.374877930000025, -23.138339995999956],
            [31.41187095600003, -23.091106414999956],
            [31.561423243000036, -23.224282794999965],
          ],
        ],
      },
      properties: {
        Shape_Leng: 5.27707599227,
        Shape_Area: 0.440663092772,
        ADM3_EN: 'Collins Chabane',
        ADM3_PCODE: 'ZA9345',
        ADM3_REF: '',
        ADM3ALT1EN: '',
        ADM3ALT2EN: '',
        ADM2_EN: 'Vhembe',
        ADM2_PCODE: 'ZA934',
        ADM1_EN: 'Limpopo',
        ADM1_PCODE: 'ZA9',
        ADM0_EN: 'South Africa',
        ADM0_PCODE: 'ZA',
        date: '2018-12-27T00:00:00.000Z',
        validOn: '2020-11-09T00:00:00.000Z',
        validTo: '1899-11-30T00:00:00.000Z',
        ADM1_ID: 'LIM',
        ADM2_ID: 'DC34',
        ADM3_ID: 'LIM345',
      },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Polygon',
        coordinates: [
          [
            [30.292336943000066, -27.95119393899995],
            [30.280709943000033, -27.81498993799994],
            [30.208594943000037, -27.788359937999928],
            [30.00096994200004, -27.899259937999943],
            [29.914110067000024, -27.988790063999943],
            [29.676849959000037, -27.959510042999966],
            [29.616861983000035, -28.04683801599998],
            [29.663289934000034, -28.14202004499998],
            [29.72759994200004, -28.12564993899997],
            [29.814084154000057, -28.215034868999965],
            [29.99042994200005, -28.18492993899997],
            [30.13208994300004, -28.177439938999953],
            [30.292336943000066, -27.95119393899995],
          ],
        ],
      },
      properties: {
        Shape_Leng: 2.80166727935,
        Shape_Area: 0.156659004568,
        ADM3_EN: 'Dannhauser',
        ADM3_PCODE: 'ZA5254',
        ADM3_REF: '',
        ADM3ALT1EN: '',
        ADM3ALT2EN: '',
        ADM2_EN: 'Amajuba',
        ADM2_PCODE: 'ZA525',
        ADM1_EN: 'KwaZulu-Natal',
        ADM1_PCODE: 'ZA5',
        ADM0_EN: 'South Africa',
        ADM0_PCODE: 'ZA',
        date: '2018-12-27T00:00:00.000Z',
        validOn: '2020-11-09T00:00:00.000Z',
        validTo: '1899-11-30T00:00:00.000Z',
        ADM1_ID: 'KZN',
        ADM2_ID: 'DC25',
        ADM3_ID: 'KZN254',
      },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Polygon',
        coordinates: [
          [
            [21.79286999900006, -26.76962999899996],
            [21.694839999000067, -26.861240003999967],
            [21.405429996000066, -26.822099994999974],
            [21.134170004000055, -26.87375999799997],
            [20.885230000000035, -26.79726999899998],
            [20.76311000000004, -26.86647000399995],
            [20.676149993000024, -26.861250003999942],
            [20.62242999700004, -26.78624999599998],
            [20.64614999500003, -26.43507999999997],
            [20.863279998000053, -26.13267999699997],
            [20.815350005000028, -26.00589999999994],
            [20.837430002000076, -25.950749993999978],
            [20.682559996000066, -25.69452000399997],
            [20.69818999900008, -25.595110000999966],
            [20.539229998000053, -25.34453000299993],
            [20.542890003000025, -25.292579994999983],
            [20.446380001000023, -25.198970001999953],
            [20.38417000100003, -25.03430000299994],
            [20.203730004000022, -24.896479994999936],
            [20.115829993000034, -24.88088999799993],
            [19.998870004000025, -24.765860007999947],
            [20.00019001000004, -25.53155999599994],
            [19.999419999000054, -26.14263000099993],
            [20.000210001000028, -26.961010000999977],
            [20.000210001000028, -27.77401999899996],
            [20.15366935700007, -27.852560042999983],
            [20.24860000600006, -27.790569304999963],
            [20.270820618000073, -27.91489028899997],
            [20.411949158000027, -27.853340148999962],
            [20.55798912000006, -28.034820556999932],
            [20.579980727000077, -28.181939240999952],
            [20.638014890000022, -28.17485348899993],
            [20.712329863000036, -28.281499865999933],
            [20.805000008000036, -28.354829999999936],
            [21.017790001000037, -28.44387000699993],
            [21.260460005000027, -28.711480002999963],
            [21.34179999400004, -28.631930000999944],
            [21.609987000000046, -28.551045001999967],
            [21.738519995000047, -28.47525000099995],
            [21.837610093000023, -28.38274006399996],
            [21.774179568000022, -28.353029205999974],
            [21.747940063000044, -28.23625945999993],
            [21.681259155000077, -28.209600448999936],
            [21.808980942000062, -28.080049514999928],
            [21.788539886000024, -27.968240737999963],
            [21.987249374000044, -27.806890487999965],
            [22.006195183000045, -27.760420348999958],
            [21.91632080100004, -27.55381011999998],
            [21.999410629000067, -27.52479934699994],
            [21.999490738000077, -27.110249661999944],
            [21.99946000500006, -27.024790005999932],
            [21.917139989000077, -26.95868999399994],
            [21.872350003000065, -26.86014999799994],
            [21.79286999900006, -26.76962999899996],
          ],
        ],
      },
      properties: {
        Shape_Leng: 12.867978565,
        Shape_Area: 4.02473752019,
        ADM3_EN: 'Dawid Kruiper',
        ADM3_PCODE: 'ZA3087',
        ADM3_REF: '',
        ADM3ALT1EN: '',
        ADM3ALT2EN: '',
        ADM2_EN: 'Z F Mgcawu',
        ADM2_PCODE: 'ZA308',
        ADM1_EN: 'Nothern Cape',
        ADM1_PCODE: 'ZA3',
        ADM0_EN: 'South Africa',
        ADM0_PCODE: 'ZA',
        date: '2018-12-27T00:00:00.000Z',
        validOn: '2020-11-09T00:00:00.000Z',
        validTo: '1899-11-30T00:00:00.000Z',
        ADM1_ID: 'NC',
        ADM2_ID: 'DC8',
        ADM3_ID: 'NC087',
      },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Polygon',
        coordinates: [
          [
            [28.76977000100004, -28.12457999999998],
            [28.804749998000034, -28.019829999999956],
            [28.737960000000044, -27.976099998999928],
            [28.728190004000055, -28.022859996999955],
            [28.566879998000047, -28.01779999799993],
            [28.320419998000034, -28.05972999599993],
            [28.27760999900005, -28.119179998999982],
            [28.181635002000064, -28.108182003999957],
            [28.027990001000035, -28.176749997999934],
            [27.992710009000064, -28.23198998999993],
            [27.78866001800003, -28.24798099399993],
            [27.860509998000055, -28.361190002999933],
            [27.808520000000044, -28.458240001999968],
            [27.833885998000028, -28.55083700299997],
            [27.901350000000036, -28.555850002999932],
            [28.03999999000007, -28.624859992999973],
            [28.10165998900004, -28.76714999899997],
            [28.168510000000026, -28.705259996999928],
            [28.35281999600005, -28.700249996999958],
            [28.41324001600003, -28.62741998599995],
            [28.63148000700005, -28.582509997999978],
            [28.651800003000062, -28.496539998999936],
            [28.58237000200006, -28.449420001999954],
            [28.65504001000005, -28.251870002999965],
            [28.71572999700004, -28.235520002999976],
            [28.76977000100004, -28.12457999999998],
          ],
        ],
      },
      properties: {
        Shape_Leng: 4.49672095631,
        Shape_Area: 0.448029737899,
        ADM3_EN: 'Dihlabeng',
        ADM3_PCODE: 'ZA4192',
        ADM3_REF: '',
        ADM3ALT1EN: '',
        ADM3ALT2EN: '',
        ADM2_EN: 'Thabo Mofutsanyane',
        ADM2_PCODE: 'ZA419',
        ADM1_EN: 'Free State',
        ADM1_PCODE: 'ZA4',
        ADM0_EN: 'South Africa',
        ADM0_PCODE: 'ZA',
        date: '2018-12-27T00:00:00.000Z',
        validOn: '2020-11-09T00:00:00.000Z',
        validTo: '1899-11-30T00:00:00.000Z',
        ADM1_ID: 'FS',
        ADM2_ID: 'DC19',
        ADM3_ID: 'FS192',
      },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Polygon',
        coordinates: [
          [
            [24.534639003000052, -28.092088995999973],
            [24.46728999900006, -27.980569998999954],
            [24.360459994000053, -27.91067000299995],
            [24.452310005000072, -27.782880002999946],
            [24.40528000100005, -27.681180001999962],
            [24.111000001000036, -27.73898000099996],
            [23.644100000000037, -27.833489998999937],
            [23.580930004000038, -27.879310000999965],
            [23.834599996000065, -28.015079999999955],
            [23.79066000200004, -28.082849995999936],
            [23.891420002000075, -28.12594000599995],
            [23.81438000000003, -28.333800002999965],
            [23.828049990000068, -28.39098000299998],
            [23.75470000000007, -28.52878000399994],
            [23.908660008000027, -28.641440005999982],
            [23.949589996000043, -28.603360003999967],
            [24.117039961000046, -28.59861322499995],
            [24.200259999000025, -28.517570000999967],
            [24.33348000700005, -28.560820004999982],
            [24.408940005000034, -28.62680000499995],
            [24.521699994000073, -28.674599994999937],
            [24.608249999000066, -28.59722000599993],
            [24.606599999000025, -28.49547999699996],
            [24.688020003000076, -28.51417999599994],
            [24.726490004000027, -28.449739990999944],
            [24.733319382000047, -28.341136328999937],
            [24.656249999000067, -28.202390005999973],
            [24.534639003000052, -28.092088995999973],
          ],
        ],
      },
      properties: {
        Shape_Leng: 4.66505381618,
        Shape_Area: 0.672339156198,
        ADM3_EN: 'Dikgatlong',
        ADM3_PCODE: 'ZA3092',
        ADM3_REF: '',
        ADM3ALT1EN: '',
        ADM3ALT2EN: '',
        ADM2_EN: 'Frances Baard',
        ADM2_PCODE: 'ZA309',
        ADM1_EN: 'Nothern Cape',
        ADM1_PCODE: 'ZA3',
        ADM0_EN: 'South Africa',
        ADM0_PCODE: 'ZA',
        date: '2018-12-27T00:00:00.000Z',
        validOn: '2020-11-09T00:00:00.000Z',
        validTo: '1899-11-30T00:00:00.000Z',
        ADM1_ID: 'NC',
        ADM2_ID: 'DC9',
        ADM3_ID: 'NC092',
      },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Polygon',
        coordinates: [
          [
            [28.763910003000035, -26.518009998999958],
            [28.641620001000035, -26.507569995999972],
            [28.40009999700004, -26.655044999999973],
            [28.406850002000056, -26.761710001999973],
            [28.24428000000006, -26.88477999899993],
            [28.300429999000073, -26.94016000199997],
            [28.392150000000072, -26.93142000299997],
            [28.413320002000034, -27.00685999999996],
            [28.485850002000063, -26.971109997999974],
            [28.585470052000062, -27.035860016999948],
            [28.646920004000037, -26.953039996999962],
            [28.81085999800007, -27.038610003999963],
            [28.911099997000065, -27.01854000299994],
            [28.851600003000044, -26.923019998999962],
            [28.917940002000023, -26.843039999999974],
            [28.88269999700003, -26.75741000299996],
            [28.93213999900007, -26.71104999599993],
            [28.897497628000053, -26.62397787699996],
            [28.83678999700004, -26.536380003999966],
            [28.763910003000035, -26.518009998999958],
          ],
        ],
      },
      properties: {
        Shape_Leng: 3.58694984125,
        Shape_Area: 0.24003233072,
        ADM3_EN: 'Dipaleseng',
        ADM3_PCODE: 'ZA8306',
        ADM3_REF: '',
        ADM3ALT1EN: '',
        ADM3ALT2EN: '',
        ADM2_EN: 'Gert Sibande',
        ADM2_PCODE: 'ZA830',
        ADM1_EN: 'Mpumalanga',
        ADM1_PCODE: 'ZA8',
        ADM0_EN: 'South Africa',
        ADM0_PCODE: 'ZA',
        date: '2018-12-27T00:00:00.000Z',
        validOn: '2020-11-09T00:00:00.000Z',
        validTo: '1899-11-30T00:00:00.000Z',
        ADM1_ID: 'MP',
        ADM2_ID: 'DC30',
        ADM3_ID: 'MP306',
      },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Polygon',
        coordinates: [
          [
            [26.462370000000078, -25.745369995999965],
            [26.297702521000076, -25.667500191999977],
            [26.25829238500006, -25.774949710999977],
            [26.109244997000076, -25.70210999799997],
            [26.022920708000072, -25.837961614999983],
            [25.924569998000038, -25.911579996999933],
            [25.801900001000035, -25.90005999599998],
            [25.78735000300003, -26.019609996999975],
            [25.71304000300006, -26.22758000999994],
            [25.826899999000034, -26.200359996999964],
            [25.889180003000035, -26.320510008999975],
            [25.866760003000024, -26.35990000099997],
            [26.015239996000048, -26.448830001999966],
            [26.101999997000064, -26.46177000199998],
            [26.103160003000028, -26.578400001999967],
            [26.248110002000033, -26.58731999899993],
            [26.384739999000033, -26.499899997999933],
            [26.45990999600008, -26.483499998999946],
            [26.483649998000033, -26.38641999799995],
            [26.55844078100006, -26.340418393999983],
            [26.545779997000068, -26.172699997999928],
            [26.62964000900007, -26.13613000099997],
            [26.61765100300005, -26.06486700199997],
            [26.709239998000044, -26.04755999899993],
            [26.807079999000052, -26.084029998999938],
            [26.77055000200005, -25.95232999999996],
            [26.643529998000076, -25.868000000999928],
            [26.580030006000072, -25.782679995999956],
            [26.462370000000078, -25.745369995999965],
          ],
        ],
      },
      properties: {
        Shape_Leng: 4.61413518887,
        Shape_Area: 0.576351618659,
        ADM3_EN: 'Ditsobotla',
        ADM3_PCODE: 'ZA6384',
        ADM3_REF: '',
        ADM3ALT1EN: '',
        ADM3ALT2EN: '',
        ADM2_EN: 'Ngaka Modiri Molema',
        ADM2_PCODE: 'ZA638',
        ADM1_EN: 'North West',
        ADM1_PCODE: 'ZA6',
        ADM0_EN: 'South Africa',
        ADM0_PCODE: 'ZA',
        date: '2018-12-27T00:00:00.000Z',
        validOn: '2020-11-09T00:00:00.000Z',
        validTo: '1899-11-30T00:00:00.000Z',
        ADM1_ID: 'NW',
        ADM2_ID: 'DC38',
        ADM3_ID: 'NW384',
      },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Polygon',
        coordinates: [
          [
            [24.50627000000003, -31.706830001999947],
            [24.345990001000075, -31.714480004999984],
            [24.26825000300005, -31.76666999699995],
            [24.152459995000072, -31.78860999799997],
            [24.164199997000026, -31.902410002999943],
            [24.222410000000025, -31.95564000099995],
            [24.140870001000053, -32.01170999799996],
            [24.100129996000078, -32.16399999999993],
            [23.892299997000066, -32.25494999599994],
            [23.79785000100003, -32.19407000299998],
            [23.670450002000052, -32.23767000399994],
            [23.66514999900005, -32.344229997999946],
            [23.448959998000078, -32.323269997999944],
            [23.40985000200004, -32.38919999899997],
            [23.221610003000023, -32.42503999999997],
            [23.288155001000064, -32.55120999799993],
            [23.30130999800008, -32.65178999899996],
            [23.37862000100006, -32.82501999599998],
            [23.149329996000063, -32.766739997999935],
            [23.007439997000063, -32.872819998999944],
            [22.934090000000026, -33.02165999899995],
            [22.892269998000074, -33.14163000399998],
            [22.735740001000067, -33.39476999799996],
            [22.774430000000052, -33.41974000199997],
            [22.93478000300007, -33.42914000099995],
            [23.134800004000056, -33.38762000099996],
            [23.297124998000072, -33.38864000099994],
            [23.354879999000048, -33.441169996999975],
            [23.495619998000052, -33.44344001099995],
            [23.603999999000052, -33.49640000199997],
            [23.61687000300003, -33.570239998999966],
            [23.72229000300007, -33.61748999699995],
            [24.060740003000035, -33.69838999899997],
            [24.187689996000074, -33.764760000999956],
            [24.290979996000033, -33.71189999999996],
            [24.499620832000062, -33.77845492599994],
            [24.53532000000007, -33.66285999999997],
            [24.730740001000072, -33.62038000199993],
            [24.70185000200007, -33.51453000099997],
            [24.798039996000057, -33.483420001999946],
            [24.880290003000027, -33.257470001999934],
            [25.13477000300003, -33.295069997999974],
            [25.178260000000023, -33.251679999999965],
            [25.173969998000075, -33.119599996999966],
            [25.113699999000062, -33.11572000199993],
            [25.077050000000042, -33.00292999699997],
            [25.08741000200007, -32.87103000199994],
            [24.910831407000046, -32.74323000299995],
            [24.691030004000027, -32.69167999699994],
            [24.41367999600004, -32.73698000299993],
            [24.45657920800005, -32.64081954999995],
            [24.545329996000078, -32.56204000199995],
            [24.589819996000074, -32.44383999799993],
            [24.76141000100006, -32.377580000999956],
            [24.795180001000062, -32.40922999899993],
            [24.949610000000064, -32.241180001999965],
            [24.915539999000032, -32.17211999799997],
            [24.939119998000024, -31.90504999899997],
            [24.899250004000066, -31.837270003999947],
            [24.704399998000042, -31.744279999999947],
            [24.50627000000003, -31.706830001999947],
          ],
        ],
      },
      properties: {
        Shape_Leng: 11.4667606096,
        Shape_Area: 2.75994605327,
        ADM3_EN: 'Dr Beyers Naude',
        ADM3_PCODE: 'ZA2101',
        ADM3_REF: '',
        ADM3ALT1EN: '',
        ADM3ALT2EN: '',
        ADM2_EN: 'Cacadu',
        ADM2_PCODE: 'ZA210',
        ADM1_EN: 'Eastern Cape',
        ADM1_PCODE: 'ZA2',
        ADM0_EN: 'South Africa',
        ADM0_PCODE: 'ZA',
        date: '2018-12-27T00:00:00.000Z',
        validOn: '2020-11-09T00:00:00.000Z',
        validTo: '1899-11-30T00:00:00.000Z',
        ADM1_ID: 'EC',
        ADM2_ID: 'DC10',
        ADM3_ID: 'EC101',
      },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Polygon',
        coordinates: [
          [
            [29.118499962000044, -25.10752004099993],
            [29.070663960000047, -25.06546604199997],
            [28.971709970000063, -25.070179966999945],
            [28.89165997200007, -24.955459962999953],
            [28.924069974000076, -24.901529977999928],
            [28.759379997000053, -24.91135000099996],
            [28.713779997000074, -24.95362000199998],
            [28.605540003000044, -25.003799997999977],
            [28.634289996000064, -25.058240001999934],
            [28.473739998000042, -25.08931999899994],
            [28.379259999000055, -25.155299998999965],
            [28.461599997000064, -25.20147999699998],
            [28.536829999000076, -25.152549990999944],
            [28.651569996000035, -25.142899996999972],
            [28.74458899700005, -25.10961200099996],
            [28.77541000000008, -25.18377000299995],
            [28.739590001000067, -25.28853000099997],
            [28.79100999800005, -25.328339997999933],
            [28.899134004000075, -25.235077002999958],
            [29.032259983000074, -25.249330019999945],
            [29.042509981000023, -25.140500019999934],
            [29.118499962000044, -25.10752004099993],
          ],
        ],
      },
      properties: {
        Shape_Leng: 2.54047876141,
        Shape_Area: 0.126773043614,
        ADM3_EN: 'Dr JS Moroka',
        ADM3_PCODE: 'ZA8316',
        ADM3_REF: '',
        ADM3ALT1EN: '',
        ADM3ALT2EN: '',
        ADM2_EN: 'Nkangala',
        ADM2_PCODE: 'ZA831',
        ADM1_EN: 'Mpumalanga',
        ADM1_PCODE: 'ZA8',
        ADM0_EN: 'South Africa',
        ADM0_PCODE: 'ZA',
        date: '2018-12-27T00:00:00.000Z',
        validOn: '2020-11-09T00:00:00.000Z',
        validTo: '1899-11-30T00:00:00.000Z',
        ADM1_ID: 'MP',
        ADM2_ID: 'DC31',
        ADM3_ID: 'MP316',
      },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Polygon',
        coordinates: [
          [
            [29.957625609000047, -29.78094086699997],
            [29.592859925000027, -29.577360029999966],
            [29.493708880000042, -29.586860324999975],
            [29.299845521000066, -29.49893551899993],
            [29.31973994200007, -29.581399939999983],
            [29.279189942000073, -29.644739939999965],
            [29.183429942000032, -29.66821993999997],
            [29.131659942000056, -29.825630064999928],
            [29.16882494200007, -29.912705064999955],
            [29.417289942000025, -29.969134939999947],
            [29.632879942000045, -30.033889939999938],
            [29.673859942000036, -30.079409939999948],
            [29.77227994200007, -30.061450064999974],
            [29.852376942000035, -30.117639940999936],
            [30.043649048000077, -30.056479173999946],
            [30.105759943000066, -29.97464993999995],
            [30.045361357000047, -29.829961907999973],
            [29.957625609000047, -29.78094086699997],
          ],
        ],
      },
      properties: {
        Shape_Leng: 4.10818196791,
        Shape_Area: 0.336199816895,
        ADM3_EN: 'Dr Nkosazana Dlamini Zuma',
        ADM3_PCODE: 'ZA5436',
        ADM3_REF: '',
        ADM3ALT1EN: '',
        ADM3ALT2EN: '',
        ADM2_EN: 'Sisonke',
        ADM2_PCODE: 'ZA543',
        ADM1_EN: 'KwaZulu-Natal',
        ADM1_PCODE: 'ZA5',
        ADM0_EN: 'South Africa',
        ADM0_PCODE: 'ZA',
        date: '2018-12-27T00:00:00.000Z',
        validOn: '2020-11-09T00:00:00.000Z',
        validTo: '1899-11-30T00:00:00.000Z',
        ADM1_ID: 'KZN',
        ADM2_ID: 'DC43',
        ADM3_ID: 'KZN436',
      },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Polygon',
        coordinates: [
          [
            [30.25076000100006, -26.824759995999955],
            [30.13794000100006, -26.834820003999937],
            [30.111160004000055, -26.736320001999957],
            [29.994810001000076, -26.69772000399996],
            [29.963759999000047, -26.770670001999974],
            [29.842960000000062, -26.799460003999968],
            [29.657430000000033, -26.86930000199993],
            [29.665229999000076, -26.943229998999982],
            [29.620230004000064, -27.074550002999956],
            [29.55040000300005, -27.18561000099993],
            [29.418859999000063, -27.254519999999957],
            [29.618910002000064, -27.506020001999957],
            [29.75867998600006, -27.442570014999944],
            [29.840189999000074, -27.37898998099996],
            [29.89913997700006, -27.385490027999936],
            [30.15023998600003, -27.392249985999968],
            [30.367609988000027, -27.267429979999974],
            [30.448269998000058, -27.32773993799998],
            [30.527049997000063, -27.315749989999972],
            [30.44848999900006, -27.207199997999965],
            [30.328069995000078, -27.183920000999933],
            [30.39947999900005, -27.021520000999942],
            [30.295749998000076, -27.016160000999946],
            [30.25076000100006, -26.824759995999955],
          ],
        ],
      },
      properties: {
        Shape_Leng: 4.85953823022,
        Shape_Area: 0.475832020477,
        ADM3_EN: 'Dr Pixley Ka Isaka Seme',
        ADM3_PCODE: 'ZA8304',
        ADM3_REF: '',
        ADM3ALT1EN: '',
        ADM3ALT2EN: '',
        ADM2_EN: 'Gert Sibande',
        ADM2_PCODE: 'ZA830',
        ADM1_EN: 'Mpumalanga',
        ADM1_PCODE: 'ZA8',
        ADM0_EN: 'South Africa',
        ADM0_PCODE: 'ZA',
        date: '2018-12-27T00:00:00.000Z',
        validOn: '2020-11-09T00:00:00.000Z',
        validTo: '1899-11-30T00:00:00.000Z',
        ADM1_ID: 'MP',
        ADM2_ID: 'DC30',
        ADM3_ID: 'MP304',
      },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Polygon',
        coordinates: [
          [
            [19.107040003000066, -33.54113999699996],
            [19.05773000100004, -33.200140000999966],
            [19.072419997000054, -33.127659997999956],
            [18.939005000000066, -33.19638999799997],
            [18.997350006000033, -33.307909999999936],
            [18.93405000200005, -33.49215000899994],
            [18.787539997000067, -33.637630000999934],
            [18.79257000100006, -33.81921000199998],
            [18.89678000300006, -33.79335999699998],
            [18.93153999900005, -33.87908000199997],
            [19.094160008000074, -33.831670000999964],
            [19.21404900600004, -33.857067995999955],
            [19.183989998000072, -33.715390001999936],
            [19.101960000000076, -33.606760005999945],
            [19.107040003000066, -33.54113999699996],
          ],
        ],
      },
      properties: {
        Shape_Leng: 2.78528711697,
        Shape_Area: 0.149364094634,
        ADM3_EN: 'Drakenstein',
        ADM3_PCODE: 'ZA1023',
        ADM3_REF: '',
        ADM3ALT1EN: '',
        ADM3ALT2EN: '',
        ADM2_EN: 'Cape Winelands',
        ADM2_PCODE: 'ZA102',
        ADM1_EN: 'Western Cape',
        ADM1_PCODE: 'ZA1',
        ADM0_EN: 'South Africa',
        ADM0_PCODE: 'ZA',
        date: '2018-12-27T00:00:00.000Z',
        validOn: '2020-11-09T00:00:00.000Z',
        validTo: '1899-11-30T00:00:00.000Z',
        ADM1_ID: 'WC',
        ADM2_ID: 'DC2',
        ADM3_ID: 'WC023',
      },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Polygon',
        coordinates: [
          [
            [31.14086502400005, -27.362659979999933],
            [31.100959988000056, -27.335760020999942],
            [30.95578998900004, -27.35970998299996],
            [30.922159988000033, -27.305049981999957],
            [30.829679989000056, -27.350149981999948],
            [30.706799990000036, -27.283289986999932],
            [30.527049997000063, -27.315749989999972],
            [30.448269998000058, -27.32773993799998],
            [30.509639943000025, -27.45658993799998],
            [30.58674994300003, -27.499829937999948],
            [30.66423994300004, -27.679150062999952],
            [30.95817994300006, -27.618759937999982],
            [31.048419943000056, -27.62223993799995],
            [31.087359943000024, -27.519769937999968],
            [31.189004478000072, -27.454314525999962],
            [31.14086502400005, -27.362659979999933],
          ],
        ],
      },
      properties: {
        Shape_Leng: 2.85251132913,
        Shape_Area: 0.177381266365,
        ADM3_EN: 'eDumbe',
        ADM3_PCODE: 'ZA5261',
        ADM3_REF: '',
        ADM3ALT1EN: '',
        ADM3ALT2EN: '',
        ADM2_EN: 'Zululand',
        ADM2_PCODE: 'ZA526',
        ADM1_EN: 'KwaZulu-Natal',
        ADM1_PCODE: 'ZA5',
        ADM0_EN: 'South Africa',
        ADM0_PCODE: 'ZA',
        date: '2018-12-27T00:00:00.000Z',
        validOn: '2020-11-09T00:00:00.000Z',
        validTo: '1899-11-30T00:00:00.000Z',
        ADM1_ID: 'KZN',
        ADM2_ID: 'DC26',
        ADM3_ID: 'KZN261',
      },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Polygon',
        coordinates: [
          [
            [28.50305499700005, -26.063800002999983],
            [28.407189997000046, -25.924090001999957],
            [28.181050000000027, -25.91954999799998],
            [28.158183001000054, -26.038249999999948],
            [28.184829997000065, -26.089259998999978],
            [28.112739996000073, -26.167779997999958],
            [28.122851998000044, -26.247929002999967],
            [28.067101999000045, -26.34194000399998],
            [28.076060002000077, -26.415370002999964],
            [28.22039999900005, -26.43628000399997],
            [28.27401000100008, -26.358679997999957],
            [28.45023000200007, -26.440749996999955],
            [28.517879997000023, -26.361959997999975],
            [28.52715000300003, -26.178740003999962],
            [28.50305499700005, -26.063800002999983],
          ],
        ],
      },
      properties: {
        Shape_Leng: 2.80955042854,
        Shape_Area: 0.178388166811,
        ADM3_EN: 'Ekurhuleni',
        ADM3_PCODE: 'ZA7970',
        ADM3_REF: '',
        ADM3ALT1EN: '',
        ADM3ALT2EN: '',
        ADM2_EN: 'Ekurhuleni',
        ADM2_PCODE: 'ZA797',
        ADM1_EN: 'Gauteng',
        ADM1_PCODE: 'ZA7',
        ADM0_EN: 'South Africa',
        ADM0_PCODE: 'ZA',
        date: '2018-12-27T00:00:00.000Z',
        validOn: '2020-11-09T00:00:00.000Z',
        validTo: '1899-11-30T00:00:00.000Z',
        ADM1_ID: 'GT',
        ADM2_ID: 'EKU',
        ADM3_ID: 'EKU',
      },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Polygon',
        coordinates: [
          [
            [29.978949982000074, -25.09211998199993],
            [29.905889985000044, -25.047489970999948],
            [29.90509600200005, -24.93239899899993],
            [29.88128794800008, -24.977264050999963],
            [29.71831994300004, -25.000330059999953],
            [29.63672994600006, -24.95306005699996],
            [29.264749942000037, -25.09795006099995],
            [29.20069994200003, -25.05465006099996],
            [29.118499962000044, -25.10752004099993],
            [29.042509981000023, -25.140500019999934],
            [29.032259983000074, -25.249330019999945],
            [29.166959960000042, -25.30336004199995],
            [29.264433960000076, -25.37546304199998],
            [29.36245997900005, -25.407110020999937],
            [29.51882997900003, -25.42279002199996],
            [29.67385997200006, -25.37216002899993],
            [29.77023997200007, -25.401530028999957],
            [29.88791996200007, -25.338579954999943],
            [29.990589983000064, -25.33825002599997],
            [30.009839971000076, -25.231280030999983],
            [29.978949982000074, -25.09211998199993],
          ],
        ],
      },
      properties: {
        Shape_Leng: 3.39971717425,
        Shape_Area: 0.332586185219,
        ADM3_EN: 'Elias Motsoaledi',
        ADM3_PCODE: 'ZA9472',
        ADM3_REF: '',
        ADM3ALT1EN: '',
        ADM3ALT2EN: '',
        ADM2_EN: 'Sekhukhune',
        ADM2_PCODE: 'ZA947',
        ADM1_EN: 'Limpopo',
        ADM1_PCODE: 'ZA9',
        ADM0_EN: 'South Africa',
        ADM0_PCODE: 'ZA',
        date: '2018-12-27T00:00:00.000Z',
        validOn: '2020-11-09T00:00:00.000Z',
        validTo: '1899-11-30T00:00:00.000Z',
        ADM1_ID: 'LIM',
        ADM2_ID: 'DC47',
        ADM3_ID: 'LIM472',
      },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Polygon',
        coordinates: [
          [
            [28.560369998000056, -30.655260001999977],
            [28.569840000000056, -30.49629000599998],
            [28.480840004000072, -30.422299996999982],
            [28.268770003000043, -30.37372999699994],
            [28.17955999700007, -30.438919987999952],
            [28.17735000400006, -30.522410002999948],
            [28.114130001000035, -30.59903000199995],
            [28.117680000000064, -30.668669996999938],
            [28.132130000000075, -30.83530000199994],
            [27.981575001000067, -31.07651500099996],
            [27.985490002000063, -31.15199000299998],
            [27.931252005000033, -31.234014000999935],
            [28.08077000000003, -31.32375000199994],
            [28.216159997000034, -31.31280000299995],
            [28.260700004000057, -31.37043999699995],
            [28.38126500100003, -31.48000000099995],
            [28.38231999900006, -31.48055000499994],
            [28.49925999800007, -31.33262999899995],
            [28.497800006000034, -31.250270003999958],
            [28.61938999800003, -31.236869998999964],
            [28.67548000000005, -31.134970003999968],
            [28.52592000100003, -31.048859997999955],
            [28.63861000000003, -30.920929998999952],
            [28.641113076000067, -30.772916348999956],
            [28.560369998000056, -30.655260001999977],
          ],
        ],
      },
      properties: {
        Shape_Leng: 4.90757707541,
        Shape_Area: 0.473624936114,
        ADM3_EN: 'Elundini',
        ADM3_PCODE: 'ZA2141',
        ADM3_REF: '',
        ADM3ALT1EN: '',
        ADM3ALT2EN: '',
        ADM2_EN: 'Joe Gqabi',
        ADM2_PCODE: 'ZA214',
        ADM1_EN: 'Eastern Cape',
        ADM1_PCODE: 'ZA2',
        ADM0_EN: 'South Africa',
        ADM0_PCODE: 'ZA',
        date: '2018-12-27T00:00:00.000Z',
        validOn: '2020-11-09T00:00:00.000Z',
        validTo: '1899-11-30T00:00:00.000Z',
        ADM1_ID: 'EC',
        ADM2_ID: 'DC14',
        ADM3_ID: 'EC141',
      },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Polygon',
        coordinates: [
          [
            [30.448269998000058, -27.32773993799998],
            [30.367609988000027, -27.267429979999974],
            [30.15023998600003, -27.392249985999968],
            [29.89913997700006, -27.385490027999936],
            [29.920159942000055, -27.57922993799997],
            [30.081719943000053, -27.724890062999975],
            [30.21058994300006, -27.732319937999932],
            [30.208594943000037, -27.788359937999928],
            [30.280709943000033, -27.81498993799994],
            [30.292336943000066, -27.95119393899995],
            [30.386210068000025, -27.93055993799993],
            [30.43239094300003, -27.97368006399995],
            [30.56970006800003, -28.008950063999976],
            [30.60214006800004, -27.93359993799993],
            [30.66423994300004, -27.679150062999952],
            [30.58674994300003, -27.499829937999948],
            [30.509639943000025, -27.45658993799998],
            [30.448269998000058, -27.32773993799998],
          ],
        ],
      },
      properties: {
        Shape_Leng: 3.87819889259,
        Shape_Area: 0.323580843682,
        ADM3_EN: 'Emadlangeni',
        ADM3_PCODE: 'ZA5253',
        ADM3_REF: '',
        ADM3ALT1EN: '',
        ADM3ALT2EN: '',
        ADM2_EN: 'Amajuba',
        ADM2_PCODE: 'ZA525',
        ADM1_EN: 'KwaZulu-Natal',
        ADM1_PCODE: 'ZA5',
        ADM0_EN: 'South Africa',
        ADM0_PCODE: 'ZA',
        date: '2018-12-27T00:00:00.000Z',
        validOn: '2020-11-09T00:00:00.000Z',
        validTo: '1899-11-30T00:00:00.000Z',
        ADM1_ID: 'KZN',
        ADM2_ID: 'DC25',
        ADM3_ID: 'KZN253',
      },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Polygon',
        coordinates: [
          [
            [30.449239999000042, -25.34495999799998],
            [30.35099000100007, -25.492479996999975],
            [30.22945999800004, -25.432410000999937],
            [30.190750003000062, -25.275810001999957],
            [30.143230006000067, -25.245810008999968],
            [30.025460004000024, -25.367719999999963],
            [29.990589983000064, -25.33825002599997],
            [29.88791996200007, -25.338579954999943],
            [29.77023997200007, -25.401530028999957],
            [29.67385997200006, -25.37216002899993],
            [29.51882997900003, -25.42279002199996],
            [29.58592999600006, -25.581449997999982],
            [29.713110003000054, -25.572179999999946],
            [29.825900000000047, -25.701420002999953],
            [29.80094000300005, -25.84876000199995],
            [29.86179000100003, -25.862450002999935],
            [29.943750004000037, -25.905660000999944],
            [30.21375000200004, -25.804019998999934],
            [30.299050002000058, -25.92637999699997],
            [30.381149996000033, -25.886899995999954],
            [30.61119000900004, -25.719020000999933],
            [30.64662999500007, -25.71242000899997],
            [30.665619998000068, -25.672980000999928],
            [30.565345999000044, -25.481235995999953],
            [30.48011000200006, -25.45239000199996],
            [30.449239999000042, -25.34495999799998],
          ],
        ],
      },
      properties: {
        Shape_Leng: 4.46655682509,
        Shape_Area: 0.425526659129,
        ADM3_EN: 'Emakhazeni',
        ADM3_PCODE: 'ZA8314',
        ADM3_REF: '',
        ADM3ALT1EN: '',
        ADM3ALT2EN: '',
        ADM2_EN: 'Nkangala',
        ADM2_PCODE: 'ZA831',
        ADM1_EN: 'Mpumalanga',
        ADM1_PCODE: 'ZA8',
        ADM0_EN: 'South Africa',
        ADM0_PCODE: 'ZA',
        date: '2018-12-27T00:00:00.000Z',
        validOn: '2020-11-09T00:00:00.000Z',
        validTo: '1899-11-30T00:00:00.000Z',
        ADM1_ID: 'MP',
        ADM2_ID: 'DC31',
        ADM3_ID: 'MP314',
      },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Polygon',
        coordinates: [
          [
            [27.437136002000045, -31.676665999999955],
            [27.482256434000078, -31.58604907299997],
            [27.474440000000072, -31.481229999999982],
            [27.59864000300007, -31.443719990999966],
            [27.57744999700003, -31.38920000199994],
            [27.62412000300003, -31.224029996999946],
            [27.569559997000056, -31.209089997999968],
            [27.45131000200007, -31.25719000199996],
            [27.408460002000027, -31.418459998999936],
            [27.275999996000053, -31.339759998999966],
            [27.175179998000033, -31.367779996999957],
            [27.130789996000033, -31.42660000099994],
            [27.047469999000043, -31.34454999899998],
            [26.93464499600003, -31.343969998999967],
            [26.846869999000035, -31.435850002999928],
            [26.86690999700005, -31.584949996999967],
            [26.848800002000075, -31.691829996999957],
            [26.980839996000043, -31.82716000499994],
            [27.208040002000075, -31.96216999799998],
            [27.27276160400004, -31.933650016999934],
            [27.407873005000056, -31.895912003999968],
            [27.434009997000032, -31.80967900299993],
            [27.39869999600006, -31.72566999999998],
            [27.437136002000045, -31.676665999999955],
          ],
        ],
      },
      properties: {
        Shape_Leng: 3.90946024818,
        Shape_Area: 0.331105850947,
        ADM3_EN: 'Emalahleni',
        ADM3_PCODE: 'ZA2136',
        ADM3_REF: '',
        ADM3ALT1EN: '',
        ADM3ALT2EN: '',
        ADM2_EN: 'Chris Hani',
        ADM2_PCODE: 'ZA213',
        ADM1_EN: 'Eastern Cape',
        ADM1_PCODE: 'ZA2',
        ADM0_EN: 'South Africa',
        ADM0_PCODE: 'ZA',
        date: '2018-12-27T00:00:00.000Z',
        validOn: '2020-11-09T00:00:00.000Z',
        validTo: '1899-11-30T00:00:00.000Z',
        ADM1_ID: 'EC',
        ADM2_ID: 'DC13',
        ADM3_ID: 'EC136',
      },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Polygon',
        coordinates: [
          [
            [29.289129996000042, -25.74535999799997],
            [29.117270000000076, -25.656499999999937],
            [29.00829000300007, -25.66057000099994],
            [28.938169999000024, -25.823284995999927],
            [28.94107000200006, -25.877290002999928],
            [28.95366000100006, -25.97478000199993],
            [28.919584000000043, -26.100004998999964],
            [28.99935000100004, -26.120870002999936],
            [28.984219996000036, -26.23693000999998],
            [29.033262001000026, -26.225760002999948],
            [29.12359000200007, -26.38428999699994],
            [29.173069997000027, -26.34888999599997],
            [29.335469998000065, -26.348330001999955],
            [29.387970000000053, -26.20490000099994],
            [29.40244799900006, -26.063212007999937],
            [29.327979998000046, -25.791719995999983],
            [29.289129996000042, -25.74535999799997],
          ],
        ],
      },
      properties: {
        Shape_Leng: 2.91551234476,
        Shape_Area: 0.24144083883,
        ADM3_EN: 'Emalahleni',
        ADM3_PCODE: 'ZA8312',
        ADM3_REF: '',
        ADM3ALT1EN: '',
        ADM3ALT2EN: '',
        ADM2_EN: 'Nkangala',
        ADM2_PCODE: 'ZA831',
        ADM1_EN: 'Mpumalanga',
        ADM1_PCODE: 'ZA8',
        ADM0_EN: 'South Africa',
        ADM0_PCODE: 'ZA',
        date: '2018-12-27T00:00:00.000Z',
        validOn: '2020-11-09T00:00:00.000Z',
        validTo: '1899-11-30T00:00:00.000Z',
        ADM1_ID: 'MP',
        ADM2_ID: 'DC31',
        ADM3_ID: 'MP312',
      },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Polygon',
        coordinates: [
          [
            [27.887210001000028, -26.526250000999937],
            [27.759710004000056, -26.48386998799998],
            [27.76128999900004, -26.419150000999934],
            [27.675980000000038, -26.52434999999997],
            [27.667929998000034, -26.610549996999964],
            [27.579600001000074, -26.60752999899995],
            [27.569090002000053, -26.647160003999943],
            [27.590429997000058, -26.73836000299997],
            [27.716306001000078, -26.761676999999963],
            [27.873640003000048, -26.747630000999948],
            [27.940960001000064, -26.675899998999967],
            [28.000489998000035, -26.703320000999952],
            [27.962234996000063, -26.644136996999976],
            [27.983020000000067, -26.555829996999933],
            [27.887210001000028, -26.526250000999937],
          ],
        ],
      },
      properties: {
        Shape_Leng: 2.058279028,
        Shape_Area: 0.0875449433909,
        ADM3_EN: 'Emfuleni',
        ADM3_PCODE: 'ZA7421',
        ADM3_REF: '',
        ADM3ALT1EN: '',
        ADM3ALT2EN: '',
        ADM2_EN: 'Sedibeng',
        ADM2_PCODE: 'ZA742',
        ADM1_EN: 'Gauteng',
        ADM1_PCODE: 'ZA7',
        ADM0_EN: 'South Africa',
        ADM0_PCODE: 'ZA',
        date: '2018-12-27T00:00:00.000Z',
        validOn: '2020-11-09T00:00:00.000Z',
        validTo: '1899-11-30T00:00:00.000Z',
        ADM1_ID: 'GT',
        ADM2_ID: 'DC42',
        ADM3_ID: 'GT421',
      },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Polygon',
        coordinates: [
          [
            [23.84207999800003, -30.195130001999928],
            [23.776339997000036, -30.103039999999964],
            [23.64245999800005, -30.14434999799994],
            [23.497719998000036, -30.058619999999962],
            [23.352890002000038, -30.066130000999976],
            [23.239449998000055, -29.901959990999956],
            [23.183677033000038, -29.938064673999975],
            [23.206658358000027, -30.039386014999934],
            [23.113139998000065, -30.15642999199997],
            [22.982039997000072, -30.238129999999956],
            [22.997989996000058, -30.377350010999976],
            [23.230259997000076, -30.39873000199998],
            [23.242530001000034, -30.54131999699996],
            [23.094329997000045, -30.56744999899996],
            [23.064460002000033, -30.65116999299994],
            [23.067449999000075, -30.799329997999962],
            [23.109370006000063, -30.828209998999967],
            [23.22530000300003, -30.95372999799997],
            [23.325510000000065, -30.95398999599996],
            [23.40172999200007, -31.034099999999967],
            [23.513484996000045, -30.950600004999956],
            [23.556749640000078, -31.007575371999962],
            [23.65829862000004, -30.89690928799996],
            [23.70332011100004, -30.941973490999942],
            [23.86042999400007, -30.864940004999937],
            [23.987642298000026, -30.910912614999972],
            [24.13678764200006, -31.042860877999942],
            [24.152299998000046, -31.18035000599997],
            [24.23489000400008, -31.21799999999996],
            [24.265629998000065, -31.324039997999932],
            [24.387529998000048, -31.386800001999973],
            [24.400949998000044, -31.443599991999974],
            [24.56719000100003, -31.41864000099997],
            [24.82237615400004, -31.04039404699995],
            [24.757820000000038, -30.870549997999944],
            [24.644425397000077, -30.751596894999977],
            [24.54078180600004, -30.731442956999956],
            [24.452420000000075, -30.658369997999955],
            [24.274300003000064, -30.583859995999944],
            [24.277617081000074, -30.448922981999942],
            [24.018870006000043, -30.339969998999948],
            [23.84207999800003, -30.195130001999928],
          ],
        ],
      },
      properties: {
        Shape_Leng: 7.83208075781,
        Shape_Area: 1.26821904043,
        ADM3_EN: 'Emthanjeni',
        ADM3_PCODE: 'ZA3073',
        ADM3_REF: '',
        ADM3ALT1EN: '',
        ADM3ALT2EN: '',
        ADM2_EN: 'Pixley ka Seme',
        ADM2_PCODE: 'ZA307',
        ADM1_EN: 'Nothern Cape',
        ADM1_PCODE: 'ZA3',
        ADM0_EN: 'South Africa',
        ADM0_PCODE: 'ZA',
        date: '2018-12-27T00:00:00.000Z',
        validOn: '2020-11-09T00:00:00.000Z',
        validTo: '1899-11-30T00:00:00.000Z',
        ADM1_ID: 'NC',
        ADM2_ID: 'DC7',
        ADM3_ID: 'NC073',
      },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Polygon',
        coordinates: [
          [
            [30.56970006800003, -28.008950063999976],
            [30.43239094300003, -27.97368006399995],
            [30.386210068000025, -27.93055993799993],
            [30.292336943000066, -27.95119393899995],
            [30.13208994300004, -28.177439938999953],
            [29.99042994200005, -28.18492993899997],
            [29.97679394200003, -28.239587938999932],
            [30.23359494300007, -28.408709938999948],
            [30.35194994300008, -28.266459938999958],
            [30.505729943000063, -28.262689938999983],
            [30.51365994300005, -28.171299938999937],
            [30.56970006800003, -28.008950063999976],
          ],
        ],
      },
      properties: {
        Shape_Leng: 2.52472355537,
        Shape_Area: 0.147952929412,
        ADM3_EN: 'Endumeni',
        ADM3_PCODE: 'ZA5241',
        ADM3_REF: '',
        ADM3ALT1EN: '',
        ADM3ALT2EN: '',
        ADM2_EN: 'Umzinyathi',
        ADM2_PCODE: 'ZA524',
        ADM1_EN: 'KwaZulu-Natal',
        ADM1_PCODE: 'ZA5',
        ADM0_EN: 'South Africa',
        ADM0_PCODE: 'ZA',
        date: '2018-12-27T00:00:00.000Z',
        validOn: '2020-11-09T00:00:00.000Z',
        validTo: '1899-11-30T00:00:00.000Z',
        ADM1_ID: 'KZN',
        ADM2_ID: 'DC24',
        ADM3_ID: 'KZN241',
      },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Polygon',
        coordinates: [
          [
            [28.38126500100003, -31.48000000099995],
            [28.260700004000057, -31.37043999699995],
            [28.156989999000075, -31.40189999699993],
            [28.04843999700006, -31.50576999599997],
            [27.97181999000003, -31.537730001999932],
            [27.746920001000035, -31.556189996999933],
            [27.758459997000045, -31.65649000899998],
            [27.879180003000045, -31.81473000099993],
            [28.016820001000042, -31.87285000399993],
            [27.98333358800005, -31.98428535499994],
            [28.010034442000062, -32.03639166599993],
            [28.01884885800007, -32.043181292999975],
            [28.19468000300003, -31.96641000099993],
            [28.263330001000043, -31.791320002999953],
            [28.351969998000072, -31.828649999999982],
            [28.309010002000036, -31.618319996999958],
            [28.38110000300003, -31.558009996999942],
            [28.38126500100003, -31.48000000099995],
          ],
        ],
      },
      properties: {
        Shape_Leng: 3.00382138415,
        Shape_Area: 0.236253770028,
        ADM3_EN: 'Engcobo',
        ADM3_PCODE: 'ZA2137',
        ADM3_REF: '',
        ADM3ALT1EN: '',
        ADM3ALT2EN: '',
        ADM2_EN: 'Chris Hani',
        ADM2_PCODE: 'ZA213',
        ADM1_EN: 'Eastern Cape',
        ADM1_PCODE: 'ZA2',
        ADM0_EN: 'South Africa',
        ADM0_PCODE: 'ZA',
        date: '2018-12-27T00:00:00.000Z',
        validOn: '2020-11-09T00:00:00.000Z',
        validTo: '1899-11-30T00:00:00.000Z',
        ADM1_ID: 'EC',
        ADM2_ID: 'DC13',
        ADM3_ID: 'EC137',
      },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Polygon',
        coordinates: [
          [
            [26.846869999000035, -31.435850002999928],
            [26.743230006000033, -31.417259999999942],
            [26.633320001000072, -31.455249996999953],
            [26.61266000300003, -31.371979990999932],
            [26.70870000000008, -31.27709999999996],
            [26.628740004000065, -31.22938999799993],
            [26.426300000000026, -31.184740002999945],
            [26.237009998000076, -31.224320000999967],
            [26.20341999900006, -31.27723999899996],
            [26.033190004000062, -31.332179999999937],
            [25.965890002000037, -31.47676999999993],
            [25.769259997000063, -31.444140002999973],
            [25.589330002000054, -31.48531000199995],
            [25.61735999700005, -31.577260000999956],
            [25.454490001000067, -31.684599997999953],
            [25.634099999000057, -31.839609996999968],
            [25.850160000000074, -31.908890000999975],
            [25.99953000100004, -32.005000001999974],
            [26.076000003000047, -32.11261999599998],
            [26.20688999600003, -32.16447000299996],
            [26.191329997000025, -32.285230000999945],
            [26.30962000100004, -32.37600999599994],
            [26.53369001200008, -32.36017999799998],
            [26.662449998000056, -32.42792999899996],
            [26.775780000000054, -32.333279999999945],
            [27.010920000000056, -32.22249999999997],
            [27.16072999900007, -32.23849999799995],
            [27.451350003000073, -32.35220999699993],
            [27.507879998000078, -32.230749996999975],
            [27.39748000000003, -32.136169999999936],
            [27.41182000300006, -32.09891999799993],
            [27.27276160400004, -31.933650016999934],
            [27.208040002000075, -31.96216999799998],
            [26.980839996000043, -31.82716000499994],
            [26.848800002000075, -31.691829996999957],
            [26.86690999700005, -31.584949996999967],
            [26.846869999000035, -31.435850002999928],
          ],
        ],
      },
      properties: {
        Shape_Leng: 8.28544365363,
        Shape_Area: 1.29408915301,
        ADM3_EN: 'Enoch Mgijima',
        ADM3_PCODE: 'ZA2139',
        ADM3_REF: '',
        ADM3ALT1EN: '',
        ADM3ALT2EN: '',
        ADM2_EN: 'Chris Hani',
        ADM2_PCODE: 'ZA213',
        ADM1_EN: 'Eastern Cape',
        ADM1_PCODE: 'ZA2',
        ADM0_EN: 'South Africa',
        ADM0_PCODE: 'ZA',
        date: '2018-12-27T00:00:00.000Z',
        validOn: '2020-11-09T00:00:00.000Z',
        validTo: '1899-11-30T00:00:00.000Z',
        ADM1_ID: 'EC',
        ADM2_ID: 'DC13',
        ADM3_ID: 'EC139',
      },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Polygon',
        coordinates: [
          [
            [29.63672994600006, -24.95306005699996],
            [29.744279943000038, -24.791230060999965],
            [29.63471994400004, -24.80052005999994],
            [29.478030018000027, -24.763619981999966],
            [29.434069945000033, -24.709770056999957],
            [29.470755001000043, -24.640615002999937],
            [29.400489983000057, -24.608530019999932],
            [29.369900037000036, -24.663356028999942],
            [29.247380000000078, -24.71360999999996],
            [29.183149963000062, -24.939920040999937],
            [29.082879972000057, -24.981209941999964],
            [29.05592998000003, -24.912259990999928],
            [28.924069974000076, -24.901529977999928],
            [28.89165997200007, -24.955459962999953],
            [28.971709970000063, -25.070179966999945],
            [29.070663960000047, -25.06546604199997],
            [29.118499962000044, -25.10752004099993],
            [29.20069994200003, -25.05465006099996],
            [29.264749942000037, -25.09795006099995],
            [29.63672994600006, -24.95306005699996],
          ],
        ],
      },
      properties: {
        Shape_Leng: 3.08051261568,
        Shape_Area: 0.17972156316,
        ADM3_EN: 'Ephraim Mogale',
        ADM3_PCODE: 'ZA9471',
        ADM3_REF: '',
        ADM3ALT1EN: '',
        ADM3ALT2EN: '',
        ADM2_EN: 'Sekhukhune',
        ADM2_PCODE: 'ZA947',
        ADM1_EN: 'Limpopo',
        ADM1_PCODE: 'ZA9',
        ADM0_EN: 'South Africa',
        ADM0_PCODE: 'ZA',
        date: '2018-12-27T00:00:00.000Z',
        validOn: '2020-11-09T00:00:00.000Z',
        validTo: '1899-11-30T00:00:00.000Z',
        ADM1_ID: 'LIM',
        ADM2_ID: 'DC47',
        ADM3_ID: 'LIM471',
      },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Polygon',
        coordinates: [
          [
            [31.185754944000053, -29.57178493999993],
            [31.094409943000073, -29.538089939999963],
            [30.84250994300004, -29.62561993999998],
            [30.727179943000067, -29.57093993999996],
            [30.673752943000068, -29.619902064999962],
            [30.569389943000033, -29.731649939999954],
            [30.575999943000056, -29.831499939999958],
            [30.675250068000025, -29.92222093999993],
            [30.59611407400007, -30.12389829899996],
            [30.691450991000067, -30.149606948999974],
            [30.76486794300007, -30.26878394099998],
            [30.898679943000047, -30.041720064999936],
            [31.061419943000033, -29.87597993999998],
            [31.038409943000033, -29.823229939999976],
            [31.185754944000053, -29.57178493999993],
          ],
        ],
      },
      properties: {
        Shape_Leng: 3.14570916702,
        Shape_Area: 0.238577643459,
        ADM3_EN: 'eThekwini',
        ADM3_PCODE: 'ZA5950',
        ADM3_REF: '',
        ADM3ALT1EN: '',
        ADM3ALT2EN: '',
        ADM2_EN: 'eThekwini',
        ADM2_PCODE: 'ZA595',
        ADM1_EN: 'KwaZulu-Natal',
        ADM1_PCODE: 'ZA5',
        ADM0_EN: 'South Africa',
        ADM0_PCODE: 'ZA',
        date: '2018-12-27T00:00:00.000Z',
        validOn: '2020-11-09T00:00:00.000Z',
        validTo: '1899-11-30T00:00:00.000Z',
        ADM1_ID: 'KZN',
        ADM2_ID: 'ETH',
        ADM3_ID: 'ETH',
      },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Polygon',
        coordinates: [
          [
            [24.01494999700003, -27.32367000599993],
            [23.936559998000064, -27.410819997999965],
            [23.81460000000004, -27.478799993999928],
            [23.767069999000057, -27.55323999899997],
            [23.610819999000057, -27.472440004999953],
            [23.56404368500006, -27.33500288299996],
            [23.476216212000054, -27.29184161099994],
            [23.394121518000077, -27.29911970099994],
            [23.17809199800007, -27.135831004999943],
            [23.132359992000033, -27.236959997999975],
            [23.27180256200006, -27.378535727999974],
            [23.372723996000047, -27.464460996999946],
            [23.264870004000045, -27.519079998999928],
            [23.28857000200003, -27.71421000299995],
            [23.16024999900003, -27.728569997999955],
            [23.085480007000058, -27.844829997999966],
            [23.097749994000026, -27.888769999999965],
            [23.11221000200004, -27.962780004999956],
            [23.362025980000055, -27.942167130999962],
            [23.443899998000063, -27.955179999999928],
            [23.580930004000038, -27.879310000999965],
            [23.644100000000037, -27.833489998999937],
            [24.111000001000036, -27.73898000099996],
            [24.118620004000036, -27.621739997999953],
            [24.050610001000052, -27.602729996999983],
            [24.05751000300006, -27.429419999999936],
            [24.08627000100006, -27.35349000399998],
            [24.01494999700003, -27.32367000599993],
          ],
        ],
      },
      properties: {
        Shape_Leng: 4.28678734682,
        Shape_Area: 0.410953773525,
        ADM3_EN: 'Ga-Segonyana',
        ADM3_PCODE: 'ZA3452',
        ADM3_REF: '',
        ADM3ALT1EN: '',
        ADM3ALT2EN: '',
        ADM2_EN: 'John Taolo Gaetsewe',
        ADM2_PCODE: 'ZA345',
        ADM1_EN: 'Nothern Cape',
        ADM1_PCODE: 'ZA3',
        ADM0_EN: 'South Africa',
        ADM0_PCODE: 'ZA',
        date: '2018-12-27T00:00:00.000Z',
        validOn: '2020-11-09T00:00:00.000Z',
        validTo: '1899-11-30T00:00:00.000Z',
        ADM1_ID: 'NC',
        ADM2_ID: 'DC45',
        ADM3_ID: 'NC452',
      },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Polygon',
        coordinates: [
          [
            [23.097749994000026, -27.888769999999965],
            [23.085480007000058, -27.844829997999966],
            [23.16024999900003, -27.728569997999955],
            [23.28857000200003, -27.71421000299995],
            [23.264870004000045, -27.519079998999928],
            [23.372723996000047, -27.464460996999946],
            [23.27180256200006, -27.378535727999974],
            [23.21585000400006, -27.41918999799998],
            [22.837420001000055, -27.39042000099994],
            [22.84454000100004, -27.543719993999957],
            [22.714579996000055, -27.549159994999968],
            [22.70051000600006, -27.687049999999942],
            [22.80168999700004, -27.792869998999947],
            [22.73954999500006, -27.850730004999946],
            [22.727434177000077, -27.930350277999935],
            [22.772809996000035, -27.98414000599996],
            [22.933089995000046, -27.887949998999943],
            [23.023049999000023, -27.857989999999972],
            [23.097749994000026, -27.888769999999965],
          ],
        ],
      },
      properties: {
        Shape_Leng: 2.93883672465,
        Shape_Area: 0.242139367758,
        ADM3_EN: 'Gamagara',
        ADM3_PCODE: 'ZA3453',
        ADM3_REF: '',
        ADM3ALT1EN: '',
        ADM3ALT2EN: '',
        ADM2_EN: 'John Taolo Gaetsewe',
        ADM2_PCODE: 'ZA345',
        ADM1_EN: 'Nothern Cape',
        ADM1_PCODE: 'ZA3',
        ADM0_EN: 'South Africa',
        ADM0_PCODE: 'ZA',
        date: '2018-12-27T00:00:00.000Z',
        validOn: '2020-11-09T00:00:00.000Z',
        validTo: '1899-11-30T00:00:00.000Z',
        ADM1_ID: 'NC',
        ADM2_ID: 'DC45',
        ADM3_ID: 'NC453',
      },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Polygon',
        coordinates: [
          [
            [23.61687000300003, -33.570239998999966],
            [23.603999999000052, -33.49640000199997],
            [23.495619998000052, -33.44344001099995],
            [23.354879999000048, -33.441169996999975],
            [23.297124998000072, -33.38864000099994],
            [23.134800004000056, -33.38762000099996],
            [22.93478000300007, -33.42914000099995],
            [22.774430000000052, -33.41974000199997],
            [22.716079999000044, -33.531680000999984],
            [22.755659997000066, -33.64072999299998],
            [22.588689998000063, -33.636669997999945],
            [22.371800003000033, -33.659389991999944],
            [22.36878000400003, -33.792810000999964],
            [22.233749998000064, -33.888240003999954],
            [22.27986000100003, -34.02149000299994],
            [22.35457000100007, -34.05442999999997],
            [22.484639999000024, -34.05125999599994],
            [22.563649999000063, -33.99610999999993],
            [22.770545002000063, -34.02744999899994],
            [22.800279998000065, -33.84118000299998],
            [22.876550004000023, -33.815959996999936],
            [23.076460000000054, -33.80858000199993],
            [23.22901000300004, -33.87834999699993],
            [23.33441000600004, -33.85656000299997],
            [23.395039996000037, -33.79263999899996],
            [23.43994000200007, -33.717390000999956],
            [23.555529998000054, -33.67295999799995],
            [23.670440004000056, -33.67255999799994],
            [23.61687000300003, -33.570239998999966],
          ],
        ],
      },
      properties: {
        Shape_Leng: 4.87896943981,
        Shape_Area: 0.504793300972,
        ADM3_EN: 'George',
        ADM3_PCODE: 'ZA1044',
        ADM3_REF: '',
        ADM3ALT1EN: '',
        ADM3ALT2EN: '',
        ADM2_EN: 'Eden',
        ADM2_PCODE: 'ZA104',
        ADM1_EN: 'Western Cape',
        ADM1_PCODE: 'ZA1',
        ADM0_EN: 'South Africa',
        ADM0_PCODE: 'ZA',
        date: '2018-12-27T00:00:00.000Z',
        validOn: '2020-11-09T00:00:00.000Z',
        validTo: '1899-11-30T00:00:00.000Z',
        ADM1_ID: 'WC',
        ADM2_ID: 'DC4',
        ADM3_ID: 'WC044',
      },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Polygon',
        coordinates: [
          [
            [29.540350001000036, -26.253879996999956],
            [29.493449996000038, -26.16954999899997],
            [29.387970000000053, -26.20490000099994],
            [29.335469998000065, -26.348330001999955],
            [29.173069997000027, -26.34888999599997],
            [29.12359000200007, -26.38428999699994],
            [29.033262001000026, -26.225760002999948],
            [28.984219996000036, -26.23693000999998],
            [28.886340003000043, -26.257710001999953],
            [28.838440003000073, -26.340750001999936],
            [28.763910003000035, -26.518009998999958],
            [28.83678999700004, -26.536380003999966],
            [28.897497628000053, -26.62397787699996],
            [28.99211000400004, -26.608889999999974],
            [28.99120000000005, -26.685969996999972],
            [29.24139999700003, -26.716839999999934],
            [29.22379999900005, -26.658330002999946],
            [29.459380003000035, -26.64670999699996],
            [29.486830000000054, -26.55331000299998],
            [29.61916999500005, -26.52905999799998],
            [29.629110001000072, -26.48149000099994],
            [29.468669998000053, -26.352490001999968],
            [29.540350001000036, -26.253879996999956],
          ],
        ],
      },
      properties: {
        Shape_Leng: 3.38955863153,
        Shape_Area: 0.26743359283,
        ADM3_EN: 'Govan Mbeki',
        ADM3_PCODE: 'ZA8307',
        ADM3_REF: '',
        ADM3ALT1EN: '',
        ADM3ALT2EN: '',
        ADM2_EN: 'Gert Sibande',
        ADM2_PCODE: 'ZA830',
        ADM1_EN: 'Mpumalanga',
        ADM1_PCODE: 'ZA8',
        ADM0_EN: 'South Africa',
        ADM0_PCODE: 'ZA',
        date: '2018-12-27T00:00:00.000Z',
        validOn: '2020-11-09T00:00:00.000Z',
        validTo: '1899-11-30T00:00:00.000Z',
        ADM1_ID: 'MP',
        ADM2_ID: 'DC30',
        ADM3_ID: 'MP307',
      },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Polygon',
        coordinates: [
          [
            [28.38763500300007, -32.67960000199997],
            [28.14542000000006, -32.50955998899997],
            [28.047360000000026, -32.53638000299998],
            [27.893980003000024, -32.45614999999998],
            [27.787990002000072, -32.52757000199995],
            [27.677970001000062, -32.66043999699997],
            [27.78268999900007, -32.74894000399996],
            [27.882910001000027, -32.78550000299998],
            [27.95717783400005, -32.75833922499993],
            [27.991459946000077, -32.85556183399996],
            [28.075529994000078, -32.907794999999965],
            [28.117580002000068, -32.83005999799997],
            [28.38763500300007, -32.67960000199997],
          ],
        ],
      },
      properties: {
        Shape_Leng: 3.11445940711,
        Shape_Area: 0.163395794292,
        ADM3_EN: 'Great Kei',
        ADM3_PCODE: 'ZA2123',
        ADM3_REF: '',
        ADM3ALT1EN: '',
        ADM3ALT2EN: '',
        ADM2_EN: 'Amathole',
        ADM2_PCODE: 'ZA212',
        ADM1_EN: 'Eastern Cape',
        ADM1_PCODE: 'ZA2',
        ADM0_EN: 'South Africa',
        ADM0_PCODE: 'ZA',
        date: '2018-12-27T00:00:00.000Z',
        validOn: '2020-11-09T00:00:00.000Z',
        validTo: '1899-11-30T00:00:00.000Z',
        ADM1_ID: 'EC',
        ADM2_ID: 'DC12',
        ADM3_ID: 'EC123',
      },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Polygon',
        coordinates: [
          [
            [31.561423243000036, -23.224282794999965],
            [31.41187095600003, -23.091106414999956],
            [31.374877930000025, -23.138339995999956],
            [31.20694541900008, -23.219594954999934],
            [31.15665817300004, -23.188066482999943],
            [30.966876984000066, -23.174127578999958],
            [30.728049972000065, -23.072310030999972],
            [30.652229971000054, -23.157420025999954],
            [30.562659973000052, -23.17569003099993],
            [30.487569971000028, -23.244240030999947],
            [30.334979974000078, -23.249440032999928],
            [30.36914997300005, -23.310160027999927],
            [30.29401998000003, -23.385680021999974],
            [30.337409997000066, -23.423950005999927],
            [30.48264000100005, -23.341860002999965],
            [30.53821799600007, -23.40169099899998],
            [30.617409998000028, -23.388989997999943],
            [30.688910001000067, -23.45541999699998],
            [30.624930001000052, -23.596700001999977],
            [30.759670003000053, -23.697349990999953],
            [31.078299997000045, -23.64602999999994],
            [31.143371582000043, -23.531866073999936],
            [31.173540115000037, -23.350185393999936],
            [31.56120207300006, -23.226929905999953],
            [31.561423243000036, -23.224282794999965],
          ],
        ],
      },
      properties: {
        Shape_Leng: 4.67477862915,
        Shape_Area: 0.368399441704,
        ADM3_EN: 'Greater Giyani',
        ADM3_PCODE: 'ZA9331',
        ADM3_REF: '',
        ADM3ALT1EN: '',
        ADM3ALT2EN: '',
        ADM2_EN: 'Mopani',
        ADM2_PCODE: 'ZA933',
        ADM1_EN: 'Limpopo',
        ADM1_PCODE: 'ZA9',
        ADM0_EN: 'South Africa',
        ADM0_PCODE: 'ZA',
        date: '2018-12-27T00:00:00.000Z',
        validOn: '2020-11-09T00:00:00.000Z',
        validTo: '1899-11-30T00:00:00.000Z',
        ADM1_ID: 'LIM',
        ADM2_ID: 'DC33',
        ADM3_ID: 'LIM331',
      },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Polygon',
        coordinates: [
          [
            [29.417289942000025, -29.969134939999947],
            [29.16882494200007, -29.912705064999955],
            [29.01473997200003, -30.00179996999998],
            [29.117240037000045, -30.10018996799994],
            [29.13716997100005, -30.26233997199995],
            [29.301859965000062, -30.320119956999974],
            [29.305009976000065, -30.379859949999968],
            [29.196769982000035, -30.43439003499998],
            [29.13525000100003, -30.605139977999954],
            [29.372800038000037, -30.64896003499996],
            [29.51235997200007, -30.61821998299996],
            [29.543550296000035, -30.647186529999942],
            [29.57220004100003, -30.655149972999936],
            [29.640639942000064, -30.562039940999966],
            [29.573779942000044, -30.404852940999945],
            [29.497840067000027, -30.34030994099993],
            [29.524589942000034, -30.22235994099998],
            [29.38802994200006, -30.157550065999942],
            [29.47891994200006, -30.040369939999948],
            [29.417289942000025, -29.969134939999947],
          ],
        ],
      },
      properties: {
        Shape_Leng: 3.6511984869,
        Shape_Area: 0.251293494812,
        ADM3_EN: 'Greater Kokstad',
        ADM3_PCODE: 'ZA5433',
        ADM3_REF: '',
        ADM3ALT1EN: '',
        ADM3ALT2EN: '',
        ADM2_EN: 'Sisonke',
        ADM2_PCODE: 'ZA543',
        ADM1_EN: 'KwaZulu-Natal',
        ADM1_PCODE: 'ZA5',
        ADM0_EN: 'South Africa',
        ADM0_PCODE: 'ZA',
        date: '2018-12-27T00:00:00.000Z',
        validOn: '2020-11-09T00:00:00.000Z',
        validTo: '1899-11-30T00:00:00.000Z',
        ADM1_ID: 'KZN',
        ADM2_ID: 'DC43',
        ADM3_ID: 'KZN433',
      },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Polygon',
        coordinates: [
          [
            [30.29401998000003, -23.385680021999974],
            [30.268560962000038, -23.324409040999967],
            [30.151606737000066, -23.31379967999993],
            [30.03769998200005, -23.33871002199993],
            [30.00599999700006, -23.447810002999972],
            [30.03643999800005, -23.57296999899995],
            [29.961120004000065, -23.66007000199994],
            [30.20124999500007, -23.753669998999953],
            [30.306069999000044, -23.631559996999954],
            [30.367669998000054, -23.624050000999944],
            [30.41791999800006, -23.52138999899995],
            [30.474790003000066, -23.56907999699996],
            [30.562779997000064, -23.552449998999975],
            [30.624930001000052, -23.596700001999977],
            [30.688910001000067, -23.45541999699998],
            [30.617409998000028, -23.388989997999943],
            [30.53821799600007, -23.40169099899998],
            [30.48264000100005, -23.341860002999965],
            [30.337409997000066, -23.423950005999927],
            [30.29401998000003, -23.385680021999974],
          ],
        ],
      },
      properties: {
        Shape_Leng: 2.8078116683,
        Shape_Area: 0.167169828728,
        ADM3_EN: 'Greater Letaba',
        ADM3_PCODE: 'ZA9332',
        ADM3_REF: '',
        ADM3ALT1EN: '',
        ADM3ALT2EN: '',
        ADM2_EN: 'Mopani',
        ADM2_PCODE: 'ZA933',
        ADM1_EN: 'Limpopo',
        ADM1_PCODE: 'ZA9',
        ADM0_EN: 'South Africa',
        ADM0_PCODE: 'ZA',
        date: '2018-12-27T00:00:00.000Z',
        validOn: '2020-11-09T00:00:00.000Z',
        validTo: '1899-11-30T00:00:00.000Z',
        ADM1_ID: 'LIM',
        ADM2_ID: 'DC33',
        ADM3_ID: 'LIM332',
      },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Polygon',
        coordinates: [
          [
            [24.32020501200003, -27.082695000999934],
            [24.223860002000038, -27.125290002999975],
            [24.13135999800005, -27.011900001999948],
            [24.037450000000035, -27.053699998999946],
            [23.973560000000077, -27.096379997999975],
            [23.89646999400003, -27.252659998999945],
            [24.01494999700003, -27.32367000599993],
            [24.08627000100006, -27.35349000399998],
            [24.05751000300006, -27.429419999999936],
            [24.050610001000052, -27.602729996999983],
            [24.118620004000036, -27.621739997999953],
            [24.111000001000036, -27.73898000099996],
            [24.40528000100005, -27.681180001999962],
            [24.452310005000072, -27.782880002999946],
            [24.360459994000053, -27.91067000299995],
            [24.46728999900006, -27.980569998999954],
            [24.534639003000052, -28.092088995999973],
            [24.62935000300007, -27.994309999999928],
            [24.615819999000053, -27.903600000999973],
            [24.699320003000025, -27.828289996999956],
            [24.65866999700006, -27.790939992999938],
            [24.692299998000067, -27.64521999899995],
            [24.80117000000007, -27.70177999699996],
            [24.99972000100007, -27.680830003999972],
            [25.047909998000023, -27.69973999599995],
            [25.08783999600007, -27.657509996999977],
            [25.006389997000042, -27.524169997999934],
            [24.892087678000053, -27.39611040099993],
            [24.782400004000067, -27.406860000999927],
            [24.777190000000076, -27.333240003999947],
            [24.699311089000048, -27.234209972999963],
            [24.58572914000007, -27.29284741999993],
            [24.612945007000064, -27.337962009999956],
            [24.45717000800005, -27.424419997999962],
            [24.380169998000042, -27.272490003999962],
            [24.415399998000055, -27.211610002999976],
            [24.32020501200003, -27.082695000999934],
          ],
        ],
      },
      properties: {
        Shape_Leng: 5.13337731909,
        Shape_Area: 0.514994723782,
        ADM3_EN: 'Greater Taung',
        ADM3_PCODE: 'ZA6394',
        ADM3_REF: '',
        ADM3ALT1EN: '',
        ADM3ALT2EN: '',
        ADM2_EN: 'Dr Ruth Segomotsi Mompati',
        ADM2_PCODE: 'ZA639',
        ADM1_EN: 'North West',
        ADM1_PCODE: 'ZA6',
        ADM0_EN: 'South Africa',
        ADM0_PCODE: 'ZA',
        date: '2018-12-27T00:00:00.000Z',
        validOn: '2020-11-09T00:00:00.000Z',
        validTo: '1899-11-30T00:00:00.000Z',
        ADM1_ID: 'NW',
        ADM2_ID: 'DC39',
        ADM3_ID: 'NW394',
      },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Polygon',
        coordinates: [
          [
            [30.366215000000068, -24.283094996999978],
            [30.27315999700005, -24.320040002999974],
            [30.177500003000034, -24.304190000999938],
            [30.139430004000076, -24.247240002999945],
            [30.04109999600007, -24.20681999599998],
            [29.769109997000044, -24.272990001999972],
            [29.696560009000052, -24.46678998899995],
            [29.776340022000056, -24.60466998199996],
            [30.087270011000044, -24.62058998699996],
            [30.119780013000025, -24.699679987999957],
            [30.021230020000075, -24.83914998399996],
            [29.934160027000075, -24.81397497699993],
            [29.90509600200005, -24.93239899899993],
            [29.905889985000044, -25.047489970999948],
            [29.978949982000074, -25.09211998199993],
            [30.144389997000076, -25.12378999899994],
            [30.19197998900006, -24.85547000899993],
            [30.42507000300003, -24.854859999999974],
            [30.45153999200005, -24.912000003999935],
            [30.634880004000024, -24.852770000999953],
            [30.720100002000038, -24.70523800899997],
            [30.73017999900003, -24.49849999999998],
            [30.758979999000076, -24.460219998999946],
            [30.533529998000063, -24.439709997999955],
            [30.366215000000068, -24.283094996999978],
          ],
        ],
      },
      properties: {
        Shape_Leng: 4.85312494876,
        Shape_Area: 0.507541396751,
        ADM3_EN: 'Greater Tubatse/Fetakgomo',
        ADM3_PCODE: 'ZA9476',
        ADM3_REF: '',
        ADM3ALT1EN: '',
        ADM3ALT2EN: '',
        ADM2_EN: 'Sekhukhune',
        ADM2_PCODE: 'ZA947',
        ADM1_EN: 'Limpopo',
        ADM1_PCODE: 'ZA9',
        ADM0_EN: 'South Africa',
        ADM0_PCODE: 'ZA',
        date: '2018-12-27T00:00:00.000Z',
        validOn: '2020-11-09T00:00:00.000Z',
        validTo: '1899-11-30T00:00:00.000Z',
        ADM1_ID: 'LIM',
        ADM2_ID: 'DC47',
        ADM3_ID: 'LIM476',
      },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Polygon',
        coordinates: [
          [
            [30.624930001000052, -23.596700001999977],
            [30.562779997000064, -23.552449998999975],
            [30.474790003000066, -23.56907999699996],
            [30.41791999800006, -23.52138999899995],
            [30.367669998000054, -23.624050000999944],
            [30.306069999000044, -23.631559996999954],
            [30.20124999500007, -23.753669998999953],
            [29.961120004000065, -23.66007000199994],
            [29.887920003000033, -23.67941999599998],
            [29.928179999000065, -23.79767999799998],
            [29.86374999900005, -23.95138000099996],
            [30.074549997000076, -24.01201999699998],
            [30.321530000000052, -24.12969000099997],
            [30.453314593000073, -23.958283071999972],
            [30.480120000000056, -23.980880010999954],
            [30.557380004000038, -23.94147999599994],
            [30.585719999000048, -23.84737000299998],
            [30.525589999000033, -23.727099995999936],
            [30.624930001000052, -23.596700001999977],
          ],
        ],
      },
      properties: {
        Shape_Leng: 3.1884135723,
        Shape_Area: 0.256707328005,
        ADM3_EN: 'Greater Tzaneen',
        ADM3_PCODE: 'ZA9333',
        ADM3_REF: '',
        ADM3ALT1EN: '',
        ADM3ALT2EN: '',
        ADM2_EN: 'Mopani',
        ADM2_PCODE: 'ZA933',
        ADM1_EN: 'Limpopo',
        ADM1_PCODE: 'ZA9',
        ADM0_EN: 'South Africa',
        ADM0_PCODE: 'ZA',
        date: '2018-12-27T00:00:00.000Z',
        validOn: '2020-11-09T00:00:00.000Z',
        validTo: '1899-11-30T00:00:00.000Z',
        ADM1_ID: 'LIM',
        ADM2_ID: 'DC33',
        ADM3_ID: 'LIM333',
      },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Polygon',
        coordinates: [
          [
            [21.19539999400007, -29.63724999699997],
            [20.85758000000004, -29.858560000999944],
            [20.803750000000036, -29.942299994999928],
            [20.708139995000067, -29.985630003999972],
            [20.626389998000036, -29.86317000899993],
            [20.66141000400006, -29.643069998999977],
            [20.594470001000047, -29.63484000099993],
            [20.519840011000042, -29.71901999399995],
            [20.436840005000022, -29.615849998999977],
            [20.156710000000032, -29.65250999799997],
            [20.175209997000024, -29.76437999799998],
            [20.046140007000076, -29.861769997999943],
            [19.995640000000037, -29.86673000099995],
            [19.88141577600004, -29.777029720999963],
            [19.786281221000024, -29.87555758299993],
            [19.888157084000056, -30.093689299999937],
            [19.839409490000037, -30.14641333399993],
            [19.878073176000044, -30.228297167999983],
            [20.002280002000077, -30.279270004999944],
            [19.80409999500006, -30.38556000099993],
            [19.65014999500005, -30.37897000499993],
            [19.533789999000078, -30.316980004999948],
            [19.368379996000044, -30.296359999999936],
            [19.298139999000057, -30.25407999899994],
            [19.083110653000062, -30.342430426999954],
            [19.00597000600004, -30.49702999999994],
            [18.951480022000055, -30.74443989799994],
            [18.98449000100004, -30.945810002999963],
            [18.911770010000055, -30.978929996999966],
            [18.947600004000037, -31.112910003999957],
            [18.944460003000074, -31.237319997999975],
            [19.013010002000044, -31.305680002999964],
            [18.980130002000067, -31.355239989999973],
            [19.085420003000024, -31.526930000999982],
            [19.06556000300003, -31.706309998999984],
            [19.08627000200005, -31.794479999999965],
            [19.02622000100007, -31.876639998999963],
            [19.395849996000038, -32.01511000299996],
            [19.515190005000022, -32.11519999999996],
            [19.49150000000003, -32.25237000599998],
            [19.409080002000053, -32.29007999799995],
            [19.496370003000038, -32.47481999799993],
            [19.48680500300003, -32.56543999599995],
            [19.528249996000056, -32.67323999799993],
            [19.60495000000003, -32.62945999799996],
            [19.621850004000066, -32.47062000099993],
            [19.802700001000062, -32.393700001999946],
            [19.93749000300005, -32.37727999799995],
            [20.151830002000054, -32.18651999499997],
            [20.16472000600004, -32.087359996999965],
            [20.27734815100007, -32.08378968099993],
            [20.280049993000034, -32.012410003999946],
            [20.371859999000037, -31.822040002999984],
            [20.648430004000033, -31.84450000099997],
            [20.562474999000074, -31.72275300299998],
            [20.610494997000046, -31.657463999999948],
            [20.557600001000026, -31.604780003999963],
            [20.59158000700006, -31.310629998999957],
            [20.54742999700005, -31.201530005999928],
            [20.403079998000067, -31.18552000099993],
            [20.351190004000046, -31.090939996999964],
            [20.389879999000073, -30.95676499399997],
            [20.459320002000027, -30.898930002999975],
            [20.383159999000043, -30.81525999799993],
            [20.615560091000077, -30.654913388999944],
            [20.938535434000073, -30.61665292799995],
            [20.92542594300005, -30.50003415699996],
            [21.055962842000042, -30.485085638999976],
            [21.251485715000058, -30.39702336299996],
            [21.143060010000056, -30.25622992199993],
            [21.165240002000075, -30.08564999999993],
            [21.242980001000035, -30.039089993999937],
            [21.305260006000026, -29.980409994999945],
            [21.154130002000045, -29.872619999999984],
            [21.27204000300003, -29.736279998999976],
            [21.19539999400007, -29.63724999699997],
          ],
        ],
      },
      properties: {
        Shape_Leng: 14.2365431669,
        Shape_Area: 3.69050817092,
        ADM3_EN: 'Hantam',
        ADM3_PCODE: 'ZA3065',
        ADM3_REF: '',
        ADM3ALT1EN: '',
        ADM3ALT2EN: '',
        ADM2_EN: 'Namakwa',
        ADM2_PCODE: 'ZA306',
        ADM1_EN: 'Nothern Cape',
        ADM1_PCODE: 'ZA3',
        ADM0_EN: 'South Africa',
        ADM0_PCODE: 'ZA',
        date: '2018-12-27T00:00:00.000Z',
        validOn: '2020-11-09T00:00:00.000Z',
        validTo: '1899-11-30T00:00:00.000Z',
        ADM1_ID: 'NC',
        ADM2_ID: 'DC6',
        ADM3_ID: 'NC065',
      },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Polygon',
        coordinates: [
          [
            [21.70035000200005, -33.85285000099998],
            [21.740035060000025, -33.79614592699994],
            [21.64827000400004, -33.83040999599996],
            [21.423320000000047, -33.84758999899998],
            [21.371060003000025, -33.81989999799998],
            [21.084609999000065, -33.82291999699993],
            [20.943380000000047, -33.85187000199994],
            [20.93403999800006, -33.94762000299994],
            [20.833790001000068, -33.971330002999935],
            [20.707270003000076, -33.955120000999955],
            [20.754300000000057, -34.09724999699995],
            [20.640100002000054, -34.08596000399996],
            [20.664950003000058, -34.18847999899998],
            [20.599380001000043, -34.27291000399998],
            [20.596289999000078, -34.34796999699995],
            [20.849963002000038, -34.40340599799998],
            [20.933440003000044, -34.36599999799995],
            [21.13432000000006, -34.38354999699993],
            [21.29070999700008, -34.43676999699994],
            [21.53569999900003, -34.35636999999997],
            [21.69624999800004, -34.394990003999965],
            [21.88696999700005, -34.34357999699995],
            [21.792579998000065, -34.28613000099995],
            [21.71243143600003, -34.127638167999976],
            [21.715360004000047, -34.043579998999974],
            [21.65139000100004, -33.92818999899998],
            [21.70035000200005, -33.85285000099998],
          ],
        ],
      },
      properties: {
        Shape_Leng: 5.11072699701,
        Shape_Area: 0.560290151435,
        ADM3_EN: 'Hessequa',
        ADM3_PCODE: 'ZA1042',
        ADM3_REF: '',
        ADM3ALT1EN: '',
        ADM3ALT2EN: '',
        ADM2_EN: 'Eden',
        ADM2_PCODE: 'ZA104',
        ADM1_EN: 'Western Cape',
        ADM1_PCODE: 'ZA1',
        ADM0_EN: 'South Africa',
        ADM0_PCODE: 'ZA',
        date: '2018-12-27T00:00:00.000Z',
        validOn: '2020-11-09T00:00:00.000Z',
        validTo: '1899-11-30T00:00:00.000Z',
        ADM1_ID: 'WC',
        ADM2_ID: 'DC4',
        ADM3_ID: 'WC042',
      },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Polygon',
        coordinates: [
          [
            [29.689915942000027, -29.402831939999942],
            [29.61328005200005, -29.408469929999967],
            [29.506799942000043, -29.33977993999997],
            [29.45545994200006, -29.341249939999955],
            [29.403389942000047, -29.444019939999976],
            [29.299845521000066, -29.49893551899993],
            [29.493708880000042, -29.586860324999975],
            [29.592859925000027, -29.577360029999966],
            [29.957625609000047, -29.78094086699997],
            [29.980332055000076, -29.719404435999934],
            [30.069199943000058, -29.72404006499994],
            [30.10609994300006, -29.629689939999935],
            [29.918909942000028, -29.533619939999937],
            [29.821639942000047, -29.456689939999933],
            [29.689915942000027, -29.402831939999942],
          ],
        ],
      },
      properties: {
        Shape_Leng: 2.70000333588,
        Shape_Area: 0.149833341896,
        ADM3_EN: 'Impendle',
        ADM3_PCODE: 'ZA5224',
        ADM3_REF: '',
        ADM3ALT1EN: '',
        ADM3ALT2EN: '',
        ADM2_EN: 'Umgungundlovu',
        ADM2_PCODE: 'ZA522',
        ADM1_EN: 'KwaZulu-Natal',
        ADM1_PCODE: 'ZA5',
        ADM0_EN: 'South Africa',
        ADM0_PCODE: 'ZA',
        date: '2018-12-27T00:00:00.000Z',
        validOn: '2020-11-09T00:00:00.000Z',
        validTo: '1899-11-30T00:00:00.000Z',
        ADM1_ID: 'KZN',
        ADM2_ID: 'DC22',
        ADM3_ID: 'KZN224',
      },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Polygon',
        coordinates: [
          [
            [30.267529943000056, -28.731019938999964],
            [30.144079943000065, -28.745679938999956],
            [30.043330067000056, -28.70574993899993],
            [29.99502994200003, -28.642819938999935],
            [29.88163006700006, -28.669499938999934],
            [29.761249942000063, -28.737949938999975],
            [29.67715006700007, -28.866379938999955],
            [29.540569942000047, -28.93754993899995],
            [29.47361006700004, -29.091747939999948],
            [29.357050041000036, -29.134250605999966],
            [29.45545994200006, -29.341249939999955],
            [29.506799942000043, -29.33977993999997],
            [29.609740067000075, -29.24864993999995],
            [29.652099942000063, -29.297079939999946],
            [29.753790067000068, -29.283259939999937],
            [29.75571994200004, -29.206939939999984],
            [29.854859942000076, -29.21807993999994],
            [29.926899942000034, -29.121849939999947],
            [30.027989942000033, -29.05932006499995],
            [30.086179943000047, -28.966530063999983],
            [30.229629943000077, -28.984039938999956],
            [30.287469943000076, -28.91489993899995],
            [30.267529943000056, -28.731019938999964],
          ],
        ],
      },
      properties: {
        Shape_Leng: 3.80352567228,
        Shape_Area: 0.314674717572,
        ADM3_EN: 'Inkosi Langalibalele',
        ADM3_PCODE: 'ZA5237',
        ADM3_REF: '',
        ADM3ALT1EN: '',
        ADM3ALT2EN: '',
        ADM2_EN: 'Uthukela',
        ADM2_PCODE: 'ZA523',
        ADM1_EN: 'KwaZulu-Natal',
        ADM1_PCODE: 'ZA5',
        ADM0_EN: 'South Africa',
        ADM0_PCODE: 'ZA',
        date: '2018-12-27T00:00:00.000Z',
        validOn: '2020-11-09T00:00:00.000Z',
        validTo: '1899-11-30T00:00:00.000Z',
        ADM1_ID: 'KZN',
        ADM2_ID: 'DC23',
        ADM3_ID: 'KZN237',
      },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Polygon',
        coordinates: [
          [
            [28.010034442000062, -32.03639166599993],
            [27.98333358800005, -31.98428535499994],
            [28.016820001000042, -31.87285000399993],
            [27.879180003000045, -31.81473000099993],
            [27.758459997000045, -31.65649000899998],
            [27.694469998000045, -31.713420002999953],
            [27.52737471100005, -31.726878330999966],
            [27.437136002000045, -31.676665999999955],
            [27.39869999600006, -31.72566999999998],
            [27.434009997000032, -31.80967900299993],
            [27.407873005000056, -31.895912003999968],
            [27.27276160400004, -31.933650016999934],
            [27.41182000300006, -32.09891999799993],
            [27.39748000000003, -32.136169999999936],
            [27.507879998000078, -32.230749996999975],
            [27.60068758700004, -32.21345436599995],
            [27.64370824200006, -32.278592110999966],
            [27.758832939000058, -32.331968064999955],
            [27.812770000000057, -32.183239998999966],
            [27.775190001000055, -32.10948000299993],
            [27.889110002000052, -32.04975000299993],
            [28.010034442000062, -32.03639166599993],
          ],
        ],
      },
      properties: {
        Shape_Leng: 4.35287552997,
        Shape_Area: 0.274136199924,
        ADM3_EN: 'Intsika Yethu',
        ADM3_PCODE: 'ZA2135',
        ADM3_REF: '',
        ADM3ALT1EN: '',
        ADM3ALT2EN: '',
        ADM2_EN: 'Chris Hani',
        ADM2_PCODE: 'ZA213',
        ADM1_EN: 'Eastern Cape',
        ADM1_PCODE: 'ZA2',
        ADM0_EN: 'South Africa',
        ADM0_PCODE: 'ZA',
        date: '2018-12-27T00:00:00.000Z',
        validOn: '2020-11-09T00:00:00.000Z',
        validTo: '1899-11-30T00:00:00.000Z',
        ADM1_ID: 'EC',
        ADM2_ID: 'DC13',
        ADM3_ID: 'EC135',
      },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Polygon',
        coordinates: [
          [
            [25.38621000100005, -31.21784000399998],
            [25.22504000300006, -31.195199999999943],
            [25.170479998000076, -31.23917999899993],
            [25.00562000000008, -31.263099998999962],
            [24.852990005000038, -31.328209989999948],
            [24.788679998000077, -31.389460002999954],
            [24.664990001000035, -31.38366000999997],
            [24.56719000100003, -31.41864000099997],
            [24.503910002000055, -31.568419998999957],
            [24.50627000000003, -31.706830001999947],
            [24.704399998000042, -31.744279999999947],
            [24.899250004000066, -31.837270003999947],
            [24.939119998000024, -31.90504999899997],
            [24.915539999000032, -32.17211999799997],
            [24.949610000000064, -32.241180001999965],
            [25.128310002000035, -32.291099997999936],
            [25.167560003000062, -32.328709999999944],
            [25.534059996000053, -32.394469998999966],
            [25.65508199800007, -32.50690700299998],
            [25.785559999000043, -32.53790000099997],
            [25.887309997000045, -32.48680000199994],
            [25.951069612000026, -32.36404736299994],
            [26.191329997000025, -32.285230000999945],
            [26.20688999600003, -32.16447000299996],
            [26.076000003000047, -32.11261999599998],
            [25.99953000100004, -32.005000001999974],
            [25.850160000000074, -31.908890000999975],
            [25.634099999000057, -31.839609996999968],
            [25.454490001000067, -31.684599997999953],
            [25.61735999700005, -31.577260000999956],
            [25.589330002000054, -31.48531000199995],
            [25.557529999000053, -31.27799000699997],
            [25.38621000100005, -31.21784000399998],
          ],
        ],
      },
      properties: {
        Shape_Leng: 7.04663994376,
        Shape_Area: 1.1115273355,
        ADM3_EN: 'Inxuba Yethemba',
        ADM3_PCODE: 'ZA2131',
        ADM3_REF: '',
        ADM3ALT1EN: '',
        ADM3ALT2EN: '',
        ADM2_EN: 'Chris Hani',
        ADM2_PCODE: 'ZA213',
        ADM1_EN: 'Eastern Cape',
        ADM1_PCODE: 'ZA2',
        ADM0_EN: 'South Africa',
        ADM0_PCODE: 'ZA',
        date: '2018-12-27T00:00:00.000Z',
        validOn: '2020-11-09T00:00:00.000Z',
        validTo: '1899-11-30T00:00:00.000Z',
        ADM1_ID: 'EC',
        ADM2_ID: 'DC13',
        ADM3_ID: 'EC131',
      },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Polygon',
        coordinates: [
          [
            [24.037450000000035, -27.053699998999946],
            [23.97037000100005, -26.894200001999934],
            [23.853230004000068, -26.890140002999942],
            [23.760750002000066, -26.840960000999928],
            [23.48713000300006, -26.739709004999952],
            [23.583750000000066, -26.617149997999945],
            [23.46295999800003, -26.53108999799997],
            [23.266410002000043, -26.48539999899998],
            [23.28205000300005, -26.339470002999974],
            [23.221740004000026, -26.271270000999948],
            [23.310979995000025, -26.141849999999977],
            [23.215819999000075, -26.115730003999943],
            [23.23214999700008, -26.052690002999952],
            [23.35388199700003, -26.08947800599998],
            [23.387359998000022, -26.006159999999966],
            [23.086910001000035, -25.982559995999964],
            [23.064800003000073, -26.099059994999948],
            [22.987040000000036, -26.089979995999954],
            [22.90705999900007, -26.14592000199997],
            [22.84187000000003, -26.39330000299998],
            [22.803159997000023, -26.453680000999952],
            [22.708800001000043, -26.410789998999974],
            [22.702940002000048, -26.11985000599998],
            [22.632170006000024, -26.121280000999946],
            [22.557409999000072, -26.221759994999957],
            [22.42220999500006, -26.223240002999944],
            [22.366780000000063, -26.319170002999954],
            [22.24725000500007, -26.34704000299996],
            [22.04823000600004, -26.635049994999974],
            [21.953129998000065, -26.66870999699995],
            [21.787390000000073, -26.676060003999964],
            [21.79286999900006, -26.76962999899996],
            [21.872350003000065, -26.86014999799994],
            [21.917139989000077, -26.95868999399994],
            [21.99946000500006, -27.024790005999932],
            [21.999490738000077, -27.110249661999944],
            [22.124309996000022, -27.07355999899994],
            [22.20940000300004, -27.094450000999927],
            [22.324780004000047, -27.07768999299998],
            [22.341339995000055, -27.26111000399993],
            [22.487789994000025, -27.278889996999965],
            [22.620430000000056, -27.26307000099996],
            [22.68164999800007, -27.347749998999973],
            [22.669130004000067, -27.450710002999983],
            [22.714579996000055, -27.549159994999968],
            [22.84454000100004, -27.543719993999957],
            [22.837420001000055, -27.39042000099994],
            [23.21585000400006, -27.41918999799998],
            [23.27180256200006, -27.378535727999974],
            [23.132359992000033, -27.236959997999975],
            [23.17809199800007, -27.135831004999943],
            [23.394121518000077, -27.29911970099994],
            [23.476216212000054, -27.29184161099994],
            [23.56404368500006, -27.33500288299996],
            [23.610819999000057, -27.472440004999953],
            [23.767069999000057, -27.55323999899997],
            [23.81460000000004, -27.478799993999928],
            [23.936559998000064, -27.410819997999965],
            [24.01494999700003, -27.32367000599993],
            [23.89646999400003, -27.252659998999945],
            [23.973560000000077, -27.096379997999975],
            [24.037450000000035, -27.053699998999946],
          ],
        ],
      },
      properties: {
        Shape_Leng: 9.63442004603,
        Shape_Area: 1.83235010515,
        ADM3_EN: 'Joe Morolong',
        ADM3_PCODE: 'ZA3451',
        ADM3_REF: '',
        ADM3ALT1EN: '',
        ADM3ALT2EN: '',
        ADM2_EN: 'John Taolo Gaetsewe',
        ADM2_PCODE: 'ZA345',
        ADM1_EN: 'Nothern Cape',
        ADM1_PCODE: 'ZA3',
        ADM0_EN: 'South Africa',
        ADM0_PCODE: 'ZA',
        date: '2018-12-27T00:00:00.000Z',
        validOn: '2020-11-09T00:00:00.000Z',
        validTo: '1899-11-30T00:00:00.000Z',
        ADM1_ID: 'NC',
        ADM2_ID: 'DC45',
        ADM3_ID: 'NC451',
      },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Polygon',
        coordinates: [
          [
            [32.34588994500007, -26.855900061999932],
            [32.09255994400007, -26.804870061999964],
            [32.015859944000056, -26.81988006199998],
            [31.974549944000046, -27.116409937999947],
            [31.97775994400007, -27.31752006299996],
            [32.02069994400006, -27.512840062999942],
            [31.951619944000072, -27.61907993799997],
            [31.996179944000062, -27.885269937999965],
            [32.031879944000025, -27.92858006299997],
            [32.33728794500007, -27.753563062999945],
            [32.41573307700003, -27.661980149999977],
            [32.40859994500005, -27.483649062999973],
            [32.25805994500007, -27.50983006299998],
            [32.22306994500008, -27.478569937999964],
            [32.26145994500007, -27.35058006299994],
            [32.21628007000004, -27.203829937999956],
            [32.301769945000046, -27.020810062999942],
            [32.34588994500007, -26.855900061999932],
          ],
        ],
      },
      properties: {
        Shape_Leng: 4.20726508158,
        Shape_Area: 0.314011284058,
        ADM3_EN: 'Jozini',
        ADM3_PCODE: 'ZA5272',
        ADM3_REF: '',
        ADM3ALT1EN: '',
        ADM3ALT2EN: '',
        ADM2_EN: 'Umkhanyakude',
        ADM2_PCODE: 'ZA527',
        ADM1_EN: 'KwaZulu-Natal',
        ADM1_PCODE: 'ZA5',
        ADM0_EN: 'South Africa',
        ADM0_PCODE: 'ZA',
        date: '2018-12-27T00:00:00.000Z',
        validOn: '2020-11-09T00:00:00.000Z',
        validTo: '1899-11-30T00:00:00.000Z',
        ADM1_ID: 'KZN',
        ADM2_ID: 'DC27',
        ADM3_ID: 'KZN272',
      },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Polygon',
        coordinates: [
          [
            [24.485275002000037, -25.74938999799997],
            [24.380810002000032, -25.764859996999974],
            [24.278469999000038, -25.713250002999928],
            [24.194069996000053, -25.62106999699995],
            [24.003529996000054, -25.650190003999967],
            [23.90337999700006, -25.626810000999967],
            [23.75825999700004, -25.469259996999938],
            [23.594380000000058, -25.397010000999956],
            [23.500439999000037, -25.33184999599996],
            [23.36049999200003, -25.28622999299995],
            [23.192250000000058, -25.277310002999968],
            [22.97794000300007, -25.33985999799995],
            [22.863750003000064, -25.479619997999976],
            [22.81481999600004, -25.57882000099994],
            [22.853459996000026, -25.611629996999966],
            [22.738069997000025, -25.85504000399993],
            [22.72104999800007, -26.018560002999948],
            [22.632170006000024, -26.121280000999946],
            [22.702940002000048, -26.11985000599998],
            [22.708800001000043, -26.410789998999974],
            [22.803159997000023, -26.453680000999952],
            [22.84187000000003, -26.39330000299998],
            [22.90705999900007, -26.14592000199997],
            [22.987040000000036, -26.089979995999954],
            [23.064800003000073, -26.099059994999948],
            [23.086910001000035, -25.982559995999964],
            [23.387359998000022, -26.006159999999966],
            [23.35388199700003, -26.08947800599998],
            [23.23214999700008, -26.052690002999952],
            [23.215819999000075, -26.115730003999943],
            [23.310979995000025, -26.141849999999977],
            [23.221740004000026, -26.271270000999948],
            [23.28205000300005, -26.339470002999974],
            [23.266410002000043, -26.48539999899998],
            [23.46295999800003, -26.53108999799997],
            [23.583750000000066, -26.617149997999945],
            [23.48713000300006, -26.739709004999952],
            [23.760750002000066, -26.840960000999928],
            [23.853230004000068, -26.890140002999942],
            [23.97037000100005, -26.894200001999934],
            [24.037450000000035, -27.053699998999946],
            [24.13135999800005, -27.011900001999948],
            [24.223860002000038, -27.125290002999975],
            [24.32020501200003, -27.082695000999934],
            [24.265849997000032, -26.960619995999934],
            [24.276980004000052, -26.883239997999965],
            [24.780250000000024, -26.642580006999935],
            [24.657379999000057, -26.48580999799998],
            [24.602179997000064, -26.51544999899994],
            [24.53613000100006, -26.401690000999963],
            [24.677920003000054, -26.329109999999957],
            [24.635080001000063, -26.269699997999965],
            [24.76417999800003, -26.205250000999968],
            [24.804080002000035, -26.158249998999963],
            [24.667030001000057, -25.921250002999955],
            [24.465069998000047, -25.790170003999947],
            [24.485275002000037, -25.74938999799997],
          ],
        ],
      },
      properties: {
        Shape_Leng: 10.0361943246,
        Shape_Area: 2.15034740214,
        ADM3_EN: 'Kagisano/Molopo',
        ADM3_PCODE: 'ZA6397',
        ADM3_REF: '',
        ADM3ALT1EN: '',
        ADM3ALT2EN: '',
        ADM2_EN: 'Dr Ruth Segomotsi Mompati',
        ADM2_PCODE: 'ZA639',
        ADM1_EN: 'North West',
        ADM1_PCODE: 'ZA6',
        ADM0_EN: 'South Africa',
        ADM0_PCODE: 'ZA',
        date: '2018-12-27T00:00:00.000Z',
        validOn: '2020-11-09T00:00:00.000Z',
        validTo: '1899-11-30T00:00:00.000Z',
        ADM1_ID: 'NW',
        ADM2_ID: 'DC39',
        ADM3_ID: 'NW397',
      },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Polygon',
        coordinates: [
          [
            [21.260460005000027, -28.711480002999963],
            [21.017790001000037, -28.44387000699993],
            [20.805000008000036, -28.354829999999936],
            [20.712329863000036, -28.281499865999933],
            [20.638014890000022, -28.17485348899993],
            [20.579980727000077, -28.181939240999952],
            [20.55798912000006, -28.034820556999932],
            [20.411949158000027, -27.853340148999962],
            [20.270820618000073, -27.91489028899997],
            [20.24860000600006, -27.790569304999963],
            [20.15366935700007, -27.852560042999983],
            [20.000210001000028, -27.77401999899996],
            [19.999159993000035, -28.42768000199993],
            [19.730049999000073, -28.487909996999974],
            [19.670849996000072, -28.529369997999936],
            [19.54847999800006, -28.540839999999946],
            [19.509289998000042, -28.596540000999937],
            [19.61911000400005, -28.690560009999956],
            [19.666229997000073, -28.82979000399996],
            [19.779510006000066, -28.87642000699998],
            [19.576690000000042, -29.09468199899993],
            [19.60131999600003, -29.27185000099996],
            [19.74025000200004, -29.428609989999984],
            [19.76216999600007, -29.58204000199993],
            [19.585969998000053, -29.609920000999978],
            [19.574820000000045, -29.72529000299994],
            [19.659080006000067, -29.793019999999956],
            [19.88141577600004, -29.777029720999963],
            [19.995640000000037, -29.86673000099995],
            [20.046140007000076, -29.861769997999943],
            [20.175209997000024, -29.76437999799998],
            [20.156710000000032, -29.65250999799997],
            [20.436840005000022, -29.615849998999977],
            [20.519840011000042, -29.71901999399995],
            [20.594470001000047, -29.63484000099993],
            [20.66141000400006, -29.643069998999977],
            [20.626389998000036, -29.86317000899993],
            [20.708139995000067, -29.985630003999972],
            [20.803750000000036, -29.942299994999928],
            [20.85758000000004, -29.858560000999944],
            [21.19539999400007, -29.63724999699997],
            [21.27092000500005, -29.46521999899994],
            [21.274170001000073, -29.35798000699998],
            [21.182412257000067, -29.25857309299994],
            [21.301664241000026, -29.154666990999942],
            [21.308571252000036, -29.06743649799995],
            [21.211321918000067, -29.00890848699993],
            [21.251049996000063, -28.930944996999983],
            [21.125769997000077, -28.831600006999963],
            [21.260460005000027, -28.711480002999963],
          ],
        ],
      },
      properties: {
        Shape_Leng: 8.6689912938,
        Shape_Area: 2.44171944369,
        ADM3_EN: 'Kai Garib',
        ADM3_PCODE: 'ZA3082',
        ADM3_REF: '',
        ADM3ALT1EN: '',
        ADM3ALT2EN: '',
        ADM2_EN: 'Z F Mgcawu',
        ADM2_PCODE: 'ZA308',
        ADM1_EN: 'Nothern Cape',
        ADM1_PCODE: 'ZA3',
        ADM0_EN: 'South Africa',
        ADM0_PCODE: 'ZA',
        date: '2018-12-27T00:00:00.000Z',
        validOn: '2020-11-09T00:00:00.000Z',
        validTo: '1899-11-30T00:00:00.000Z',
        ADM1_ID: 'NC',
        ADM2_ID: 'DC8',
        ADM3_ID: 'NC082',
      },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Polygon',
        coordinates: [
          [
            [19.083110653000062, -30.342430426999954],
            [19.010570526000038, -30.164569854999968],
            [19.011909485000047, -30.074069976999965],
            [18.908290863000047, -30.063850402999947],
            [18.859159470000066, -29.94660949699994],
            [18.86706924400005, -29.845760344999974],
            [18.808450699000048, -29.83167076099994],
            [18.725596495000048, -29.864108638999937],
            [18.605489997000063, -29.86041000199998],
            [18.493659973000035, -29.91807937599998],
            [18.36712000500006, -29.934800000999928],
            [18.333249994000028, -29.89559999399995],
            [18.219024793000074, -29.91100935199995],
            [18.208803792000026, -30.000553882999952],
            [18.000010002000067, -30.06589999399995],
            [17.863600003000045, -30.06668999599998],
            [17.732490003000066, -30.020719999999983],
            [17.603879995000057, -30.012490001999936],
            [17.519239995000078, -29.949870000999965],
            [17.439129999000045, -30.03308999899997],
            [17.312240005000035, -30.092839996999942],
            [17.247240000000033, -30.003180004999933],
            [17.181000002000076, -30.061730000999944],
            [17.273790002000055, -30.33460000399998],
            [17.433960005000074, -30.620780001999947],
            [17.523589997000045, -30.735550001999968],
            [17.595329993000064, -30.90001000099994],
            [17.679419990000042, -30.99910000099993],
            [17.757580003000044, -31.15196999999995],
            [17.926409999000043, -31.011390002999974],
            [17.880299998000055, -30.92393999899997],
            [17.99337999900007, -30.91874000399997],
            [18.006479003000038, -30.791239995999945],
            [18.08917999700003, -30.787869995999984],
            [18.169180004000054, -30.848559998999974],
            [18.264169999000046, -30.818319993999978],
            [18.37103999900006, -30.659629996999968],
            [18.413759999000035, -30.527349999999956],
            [18.502150001000075, -30.44442000199996],
            [18.570120003000056, -30.43025999799994],
            [18.65514954100007, -30.556709298999976],
            [18.758710861000054, -30.56786918599994],
            [18.794500351000067, -30.667619704999936],
            [18.951480022000055, -30.74443989799994],
            [19.00597000600004, -30.49702999999994],
            [19.083110653000062, -30.342430426999954],
          ],
        ],
      },
      properties: {
        Shape_Leng: 7.3900919795,
        Shape_Area: 1.33340681733,
        ADM3_EN: 'Kamiesberg',
        ADM3_PCODE: 'ZA3064',
        ADM3_REF: '',
        ADM3ALT1EN: '',
        ADM3ALT2EN: '',
        ADM2_EN: 'Namakwa',
        ADM2_PCODE: 'ZA306',
        ADM1_EN: 'Nothern Cape',
        ADM1_PCODE: 'ZA3',
        ADM0_EN: 'South Africa',
        ADM0_PCODE: 'ZA',
        date: '2018-12-27T00:00:00.000Z',
        validOn: '2020-11-09T00:00:00.000Z',
        validTo: '1899-11-30T00:00:00.000Z',
        ADM1_ID: 'NC',
        ADM2_ID: 'DC6',
        ADM3_ID: 'NC064',
      },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Polygon',
        coordinates: [
          [
            [21.902079997000044, -33.36495998799995],
            [21.82723999700005, -33.391039999999975],
            [21.611950001000025, -33.39679999999993],
            [21.43310000200006, -33.39417000299994],
            [21.00971000100003, -33.43926999599995],
            [20.921800000000076, -33.43065000099995],
            [20.762000002000036, -33.490839989999984],
            [20.547599998000067, -33.51951999599993],
            [20.503258997000046, -33.63700000199998],
            [20.66602000200004, -33.621970003999934],
            [20.800259999000048, -33.71500999899996],
            [21.010339999000053, -33.75656000099997],
            [20.943380000000047, -33.85187000199994],
            [21.084609999000065, -33.82291999699993],
            [21.371060003000025, -33.81989999799998],
            [21.423320000000047, -33.84758999899998],
            [21.64827000400004, -33.83040999599996],
            [21.740035060000025, -33.79614592699994],
            [21.72279999600005, -33.70531999599996],
            [21.837480004000042, -33.737309996999954],
            [21.935039999000026, -33.66770000399998],
            [21.936273998000047, -33.524975996999956],
            [21.902079997000044, -33.36495998799995],
          ],
        ],
      },
      properties: {
        Shape_Leng: 4.26917976412,
        Shape_Area: 0.462917053989,
        ADM3_EN: 'Kannaland',
        ADM3_PCODE: 'ZA1041',
        ADM3_REF: '',
        ADM3ALT1EN: '',
        ADM3ALT2EN: '',
        ADM2_EN: 'Eden',
        ADM2_PCODE: 'ZA104',
        ADM1_EN: 'Western Cape',
        ADM1_PCODE: 'ZA1',
        ADM0_EN: 'South Africa',
        ADM0_PCODE: 'ZA',
        date: '2018-12-27T00:00:00.000Z',
        validOn: '2020-11-09T00:00:00.000Z',
        validTo: '1899-11-30T00:00:00.000Z',
        ADM1_ID: 'WC',
        ADM2_ID: 'DC4',
        ADM3_ID: 'WC041',
      },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Polygon',
        coordinates: [
          [
            [22.014210001000038, -30.005780001999938],
            [21.914559999000062, -29.99111000199997],
            [21.832669999000075, -30.02786999799997],
            [21.694749994000063, -29.99543999699995],
            [21.507410005000054, -30.031300002999956],
            [21.425669999000036, -29.98637999899995],
            [21.242980001000035, -30.039089993999937],
            [21.165240002000075, -30.08564999999993],
            [21.143060010000056, -30.25622992199993],
            [21.251485715000058, -30.39702336299996],
            [21.308110001000045, -30.543559998999967],
            [21.270914998000023, -30.58946999799997],
            [21.420920005000028, -30.728590003999955],
            [21.493310000000065, -30.82814000199994],
            [21.483030000000042, -30.993860000999973],
            [21.509820001000037, -31.057220004999976],
            [21.670689993000053, -31.09759999099998],
            [21.700109998000073, -31.063510004999955],
            [21.84595000400003, -31.064089998999975],
            [22.003210005000028, -31.01237000599997],
            [22.082209996000074, -31.05149999899993],
            [22.077040002000047, -31.13426999799998],
            [22.18747999200008, -31.168899995999936],
            [22.443519997000067, -31.13095000499993],
            [22.49762999400008, -31.095800003999955],
            [22.462409981000064, -31.00684083599998],
            [22.664740004000066, -30.954339997999966],
            [22.78191000100003, -30.947620006999955],
            [22.896609996000052, -30.879749998999955],
            [23.056190006000065, -30.88226999899996],
            [23.109370006000063, -30.828209998999967],
            [23.067449999000075, -30.799329997999962],
            [23.064460002000033, -30.65116999299994],
            [23.094329997000045, -30.56744999899996],
            [23.242530001000034, -30.54131999699996],
            [23.230259997000076, -30.39873000199998],
            [22.997989996000058, -30.377350010999976],
            [22.982039997000072, -30.238129999999956],
            [22.93757000000005, -30.123549999999966],
            [22.748339995000038, -30.079269994999947],
            [22.64779999500007, -30.130230000999973],
            [22.60809000000006, -30.199300002999962],
            [22.523539997000057, -30.15835999899997],
            [22.466299999000057, -30.190420005999954],
            [22.299599989000058, -30.196430008999982],
            [22.208989994000035, -30.12486999799995],
            [22.034579999000073, -30.05758999899996],
            [22.014210001000038, -30.005780001999938],
          ],
        ],
      },
      properties: {
        Shape_Leng: 7.54047945138,
        Shape_Area: 1.66399524777,
        ADM3_EN: 'Kareeberg',
        ADM3_PCODE: 'ZA3074',
        ADM3_REF: '',
        ADM3ALT1EN: '',
        ADM3ALT2EN: '',
        ADM2_EN: 'Pixley ka Seme',
        ADM2_PCODE: 'ZA307',
        ADM1_EN: 'Nothern Cape',
        ADM1_PCODE: 'ZA3',
        ADM0_EN: 'South Africa',
        ADM0_PCODE: 'ZA',
        date: '2018-12-27T00:00:00.000Z',
        validOn: '2020-11-09T00:00:00.000Z',
        validTo: '1899-11-30T00:00:00.000Z',
        ADM1_ID: 'NC',
        ADM2_ID: 'DC7',
        ADM3_ID: 'NC074',
      },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Polygon',
        coordinates: [
          [
            [21.670689993000053, -31.09759999099998],
            [21.509820001000037, -31.057220004999976],
            [21.483030000000042, -30.993860000999973],
            [21.493310000000065, -30.82814000199994],
            [21.420920005000028, -30.728590003999955],
            [21.270914998000023, -30.58946999799997],
            [21.308110001000045, -30.543559998999967],
            [21.251485715000058, -30.39702336299996],
            [21.055962842000042, -30.485085638999976],
            [20.92542594300005, -30.50003415699996],
            [20.938535434000073, -30.61665292799995],
            [20.615560091000077, -30.654913388999944],
            [20.383159999000043, -30.81525999799993],
            [20.459320002000027, -30.898930002999975],
            [20.389879999000073, -30.95676499399997],
            [20.351190004000046, -31.090939996999964],
            [20.403079998000067, -31.18552000099993],
            [20.54742999700005, -31.201530005999928],
            [20.59158000700006, -31.310629998999957],
            [20.557600001000026, -31.604780003999963],
            [20.610494997000046, -31.657463999999948],
            [20.562474999000074, -31.72275300299998],
            [20.648430004000033, -31.84450000099997],
            [20.371859999000037, -31.822040002999984],
            [20.280049993000034, -32.012410003999946],
            [20.27734815100007, -32.08378968099993],
            [20.16472000600004, -32.087359996999965],
            [20.151830002000054, -32.18651999499997],
            [20.240840003000073, -32.22418999599995],
            [20.096810000000062, -32.50295999699995],
            [20.187609997000038, -32.752670002999935],
            [20.299899996000022, -32.80495999899995],
            [20.43859999500006, -32.940060003999974],
            [20.59210000400003, -32.92646999899995],
            [20.731170002000056, -32.944994994999945],
            [20.832430000000045, -32.81737000299995],
            [20.792200000000037, -32.73503001199998],
            [20.84410000400004, -32.66243999499994],
            [20.962780000000066, -32.639299996999966],
            [21.06028999600005, -32.65550000199994],
            [21.188309998000022, -32.50304999499997],
            [21.303010011000026, -32.402440001999935],
            [21.561809999000047, -32.314730001999976],
            [21.536010000000033, -32.22922000999995],
            [21.64457999800004, -32.20871000099993],
            [21.691649995000034, -32.24857000199995],
            [21.855109998000046, -32.275509994999936],
            [21.995920002000048, -32.20298000399998],
            [22.016439990000038, -32.11425999499994],
            [22.094980004000035, -32.00105999899995],
            [22.07133000300007, -31.939299996999978],
            [22.166599999000027, -31.893089998999983],
            [22.20401000000004, -31.76403000199997],
            [22.049580002000027, -31.76997999899993],
            [21.915515003000053, -31.645715000999928],
            [22.01165999500006, -31.590449999999976],
            [21.961949997000033, -31.512200003999965],
            [21.865479994000054, -31.49732000499995],
            [21.880160001000036, -31.399520003999953],
            [21.76240000300004, -31.27140000099996],
            [21.614755002000038, -31.24990099799993],
            [21.621859994000033, -31.15135999399996],
            [21.670689993000053, -31.09759999099998],
          ],
        ],
      },
      properties: {
        Shape_Leng: 11.1782108756,
        Shape_Area: 2.87695045928,
        ADM3_EN: 'Karoo Hoogland',
        ADM3_PCODE: 'ZA3066',
        ADM3_REF: '',
        ADM3ALT1EN: '',
        ADM3ALT2EN: '',
        ADM2_EN: 'Namakwa',
        ADM2_PCODE: 'ZA306',
        ADM1_EN: 'Nothern Cape',
        ADM1_PCODE: 'ZA3',
        ADM0_EN: 'South Africa',
        ADM0_PCODE: 'ZA',
        date: '2018-12-27T00:00:00.000Z',
        validOn: '2020-11-09T00:00:00.000Z',
        validTo: '1899-11-30T00:00:00.000Z',
        ADM1_ID: 'NC',
        ADM2_ID: 'DC6',
        ADM3_ID: 'NC066',
      },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Polygon',
        coordinates: [
          [
            [23.75470000000007, -28.52878000399994],
            [23.828049990000068, -28.39098000299998],
            [23.81438000000003, -28.333800002999965],
            [23.891420002000075, -28.12594000599995],
            [23.79066000200004, -28.082849995999936],
            [23.834599996000065, -28.015079999999955],
            [23.580930004000038, -27.879310000999965],
            [23.443899998000063, -27.955179999999928],
            [23.362025980000055, -27.942167130999962],
            [23.441180006000025, -28.085999994999952],
            [23.523630001000072, -28.095299999999952],
            [23.398839991000045, -28.282359999999983],
            [23.388720001000024, -28.371629989999974],
            [23.56819000300004, -28.449910000999978],
            [23.54312900000008, -28.517288002999976],
            [23.706969999000023, -28.58772000099998],
            [23.75470000000007, -28.52878000399994],
          ],
        ],
      },
      properties: {
        Shape_Leng: 2.37264702957,
        Shape_Area: 0.227825593793,
        ADM3_EN: 'Kgatelopele',
        ADM3_PCODE: 'ZA3086',
        ADM3_REF: '',
        ADM3ALT1EN: '',
        ADM3ALT2EN: '',
        ADM2_EN: 'Z F Mgcawu',
        ADM2_PCODE: 'ZA308',
        ADM1_EN: 'Nothern Cape',
        ADM1_PCODE: 'ZA3',
        ADM0_EN: 'South Africa',
        ADM0_PCODE: 'ZA',
        date: '2018-12-27T00:00:00.000Z',
        validOn: '2020-11-09T00:00:00.000Z',
        validTo: '1899-11-30T00:00:00.000Z',
        ADM1_ID: 'NC',
        ADM2_ID: 'DC8',
        ADM3_ID: 'NC086',
      },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Polygon',
        coordinates: [
          [
            [27.00336000200008, -25.38999000399997],
            [26.760519996000028, -25.359200002999955],
            [26.648690002000023, -25.44761000099993],
            [26.506016002000024, -25.501890998999954],
            [26.511230003000037, -25.65521999999993],
            [26.462370000000078, -25.745369995999965],
            [26.580030006000072, -25.782679995999956],
            [26.643529998000076, -25.868000000999928],
            [26.77055000200005, -25.95232999999996],
            [26.807079999000052, -26.084029998999938],
            [26.974799999000027, -26.065050000999975],
            [27.053780004000032, -26.10068999899994],
            [27.169850000000054, -26.080229996999947],
            [27.165166000000056, -25.992083996999952],
            [27.20817000200003, -25.85476999699995],
            [27.132670001000065, -25.80929999799997],
            [27.158510000000035, -25.668479997999953],
            [27.01506000200004, -25.46314999599997],
            [27.00336000200008, -25.38999000399997],
          ],
        ],
      },
      properties: {
        Shape_Leng: 3.16662920061,
        Shape_Area: 0.357382643909,
        ADM3_EN: 'Kgetlengrivier',
        ADM3_PCODE: 'ZA6374',
        ADM3_REF: '',
        ADM3ALT1EN: '',
        ADM3ALT2EN: '',
        ADM2_EN: 'Bojanala',
        ADM2_PCODE: 'ZA637',
        ADM1_EN: 'North West',
        ADM1_PCODE: 'ZA6',
        ADM0_EN: 'South Africa',
        ADM0_PCODE: 'ZA',
        date: '2018-12-27T00:00:00.000Z',
        validOn: '2020-11-09T00:00:00.000Z',
        validTo: '1899-11-30T00:00:00.000Z',
        ADM1_ID: 'NW',
        ADM2_ID: 'DC37',
        ADM3_ID: 'NW374',
      },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Polygon',
        coordinates: [
          [
            [19.88141577600004, -29.777029720999963],
            [19.659080006000067, -29.793019999999956],
            [19.574820000000045, -29.72529000299994],
            [19.585969998000053, -29.609920000999978],
            [19.76216999600007, -29.58204000199993],
            [19.74025000200004, -29.428609989999984],
            [19.60131999600003, -29.27185000099996],
            [19.576690000000042, -29.09468199899993],
            [19.779510006000066, -28.87642000699998],
            [19.666229997000073, -28.82979000399996],
            [19.61911000400005, -28.690560009999956],
            [19.509289998000042, -28.596540000999937],
            [19.489680003000046, -28.681990000999974],
            [19.405399998000064, -28.73625999999996],
            [19.269790002000036, -28.74202999599993],
            [19.239820002000044, -28.805799999999977],
            [19.284870002000048, -28.90855999599995],
            [19.118289996000044, -28.969439998999974],
            [19.005929999000045, -28.924270003999936],
            [18.93564000400005, -28.857239995999976],
            [18.728670004000037, -28.83170000299998],
            [18.51208000400004, -28.88948000399995],
            [18.619520005000027, -29.01807000499997],
            [18.595510002000026, -29.138489997999955],
            [18.642949998000063, -29.218010000999982],
            [18.651000003000036, -29.421729995999954],
            [18.74867000000006, -29.418060000999958],
            [18.776649517000067, -29.48357621799994],
            [18.761089325000057, -29.675640105999946],
            [18.808450699000048, -29.83167076099994],
            [18.86706924400005, -29.845760344999974],
            [18.859159470000066, -29.94660949699994],
            [18.908290863000047, -30.063850402999947],
            [19.011909485000047, -30.074069976999965],
            [19.010570526000038, -30.164569854999968],
            [19.083110653000062, -30.342430426999954],
            [19.298139999000057, -30.25407999899994],
            [19.368379996000044, -30.296359999999936],
            [19.533789999000078, -30.316980004999948],
            [19.65014999500005, -30.37897000499993],
            [19.80409999500006, -30.38556000099993],
            [20.002280002000077, -30.279270004999944],
            [19.878073176000044, -30.228297167999983],
            [19.839409490000037, -30.14641333399993],
            [19.888157084000056, -30.093689299999937],
            [19.786281221000024, -29.87555758299993],
            [19.88141577600004, -29.777029720999963],
          ],
        ],
      },
      properties: {
        Shape_Leng: 7.2478410001,
        Shape_Area: 1.46267798315,
        ADM3_EN: 'Khâi-Ma',
        ADM3_PCODE: 'ZA3067',
        ADM3_REF: 'Khai-Ma',
        ADM3ALT1EN: '',
        ADM3ALT2EN: '',
        ADM2_EN: 'Namakwa',
        ADM2_PCODE: 'ZA306',
        ADM1_EN: 'Nothern Cape',
        ADM1_PCODE: 'ZA3',
        ADM0_EN: 'South Africa',
        ADM0_PCODE: 'ZA',
        date: '2018-12-27T00:00:00.000Z',
        validOn: '2020-11-09T00:00:00.000Z',
        validTo: '1899-11-30T00:00:00.000Z',
        ADM1_ID: 'NC',
        ADM2_ID: 'DC6',
        ADM3_ID: 'NC067',
      },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Polygon',
        coordinates: [
          [
            [22.123329994000073, -28.76320000299995],
            [21.926629994000052, -28.520519999999976],
            [21.90071000000006, -28.425209999999936],
            [21.837610093000023, -28.38274006399996],
            [21.738519995000047, -28.47525000099995],
            [21.609987000000046, -28.551045001999967],
            [21.34179999400004, -28.631930000999944],
            [21.260460005000027, -28.711480002999963],
            [21.125769997000077, -28.831600006999963],
            [21.251049996000063, -28.930944996999983],
            [21.211321918000067, -29.00890848699993],
            [21.308571252000036, -29.06743649799995],
            [21.301664241000026, -29.154666990999942],
            [21.182412257000067, -29.25857309299994],
            [21.274170001000073, -29.35798000699998],
            [21.27092000500005, -29.46521999899994],
            [21.19539999400007, -29.63724999699997],
            [21.27204000300003, -29.736279998999976],
            [21.154130002000045, -29.872619999999984],
            [21.305260006000026, -29.980409994999945],
            [21.242980001000035, -30.039089993999937],
            [21.425669999000036, -29.98637999899995],
            [21.507410005000054, -30.031300002999956],
            [21.694749994000063, -29.99543999699995],
            [21.832669999000075, -30.02786999799997],
            [21.914559999000062, -29.99111000199997],
            [22.014210001000038, -30.005780001999938],
            [22.010350005000078, -29.90244000499996],
            [21.81141999400006, -29.84196000299994],
            [21.721610000000055, -29.77482000699996],
            [21.829969998000024, -29.62319000599996],
            [21.784930006000025, -29.556609996999953],
            [21.89981999400004, -29.44913000599996],
            [21.845669998000062, -29.395889998999962],
            [21.979309998000076, -29.277759998999954],
            [21.83810815000004, -29.097364179999943],
            [21.95861999600004, -29.015709998999967],
            [21.990960001000076, -28.94607000299993],
            [22.086310000000026, -28.950620004999962],
            [22.217938996000044, -29.098789993999958],
            [22.142559995000056, -28.914550006999946],
            [22.041870001000063, -28.839910001999954],
            [22.123329994000073, -28.76320000299995],
          ],
        ],
      },
      properties: {
        Shape_Leng: 6.42839834465,
        Shape_Area: 1.03076946142,
        ADM3_EN: 'Kheis',
        ADM3_PCODE: 'ZA3084',
        ADM3_REF: '',
        ADM3ALT1EN: '',
        ADM3ALT2EN: '',
        ADM2_EN: 'Z F Mgcawu',
        ADM2_PCODE: 'ZA308',
        ADM1_EN: 'Nothern Cape',
        ADM1_PCODE: 'ZA3',
        ADM0_EN: 'South Africa',
        ADM0_PCODE: 'ZA',
        date: '2018-12-27T00:00:00.000Z',
        validOn: '2020-11-09T00:00:00.000Z',
        validTo: '1899-11-30T00:00:00.000Z',
        ADM1_ID: 'NC',
        ADM2_ID: 'DC8',
        ADM3_ID: 'NC084',
      },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Polygon',
        coordinates: [
          [
            [28.75467999700004, -31.485959996999952],
            [28.65908999900006, -31.449470000999952],
            [28.527210000000025, -31.49379999699994],
            [28.38231999900006, -31.48055000499994],
            [28.38126500100003, -31.48000000099995],
            [28.38110000300003, -31.558009996999942],
            [28.309010002000036, -31.618319996999958],
            [28.351969998000072, -31.828649999999982],
            [28.427450011000076, -31.870229996999967],
            [28.46518999700004, -31.96782000199994],
            [28.597819996000055, -31.97172999999998],
            [28.782199997000077, -32.045999999999935],
            [28.925870003000057, -31.94461999899994],
            [29.09341000300003, -32.05934999799996],
            [29.186300001000063, -31.949629997999978],
            [29.09648000100003, -31.87912999799994],
            [28.949460000000045, -31.835159999999973],
            [28.820739999000068, -31.686599996999973],
            [28.812939999000037, -31.50752999799994],
            [28.75467999700004, -31.485959996999952],
          ],
        ],
      },
      properties: {
        Shape_Leng: 5.25163651957,
        Shape_Area: 0.287395039396,
        ADM3_EN: 'King Sabata Dalindyebo',
        ADM3_PCODE: 'ZA2157',
        ADM3_REF: '',
        ADM3ALT1EN: '',
        ADM3ALT2EN: '',
        ADM2_EN: 'O.R.Tambo',
        ADM2_PCODE: 'ZA215',
        ADM1_EN: 'Eastern Cape',
        ADM1_PCODE: 'ZA2',
        ADM0_EN: 'South Africa',
        ADM0_PCODE: 'ZA',
        date: '2018-12-27T00:00:00.000Z',
        validOn: '2020-11-09T00:00:00.000Z',
        validTo: '1899-11-30T00:00:00.000Z',
        ADM1_ID: 'EC',
        ADM2_ID: 'DC15',
        ADM3_ID: 'EC157',
      },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Polygon',
        coordinates: [
          [
            [23.22901000300004, -33.87834999699993],
            [23.076460000000054, -33.80858000199993],
            [22.876550004000023, -33.815959996999936],
            [22.800279998000065, -33.84118000299998],
            [22.770545002000063, -34.02744999899994],
            [22.970259997000028, -34.08607000799998],
            [23.164119998000047, -34.08305000099995],
            [23.168739996000056, -34.006250001999945],
            [23.22901000300004, -33.87834999699993],
          ],
        ],
      },
      properties: {
        Shape_Leng: 1.65049446238,
        Shape_Area: 0.10813140644,
        ADM3_EN: 'Knysna',
        ADM3_PCODE: 'ZA1048',
        ADM3_REF: '',
        ADM3ALT1EN: '',
        ADM3ALT2EN: '',
        ADM2_EN: 'Eden',
        ADM2_PCODE: 'ZA104',
        ADM1_EN: 'Western Cape',
        ADM1_PCODE: 'ZA1',
        ADM0_EN: 'South Africa',
        ADM0_PCODE: 'ZA',
        date: '2018-12-27T00:00:00.000Z',
        validOn: '2020-11-09T00:00:00.000Z',
        validTo: '1899-11-30T00:00:00.000Z',
        ADM1_ID: 'WC',
        ADM2_ID: 'DC4',
        ADM3_ID: 'WC048',
      },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Polygon',
        coordinates: [
          [
            [25.74124000000006, -29.226039999999955],
            [25.611300003000053, -29.22368000199998],
            [25.48107000300007, -29.30731999799997],
            [25.51446999700005, -29.396549999999934],
            [25.487039997000068, -29.558379999999943],
            [25.334260004000043, -29.663089998999965],
            [25.290639999000064, -29.594160003999946],
            [25.200680000000034, -29.624979999999937],
            [25.163710003000062, -29.533950001999983],
            [25.013330000000053, -29.635550002999935],
            [24.953770001000066, -29.647430002999954],
            [24.975579999000047, -29.914909999999963],
            [24.89881000300005, -29.92291000399996],
            [24.86915016200004, -30.025550841999973],
            [24.798487668000064, -30.03417014699994],
            [24.90156000500008, -30.208240003999947],
            [24.950169006000067, -30.224845002999928],
            [25.035619999000062, -30.34420999799994],
            [25.307119999000065, -30.57707999799993],
            [25.376580002000026, -30.55988999699997],
            [25.467099997000048, -30.624210010999946],
            [25.60308999700004, -30.594389999999976],
            [25.63086000000004, -30.65934999999996],
            [25.778900001000068, -30.67587999999995],
            [25.973089990000062, -30.53938999299993],
            [26.162559999000052, -30.483489996999936],
            [26.280609999000035, -30.57835999799994],
            [26.323570003000043, -30.502430001999983],
            [26.167120000000068, -30.272320001999958],
            [26.144799998000053, -30.166320002999953],
            [26.26020000400007, -30.03568000399997],
            [26.19140999900003, -29.93883999999997],
            [26.250320007000028, -29.83436999299994],
            [26.38681000200006, -29.74058999999994],
            [26.42430999900006, -29.661220000999947],
            [26.38225999900004, -29.61614000399993],
            [26.285309993000055, -29.59818999199996],
            [26.22419000900004, -29.47957999399995],
            [26.07777000300007, -29.47969000599994],
            [26.032304999000075, -29.41709499899997],
            [25.992639989000054, -29.27310999799994],
            [25.74124000000006, -29.226039999999955],
          ],
        ],
      },
      properties: {
        Shape_Leng: 7.86910548732,
        Shape_Area: 1.46245002387,
        ADM3_EN: 'Kopanong',
        ADM3_PCODE: 'ZA4162',
        ADM3_REF: '',
        ADM3ALT1EN: '',
        ADM3ALT2EN: '',
        ADM2_EN: 'Xhariep',
        ADM2_PCODE: 'ZA416',
        ADM1_EN: 'Free State',
        ADM1_PCODE: 'ZA4',
        ADM0_EN: 'South Africa',
        ADM0_PCODE: 'ZA',
        date: '2018-12-27T00:00:00.000Z',
        validOn: '2020-11-09T00:00:00.000Z',
        validTo: '1899-11-30T00:00:00.000Z',
        ADM1_ID: 'FS',
        ADM2_ID: 'DC16',
        ADM3_ID: 'FS162',
      },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Polygon',
        coordinates: [
          [
            [24.499620832000062, -33.77845492599994],
            [24.290979996000033, -33.71189999999996],
            [24.187689996000074, -33.764760000999956],
            [24.060740003000035, -33.69838999899997],
            [23.72229000300007, -33.61748999699995],
            [23.61687000300003, -33.570239998999966],
            [23.670440004000056, -33.67255999799994],
            [23.555529998000054, -33.67295999799995],
            [23.43994000200007, -33.717390000999956],
            [23.395039996000037, -33.79263999899996],
            [23.517920004000075, -33.78562000299996],
            [23.65522999800004, -33.88738999699996],
            [23.647020000000055, -33.98055999999997],
            [23.846519999000066, -34.02708999999993],
            [24.193609999000046, -34.066030001999934],
            [24.38194999700005, -34.10308000099997],
            [24.444949999000073, -34.14358999899997],
            [24.62037999900008, -34.01379000099996],
            [24.494579999000052, -33.95100999899995],
            [24.517700000000048, -33.88763000199998],
            [24.632519999000067, -33.87440999699993],
            [24.661859998000068, -33.80725000199993],
            [24.499620832000062, -33.77845492599994],
          ],
        ],
      },
      properties: {
        Shape_Leng: 4.11542641797,
        Shape_Area: 0.354842917006,
        ADM3_EN: 'Kou-Kamma',
        ADM3_PCODE: 'ZA2109',
        ADM3_REF: '',
        ADM3ALT1EN: '',
        ADM3ALT2EN: '',
        ADM2_EN: 'Cacadu',
        ADM2_PCODE: 'ZA210',
        ADM1_EN: 'Eastern Cape',
        ADM1_PCODE: 'ZA2',
        ADM0_EN: 'South Africa',
        ADM0_PCODE: 'ZA',
        date: '2018-12-27T00:00:00.000Z',
        validOn: '2020-11-09T00:00:00.000Z',
        validTo: '1899-11-30T00:00:00.000Z',
        ADM1_ID: 'EC',
        ADM2_ID: 'DC10',
        ADM3_ID: 'EC109',
      },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Polygon',
        coordinates: [
          [
            [25.235029991000033, -33.83690000099995],
            [25.081420003000062, -33.78668000299996],
            [24.829460003000065, -33.64256999699995],
            [24.730740001000072, -33.62038000199993],
            [24.53532000000007, -33.66285999999997],
            [24.499620832000062, -33.77845492599994],
            [24.661859998000068, -33.80725000199993],
            [24.632519999000067, -33.87440999699993],
            [24.517700000000048, -33.88763000199998],
            [24.494579999000052, -33.95100999899995],
            [24.62037999900008, -34.01379000099996],
            [24.444949999000073, -34.14358999899997],
            [24.599060000000065, -34.18793000199997],
            [24.65895000300003, -34.174910000999944],
            [24.827279997000062, -34.211150001999954],
            [24.842940002000034, -34.141580001999955],
            [24.921540004000065, -34.078840000999946],
            [24.93680000100005, -34.005540002999965],
            [25.07785000000007, -33.964749998999935],
            [25.221490003000042, -33.97076999999996],
            [25.235029991000033, -33.83690000099995],
          ],
        ],
      },
      properties: {
        Shape_Leng: 3.46956160145,
        Shape_Area: 0.260310487183,
        ADM3_EN: 'Kouga',
        ADM3_PCODE: 'ZA2108',
        ADM3_REF: '',
        ADM3ALT1EN: '',
        ADM3ALT2EN: '',
        ADM2_EN: 'Cacadu',
        ADM2_PCODE: 'ZA210',
        ADM1_EN: 'Eastern Cape',
        ADM1_PCODE: 'ZA2',
        ADM0_EN: 'South Africa',
        ADM0_PCODE: 'ZA',
        date: '2018-12-27T00:00:00.000Z',
        validOn: '2020-11-09T00:00:00.000Z',
        validTo: '1899-11-30T00:00:00.000Z',
        ADM1_ID: 'EC',
        ADM2_ID: 'DC10',
        ADM3_ID: 'EC108',
      },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Polygon',
        coordinates: [
          [
            [31.47476994400006, -29.25055006499997],
            [31.369890000000055, -29.248049999999978],
            [31.31832098900003, -29.15002999999996],
            [31.288724944000023, -29.16400993999997],
            [31.234284944000024, -29.180706939999936],
            [31.16599294400004, -29.25839093999997],
            [31.182687944000065, -29.352972939999972],
            [31.05069994300004, -29.48628006499996],
            [31.094409943000073, -29.538089939999963],
            [31.185754944000053, -29.57178493999993],
            [31.34081994400003, -29.382049939999945],
            [31.47476994400006, -29.25055006499997],
          ],
        ],
      },
      properties: {
        Shape_Leng: 2.05621689902,
        Shape_Area: 0.0682853921263,
        ADM3_EN: 'KwaDukuza',
        ADM3_PCODE: 'ZA5292',
        ADM3_REF: '',
        ADM3ALT1EN: '',
        ADM3ALT2EN: '',
        ADM2_EN: 'iLembe',
        ADM2_PCODE: 'ZA529',
        ADM1_EN: 'KwaZulu-Natal',
        ADM1_PCODE: 'ZA5',
        ADM0_EN: 'South Africa',
        ADM0_PCODE: 'ZA',
        date: '2018-12-27T00:00:00.000Z',
        validOn: '2020-11-09T00:00:00.000Z',
        validTo: '1899-11-30T00:00:00.000Z',
        ADM1_ID: 'KZN',
        ADM2_ID: 'DC29',
        ADM3_ID: 'KZN292',
      },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Polygon',
        coordinates: [
          [
            [21.432109997000055, -32.75672999699998],
            [21.426580004000073, -32.66712999799995],
            [21.35224000100004, -32.65772999899997],
            [21.188309998000022, -32.50304999499997],
            [21.06028999600005, -32.65550000199994],
            [20.962780000000066, -32.639299996999966],
            [20.84410000400004, -32.66243999499994],
            [20.792200000000037, -32.73503001199998],
            [20.832430000000045, -32.81737000299995],
            [20.731170002000056, -32.944994994999945],
            [20.59210000400003, -32.92646999899995],
            [20.43859999500006, -32.940060003999974],
            [20.383750003000046, -33.03627999999998],
            [20.302549999000064, -33.067999992999944],
            [20.306440000000066, -33.15933999899994],
            [20.202179999000066, -33.17010999799993],
            [20.257969999000068, -33.18844999099997],
            [20.209170001000075, -33.379799996999964],
            [20.368039999000075, -33.36626999999993],
            [20.336220000000026, -33.48781999099998],
            [20.49801999700003, -33.463870002999954],
            [20.547599998000067, -33.51951999599993],
            [20.762000002000036, -33.490839989999984],
            [20.921800000000076, -33.43065000099995],
            [21.00971000100003, -33.43926999599995],
            [21.43310000200006, -33.39417000299994],
            [21.611950001000025, -33.39679999999993],
            [21.637269998000022, -33.14128000299996],
            [21.578090002000067, -33.11589000299995],
            [21.395930001000067, -32.937919997999984],
            [21.432109997000055, -32.75672999699998],
          ],
        ],
      },
      properties: {
        Shape_Leng: 5.5011410155,
        Shape_Area: 0.84855054254,
        ADM3_EN: 'Laingsburg',
        ADM3_PCODE: 'ZA1051',
        ADM3_REF: '',
        ADM3ALT1EN: '',
        ADM3ALT2EN: '',
        ADM2_EN: 'Central Karoo',
        ADM2_PCODE: 'ZA105',
        ADM1_EN: 'Western Cape',
        ADM1_PCODE: 'ZA1',
        ADM0_EN: 'South Africa',
        ADM0_PCODE: 'ZA',
        date: '2018-12-27T00:00:00.000Z',
        validOn: '2020-11-09T00:00:00.000Z',
        validTo: '1899-11-30T00:00:00.000Z',
        ADM1_ID: 'WC',
        ADM2_ID: 'DC5',
        ADM3_ID: 'WC051',
      },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Polygon',
        coordinates: [
          [
            [20.547599998000067, -33.51951999599993],
            [20.49801999700003, -33.463870002999954],
            [20.336220000000026, -33.48781999099998],
            [20.24153099700004, -33.53804599699998],
            [19.992483868000022, -33.556838168999946],
            [19.91710001100006, -33.51927000099994],
            [19.637590002000024, -33.536550001999956],
            [19.69963000100006, -33.63793000199996],
            [19.681389998000043, -33.79936999999995],
            [19.532279998000035, -33.878429998999934],
            [19.506889998000077, -33.97169999999994],
            [19.700139997000065, -34.046400001999984],
            [20.007460002000073, -34.09391999899998],
            [20.19609000300005, -34.03999999699994],
            [20.29133999900006, -34.09129999999993],
            [20.324430000000064, -33.94957000299996],
            [20.436040003000073, -33.95774000799997],
            [20.43534999900004, -33.82639999999998],
            [20.503258997000046, -33.63700000199998],
            [20.547599998000067, -33.51951999599993],
          ],
        ],
      },
      properties: {
        Shape_Leng: 4.38281696494,
        Shape_Area: 0.439759149368,
        ADM3_EN: 'Langeberg',
        ADM3_PCODE: 'ZA1026',
        ADM3_REF: '',
        ADM3ALT1EN: '',
        ADM3ALT2EN: '',
        ADM2_EN: 'Cape Winelands',
        ADM2_PCODE: 'ZA102',
        ADM1_EN: 'Western Cape',
        ADM1_PCODE: 'ZA1',
        ADM0_EN: 'South Africa',
        ADM0_PCODE: 'ZA',
        date: '2018-12-27T00:00:00.000Z',
        validOn: '2020-11-09T00:00:00.000Z',
        validTo: '1899-11-30T00:00:00.000Z',
        ADM1_ID: 'WC',
        ADM2_ID: 'DC2',
        ADM3_ID: 'WC026',
      },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Polygon',
        coordinates: [
          [
            [29.842960000000062, -26.799460003999968],
            [29.82264400200006, -26.669365995999954],
            [29.640350003000037, -26.62790999899994],
            [29.61916999500005, -26.52905999799998],
            [29.486830000000054, -26.55331000299998],
            [29.459380003000035, -26.64670999699996],
            [29.22379999900005, -26.658330002999946],
            [29.24139999700003, -26.716839999999934],
            [28.99120000000005, -26.685969996999972],
            [28.99211000400004, -26.608889999999974],
            [28.897497628000053, -26.62397787699996],
            [28.93213999900007, -26.71104999599993],
            [28.88269999700003, -26.75741000299996],
            [28.917940002000023, -26.843039999999974],
            [28.851600003000044, -26.923019998999962],
            [28.911099997000065, -27.01854000299994],
            [29.015141792000065, -27.00995693699997],
            [29.136369999000067, -27.154220002999978],
            [29.22980999400005, -27.16722999899997],
            [29.418859999000063, -27.254519999999957],
            [29.55040000300005, -27.18561000099993],
            [29.620230004000064, -27.074550002999956],
            [29.665229999000076, -26.943229998999982],
            [29.657430000000033, -26.86930000199993],
            [29.842960000000062, -26.799460003999968],
          ],
        ],
      },
      properties: {
        Shape_Leng: 4.69319963236,
        Shape_Area: 0.413919614496,
        ADM3_EN: 'Lekwa',
        ADM3_PCODE: 'ZA8305',
        ADM3_REF: '',
        ADM3ALT1EN: '',
        ADM3ALT2EN: '',
        ADM2_EN: 'Gert Sibande',
        ADM2_PCODE: 'ZA830',
        ADM1_EN: 'Mpumalanga',
        ADM1_PCODE: 'ZA8',
        ADM0_EN: 'South Africa',
        ADM0_PCODE: 'ZA',
        date: '2018-12-27T00:00:00.000Z',
        validOn: '2020-11-09T00:00:00.000Z',
        validTo: '1899-11-30T00:00:00.000Z',
        ADM1_ID: 'MP',
        ADM2_ID: 'DC30',
        ADM3_ID: 'MP305',
      },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Polygon',
        coordinates: [
          [
            [25.830239996000046, -27.566190002999974],
            [25.75372000300007, -27.53448999799997],
            [25.824801989000036, -27.363042002999975],
            [25.77230000000003, -27.209251999999935],
            [25.674375057000077, -27.222110529999952],
            [25.683379998000078, -27.336409999999944],
            [25.46993999600005, -27.391249994999953],
            [25.272590001000026, -27.40545999699998],
            [25.094339999000056, -27.462959999999953],
            [25.006389997000042, -27.524169997999934],
            [25.08783999600007, -27.657509996999977],
            [25.047909998000023, -27.69973999599995],
            [24.829840000000047, -27.931289999999933],
            [24.847410723000053, -27.957974664999938],
            [24.950559998000074, -28.11313999999993],
            [25.028080000000045, -28.07348000199994],
            [25.09060000200003, -27.984029998999972],
            [25.277410003000057, -27.795319995999932],
            [25.323529997000037, -27.793790000999934],
            [25.47943000300006, -27.69338000099998],
            [25.830239996000046, -27.566190002999974],
          ],
        ],
      },
      properties: {
        Shape_Leng: 3.96000082136,
        Shape_Area: 0.334096580455,
        ADM3_EN: 'Lekwa-Teemane',
        ADM3_PCODE: 'ZA6396',
        ADM3_REF: '',
        ADM3ALT1EN: '',
        ADM3ALT2EN: '',
        ADM2_EN: 'Dr Ruth Segomotsi Mompati',
        ADM2_PCODE: 'ZA639',
        ADM1_EN: 'North West',
        ADM1_PCODE: 'ZA6',
        ADM0_EN: 'South Africa',
        ADM0_PCODE: 'ZA',
        date: '2018-12-27T00:00:00.000Z',
        validOn: '2020-11-09T00:00:00.000Z',
        validTo: '1899-11-30T00:00:00.000Z',
        ADM1_ID: 'NW',
        ADM2_ID: 'DC39',
        ADM3_ID: 'NW396',
      },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Polygon',
        coordinates: [
          [
            [30.321530000000052, -24.12969000099997],
            [30.074549997000076, -24.01201999699998],
            [29.86374999900005, -23.95138000099996],
            [29.82726000300005, -24.040580000999967],
            [29.59651999600004, -24.18110998999998],
            [29.332289996000043, -24.296910002999937],
            [29.18896999900005, -24.256940002999954],
            [29.07267000400003, -24.20644999899997],
            [29.050850007000065, -24.37110999899994],
            [29.230420004000052, -24.337659997999936],
            [29.334540006000054, -24.55575000099998],
            [29.400489983000057, -24.608530019999932],
            [29.470755001000043, -24.640615002999937],
            [29.613280021000037, -24.459469980999927],
            [29.696560009000052, -24.46678998899995],
            [29.769109997000044, -24.272990001999972],
            [30.04109999600007, -24.20681999599998],
            [30.139430004000076, -24.247240002999945],
            [30.177500003000034, -24.304190000999938],
            [30.27315999700005, -24.320040002999974],
            [30.366215000000068, -24.283094996999978],
            [30.361639998000044, -24.16828000199996],
            [30.321530000000052, -24.12969000099997],
          ],
        ],
      },
      properties: {
        Shape_Leng: 4.34087078915,
        Shape_Area: 0.309797721451,
        ADM3_EN: 'Lepele-Nkumpi',
        ADM3_PCODE: 'ZA9355',
        ADM3_REF: '',
        ADM3ALT1EN: '',
        ADM3ALT2EN: '',
        ADM2_EN: 'Capricorn',
        ADM2_PCODE: 'ZA935',
        ADM1_EN: 'Limpopo',
        ADM1_PCODE: 'ZA9',
        ADM0_EN: 'South Africa',
        ADM0_PCODE: 'ZA',
        date: '2018-12-27T00:00:00.000Z',
        validOn: '2020-11-09T00:00:00.000Z',
        validTo: '1899-11-30T00:00:00.000Z',
        ADM1_ID: 'LIM',
        ADM2_ID: 'DC35',
        ADM3_ID: 'LIM355',
      },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Polygon',
        coordinates: [
          [
            [28.595938052000065, -23.40472805199994],
            [28.47404000000006, -23.31218999999993],
            [28.413290000000075, -23.351669999999956],
            [28.32009000000005, -23.204019999999957],
            [28.33707000000004, -23.12283999999994],
            [28.22434000000004, -23.04932999999994],
            [28.234560000000045, -22.96703999999994],
            [28.147640000000024, -22.916039999999953],
            [28.096936971000048, -22.811053028999936],
            [28.036819999000045, -22.913029998999946],
            [27.935290001000055, -22.965570001999936],
            [27.92054999800007, -23.067779996999946],
            [27.765299995000078, -23.142420001999938],
            [27.575579998000023, -23.261340003999976],
            [27.563889997000047, -23.34816000099994],
            [27.427040000000034, -23.42577999599996],
            [27.34881000300004, -23.397520001999965],
            [27.30296000100003, -23.46266000199995],
            [27.13405000000006, -23.53663998999997],
            [27.081149998000058, -23.643310002999954],
            [27.001056619000053, -23.68903439199994],
            [27.011089325000057, -23.790990828999952],
            [27.12767982500003, -23.953420638999944],
            [27.318460464000054, -24.028549193999936],
            [27.538343234000024, -24.16780973799996],
            [27.502357483000026, -24.219268798999963],
            [27.49366569500006, -24.355215072999954],
            [27.57467000300005, -24.42819999699998],
            [27.648829998000053, -24.35488000099997],
            [27.757870008000054, -24.404029999999977],
            [27.800519996000048, -24.308380003999957],
            [27.99956700300004, -24.308558000999938],
            [27.990230002000033, -24.180269996999982],
            [28.15887000400005, -24.15757999799996],
            [28.23605999600005, -24.005709999999965],
            [28.41582599900005, -23.99717700399998],
            [28.341249997000034, -23.918999998999936],
            [28.29962000100005, -23.804319998999972],
            [28.162660000000074, -23.63243999799994],
            [28.166709997000055, -23.508380003999946],
            [28.383020000000045, -23.438269996999963],
            [28.464309996000054, -23.54534001099995],
            [28.595938052000065, -23.40472805199994],
          ],
        ],
      },
      properties: {
        Shape_Leng: 8.0248304631,
        Shape_Area: 1.22101749743,
        ADM3_EN: 'Lephalale',
        ADM3_PCODE: 'ZA9362',
        ADM3_REF: '',
        ADM3ALT1EN: '',
        ADM3ALT2EN: '',
        ADM2_EN: 'Waterberg',
        ADM2_PCODE: 'ZA936',
        ADM1_EN: 'Limpopo',
        ADM1_PCODE: 'ZA9',
        ADM0_EN: 'South Africa',
        ADM0_PCODE: 'ZA',
        date: '2018-12-27T00:00:00.000Z',
        validOn: '2020-11-09T00:00:00.000Z',
        validTo: '1899-11-30T00:00:00.000Z',
        ADM1_ID: 'LIM',
        ADM2_ID: 'DC36',
        ADM3_ID: 'LIM362',
      },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Polygon',
        coordinates: [
          [
            [28.838440003000073, -26.340750001999936],
            [28.710120010000026, -26.34124000099996],
            [28.53053999900004, -26.225309994999975],
            [28.52715000300003, -26.178740003999962],
            [28.517879997000023, -26.361959997999975],
            [28.45023000200007, -26.440749996999955],
            [28.27401000100008, -26.358679997999957],
            [28.22039999900005, -26.43628000399997],
            [28.27136999700008, -26.50299999799995],
            [28.17946999700007, -26.57937000299995],
            [28.28172999900005, -26.67601000299993],
            [28.40009999700004, -26.655044999999973],
            [28.641620001000035, -26.507569995999972],
            [28.763910003000035, -26.518009998999958],
            [28.838440003000073, -26.340750001999936],
          ],
        ],
      },
      properties: {
        Shape_Leng: 3.08518870899,
        Shape_Area: 0.134348255045,
        ADM3_EN: 'Lesedi',
        ADM3_PCODE: 'ZA7423',
        ADM3_REF: '',
        ADM3ALT1EN: '',
        ADM3ALT2EN: '',
        ADM2_EN: 'Sedibeng',
        ADM2_PCODE: 'ZA742',
        ADM1_EN: 'Gauteng',
        ADM1_PCODE: 'ZA7',
        ADM0_EN: 'South Africa',
        ADM0_PCODE: 'ZA',
        date: '2018-12-27T00:00:00.000Z',
        validOn: '2020-11-09T00:00:00.000Z',
        validTo: '1899-11-30T00:00:00.000Z',
        ADM1_ID: 'GT',
        ADM2_ID: 'DC42',
        ADM3_ID: 'GT423',
      },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Polygon',
        coordinates: [
          [
            [25.745260002000066, -28.90640000299993],
            [25.529370003000054, -28.852530000999934],
            [25.39003999700003, -28.91682000199995],
            [25.24056999800007, -28.907160001999955],
            [25.112190000000055, -28.961339996999982],
            [25.085560000000044, -28.907610000999966],
            [24.959300002000077, -28.944860003999963],
            [24.80182700000006, -28.828258003999963],
            [24.691780003000076, -29.025719998999932],
            [24.34662000000003, -29.65592999599994],
            [24.411580000000072, -29.79073999999997],
            [24.470020000000034, -29.811780003999957],
            [24.67129999900004, -29.971449999999948],
            [24.798487668000064, -30.03417014699994],
            [24.86915016200004, -30.025550841999973],
            [24.89881000300005, -29.92291000399996],
            [24.975579999000047, -29.914909999999963],
            [24.953770001000066, -29.647430002999954],
            [25.013330000000053, -29.635550002999935],
            [25.163710003000062, -29.533950001999983],
            [25.200680000000034, -29.624979999999937],
            [25.290639999000064, -29.594160003999946],
            [25.334260004000043, -29.663089998999965],
            [25.487039997000068, -29.558379999999943],
            [25.51446999700005, -29.396549999999934],
            [25.48107000300007, -29.30731999799997],
            [25.611300003000053, -29.22368000199998],
            [25.74124000000006, -29.226039999999955],
            [25.719359998000073, -29.006290000999968],
            [25.745260002000066, -28.90640000299993],
          ],
        ],
      },
      properties: {
        Shape_Leng: 6.19574835937,
        Shape_Area: 0.913197042684,
        ADM3_EN: 'Letsemeng',
        ADM3_PCODE: 'ZA4161',
        ADM3_REF: '',
        ADM3ALT1EN: '',
        ADM3ALT2EN: '',
        ADM2_EN: 'Xhariep',
        ADM2_PCODE: 'ZA416',
        ADM1_EN: 'Free State',
        ADM1_PCODE: 'ZA4',
        ADM0_EN: 'South Africa',
        ADM0_PCODE: 'ZA',
        date: '2018-12-27T00:00:00.000Z',
        validOn: '2020-11-09T00:00:00.000Z',
        validTo: '1899-11-30T00:00:00.000Z',
        ADM1_ID: 'FS',
        ADM2_ID: 'DC16',
        ADM3_ID: 'FS161',
      },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Polygon',
        coordinates: [
          [
            [27.821660003000034, -24.974580001999982],
            [27.597490003000075, -24.984869999999944],
            [27.54359999600007, -25.09587999799993],
            [27.486900001000038, -25.07841999799996],
            [27.490199997000047, -25.197209999999927],
            [27.42797999800007, -25.289660004999973],
            [27.521150001000024, -25.341440000999967],
            [27.519299999000054, -25.41993999699997],
            [27.619709999000065, -25.475030002999972],
            [27.646519999000077, -25.65016000099996],
            [27.501219999000057, -25.637849999999958],
            [27.532289998000067, -25.849960000999943],
            [27.643549999000072, -25.79591999799993],
            [27.744549997000036, -25.894620002999943],
            [27.898200001000077, -25.859740003999946],
            [27.960169997000037, -25.815989996999974],
            [27.95763000100004, -25.59261999699993],
            [28.03595000400003, -25.470589996999934],
            [27.945639996000068, -25.40670000299997],
            [27.970759997000073, -25.362949989999947],
            [27.831360962000076, -25.20962038999994],
            [27.821660003000034, -24.974580001999982],
          ],
        ],
      },
      properties: {
        Shape_Leng: 3.83408816563,
        Shape_Area: 0.333854428243,
        ADM3_EN: 'Local Municipality of Madibeng',
        ADM3_PCODE: 'ZA6372',
        ADM3_REF: '',
        ADM3ALT1EN: '',
        ADM3ALT2EN: '',
        ADM2_EN: 'Bojanala',
        ADM2_PCODE: 'ZA637',
        ADM1_EN: 'North West',
        ADM1_PCODE: 'ZA6',
        ADM0_EN: 'South Africa',
        ADM0_PCODE: 'ZA',
        date: '2018-12-27T00:00:00.000Z',
        validOn: '2020-11-09T00:00:00.000Z',
        validTo: '1899-11-30T00:00:00.000Z',
        ADM1_ID: 'NW',
        ADM2_ID: 'DC37',
        ADM3_ID: 'NW372',
      },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Polygon',
        coordinates: [
          [
            [26.109244997000076, -25.70210999799997],
            [26.09541000300004, -25.617779998999936],
            [25.88693999900005, -25.675309996999943],
            [25.845599999000058, -25.66563999799996],
            [25.796552999000028, -25.524967999999944],
            [25.62979000100006, -25.53782000299998],
            [25.580879999000047, -25.63879998799996],
            [25.339327000000026, -25.769283996999945],
            [25.26481586600005, -25.870540888999983],
            [25.406140003000075, -25.954729997999948],
            [25.50102000100003, -26.061799995999934],
            [25.457980003000046, -26.103429999999946],
            [25.486530001000062, -26.21668999999997],
            [25.422349996000037, -26.270750000999953],
            [25.50287999300008, -26.380110000999935],
            [25.54601999700003, -26.32766999599994],
            [25.65525999500005, -26.296639997999932],
            [25.71304000300006, -26.22758000999994],
            [25.78735000300003, -26.019609996999975],
            [25.801900001000035, -25.90005999599998],
            [25.924569998000038, -25.911579996999933],
            [26.022920708000072, -25.837961614999983],
            [26.109244997000076, -25.70210999799997],
          ],
        ],
      },
      properties: {
        Shape_Leng: 3.6218622291,
        Shape_Area: 0.328385050898,
        ADM3_EN: 'Mafikeng',
        ADM3_PCODE: 'ZA6383',
        ADM3_REF: '',
        ADM3ALT1EN: '',
        ADM3ALT2EN: '',
        ADM2_EN: 'Ngaka Modiri Molema',
        ADM2_PCODE: 'ZA638',
        ADM1_EN: 'North West',
        ADM1_PCODE: 'ZA6',
        ADM0_EN: 'South Africa',
        ADM0_PCODE: 'ZA',
        date: '2018-12-27T00:00:00.000Z',
        validOn: '2020-11-09T00:00:00.000Z',
        validTo: '1899-11-30T00:00:00.000Z',
        ADM1_ID: 'NW',
        ADM2_ID: 'DC38',
        ADM3_ID: 'NW383',
      },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Polygon',
        coordinates: [
          [
            [28.911099997000065, -27.01854000299994],
            [28.81085999800007, -27.038610003999963],
            [28.646920004000037, -26.953039996999962],
            [28.585470052000062, -27.035860016999948],
            [28.485850002000063, -26.971109997999974],
            [28.413320002000034, -27.00685999999996],
            [28.312929998000072, -27.036760009999966],
            [28.26423999700006, -27.18622000299996],
            [28.227359999000043, -27.28761000199995],
            [28.283239998000056, -27.359689996999975],
            [28.250889999000037, -27.497789999999952],
            [28.258040004000065, -27.572180001999982],
            [28.426999996000063, -27.50639999799995],
            [28.511149970000076, -27.59688988399995],
            [28.74292009100003, -27.599048583999945],
            [28.785535812000035, -27.462493895999955],
            [28.880750656000032, -27.44350051899994],
            [29.005649567000034, -27.166900634999934],
            [29.015141792000065, -27.00995693699997],
            [28.911099997000065, -27.01854000299994],
          ],
        ],
      },
      properties: {
        Shape_Leng: 3.79233019085,
        Shape_Area: 0.361954390334,
        ADM3_EN: 'Mafube',
        ADM3_PCODE: 'ZA4205',
        ADM3_REF: '',
        ADM3ALT1EN: '',
        ADM3ALT2EN: '',
        ADM2_EN: 'Fezile Dabi',
        ADM2_PCODE: 'ZA420',
        ADM1_EN: 'Free State',
        ADM1_PCODE: 'ZA4',
        ADM0_EN: 'South Africa',
        ADM0_PCODE: 'ZA',
        date: '2018-12-27T00:00:00.000Z',
        validOn: '2020-11-09T00:00:00.000Z',
        validTo: '1899-11-30T00:00:00.000Z',
        ADM1_ID: 'FS',
        ADM2_ID: 'DC20',
        ADM3_ID: 'FS205',
      },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Polygon',
        coordinates: [
          [
            [24.615819999000053, -27.903600000999973],
            [24.62935000300007, -27.994309999999928],
            [24.534639003000052, -28.092088995999973],
            [24.656249999000067, -28.202390005999973],
            [24.733319382000047, -28.341136328999937],
            [24.726490004000027, -28.449739990999944],
            [24.899329996000063, -28.430469998999968],
            [25.028080000000045, -28.07348000199994],
            [24.950559998000074, -28.11313999999993],
            [24.847410723000053, -27.957974664999938],
            [24.775210000000072, -27.994110000999967],
            [24.73283566400005, -27.92022534499995],
            [24.615819999000053, -27.903600000999973],
          ],
        ],
      },
      properties: {
        Shape_Leng: 2.24057849762,
        Shape_Area: 0.142081955835,
        ADM3_EN: 'Magareng',
        ADM3_PCODE: 'ZA3093',
        ADM3_REF: '',
        ADM3ALT1EN: '',
        ADM3ALT2EN: '',
        ADM2_EN: 'Frances Baard',
        ADM2_PCODE: 'ZA309',
        ADM1_EN: 'Nothern Cape',
        ADM1_PCODE: 'ZA3',
        ADM0_EN: 'South Africa',
        ADM0_PCODE: 'ZA',
        date: '2018-12-27T00:00:00.000Z',
        validOn: '2020-11-09T00:00:00.000Z',
        validTo: '1899-11-30T00:00:00.000Z',
        ADM1_ID: 'NC',
        ADM2_ID: 'DC9',
        ADM3_ID: 'NC093',
      },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Polygon',
        coordinates: [
          [
            [26.85622999700007, -33.11492000199996],
            [26.825500001000023, -33.03946999999994],
            [26.641930006000052, -33.05028999799998],
            [26.630109996000044, -33.00432999999998],
            [26.436340003000055, -32.94746000299995],
            [26.274939998000036, -32.93697999899996],
            [26.135669990000054, -32.96016999699998],
            [25.948189998000032, -33.17266000199993],
            [25.98793999700007, -33.306610002999946],
            [26.063190003000045, -33.33309999599993],
            [26.037439996000046, -33.42363000399996],
            [26.10971500000005, -33.53468000299995],
            [26.26350000000008, -33.52023999399995],
            [26.38071999700003, -33.56256000199994],
            [26.547319999000024, -33.551599995999936],
            [26.61773000000005, -33.425029998999946],
            [26.723570003000077, -33.38443000099994],
            [26.80180000000007, -33.28460999899994],
            [26.882989998000028, -33.30600999899997],
            [26.968949999000074, -33.267660002999946],
            [26.962560000000053, -33.20239000199996],
            [26.85622999700007, -33.11492000199996],
          ],
        ],
      },
      properties: {
        Shape_Leng: 4.73358064632,
        Shape_Area: 0.423288453902,
        ADM3_EN: 'Makana',
        ADM3_PCODE: 'ZA2104',
        ADM3_REF: '',
        ADM3ALT1EN: '',
        ADM3ALT2EN: '',
        ADM2_EN: 'Cacadu',
        ADM2_PCODE: 'ZA210',
        ADM1_EN: 'Eastern Cape',
        ADM1_PCODE: 'ZA2',
        ADM0_EN: 'South Africa',
        ADM0_PCODE: 'ZA',
        date: '2018-12-27T00:00:00.000Z',
        validOn: '2020-11-09T00:00:00.000Z',
        validTo: '1899-11-30T00:00:00.000Z',
        ADM1_ID: 'EC',
        ADM2_ID: 'DC10',
        ADM3_ID: 'EC104',
      },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Polygon',
        coordinates: [
          [
            [30.32371994300007, -22.653220058999977],
            [30.10561994300008, -22.703980058999946],
            [29.928169943000057, -22.664810057999944],
            [29.798509942000067, -22.758070058999976],
            [29.748249943000076, -22.680130058999964],
            [29.61883994200008, -22.65944993399995],
            [29.538529942000025, -22.61510005799994],
            [29.36867994200003, -22.65197005899995],
            [29.308779968000067, -22.60204007799996],
            [29.20935997500004, -22.66278004299994],
            [29.244899942000075, -22.735260058999927],
            [29.166969942000037, -22.91779005899997],
            [29.246350000000064, -22.93838999999997],
            [29.31015000000008, -23.07379999999995],
            [29.251730000000066, -23.107069999999965],
            [29.267809965000026, -23.238640029999942],
            [29.59185997000003, -23.268260030999954],
            [29.616749971000047, -23.396450030999972],
            [29.741869973000064, -23.435250027999928],
            [29.866839981000055, -23.43741001999996],
            [30.03769998200005, -23.33871002199993],
            [30.151606737000066, -23.31379967999993],
            [30.245272930000056, -23.253729017999945],
            [30.189781400000072, -23.158214874999942],
            [30.23791194300003, -23.12428205899994],
            [30.410079943000028, -23.09472005899994],
            [30.355329943000072, -23.027190058999963],
            [30.164799943000048, -22.92501005899993],
            [30.205389943000057, -22.78258005899994],
            [30.32371994300007, -22.653220058999977],
          ],
        ],
      },
      properties: {
        Shape_Leng: 5.26991724363,
        Shape_Area: 0.66982944208,
        ADM3_EN: 'Makhado',
        ADM3_PCODE: 'ZA9344',
        ADM3_REF: '',
        ADM3ALT1EN: '',
        ADM3ALT2EN: '',
        ADM2_EN: 'Vhembe',
        ADM2_PCODE: 'ZA934',
        ADM1_EN: 'Limpopo',
        ADM1_PCODE: 'ZA9',
        ADM0_EN: 'South Africa',
        ADM0_PCODE: 'ZA',
        date: '2018-12-27T00:00:00.000Z',
        validOn: '2020-11-09T00:00:00.000Z',
        validTo: '1899-11-30T00:00:00.000Z',
        ADM1_ID: 'LIM',
        ADM2_ID: 'DC34',
        ADM3_ID: 'LIM344',
      },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Polygon',
        coordinates: [
          [
            [29.696560009000052, -24.46678998899995],
            [29.613280021000037, -24.459469980999927],
            [29.470755001000043, -24.640615002999937],
            [29.434069945000033, -24.709770056999957],
            [29.478030018000027, -24.763619981999966],
            [29.63471994400004, -24.80052005999994],
            [29.744279943000038, -24.791230060999965],
            [29.63672994600006, -24.95306005699996],
            [29.71831994300004, -25.000330059999953],
            [29.88128794800008, -24.977264050999963],
            [29.90509600200005, -24.93239899899993],
            [29.934160027000075, -24.81397497699993],
            [30.021230020000075, -24.83914998399996],
            [30.119780013000025, -24.699679987999957],
            [30.087270011000044, -24.62058998699996],
            [29.776340022000056, -24.60466998199996],
            [29.696560009000052, -24.46678998899995],
          ],
        ],
      },
      properties: {
        Shape_Leng: 2.67079168441,
        Shape_Area: 0.188238059667,
        ADM3_EN: 'Makhuduthamaga',
        ADM3_PCODE: 'ZA9473',
        ADM3_REF: '',
        ADM3ALT1EN: '',
        ADM3ALT2EN: '',
        ADM2_EN: 'Sekhukhune',
        ADM2_PCODE: 'ZA947',
        ADM1_EN: 'Limpopo',
        ADM1_PCODE: 'ZA9',
        ADM0_EN: 'South Africa',
        ADM0_PCODE: 'ZA',
        date: '2018-12-27T00:00:00.000Z',
        validOn: '2020-11-09T00:00:00.000Z',
        validTo: '1899-11-30T00:00:00.000Z',
        ADM1_ID: 'LIM',
        ADM2_ID: 'DC47',
        ADM3_ID: 'LIM473',
      },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Polygon',
        coordinates: [
          [
            [29.50992004400007, -28.26543993699994],
            [29.564000003000046, -28.189130001999956],
            [29.405129998000064, -28.078000001999953],
            [29.314459999000064, -28.072810002999972],
            [29.27083000400006, -27.99672000399994],
            [28.998910000000024, -28.074540001999935],
            [28.879109997000057, -28.13766998899996],
            [28.76977000100004, -28.12457999999998],
            [28.71572999700004, -28.235520002999976],
            [28.65504001000005, -28.251870002999965],
            [28.58237000200006, -28.449420001999954],
            [28.651800003000062, -28.496539998999936],
            [28.63148000700005, -28.582509997999978],
            [28.704609997000034, -28.67130999799997],
            [28.794959997000035, -28.699749999999938],
            [28.873626972000068, -28.77071189999998],
            [28.973990977000028, -28.574560038999948],
            [29.134999968000045, -28.566299966999964],
            [29.248749971000052, -28.42489996699993],
            [29.375559977000023, -28.37210997099993],
            [29.50992004400007, -28.26543993699994],
          ],
        ],
      },
      properties: {
        Shape_Leng: 3.80774932788,
        Shape_Area: 0.399149132355,
        ADM3_EN: 'Maluti a Phofung',
        ADM3_PCODE: 'ZA4194',
        ADM3_REF: '',
        ADM3ALT1EN: '',
        ADM3ALT2EN: '',
        ADM2_EN: 'Thabo Mofutsanyane',
        ADM2_PCODE: 'ZA419',
        ADM1_EN: 'Free State',
        ADM1_PCODE: 'ZA4',
        ADM0_EN: 'South Africa',
        ADM0_PCODE: 'ZA',
        date: '2018-12-27T00:00:00.000Z',
        validOn: '2020-11-09T00:00:00.000Z',
        validTo: '1899-11-30T00:00:00.000Z',
        ADM1_ID: 'FS',
        ADM2_ID: 'DC19',
        ADM3_ID: 'FS194',
      },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Polygon',
        coordinates: [
          [
            [25.665629995000074, -26.96272000099998],
            [25.38267999800007, -26.861659997999936],
            [25.324459997000076, -27.01425999199995],
            [25.10806000200006, -27.017920002999972],
            [25.15361000200005, -27.158729997999956],
            [25.07638999900007, -27.201509993999935],
            [25.007300001000033, -27.093260001999965],
            [24.895249998000054, -27.178990003999957],
            [24.777190000000076, -27.333240003999947],
            [24.782400004000067, -27.406860000999927],
            [24.892087678000053, -27.39611040099993],
            [25.006389997000042, -27.524169997999934],
            [25.094339999000056, -27.462959999999953],
            [25.272590001000026, -27.40545999699998],
            [25.46993999600005, -27.391249994999953],
            [25.683379998000078, -27.336409999999944],
            [25.674375057000077, -27.222110529999952],
            [25.616329999000072, -27.14289999999994],
            [25.68710999700005, -27.09796999899993],
            [25.665629995000074, -26.96272000099998],
          ],
        ],
      },
      properties: {
        Shape_Leng: 3.78100467842,
        Shape_Area: 0.32928676604,
        ADM3_EN: 'Mamusa',
        ADM3_PCODE: 'ZA6393',
        ADM3_REF: '',
        ADM3ALT1EN: '',
        ADM3ALT2EN: '',
        ADM2_EN: 'Dr Ruth Segomotsi Mompati',
        ADM2_PCODE: 'ZA639',
        ADM1_EN: 'North West',
        ADM1_PCODE: 'ZA6',
        ADM0_EN: 'South Africa',
        ADM0_PCODE: 'ZA',
        date: '2018-12-27T00:00:00.000Z',
        validOn: '2020-11-09T00:00:00.000Z',
        validTo: '1899-11-30T00:00:00.000Z',
        ADM1_ID: 'NW',
        ADM2_ID: 'DC39',
        ADM3_ID: 'NW393',
      },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Polygon',
        coordinates: [
          [
            [31.675313944000038, -29.05489306499993],
            [31.529589944000065, -29.056689939999956],
            [31.458979944000077, -28.991679938999937],
            [31.38785994400007, -28.99687993899994],
            [31.31832098900003, -29.15002999999996],
            [31.369890000000055, -29.248049999999978],
            [31.47476994400006, -29.25055006499997],
            [31.675313944000038, -29.05489306499993],
          ],
        ],
      },
      properties: {
        Shape_Leng: 1.62212539452,
        Shape_Area: 0.0505683779158,
        ADM3_EN: 'Mandeni',
        ADM3_PCODE: 'ZA5291',
        ADM3_REF: '',
        ADM3ALT1EN: '',
        ADM3ALT2EN: '',
        ADM2_EN: 'iLembe',
        ADM2_PCODE: 'ZA529',
        ADM1_EN: 'KwaZulu-Natal',
        ADM1_PCODE: 'ZA5',
        ADM0_EN: 'South Africa',
        ADM0_PCODE: 'ZA',
        date: '2018-12-27T00:00:00.000Z',
        validOn: '2020-11-09T00:00:00.000Z',
        validTo: '1899-11-30T00:00:00.000Z',
        ADM1_ID: 'KZN',
        ADM2_ID: 'DC29',
        ADM3_ID: 'KZN291',
      },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Polygon',
        coordinates: [
          [
            [26.81813001100005, -28.92713999299997],
            [26.71639000400006, -29.072379997999974],
            [26.634340001000055, -29.059649999999976],
            [26.56694999900003, -28.968080003999944],
            [26.47193000200008, -28.94802999999996],
            [26.403060004000054, -28.989195003999953],
            [26.33497999900004, -28.901170003999937],
            [26.280670004000058, -28.940369997999937],
            [26.165279996000038, -28.854570000999956],
            [26.09837590500007, -28.66505945399996],
            [26.01306594500005, -28.715056066999978],
            [26.02003337800005, -28.799857198999973],
            [25.926540002000024, -28.826529998999945],
            [25.87866999700003, -28.760059998999964],
            [25.856310009000026, -28.86763000299993],
            [25.745260002000066, -28.90640000299993],
            [25.719359998000073, -29.006290000999968],
            [25.74124000000006, -29.226039999999955],
            [25.992639989000054, -29.27310999799994],
            [26.032304999000075, -29.41709499899997],
            [26.07777000300007, -29.47969000599994],
            [26.22419000900004, -29.47957999399995],
            [26.285309993000055, -29.59818999199996],
            [26.38225999900004, -29.61614000399993],
            [26.551089999000055, -29.571759999999983],
            [26.62698000200004, -29.63453000399994],
            [26.660210002000042, -29.726830003999964],
            [26.78034000200006, -29.73902000299995],
            [26.733299999000053, -29.84219000099995],
            [26.82395000100007, -29.964710000999958],
            [26.81517001000003, -30.03037999299994],
            [26.946799990000045, -30.108569989999978],
            [27.06537998700003, -30.07578999499998],
            [27.091950000000054, -30.026769996999974],
            [27.216360004000023, -29.982970000999956],
            [27.09657999700005, -29.729929995999953],
            [27.013910002000046, -29.661750000999973],
            [27.12743000300003, -29.574670002999937],
            [26.998999998000045, -29.519759995999948],
            [26.91720999200004, -29.18209999299995],
            [27.051339996000024, -29.070609996999963],
            [26.962429994000047, -29.021940014999927],
            [26.94632000400003, -28.93972000399998],
            [26.81813001100005, -28.92713999299997],
          ],
        ],
      },
      properties: {
        Shape_Leng: 8.13926799594,
        Shape_Area: 0.918336844416,
        ADM3_EN: 'Mangaung',
        ADM3_PCODE: 'ZA4940',
        ADM3_REF: '',
        ADM3ALT1EN: '',
        ADM3ALT2EN: '',
        ADM2_EN: 'Mangaung',
        ADM2_PCODE: 'ZA494',
        ADM1_EN: 'Free State',
        ADM1_PCODE: 'ZA4',
        ADM0_EN: 'South Africa',
        ADM0_PCODE: 'ZA',
        date: '2018-12-27T00:00:00.000Z',
        validOn: '2020-11-09T00:00:00.000Z',
        validTo: '1899-11-30T00:00:00.000Z',
        ADM1_ID: 'FS',
        ADM2_ID: 'MAN',
        ADM3_ID: 'MAN',
      },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Polygon',
        coordinates: [
          [
            [27.18630500200004, -28.80526299899998],
            [27.15217000000007, -28.756599999999935],
            [27.029680003000067, -28.743889998999975],
            [26.911089997000033, -28.76833000199997],
            [26.81813001100005, -28.92713999299997],
            [26.94632000400003, -28.93972000399998],
            [26.962429994000047, -29.021940014999927],
            [27.051339996000024, -29.070609996999963],
            [26.91720999200004, -29.18209999299995],
            [26.998999998000045, -29.519759995999948],
            [27.12743000300003, -29.574670002999937],
            [27.277870003000032, -29.526259998999933],
            [27.370469997000043, -29.44874999999996],
            [27.54762998900003, -29.24636000299995],
            [27.551400004000072, -29.196160001999942],
            [27.65024999800005, -29.10998000099994],
            [27.527670000000057, -29.01283899699996],
            [27.47835999800003, -28.87330000299994],
            [27.401770002000035, -28.870789999999943],
            [27.18630500200004, -28.80526299899998],
          ],
        ],
      },
      properties: {
        Shape_Leng: 4.21310084384,
        Shape_Area: 0.397800367134,
        ADM3_EN: 'Mantsopa',
        ADM3_PCODE: 'ZA4196',
        ADM3_REF: '',
        ADM3ALT1EN: '',
        ADM3ALT2EN: '',
        ADM2_EN: 'Thabo Mofutsanyane',
        ADM2_PCODE: 'ZA419',
        ADM1_EN: 'Free State',
        ADM1_PCODE: 'ZA4',
        ADM0_EN: 'South Africa',
        ADM0_PCODE: 'ZA',
        date: '2018-12-27T00:00:00.000Z',
        validOn: '2020-11-09T00:00:00.000Z',
        validTo: '1899-11-30T00:00:00.000Z',
        ADM1_ID: 'FS',
        ADM2_ID: 'DC19',
        ADM3_ID: 'FS196',
      },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Polygon',
        coordinates: [
          [
            [31.029826943000046, -28.90152293899996],
            [30.993349943000055, -28.85647993899994],
            [30.91921994300003, -28.908489938999935],
            [30.980179943000053, -28.969889938999984],
            [31.02377994300008, -29.078830064999977],
            [30.93671994300007, -29.080199939999943],
            [30.86271994300006, -29.14751006499995],
            [30.984729943000048, -29.22410993999995],
            [30.98118994300006, -29.269259939999984],
            [31.088529943000026, -29.34710993999994],
            [31.13716994300006, -29.207599939999966],
            [31.234284944000024, -29.180706939999936],
            [31.288724944000023, -29.16400993999997],
            [31.175409944000023, -29.073129939999944],
            [31.029826943000046, -28.90152293899996],
          ],
        ],
      },
      properties: {
        Shape_Leng: 2.37890665001,
        Shape_Area: 0.0830445346408,
        ADM3_EN: 'Maphumulo',
        ADM3_PCODE: 'ZA5294',
        ADM3_REF: '',
        ADM3ALT1EN: '',
        ADM3ALT2EN: '',
        ADM2_EN: 'iLembe',
        ADM2_PCODE: 'ZA529',
        ADM1_EN: 'KwaZulu-Natal',
        ADM1_PCODE: 'ZA5',
        ADM0_EN: 'South Africa',
        ADM0_PCODE: 'ZA',
        date: '2018-12-27T00:00:00.000Z',
        validOn: '2020-11-09T00:00:00.000Z',
        validTo: '1899-11-30T00:00:00.000Z',
        ADM1_ID: 'KZN',
        ADM2_ID: 'DC29',
        ADM3_ID: 'KZN294',
      },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Polygon',
        coordinates: [
          [
            [26.07676000200007, -26.862330004999933],
            [26.00418999900006, -26.855189997999958],
            [25.833310002000076, -26.936159995999958],
            [25.809709999000063, -26.901179998999964],
            [25.665629995000074, -26.96272000099998],
            [25.68710999700005, -27.09796999899993],
            [25.616329999000072, -27.14289999999994],
            [25.674375057000077, -27.222110529999952],
            [25.77230000000003, -27.209251999999935],
            [25.824801989000036, -27.363042002999975],
            [25.75372000300007, -27.53448999799997],
            [25.830239996000046, -27.566190002999974],
            [25.92687999700007, -27.60387000099996],
            [26.075840000000028, -27.710650002999955],
            [26.055059999000036, -27.670060002999946],
            [26.125510000000077, -27.564780009999936],
            [26.22724000200003, -27.51340999599995],
            [26.267750000000035, -27.416309997999974],
            [26.423090004000073, -27.40686999899998],
            [26.496769998000048, -27.26495999499997],
            [26.419900003000066, -27.171359996999968],
            [26.190640002000066, -26.908319997999968],
            [26.07676000200007, -26.862330004999933],
          ],
        ],
      },
      properties: {
        Shape_Leng: 4.11499562119,
        Shape_Area: 0.425575721424,
        ADM3_EN: 'Maquassi Hills',
        ADM3_PCODE: 'ZA6404',
        ADM3_REF: '',
        ADM3ALT1EN: '',
        ADM3ALT2EN: '',
        ADM2_EN: 'Dr Kenneth Kaunda',
        ADM2_PCODE: 'ZA640',
        ADM1_EN: 'North West',
        ADM1_PCODE: 'ZA6',
        ADM0_EN: 'South Africa',
        ADM0_PCODE: 'ZA',
        date: '2018-12-27T00:00:00.000Z',
        validOn: '2020-11-09T00:00:00.000Z',
        validTo: '1899-11-30T00:00:00.000Z',
        ADM1_ID: 'NW',
        ADM2_ID: 'DC40',
        ADM3_ID: 'NW404',
      },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Polygon',
        coordinates: [
          [
            [31.063430002000075, -24.091459998999937],
            [31.012669998000035, -24.12941999399993],
            [30.940210000000036, -24.053039998999964],
            [30.77604999700003, -24.092389998999977],
            [30.675509997000063, -24.14592999699994],
            [30.480120000000056, -23.980880010999954],
            [30.453314593000073, -23.958283071999972],
            [30.321530000000052, -24.12969000099997],
            [30.361639998000044, -24.16828000199996],
            [30.366215000000068, -24.283094996999978],
            [30.533529998000063, -24.439709997999955],
            [30.758979999000076, -24.460219998999946],
            [30.871709999000075, -24.538500002999967],
            [30.95931999900006, -24.582070000999977],
            [31.226180011000054, -24.556010001999937],
            [31.25366000200006, -24.499120000999937],
            [31.159969998000065, -24.37557000199996],
            [31.05602000500005, -24.32188999699997],
            [31.063430002000075, -24.091459998999937],
          ],
        ],
      },
      properties: {
        Shape_Leng: 3.47759064468,
        Shape_Area: 0.316824749251,
        ADM3_EN: 'Maruleng',
        ADM3_PCODE: 'ZA9335',
        ADM3_REF: '',
        ADM3ALT1EN: '',
        ADM3ALT2EN: '',
        ADM2_EN: 'Mopani',
        ADM2_PCODE: 'ZA933',
        ADM1_EN: 'Limpopo',
        ADM1_PCODE: 'ZA9',
        ADM0_EN: 'South Africa',
        ADM0_PCODE: 'ZA',
        date: '2018-12-27T00:00:00.000Z',
        validOn: '2020-11-09T00:00:00.000Z',
        validTo: '1899-11-30T00:00:00.000Z',
        ADM1_ID: 'LIM',
        ADM2_ID: 'DC33',
        ADM3_ID: 'LIM335',
      },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Polygon',
        coordinates: [
          [
            [27.212212100000045, -28.57798826399994],
            [27.156730001000028, -28.558290002999968],
            [27.10645999700006, -28.401780002999942],
            [26.949080002000073, -28.382789998999954],
            [26.96328999700006, -28.27620000299993],
            [26.885040004000075, -28.22281000199996],
            [26.639371002000075, -28.218144002999964],
            [26.60966999900006, -28.30523999199994],
            [26.423150001000067, -28.31269999699998],
            [26.434859999000025, -28.368919998999957],
            [26.219069000000047, -28.468846997999947],
            [26.14789999800007, -28.557899992999978],
            [26.033569999000065, -28.586269998999967],
            [25.976949997000077, -28.615439996999953],
            [25.87866999700003, -28.760059998999964],
            [25.926540002000024, -28.826529998999945],
            [26.02003337800005, -28.799857198999973],
            [26.01306594500005, -28.715056066999978],
            [26.09837590500007, -28.66505945399996],
            [26.165279996000038, -28.854570000999956],
            [26.280670004000058, -28.940369997999937],
            [26.33497999900004, -28.901170003999937],
            [26.403060004000054, -28.989195003999953],
            [26.47193000200008, -28.94802999999996],
            [26.56694999900003, -28.968080003999944],
            [26.634340001000055, -29.059649999999976],
            [26.71639000400006, -29.072379997999974],
            [26.81813001100005, -28.92713999299997],
            [26.911089997000033, -28.76833000199997],
            [27.029680003000067, -28.743889998999975],
            [27.15217000000007, -28.756599999999935],
            [27.18630500200004, -28.80526299899998],
            [27.212212100000045, -28.57798826399994],
          ],
        ],
      },
      properties: {
        Shape_Leng: 5.90675182101,
        Shape_Area: 0.61066135792,
        ADM3_EN: 'Masilonyana',
        ADM3_PCODE: 'ZA4181',
        ADM3_REF: '',
        ADM3ALT1EN: '',
        ADM3ALT2EN: '',
        ADM2_EN: 'Lejweleputswa',
        ADM2_PCODE: 'ZA418',
        ADM1_EN: 'Free State',
        ADM1_PCODE: 'ZA4',
        ADM0_EN: 'South Africa',
        ADM0_PCODE: 'ZA',
        date: '2018-12-27T00:00:00.000Z',
        validOn: '2020-11-09T00:00:00.000Z',
        validTo: '1899-11-30T00:00:00.000Z',
        ADM1_ID: 'FS',
        ADM2_ID: 'DC18',
        ADM3_ID: 'FS181',
      },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Polygon',
        coordinates: [
          [
            [29.13525000100003, -30.605139977999954],
            [29.196769982000035, -30.43439003499998],
            [29.305009976000065, -30.379859949999968],
            [29.301859965000062, -30.320119956999974],
            [29.13716997100005, -30.26233997199995],
            [29.117240037000045, -30.10018996799994],
            [29.01473997200003, -30.00179996999998],
            [28.858790001000045, -30.088229996999928],
            [28.68988999800007, -30.124289998999984],
            [28.568249999000045, -30.122860000999935],
            [28.365100003000066, -30.168620003999933],
            [28.340290003000064, -30.234610001999954],
            [28.23643000100003, -30.259939996999947],
            [28.268770003000043, -30.37372999699994],
            [28.480840004000072, -30.422299996999982],
            [28.569840000000056, -30.49629000599998],
            [28.560369998000056, -30.655260001999977],
            [28.655906997000045, -30.649993001999974],
            [28.759363000000064, -30.588210002999972],
            [28.86030099800007, -30.685753998999928],
            [28.924677001000077, -30.68729899599998],
            [28.95614058800004, -30.57247770799995],
            [29.13525000100003, -30.605139977999954],
          ],
        ],
      },
      properties: {
        Shape_Leng: 4.52529853745,
        Shape_Area: 0.408326863464,
        ADM3_EN: 'Matatiele',
        ADM3_PCODE: 'ZA2441',
        ADM3_REF: '',
        ADM3ALT1EN: '',
        ADM3ALT2EN: '',
        ADM2_EN: 'Alfred Nzo',
        ADM2_PCODE: 'ZA244',
        ADM1_EN: 'Eastern Cape',
        ADM1_PCODE: 'ZA2',
        ADM0_EN: 'South Africa',
        ADM0_PCODE: 'ZA',
        date: '2018-12-27T00:00:00.000Z',
        validOn: '2020-11-09T00:00:00.000Z',
        validTo: '1899-11-30T00:00:00.000Z',
        ADM1_ID: 'EC',
        ADM2_ID: 'DC44',
        ADM3_ID: 'EC441',
      },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Polygon',
        coordinates: [
          [
            [27.38786999900003, -28.214080001999946],
            [27.37005000100004, -28.17026999899997],
            [27.433770001000028, -28.049759995999977],
            [27.363450000000057, -28.001459987999965],
            [27.35898200200006, -27.932452998999963],
            [27.19277999700006, -27.899749998999937],
            [27.15779000200007, -27.93333999799995],
            [27.052500003000034, -27.85931000399995],
            [27.04476999800005, -27.749099996999973],
            [26.969940004000023, -27.69444999899997],
            [27.01632999700007, -27.598240000999965],
            [26.950050003000058, -27.522500002999948],
            [26.857710002000033, -27.58600000299998],
            [26.74193000100007, -27.693630002999953],
            [26.636299999000073, -27.65908000099995],
            [26.560879991000036, -27.724080001999937],
            [26.54876000300004, -27.873959998999965],
            [26.472630004000052, -28.078289996999956],
            [26.414640001000066, -28.092130002999966],
            [26.46707999800003, -28.21218000099998],
            [26.423150001000067, -28.31269999699998],
            [26.60966999900006, -28.30523999199994],
            [26.639371002000075, -28.218144002999964],
            [26.885040004000075, -28.22281000199996],
            [26.96328999700006, -28.27620000299993],
            [26.949080002000073, -28.382789998999954],
            [27.10645999700006, -28.401780002999942],
            [27.156730001000028, -28.558290002999968],
            [27.212212100000045, -28.57798826399994],
            [27.288969775000055, -28.457538326999952],
            [27.27682999800004, -28.282779998999956],
            [27.38786999900003, -28.214080001999946],
          ],
        ],
      },
      properties: {
        Shape_Leng: 5.66018455569,
        Shape_Area: 0.522250707808,
        ADM3_EN: 'Matjhabeng',
        ADM3_PCODE: 'ZA4184',
        ADM3_REF: '',
        ADM3ALT1EN: '',
        ADM3ALT2EN: '',
        ADM2_EN: 'Lejweleputswa',
        ADM2_PCODE: 'ZA418',
        ADM1_EN: 'Free State',
        ADM1_PCODE: 'ZA4',
        ADM0_EN: 'South Africa',
        ADM0_PCODE: 'ZA',
        date: '2018-12-27T00:00:00.000Z',
        validOn: '2020-11-09T00:00:00.000Z',
        validTo: '1899-11-30T00:00:00.000Z',
        ADM1_ID: 'FS',
        ADM2_ID: 'DC18',
        ADM3_ID: 'FS184',
      },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Polygon',
        coordinates: [
          [
            [18.951480022000055, -30.74443989799994],
            [18.794500351000067, -30.667619704999936],
            [18.758710861000054, -30.56786918599994],
            [18.65514954100007, -30.556709298999976],
            [18.570120003000056, -30.43025999799994],
            [18.502150001000075, -30.44442000199996],
            [18.413759999000035, -30.527349999999956],
            [18.37103999900006, -30.659629996999968],
            [18.264169999000046, -30.818319993999978],
            [18.169180004000054, -30.848559998999974],
            [18.08917999700003, -30.787869995999984],
            [18.006479003000038, -30.791239995999945],
            [17.99337999900007, -30.91874000399997],
            [17.880299998000055, -30.92393999899997],
            [17.926409999000043, -31.011390002999974],
            [17.757580003000044, -31.15196999999995],
            [17.877319999000065, -31.27877000199993],
            [17.90044000100005, -31.352060002999963],
            [18.09782999600003, -31.55937999799994],
            [18.222789996000074, -31.74432000099995],
            [18.28007999700003, -31.898170000999983],
            [18.29026699700006, -32.00665299999997],
            [18.411920003000034, -31.94558999999998],
            [18.451599999000052, -31.84381999699997],
            [18.56123999700003, -31.87885999899993],
            [18.62286000000006, -31.95634000299998],
            [18.740900001000057, -31.878890001999935],
            [18.875510003000045, -31.85241999599998],
            [19.02622000100007, -31.876639998999963],
            [19.08627000200005, -31.794479999999965],
            [19.06556000300003, -31.706309998999984],
            [19.085420003000024, -31.526930000999982],
            [18.980130002000067, -31.355239989999973],
            [19.013010002000044, -31.305680002999964],
            [18.944460003000074, -31.237319997999975],
            [18.947600004000037, -31.112910003999957],
            [18.911770010000055, -30.978929996999966],
            [18.98449000100004, -30.945810002999963],
            [18.951480022000055, -30.74443989799994],
          ],
        ],
      },
      properties: {
        Shape_Leng: 6.72686018408,
        Shape_Area: 1.22926341664,
        ADM3_EN: 'Matzikama',
        ADM3_PCODE: 'ZA1011',
        ADM3_REF: '',
        ADM3ALT1EN: '',
        ADM3ALT2EN: '',
        ADM2_EN: 'West Coast',
        ADM2_PCODE: 'ZA101',
        ADM1_EN: 'Western Cape',
        ADM1_PCODE: 'ZA1',
        ADM0_EN: 'South Africa',
        ADM0_PCODE: 'ZA',
        date: '2018-12-27T00:00:00.000Z',
        validOn: '2020-11-09T00:00:00.000Z',
        validTo: '1899-11-30T00:00:00.000Z',
        ADM1_ID: 'WC',
        ADM2_ID: 'DC1',
        ADM3_ID: 'WC011',
      },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Polygon',
        coordinates: [
          [
            [28.351969998000072, -31.828649999999982],
            [28.263330001000043, -31.791320002999953],
            [28.19468000300003, -31.96641000099993],
            [28.01884885800007, -32.043181292999975],
            [28.25133999800005, -32.068510007999976],
            [28.235070651000058, -32.20815914999997],
            [28.31674000000004, -32.24349999999998],
            [28.55106099300008, -32.42085674699996],
            [28.675563002000047, -32.44858800199995],
            [28.882419999000035, -32.27984999699993],
            [29.09341000300003, -32.05934999799996],
            [28.925870003000057, -31.94461999899994],
            [28.782199997000077, -32.045999999999935],
            [28.597819996000055, -31.97172999999998],
            [28.46518999700004, -31.96782000199994],
            [28.427450011000076, -31.870229996999967],
            [28.351969998000072, -31.828649999999982],
          ],
        ],
      },
      properties: {
        Shape_Leng: 4.77566625444,
        Shape_Area: 0.315632298305,
        ADM3_EN: 'Mbhashe',
        ADM3_PCODE: 'ZA2121',
        ADM3_REF: '',
        ADM3ALT1EN: '',
        ADM3ALT2EN: '',
        ADM2_EN: 'Amathole',
        ADM2_PCODE: 'ZA212',
        ADM1_EN: 'Eastern Cape',
        ADM1_PCODE: 'ZA2',
        ADM0_EN: 'South Africa',
        ADM0_PCODE: 'ZA',
        date: '2018-12-27T00:00:00.000Z',
        validOn: '2020-11-09T00:00:00.000Z',
        validTo: '1899-11-30T00:00:00.000Z',
        ADM1_ID: 'EC',
        ADM2_ID: 'DC12',
        ADM3_ID: 'EC121',
      },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Polygon',
        coordinates: [
          [
            [29.57220004100003, -30.655149972999936],
            [29.543550296000035, -30.647186529999942],
            [29.522201133000067, -30.699014831999932],
            [29.56229999800007, -30.882500000999983],
            [29.511410002000048, -30.929870007999966],
            [29.609759998000072, -30.983210002999954],
            [29.584300002000077, -31.038030008999954],
            [29.846460000000036, -31.13512000099996],
            [30.047640000000058, -31.24755999699994],
            [30.193859794000048, -31.081260201999953],
            [30.142759983000076, -31.022820026999966],
            [30.146350037000047, -30.931069969999953],
            [30.092709971000033, -30.86222996799995],
            [29.961164980000035, -30.82316997199996],
            [29.852609983000036, -30.76160002699993],
            [29.57220004100003, -30.655149972999936],
          ],
        ],
      },
      properties: {
        Shape_Leng: 3.6265861871,
        Shape_Area: 0.228005089125,
        ADM3_EN: 'Mbizana',
        ADM3_PCODE: 'ZA2443',
        ADM3_REF: '',
        ADM3ALT1EN: '',
        ADM3ALT2EN: '',
        ADM2_EN: 'Alfred Nzo',
        ADM2_PCODE: 'ZA244',
        ADM1_EN: 'Eastern Cape',
        ADM1_PCODE: 'ZA2',
        ADM0_EN: 'South Africa',
        ADM0_PCODE: 'ZA',
        date: '2018-12-27T00:00:00.000Z',
        validOn: '2020-11-09T00:00:00.000Z',
        validTo: '1899-11-30T00:00:00.000Z',
        ADM1_ID: 'EC',
        ADM2_ID: 'DC44',
        ADM3_ID: 'EC443',
      },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Polygon',
        coordinates: [
          [
            [31.61089389600005, -24.98924693999993],
            [31.564248501000066, -24.96042203299993],
            [31.317630768000072, -24.96453094499998],
            [31.24930000300003, -25.018360137999935],
            [31.14072748700005, -24.98202324199997],
            [31.025230003000047, -25.030099993999954],
            [30.941120004000027, -25.128888003999975],
            [30.917219999000054, -25.20830999599997],
            [30.978155999000023, -25.29015400299994],
            [30.88181000000003, -25.38371000199993],
            [30.703239998000072, -25.361539995999976],
            [30.629890009000064, -25.28499999899998],
            [30.53197099700003, -25.349590001999957],
            [30.449239999000042, -25.34495999799998],
            [30.48011000200006, -25.45239000199996],
            [30.565345999000044, -25.481235995999953],
            [30.665619998000068, -25.672980000999928],
            [30.64662999500007, -25.71242000899997],
            [30.732650001000025, -25.741350001999933],
            [30.773649999000042, -25.86193999099993],
            [30.849860000000035, -25.92634000399994],
            [31.12657000300004, -25.92114999699993],
            [31.315939998000033, -25.74304000099994],
            [31.26208000200006, -25.69231999799996],
            [31.33077999900007, -25.608980003999932],
            [31.33545000400005, -25.522559997999963],
            [31.536829999000076, -25.46408000399998],
            [31.627029419000053, -25.272920608999982],
            [31.586380005000024, -25.025129317999983],
            [31.61089389600005, -24.98924693999993],
          ],
        ],
      },
      properties: {
        Shape_Leng: 4.8946076353,
        Shape_Area: 0.640856333015,
        ADM3_EN: 'Mbombela',
        ADM3_PCODE: 'ZA8326',
        ADM3_REF: '',
        ADM3ALT1EN: '',
        ADM3ALT2EN: '',
        ADM2_EN: 'Ehlanzeni',
        ADM2_PCODE: 'ZA832',
        ADM1_EN: 'Mpumalanga',
        ADM1_PCODE: 'ZA8',
        ADM0_EN: 'South Africa',
        ADM0_PCODE: 'ZA',
        date: '2018-12-27T00:00:00.000Z',
        validOn: '2020-11-09T00:00:00.000Z',
        validTo: '1899-11-30T00:00:00.000Z',
        ADM1_ID: 'MP',
        ADM2_ID: 'DC32',
        ADM3_ID: 'MP326',
      },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Polygon',
        coordinates: [
          [
            [27.579600001000074, -26.60752999899995],
            [27.607150003000072, -26.491600000999938],
            [27.557090001000063, -26.456379998999978],
            [27.54784999700007, -26.34328000199997],
            [27.47151000300005, -26.24495499799997],
            [27.46734000400005, -26.09226999899994],
            [27.425220000000024, -26.089389998999934],
            [27.361720000000048, -26.115669998999977],
            [27.291409998000063, -26.144620003999933],
            [27.330071000000032, -26.28181499899995],
            [27.187952000000053, -26.377862998999944],
            [27.22484999900007, -26.44396999999998],
            [27.241869998000027, -26.636459999999943],
            [27.378349998000033, -26.610679997999966],
            [27.569090002000053, -26.647160003999943],
            [27.579600001000074, -26.60752999899995],
          ],
        ],
      },
      properties: {
        Shape_Leng: 2.33644602162,
        Shape_Area: 0.147520398303,
        ADM3_EN: 'Merafong City',
        ADM3_PCODE: 'ZA7484',
        ADM3_REF: '',
        ADM3ALT1EN: '',
        ADM3ALT2EN: '',
        ADM2_EN: 'West Rand',
        ADM2_PCODE: 'ZA748',
        ADM1_EN: 'Gauteng',
        ADM1_PCODE: 'ZA7',
        ADM0_EN: 'South Africa',
        ADM0_PCODE: 'ZA',
        date: '2018-12-27T00:00:00.000Z',
        validOn: '2020-11-09T00:00:00.000Z',
        validTo: '1899-11-30T00:00:00.000Z',
        ADM1_ID: 'GT',
        ADM2_ID: 'DC48',
        ADM3_ID: 'GT484',
      },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Polygon',
        coordinates: [
          [
            [28.000489998000035, -26.703320000999952],
            [27.940960001000064, -26.675899998999967],
            [27.873640003000048, -26.747630000999948],
            [27.716306001000078, -26.761676999999963],
            [27.71045999900008, -26.842270002999953],
            [27.802670000000035, -26.997190001999968],
            [27.92860998900005, -26.96601099199995],
            [27.973670000000027, -27.042430001999946],
            [28.065730003000056, -27.046560000999932],
            [28.12675000300004, -27.137859997999954],
            [28.26423999700006, -27.18622000299996],
            [28.312929998000072, -27.036760009999966],
            [28.413320002000034, -27.00685999999996],
            [28.392150000000072, -26.93142000299997],
            [28.300429999000073, -26.94016000199997],
            [28.24428000000006, -26.88477999899993],
            [28.119130003000066, -26.889280011999972],
            [28.008180001000028, -26.770149998999955],
            [28.000489998000035, -26.703320000999952],
          ],
        ],
      },
      properties: {
        Shape_Leng: 2.78435466248,
        Shape_Area: 0.15603529902,
        ADM3_EN: 'Metsimaholo',
        ADM3_PCODE: 'ZA4204',
        ADM3_REF: '',
        ADM3ALT1EN: '',
        ADM3ALT2EN: '',
        ADM2_EN: 'Fezile Dabi',
        ADM2_PCODE: 'ZA420',
        ADM1_EN: 'Free State',
        ADM1_PCODE: 'ZA4',
        ADM0_EN: 'South Africa',
        ADM0_PCODE: 'ZA',
        date: '2018-12-27T00:00:00.000Z',
        validOn: '2020-11-09T00:00:00.000Z',
        validTo: '1899-11-30T00:00:00.000Z',
        ADM1_ID: 'FS',
        ADM2_ID: 'DC20',
        ADM3_ID: 'FS204',
      },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Polygon',
        coordinates: [
          [
            [32.41476794500005, -28.476392938999936],
            [32.30519994500003, -28.51851006399994],
            [32.212189944000045, -28.45894993899998],
            [31.990779944000053, -28.388589938999928],
            [31.981432944000062, -28.35041993899995],
            [31.96252994400004, -28.406219938999982],
            [31.811069944000053, -28.431680938999932],
            [31.793650505000073, -28.48310668599993],
            [31.829450548000068, -28.569551926999964],
            [31.896699944000034, -28.571540063999976],
            [31.95930994400004, -28.664079938999976],
            [32.022419944000035, -28.64644993899998],
            [32.147119392000036, -28.758805396999946],
            [32.368949945000054, -28.568400063999945],
            [32.41476794500005, -28.476392938999936],
          ],
        ],
      },
      properties: {
        Shape_Leng: 2.42106074934,
        Shape_Area: 0.119847408713,
        ADM3_EN: 'Mfolozi',
        ADM3_PCODE: 'ZA5281',
        ADM3_REF: '',
        ADM3ALT1EN: '',
        ADM3ALT2EN: '',
        ADM2_EN: 'Uthungulu',
        ADM2_PCODE: 'ZA528',
        ADM1_EN: 'KwaZulu-Natal',
        ADM1_PCODE: 'ZA5',
        ADM0_EN: 'South Africa',
        ADM0_PCODE: 'ZA',
        date: '2018-12-27T00:00:00.000Z',
        validOn: '2020-11-09T00:00:00.000Z',
        validTo: '1899-11-30T00:00:00.000Z',
        ADM1_ID: 'KZN',
        ADM2_ID: 'DC28',
        ADM3_ID: 'KZN281',
      },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Polygon',
        coordinates: [
          [
            [28.641113076000067, -30.772916348999956],
            [28.63861000000003, -30.920929998999952],
            [28.52592000100003, -31.048859997999955],
            [28.67548000000005, -31.134970003999968],
            [28.61938999800003, -31.236869998999964],
            [28.497800006000034, -31.250270003999958],
            [28.49925999800007, -31.33262999899995],
            [28.38231999900006, -31.48055000499994],
            [28.527210000000025, -31.49379999699994],
            [28.65908999900006, -31.449470000999952],
            [28.75467999700004, -31.485959996999952],
            [28.857829999000046, -31.480310000999964],
            [28.890780002000042, -31.31501000399993],
            [28.979800002000047, -31.28696000399998],
            [29.04294000300007, -31.32214400199996],
            [29.155575000000056, -31.319332002999943],
            [29.190579996000054, -31.274674003999962],
            [29.13230999600006, -31.09143999899993],
            [29.06473800200007, -31.037947419999966],
            [28.978939997000055, -31.025019997999948],
            [28.905729999000073, -31.077709997999932],
            [28.836249999000074, -30.941860003999977],
            [28.641113076000067, -30.772916348999956],
          ],
        ],
      },
      properties: {
        Shape_Leng: 5.25985952564,
        Shape_Area: 0.272583876658,
        ADM3_EN: 'Mhlontlo',
        ADM3_PCODE: 'ZA2156',
        ADM3_REF: '',
        ADM3ALT1EN: '',
        ADM3ALT2EN: '',
        ADM2_EN: 'O.R.Tambo',
        ADM2_PCODE: 'ZA215',
        ADM1_EN: 'Eastern Cape',
        ADM1_PCODE: 'ZA2',
        ADM0_EN: 'South Africa',
        ADM0_PCODE: 'ZA',
        date: '2018-12-27T00:00:00.000Z',
        validOn: '2020-11-09T00:00:00.000Z',
        validTo: '1899-11-30T00:00:00.000Z',
        ADM1_ID: 'EC',
        ADM2_ID: 'DC15',
        ADM3_ID: 'EC156',
      },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Polygon',
        coordinates: [
          [
            [28.067101999000045, -26.34194000399998],
            [27.912229996000065, -26.35894999599998],
            [27.869074999000077, -26.44480099799995],
            [27.887210001000028, -26.526250000999937],
            [27.983020000000067, -26.555829996999933],
            [27.962234996000063, -26.644136996999976],
            [28.000489998000035, -26.703320000999952],
            [28.008180001000028, -26.770149998999955],
            [28.119130003000066, -26.889280011999972],
            [28.24428000000006, -26.88477999899993],
            [28.406850002000056, -26.761710001999973],
            [28.40009999700004, -26.655044999999973],
            [28.28172999900005, -26.67601000299993],
            [28.17946999700007, -26.57937000299995],
            [28.27136999700008, -26.50299999799995],
            [28.22039999900005, -26.43628000399997],
            [28.076060002000077, -26.415370002999964],
            [28.067101999000045, -26.34194000399998],
          ],
        ],
      },
      properties: {
        Shape_Leng: 3.23549669072,
        Shape_Area: 0.156111779447,
        ADM3_EN: 'Midvaal',
        ADM3_PCODE: 'ZA7422',
        ADM3_REF: '',
        ADM3ALT1EN: '',
        ADM3ALT2EN: '',
        ADM2_EN: 'Sedibeng',
        ADM2_PCODE: 'ZA742',
        ADM1_EN: 'Gauteng',
        ADM1_PCODE: 'ZA7',
        ADM0_EN: 'South Africa',
        ADM0_PCODE: 'ZA',
        date: '2018-12-27T00:00:00.000Z',
        validOn: '2020-11-09T00:00:00.000Z',
        validTo: '1899-11-30T00:00:00.000Z',
        ADM1_ID: 'GT',
        ADM2_ID: 'DC42',
        ADM3_ID: 'GT422',
      },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Polygon',
        coordinates: [
          [
            [30.673752943000068, -29.619902064999962],
            [30.61805994300005, -29.549960064999937],
            [30.540799943000025, -29.618230064999977],
            [30.49535994300004, -29.70545993999997],
            [30.399539943000036, -29.748629939999944],
            [30.493019943000036, -29.899560064999946],
            [30.513780068000074, -30.08713993999993],
            [30.59611407400007, -30.12389829899996],
            [30.675250068000025, -29.92222093999993],
            [30.575999943000056, -29.831499939999958],
            [30.569389943000033, -29.731649939999954],
            [30.673752943000068, -29.619902064999962],
          ],
        ],
      },
      properties: {
        Shape_Leng: 2.64105324913,
        Shape_Area: 0.0810738179479,
        ADM3_EN: 'Mkhambathini',
        ADM3_PCODE: 'ZA5226',
        ADM3_REF: '',
        ADM3ALT1EN: '',
        ADM3ALT2EN: '',
        ADM2_EN: 'Umgungundlovu',
        ADM2_PCODE: 'ZA522',
        ADM1_EN: 'KwaZulu-Natal',
        ADM1_PCODE: 'ZA5',
        ADM0_EN: 'South Africa',
        ADM0_PCODE: 'ZA',
        date: '2018-12-27T00:00:00.000Z',
        validOn: '2020-11-09T00:00:00.000Z',
        validTo: '1899-11-30T00:00:00.000Z',
        ADM1_ID: 'KZN',
        ADM2_ID: 'DC22',
        ADM3_ID: 'KZN226',
      },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Polygon',
        coordinates: [
          [
            [31.27432998000006, -27.24317002099997],
            [31.150550002000045, -27.202080002999935],
            [30.958326003000025, -26.99212899799994],
            [30.973559995000073, -26.908210001999976],
            [30.81321999900007, -26.844480003999934],
            [30.790799998000068, -26.71228999699997],
            [30.800260002000073, -26.504059998999935],
            [30.717919996000035, -26.48579000099994],
            [30.56106000300008, -26.505720002999965],
            [30.468950001000053, -26.558599999999956],
            [30.56054000100005, -26.66385999599993],
            [30.45916999800005, -26.75693999999993],
            [30.340419997000026, -26.774899997999967],
            [30.25076000100006, -26.824759995999955],
            [30.295749998000076, -27.016160000999946],
            [30.39947999900005, -27.021520000999942],
            [30.328069995000078, -27.183920000999933],
            [30.44848999900006, -27.207199997999965],
            [30.527049997000063, -27.315749989999972],
            [30.706799990000036, -27.283289986999932],
            [30.829679989000056, -27.350149981999948],
            [30.922159988000033, -27.305049981999957],
            [30.95578998900004, -27.35970998299996],
            [31.100959988000056, -27.335760020999942],
            [31.14086502400005, -27.362659979999933],
            [31.27432998000006, -27.24317002099997],
          ],
        ],
      },
      properties: {
        Shape_Leng: 4.52560350283,
        Shape_Area: 0.443897519297,
        ADM3_EN: 'Mkhondo',
        ADM3_PCODE: 'ZA8303',
        ADM3_REF: '',
        ADM3ALT1EN: '',
        ADM3ALT2EN: '',
        ADM2_EN: 'Gert Sibande',
        ADM2_PCODE: 'ZA830',
        ADM1_EN: 'Mpumalanga',
        ADM1_PCODE: 'ZA8',
        ADM0_EN: 'South Africa',
        ADM0_PCODE: 'ZA',
        date: '2018-12-27T00:00:00.000Z',
        validOn: '2020-11-09T00:00:00.000Z',
        validTo: '1899-11-30T00:00:00.000Z',
        ADM1_ID: 'MP',
        ADM2_ID: 'DC30',
        ADM3_ID: 'MP303',
      },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Polygon',
        coordinates: [
          [
            [28.675563002000047, -32.44858800199995],
            [28.55106099300008, -32.42085674699996],
            [28.31674000000004, -32.24349999999998],
            [28.235070651000058, -32.20815914999997],
            [28.25133999800005, -32.068510007999976],
            [28.01884885800007, -32.043181292999975],
            [28.010034442000062, -32.03639166599993],
            [27.889110002000052, -32.04975000299993],
            [27.775190001000055, -32.10948000299993],
            [27.812770000000057, -32.183239998999966],
            [27.758832939000058, -32.331968064999955],
            [27.893980003000024, -32.45614999999998],
            [28.047360000000026, -32.53638000299998],
            [28.14542000000006, -32.50955998899997],
            [28.38763500300007, -32.67960000199997],
            [28.511730003000025, -32.60318999699996],
            [28.675563002000047, -32.44858800199995],
          ],
        ],
      },
      properties: {
        Shape_Leng: 4.24287841665,
        Shape_Area: 0.300529837806,
        ADM3_EN: 'Mnquma',
        ADM3_PCODE: 'ZA2122',
        ADM3_REF: '',
        ADM3ALT1EN: '',
        ADM3ALT2EN: '',
        ADM2_EN: 'Amathole',
        ADM2_PCODE: 'ZA212',
        ADM1_EN: 'Eastern Cape',
        ADM1_PCODE: 'ZA2',
        ADM0_EN: 'South Africa',
        ADM0_PCODE: 'ZA',
        date: '2018-12-27T00:00:00.000Z',
        validOn: '2020-11-09T00:00:00.000Z',
        validTo: '1899-11-30T00:00:00.000Z',
        ADM1_ID: 'EC',
        ADM2_ID: 'DC12',
        ADM3_ID: 'EC122',
      },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Polygon',
        coordinates: [
          [
            [28.41582599900005, -23.99717700399998],
            [28.23605999600005, -24.005709999999965],
            [28.15887000400005, -24.15757999799996],
            [27.990230002000033, -24.180269996999982],
            [27.99956700300004, -24.308558000999938],
            [27.800519996000048, -24.308380003999957],
            [27.757870008000054, -24.404029999999977],
            [27.648829998000053, -24.35488000099997],
            [27.57467000300005, -24.42819999699998],
            [27.675859998000078, -24.50072999799994],
            [27.70070000100003, -24.59910999599998],
            [27.89511999700005, -24.582679994999978],
            [27.996049999000036, -24.63843000199995],
            [28.09486000000004, -24.63025999699994],
            [28.29210999700007, -24.795669997999937],
            [28.36611800000003, -24.78649399699998],
            [28.50488000000007, -24.87354000299996],
            [28.65762999800006, -24.837700001999963],
            [28.713779997000074, -24.95362000199998],
            [28.759379997000053, -24.91135000099996],
            [28.924069974000076, -24.901529977999928],
            [29.05592998000003, -24.912259990999928],
            [29.082879972000057, -24.981209941999964],
            [29.183149963000062, -24.939920040999937],
            [29.247380000000078, -24.71360999999996],
            [29.369900037000036, -24.663356028999942],
            [29.400489983000057, -24.608530019999932],
            [29.334540006000054, -24.55575000099998],
            [29.230420004000052, -24.337659997999936],
            [29.050850007000065, -24.37110999899994],
            [28.913170007000076, -24.414780002999976],
            [28.801270001000034, -24.331610001999934],
            [28.692878603000054, -24.11648151099996],
            [28.578759998000066, -24.05692000199997],
            [28.434529997000027, -24.043500001999973],
            [28.41582599900005, -23.99717700399998],
          ],
        ],
      },
      properties: {
        Shape_Leng: 6.20010260937,
        Shape_Area: 0.923446987268,
        ADM3_EN: 'Modimolle/Mookgophong',
        ADM3_PCODE: 'ZA9368',
        ADM3_REF: '',
        ADM3ALT1EN: '',
        ADM3ALT2EN: '',
        ADM2_EN: 'Waterberg',
        ADM2_PCODE: 'ZA936',
        ADM1_EN: 'Limpopo',
        ADM1_PCODE: 'ZA9',
        ADM0_EN: 'South Africa',
        ADM0_PCODE: 'ZA',
        date: '2018-12-27T00:00:00.000Z',
        validOn: '2020-11-09T00:00:00.000Z',
        validTo: '1899-11-30T00:00:00.000Z',
        ADM1_ID: 'LIM',
        ADM2_ID: 'DC36',
        ADM3_ID: 'LIM368',
      },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Polygon',
        coordinates: [
          [
            [28.969249811000054, -23.59783252699998],
            [28.795609971000033, -23.416060028999937],
            [28.73576997200007, -23.330910030999974],
            [28.595938052000065, -23.40472805199994],
            [28.464309996000054, -23.54534001099995],
            [28.383020000000045, -23.438269996999963],
            [28.166709997000055, -23.508380003999946],
            [28.162660000000074, -23.63243999799994],
            [28.29962000100005, -23.804319998999972],
            [28.341249997000034, -23.918999998999936],
            [28.41582599900005, -23.99717700399998],
            [28.434529997000027, -24.043500001999973],
            [28.578759998000066, -24.05692000199997],
            [28.692878603000054, -24.11648151099996],
            [28.801270001000034, -24.331610001999934],
            [28.913170007000076, -24.414780002999976],
            [29.050850007000065, -24.37110999899994],
            [29.07267000400003, -24.20644999899997],
            [29.18896999900005, -24.256940002999954],
            [29.162150001000043, -24.079280005999976],
            [28.998438002000057, -23.841155000999947],
            [28.921390003000056, -23.81122000099998],
            [28.843200000000024, -23.833979995999982],
            [28.875519997000026, -23.64661999799995],
            [28.969249811000054, -23.59783252699998],
          ],
        ],
      },
      properties: {
        Shape_Leng: 4.94292797172,
        Shape_Area: 0.545623759934,
        ADM3_EN: 'Mogalakwena',
        ADM3_PCODE: 'ZA9367',
        ADM3_REF: '',
        ADM3ALT1EN: '',
        ADM3ALT2EN: '',
        ADM2_EN: 'Waterberg',
        ADM2_PCODE: 'ZA936',
        ADM1_EN: 'Limpopo',
        ADM1_PCODE: 'ZA9',
        ADM0_EN: 'South Africa',
        ADM0_PCODE: 'ZA',
        date: '2018-12-27T00:00:00.000Z',
        validOn: '2020-11-09T00:00:00.000Z',
        validTo: '1899-11-30T00:00:00.000Z',
        ADM1_ID: 'LIM',
        ADM2_ID: 'DC36',
        ADM3_ID: 'LIM367',
      },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Polygon',
        coordinates: [
          [
            [27.898200001000077, -25.859740003999946],
            [27.744549997000036, -25.894620002999943],
            [27.643549999000072, -25.79591999799993],
            [27.532289998000067, -25.849960000999943],
            [27.461947001000055, -25.867606000999956],
            [27.425220000000024, -26.089389998999934],
            [27.46734000400005, -26.09226999899994],
            [27.706580004000045, -26.11557000099998],
            [27.71826999700005, -26.198929998999972],
            [27.77199000300004, -26.21320999699998],
            [27.84964000000008, -26.06238001099996],
            [27.912640002000046, -26.02820999599993],
            [27.932119998000076, -25.916300000999968],
            [27.898200001000077, -25.859740003999946],
          ],
        ],
      },
      properties: {
        Shape_Leng: 2.31524619787,
        Shape_Area: 0.120991605767,
        ADM3_EN: 'Mogale City',
        ADM3_PCODE: 'ZA7481',
        ADM3_REF: '',
        ADM3ALT1EN: '',
        ADM3ALT2EN: '',
        ADM2_EN: 'West Rand',
        ADM2_PCODE: 'ZA748',
        ADM1_EN: 'Gauteng',
        ADM1_PCODE: 'ZA7',
        ADM0_EN: 'South Africa',
        ADM0_PCODE: 'ZA',
        date: '2018-12-27T00:00:00.000Z',
        validOn: '2020-11-09T00:00:00.000Z',
        validTo: '1899-11-30T00:00:00.000Z',
        ADM1_ID: 'GT',
        ADM2_ID: 'DC48',
        ADM3_ID: 'GT481',
      },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Polygon',
        coordinates: [
          [
            [27.216360004000023, -29.982970000999956],
            [27.091950000000054, -30.026769996999974],
            [27.06537998700003, -30.07578999499998],
            [26.946799990000045, -30.108569989999978],
            [26.81517001000003, -30.03037999299994],
            [26.82395000100007, -29.964710000999958],
            [26.733299999000053, -29.84219000099995],
            [26.78034000200006, -29.73902000299995],
            [26.660210002000042, -29.726830003999964],
            [26.62698000200004, -29.63453000399994],
            [26.551089999000055, -29.571759999999983],
            [26.38225999900004, -29.61614000399993],
            [26.42430999900006, -29.661220000999947],
            [26.38681000200006, -29.74058999999994],
            [26.250320007000028, -29.83436999299994],
            [26.19140999900003, -29.93883999999997],
            [26.26020000400007, -30.03568000399997],
            [26.144799998000053, -30.166320002999953],
            [26.167120000000068, -30.272320001999958],
            [26.323570003000043, -30.502430001999983],
            [26.280609999000035, -30.57835999799994],
            [26.425180002000047, -30.56523999799998],
            [26.481230003000064, -30.627629998999964],
            [26.629450004000034, -30.693879997999943],
            [26.814140004000024, -30.642670002999978],
            [26.94301000200005, -30.66214999799996],
            [27.034309991000043, -30.599859995999964],
            [27.00364999800007, -30.538309995999953],
            [27.284489999000073, -30.503400002999967],
            [27.37735000300006, -30.327119995999965],
            [27.39414999400003, -30.142469996999978],
            [27.326890001000038, -30.14812000099994],
            [27.29654000000005, -30.056109995999975],
            [27.216360004000023, -29.982970000999956],
          ],
        ],
      },
      properties: {
        Shape_Leng: 6.25858650199,
        Shape_Area: 0.822196928183,
        ADM3_EN: 'Mohokare',
        ADM3_PCODE: 'ZA4163',
        ADM3_REF: '',
        ADM3ALT1EN: '',
        ADM3ALT2EN: '',
        ADM2_EN: 'Xhariep',
        ADM2_PCODE: 'ZA416',
        ADM1_EN: 'Free State',
        ADM1_PCODE: 'ZA4',
        ADM0_EN: 'South Africa',
        ADM0_PCODE: 'ZA',
        date: '2018-12-27T00:00:00.000Z',
        validOn: '2020-11-09T00:00:00.000Z',
        validTo: '1899-11-30T00:00:00.000Z',
        ADM1_ID: 'FS',
        ADM2_ID: 'DC16',
        ADM3_ID: 'FS163',
      },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Polygon',
        coordinates: [
          [
            [30.03769998200005, -23.33871002199993],
            [29.866839981000055, -23.43741001999996],
            [29.741869973000064, -23.435250027999928],
            [29.616749971000047, -23.396450030999972],
            [29.59185997000003, -23.268260030999954],
            [29.267809965000026, -23.238640029999942],
            [29.157239969000045, -23.318800003999968],
            [29.082059956000023, -23.299960044999978],
            [29.066478751000034, -23.554339891999973],
            [29.226550967000037, -23.57999377999994],
            [29.348040001000072, -23.527159996999956],
            [29.41371999900008, -23.621129999999937],
            [29.500759989000073, -23.81135999999998],
            [29.675980003000063, -23.75132999799996],
            [29.79523000100005, -23.68082999799998],
            [29.887920003000033, -23.67941999599998],
            [29.961120004000065, -23.66007000199994],
            [30.03643999800005, -23.57296999899995],
            [30.00599999700006, -23.447810002999972],
            [30.03769998200005, -23.33871002199993],
          ],
        ],
      },
      properties: {
        Shape_Leng: 3.59597897721,
        Shape_Area: 0.320661519657,
        ADM3_EN: 'Molemole',
        ADM3_PCODE: 'ZA9353',
        ADM3_REF: '',
        ADM3ALT1EN: '',
        ADM3ALT2EN: '',
        ADM2_EN: 'Capricorn',
        ADM2_PCODE: 'ZA935',
        ADM1_EN: 'Limpopo',
        ADM1_PCODE: 'ZA9',
        ADM0_EN: 'South Africa',
        ADM0_PCODE: 'ZA',
        date: '2018-12-27T00:00:00.000Z',
        validOn: '2020-11-09T00:00:00.000Z',
        validTo: '1899-11-30T00:00:00.000Z',
        ADM1_ID: 'LIM',
        ADM2_ID: 'DC35',
        ADM3_ID: 'LIM353',
      },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Polygon',
        coordinates: [
          [
            [27.389485000000036, -26.906384999999943],
            [27.306050003000053, -26.85333999599993],
            [27.17366000100003, -26.96759000199995],
            [27.11343000200003, -26.926359996999963],
            [27.013929998000037, -26.932050001999983],
            [26.947220010000024, -26.89200999899998],
            [26.866440002000047, -26.91906000299997],
            [26.621069997000063, -27.00272000299998],
            [26.521619999000052, -27.104389999999967],
            [26.575410000000034, -27.183319997999945],
            [26.635249997000074, -27.171569999999974],
            [26.72758999000007, -27.230809999999963],
            [26.746320000000026, -27.395339999999976],
            [26.789719997000077, -27.51083998799993],
            [26.857710002000033, -27.58600000299998],
            [26.950050003000058, -27.522500002999948],
            [27.01632999700007, -27.598240000999965],
            [26.969940004000023, -27.69444999899997],
            [27.04476999800005, -27.749099996999973],
            [27.052500003000034, -27.85931000399995],
            [27.15779000200007, -27.93333999799995],
            [27.19277999700006, -27.899749998999937],
            [27.35898200200006, -27.932452998999963],
            [27.363450000000057, -28.001459987999965],
            [27.433770001000028, -28.049759995999977],
            [27.37005000100004, -28.17026999899997],
            [27.38786999900003, -28.214080001999946],
            [27.56962000200008, -28.282529995999937],
            [27.596290003000036, -28.175989998999967],
            [27.703459999000074, -28.040389999999945],
            [27.737719998000046, -27.92817000399998],
            [27.872599999000045, -27.933779998999967],
            [27.862840001000052, -27.78952000399994],
            [27.633371002000047, -27.803171000999953],
            [27.566809998000053, -27.738040001999934],
            [27.639429999000072, -27.681559998999944],
            [27.576810000000023, -27.61853999999994],
            [27.478570000000047, -27.63120999299997],
            [27.435974999000052, -27.570466000999943],
            [27.44342000200004, -27.482919996999954],
            [27.232079998000074, -27.47461999899997],
            [27.171790002000023, -27.39759000199996],
            [27.214510002000054, -27.278579999999977],
            [27.378709997000044, -27.29129999999998],
            [27.38991999700005, -27.111380001999976],
            [27.340810000000033, -27.019300001999966],
            [27.389485000000036, -26.906384999999943],
          ],
        ],
      },
      properties: {
        Shape_Leng: 7.84315591617,
        Shape_Area: 0.723757142436,
        ADM3_EN: 'Moqhaka',
        ADM3_PCODE: 'ZA4201',
        ADM3_REF: '',
        ADM3ALT1EN: '',
        ADM3ALT2EN: '',
        ADM2_EN: 'Fezile Dabi',
        ADM2_PCODE: 'ZA420',
        ADM1_EN: 'Free State',
        ADM1_PCODE: 'ZA4',
        ADM0_EN: 'South Africa',
        ADM0_PCODE: 'ZA',
        date: '2018-12-27T00:00:00.000Z',
        validOn: '2020-11-09T00:00:00.000Z',
        validTo: '1899-11-30T00:00:00.000Z',
        ADM1_ID: 'FS',
        ADM2_ID: 'DC20',
        ADM3_ID: 'FS201',
      },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Polygon',
        coordinates: [
          [
            [28.298160001000042, -25.310370001999956],
            [28.246270001000028, -25.212855003999948],
            [28.13571999900006, -25.20563999799998],
            [28.25975999700006, -25.050449999999955],
            [27.983559998000032, -24.957849997999972],
            [27.946469998000055, -25.001219999999932],
            [27.821660003000034, -24.974580001999982],
            [27.831360962000076, -25.20962038999994],
            [27.970759997000073, -25.362949989999947],
            [28.04473000400003, -25.401739994999957],
            [28.298060004000035, -25.33933999599998],
            [28.298160001000042, -25.310370001999956],
          ],
        ],
      },
      properties: {
        Shape_Leng: 2.25775450035,
        Shape_Area: 0.134135817232,
        ADM3_EN: 'Moretele',
        ADM3_PCODE: 'ZA6371',
        ADM3_REF: '',
        ADM3ALT1EN: '',
        ADM3ALT2EN: '',
        ADM2_EN: 'Bojanala',
        ADM2_PCODE: 'ZA637',
        ADM1_EN: 'North West',
        ADM1_PCODE: 'ZA6',
        ADM0_EN: 'South Africa',
        ADM0_PCODE: 'ZA',
        date: '2018-12-27T00:00:00.000Z',
        validOn: '2020-11-09T00:00:00.000Z',
        validTo: '1899-11-30T00:00:00.000Z',
        ADM1_ID: 'NW',
        ADM2_ID: 'DC37',
        ADM3_ID: 'NW371',
      },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Polygon',
        coordinates: [
          [
            [27.486900001000038, -25.07841999799996],
            [27.33695000000006, -25.08781999699994],
            [27.313600000000065, -25.042089996999948],
            [27.203468000000044, -25.033182997999972],
            [27.22609200200003, -24.963937001999966],
            [27.041219999000077, -24.88697000299993],
            [26.980720002000055, -24.77576999799993],
            [26.77954000300008, -24.837690002999977],
            [26.751259996000044, -24.88295999899998],
            [26.62201000300007, -24.809860003999972],
            [26.458280002000038, -24.809470001999955],
            [26.418109999000023, -25.046799994999958],
            [26.40502000200007, -25.28592999899996],
            [26.466040001000067, -25.29066999899993],
            [26.419300000000078, -25.477640003999966],
            [26.506016002000024, -25.501890998999954],
            [26.648690002000023, -25.44761000099993],
            [26.760519996000028, -25.359200002999955],
            [27.00336000200008, -25.38999000399997],
            [27.364950001000068, -25.32539000299994],
            [27.42797999800007, -25.289660004999973],
            [27.490199997000047, -25.197209999999927],
            [27.486900001000038, -25.07841999799996],
          ],
        ],
      },
      properties: {
        Shape_Leng: 4.28349931486,
        Shape_Area: 0.512617823268,
        ADM3_EN: 'Moses Kotane',
        ADM3_PCODE: 'ZA6375',
        ADM3_REF: '',
        ADM3ALT1EN: '',
        ADM3ALT2EN: '',
        ADM2_EN: 'Bojanala',
        ADM2_PCODE: 'ZA637',
        ADM1_EN: 'North West',
        ADM1_PCODE: 'ZA6',
        ADM0_EN: 'South Africa',
        ADM0_PCODE: 'ZA',
        date: '2018-12-27T00:00:00.000Z',
        validOn: '2020-11-09T00:00:00.000Z',
        validTo: '1899-11-30T00:00:00.000Z',
        ADM1_ID: 'NW',
        ADM2_ID: 'DC37',
        ADM3_ID: 'NW375',
      },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Polygon',
        coordinates: [
          [
            [22.233749998000064, -33.888240003999954],
            [22.123679998000057, -33.84637000299995],
            [21.932780007000076, -33.86542000399993],
            [21.70035000200005, -33.85285000099998],
            [21.65139000100004, -33.92818999899998],
            [21.715360004000047, -34.043579998999974],
            [21.71243143600003, -34.127638167999976],
            [21.792579998000065, -34.28613000099995],
            [21.88696999700005, -34.34357999699995],
            [21.932249999000078, -34.24513000299993],
            [22.112190008000027, -34.20380999899993],
            [22.12594999600003, -34.11492999799998],
            [22.23446999600003, -34.058169996999936],
            [22.35457000100007, -34.05442999999997],
            [22.27986000100003, -34.02149000299994],
            [22.233749998000064, -33.888240003999954],
          ],
        ],
      },
      properties: {
        Shape_Leng: 2.99722717464,
        Shape_Area: 0.195363901074,
        ADM3_EN: 'Mossel Bay',
        ADM3_PCODE: 'ZA1043',
        ADM3_REF: '',
        ADM3ALT1EN: '',
        ADM3ALT2EN: '',
        ADM2_EN: 'Eden',
        ADM2_PCODE: 'ZA104',
        ADM1_EN: 'Western Cape',
        ADM1_PCODE: 'ZA1',
        ADM0_EN: 'South Africa',
        ADM0_PCODE: 'ZA',
        date: '2018-12-27T00:00:00.000Z',
        validOn: '2020-11-09T00:00:00.000Z',
        validTo: '1899-11-30T00:00:00.000Z',
        ADM1_ID: 'WC',
        ADM2_ID: 'DC4',
        ADM3_ID: 'WC043',
      },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Polygon',
        coordinates: [
          [
            [30.32774164600005, -28.946712600999945],
            [30.287469943000076, -28.91489993899995],
            [30.229629943000077, -28.984039938999956],
            [30.086179943000047, -28.966530063999983],
            [30.027989942000033, -29.05932006499995],
            [29.926899942000034, -29.121849939999947],
            [29.854859942000076, -29.21807993999994],
            [29.75571994200004, -29.206939939999984],
            [29.753790067000068, -29.283259939999937],
            [29.652099942000063, -29.297079939999946],
            [29.609740067000075, -29.24864993999995],
            [29.506799942000043, -29.33977993999997],
            [29.61328005200005, -29.408469929999967],
            [29.689915942000027, -29.402831939999942],
            [30.011779942000032, -29.296710064999957],
            [30.122739943000056, -29.245109939999963],
            [30.20822894300005, -29.25164093999996],
            [30.276299943000026, -29.30914993999994],
            [30.335870068000077, -29.163850064999963],
            [30.32774164600005, -28.946712600999945],
          ],
        ],
      },
      properties: {
        Shape_Leng: 3.30117059818,
        Shape_Area: 0.162948671673,
        ADM3_EN: 'Mpofana',
        ADM3_PCODE: 'ZA5223',
        ADM3_REF: '',
        ADM3ALT1EN: '',
        ADM3ALT2EN: '',
        ADM2_EN: 'Umgungundlovu',
        ADM2_PCODE: 'ZA522',
        ADM1_EN: 'KwaZulu-Natal',
        ADM1_PCODE: 'ZA5',
        ADM0_EN: 'South Africa',
        ADM0_PCODE: 'ZA',
        date: '2018-12-27T00:00:00.000Z',
        validOn: '2020-11-09T00:00:00.000Z',
        validTo: '1899-11-30T00:00:00.000Z',
        ADM1_ID: 'KZN',
        ADM2_ID: 'DC22',
        ADM3_ID: 'KZN223',
      },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Polygon',
        coordinates: [
          [
            [30.505729943000063, -28.262689938999983],
            [30.35194994300008, -28.266459938999958],
            [30.23359494300007, -28.408709938999948],
            [30.337770068000054, -28.47392006399997],
            [30.220729943000038, -28.57331993899993],
            [30.267529943000056, -28.731019938999964],
            [30.287469943000076, -28.91489993899995],
            [30.32774164600005, -28.946712600999945],
            [30.45184994300007, -28.88077993899998],
            [30.563990068000066, -28.879339938999976],
            [30.69907394300003, -28.771935938999945],
            [30.650109943000075, -28.720729938999966],
            [30.67031594300005, -28.642552063999972],
            [30.681739943000025, -28.54084993899994],
            [30.635649943000033, -28.407980063999958],
            [30.530769943000053, -28.334409938999954],
            [30.505729943000063, -28.262689938999983],
          ],
        ],
      },
      properties: {
        Shape_Leng: 3.21311552481,
        Shape_Area: 0.219115175466,
        ADM3_EN: 'Msinga',
        ADM3_PCODE: 'ZA5244',
        ADM3_REF: '',
        ADM3ALT1EN: '',
        ADM3ALT2EN: '',
        ADM2_EN: 'Umzinyathi',
        ADM2_PCODE: 'ZA524',
        ADM1_EN: 'KwaZulu-Natal',
        ADM1_PCODE: 'ZA5',
        ADM0_EN: 'South Africa',
        ADM0_PCODE: 'ZA',
        date: '2018-12-27T00:00:00.000Z',
        validOn: '2020-11-09T00:00:00.000Z',
        validTo: '1899-11-30T00:00:00.000Z',
        ADM1_ID: 'KZN',
        ADM2_ID: 'DC24',
        ADM3_ID: 'KZN244',
      },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Polygon',
        coordinates: [
          [
            [30.717919996000035, -26.48579000099994],
            [30.698690012000043, -26.444570002999967],
            [30.755520997000076, -26.332773003999932],
            [30.624160003000043, -26.25877000299994],
            [30.592760000000055, -26.207990002999964],
            [30.493890002000057, -26.23303999999996],
            [30.35802000500007, -26.17068999999998],
            [30.209469999000078, -26.220130001999962],
            [30.06185499700007, -26.209603000999948],
            [29.96906000200005, -26.243360000999928],
            [29.80468999800007, -26.189510002999953],
            [29.66762999900004, -26.244640001999983],
            [29.540350001000036, -26.253879996999956],
            [29.468669998000053, -26.352490001999968],
            [29.629110001000072, -26.48149000099994],
            [29.61916999500005, -26.52905999799998],
            [29.640350003000037, -26.62790999899994],
            [29.82264400200006, -26.669365995999954],
            [29.842960000000062, -26.799460003999968],
            [29.963759999000047, -26.770670001999974],
            [29.994810001000076, -26.69772000399996],
            [30.111160004000055, -26.736320001999957],
            [30.13794000100006, -26.834820003999937],
            [30.25076000100006, -26.824759995999955],
            [30.340419997000026, -26.774899997999967],
            [30.45916999800005, -26.75693999999993],
            [30.56054000100005, -26.66385999599993],
            [30.468950001000053, -26.558599999999956],
            [30.56106000300008, -26.505720002999965],
            [30.717919996000035, -26.48579000099994],
          ],
        ],
      },
      properties: {
        Shape_Leng: 4.84919821453,
        Shape_Area: 0.544493572584,
        ADM3_EN: 'Msukaligwa',
        ADM3_PCODE: 'ZA8302',
        ADM3_REF: '',
        ADM3ALT1EN: '',
        ADM3ALT2EN: '',
        ADM2_EN: 'Gert Sibande',
        ADM2_PCODE: 'ZA830',
        ADM1_EN: 'Mpumalanga',
        ADM1_PCODE: 'ZA8',
        ADM0_EN: 'South Africa',
        ADM0_PCODE: 'ZA',
        date: '2018-12-27T00:00:00.000Z',
        validOn: '2020-11-09T00:00:00.000Z',
        validTo: '1899-11-30T00:00:00.000Z',
        ADM1_ID: 'MP',
        ADM2_ID: 'DC30',
        ADM3_ID: 'MP302',
      },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Polygon',
        coordinates: [
          [
            [31.811069944000053, -28.431680938999932],
            [31.70206494400003, -28.371455063999974],
            [31.53595994400007, -28.394330063999973],
            [31.504399944000056, -28.471979938999937],
            [31.32945094400003, -28.449164938999957],
            [31.249139944000035, -28.462209938999933],
            [31.15853994400004, -28.551114938999945],
            [31.19879994400003, -28.649230063999937],
            [31.346229944000072, -28.77463993899994],
            [31.450219944000025, -28.762239938999983],
            [31.520879944000058, -28.713409938999973],
            [31.651483091000046, -28.70387308599993],
            [31.719700620000026, -28.49808504899994],
            [31.793650505000073, -28.48310668599993],
            [31.811069944000053, -28.431680938999932],
          ],
        ],
      },
      properties: {
        Shape_Leng: 2.57562798672,
        Shape_Area: 0.15111958971,
        ADM3_EN: 'Mthonjaneni',
        ADM3_PCODE: 'ZA5285',
        ADM3_REF: '',
        ADM3ALT1EN: '',
        ADM3ALT2EN: '',
        ADM2_EN: 'Uthungulu',
        ADM2_PCODE: 'ZA528',
        ADM1_EN: 'KwaZulu-Natal',
        ADM1_PCODE: 'ZA5',
        ADM0_EN: 'South Africa',
        ADM0_PCODE: 'ZA',
        date: '2018-12-27T00:00:00.000Z',
        validOn: '2020-11-09T00:00:00.000Z',
        validTo: '1899-11-30T00:00:00.000Z',
        ADM1_ID: 'KZN',
        ADM2_ID: 'DC28',
        ADM3_ID: 'KZN285',
      },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Polygon',
        coordinates: [
          [
            [32.614832748000026, -28.133148029999973],
            [32.339399945000025, -28.098979938999946],
            [32.26751994500006, -28.145899938999946],
            [32.12099994400006, -28.117189938999957],
            [32.02841994400006, -28.220219938999946],
            [31.981432944000062, -28.35041993899995],
            [31.990779944000053, -28.388589938999928],
            [32.212189944000045, -28.45894993899998],
            [32.30519994500003, -28.51851006399994],
            [32.41476794500005, -28.476392938999936],
            [32.48299794500008, -28.388292063999984],
            [32.614832748000026, -28.133148029999973],
          ],
        ],
      },
      properties: {
        Shape_Leng: 2.32608709131,
        Shape_Area: 0.181188178527,
        ADM3_EN: 'Mtubatuba',
        ADM3_PCODE: 'ZA5275',
        ADM3_REF: '',
        ADM3ALT1EN: '',
        ADM3ALT2EN: '',
        ADM2_EN: 'Umkhanyakude',
        ADM2_PCODE: 'ZA527',
        ADM1_EN: 'KwaZulu-Natal',
        ADM1_PCODE: 'ZA5',
        ADM0_EN: 'South Africa',
        ADM0_PCODE: 'ZA',
        date: '2018-12-27T00:00:00.000Z',
        validOn: '2020-11-09T00:00:00.000Z',
        validTo: '1899-11-30T00:00:00.000Z',
        ADM1_ID: 'KZN',
        ADM2_ID: 'DC27',
        ADM3_ID: 'KZN275',
      },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Polygon',
        coordinates: [
          [
            [31.344896727000048, -22.534532147999982],
            [31.273680004000028, -22.37476000199996],
            [31.161999998000056, -22.328419999999937],
            [31.094109999000068, -22.348689995999962],
            [30.83917000200006, -22.29208000099993],
            [30.626089943000068, -22.336340056999973],
            [30.491889943000047, -22.316590057999974],
            [30.28287994300007, -22.354010056999982],
            [30.227539944000057, -22.294980056999975],
            [30.121569944000044, -22.308670056999972],
            [30.019849942000064, -22.23344005799993],
            [29.773589942000058, -22.141420057999937],
            [29.541009942000073, -22.152270057999942],
            [29.331989942000064, -22.20417005799993],
            [29.217199943000026, -22.178310057999965],
            [29.154999942000074, -22.214520057999948],
            [29.03693994200006, -22.21631005699993],
            [28.966579942000067, -22.307540057999972],
            [28.92327896200004, -22.457035037999958],
            [28.979110066000032, -22.581130058999975],
            [29.107339942000067, -22.539250057999936],
            [29.16587994200006, -22.553120057999934],
            [29.20935997500004, -22.66278004299994],
            [29.308779968000067, -22.60204007799996],
            [29.36867994200003, -22.65197005899995],
            [29.538529942000025, -22.61510005799994],
            [29.61883994200008, -22.65944993399995],
            [29.748249943000076, -22.680130058999964],
            [29.798509942000067, -22.758070058999976],
            [29.928169943000057, -22.664810057999944],
            [30.10561994300008, -22.703980058999946],
            [30.32371994300007, -22.653220058999977],
            [30.43528248000007, -22.659607723999954],
            [30.787693653000076, -22.592604974999972],
            [30.81725288800004, -22.500636356999962],
            [30.888754806000065, -22.48032150499995],
            [30.989229968000075, -22.608260023999946],
            [30.88948059100005, -22.71283912699994],
            [31.013439178000056, -22.72781944199994],
            [31.070337296000048, -22.802122115999964],
            [31.17854309100005, -22.672002791999944],
            [31.344896727000048, -22.534532147999982],
          ],
        ],
      },
      properties: {
        Shape_Leng: 7.17129987198,
        Shape_Area: 0.907729761784,
        ADM3_EN: 'Musina',
        ADM3_PCODE: 'ZA9341',
        ADM3_REF: '',
        ADM3ALT1EN: '',
        ADM3ALT2EN: '',
        ADM2_EN: 'Vhembe',
        ADM2_PCODE: 'ZA934',
        ADM1_EN: 'Limpopo',
        ADM1_PCODE: 'ZA9',
        ADM0_EN: 'South Africa',
        ADM0_PCODE: 'ZA',
        date: '2018-12-27T00:00:00.000Z',
        validOn: '2020-11-09T00:00:00.000Z',
        validTo: '1899-11-30T00:00:00.000Z',
        ADM1_ID: 'LIM',
        ADM2_ID: 'DC34',
        ADM3_ID: 'LIM341',
      },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Polygon',
        coordinates: [
          [
            [26.857710002000033, -27.58600000299998],
            [26.789719997000077, -27.51083998799993],
            [26.746320000000026, -27.395339999999976],
            [26.72758999000007, -27.230809999999963],
            [26.635249997000074, -27.171569999999974],
            [26.575410000000034, -27.183319997999945],
            [26.521619999000052, -27.104389999999967],
            [26.419900003000066, -27.171359996999968],
            [26.496769998000048, -27.26495999499997],
            [26.423090004000073, -27.40686999899998],
            [26.267750000000035, -27.416309997999974],
            [26.22724000200003, -27.51340999599995],
            [26.125510000000077, -27.564780009999936],
            [26.055059999000036, -27.670060002999946],
            [26.075840000000028, -27.710650002999955],
            [26.12547600000005, -27.818566998999984],
            [26.217400003000023, -27.88307999999995],
            [26.188231002000066, -28.001318002999938],
            [26.414640001000066, -28.092130002999966],
            [26.472630004000052, -28.078289996999956],
            [26.54876000300004, -27.873959998999965],
            [26.560879991000036, -27.724080001999937],
            [26.636299999000073, -27.65908000099995],
            [26.74193000100007, -27.693630002999953],
            [26.857710002000033, -27.58600000299998],
          ],
        ],
      },
      properties: {
        Shape_Leng: 4.51558898054,
        Shape_Area: 0.377482374195,
        ADM3_EN: 'Nala',
        ADM3_PCODE: 'ZA4185',
        ADM3_REF: '',
        ADM3ALT1EN: '',
        ADM3ALT2EN: '',
        ADM2_EN: 'Lejweleputswa',
        ADM2_PCODE: 'ZA418',
        ADM1_EN: 'Free State',
        ADM1_PCODE: 'ZA4',
        ADM0_EN: 'South Africa',
        ADM0_PCODE: 'ZA',
        date: '2018-12-27T00:00:00.000Z',
        validOn: '2020-11-09T00:00:00.000Z',
        validTo: '1899-11-30T00:00:00.000Z',
        ADM1_ID: 'FS',
        ADM2_ID: 'DC18',
        ADM3_ID: 'FS185',
      },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Polygon',
        coordinates: [
          [
            [25.16958999700006, -26.519929997999952],
            [25.06620299900004, -26.55029499999995],
            [24.991200003000074, -26.39093999199997],
            [24.85785000000004, -26.394999999999982],
            [24.76417999800003, -26.205250000999968],
            [24.635080001000063, -26.269699997999965],
            [24.677920003000054, -26.329109999999957],
            [24.53613000100006, -26.401690000999963],
            [24.602179997000064, -26.51544999899994],
            [24.657379999000057, -26.48580999799998],
            [24.780250000000024, -26.642580006999935],
            [24.276980004000052, -26.883239997999965],
            [24.265849997000032, -26.960619995999934],
            [24.32020501200003, -27.082695000999934],
            [24.415399998000055, -27.211610002999976],
            [24.380169998000042, -27.272490003999962],
            [24.45717000800005, -27.424419997999962],
            [24.612945007000064, -27.337962009999956],
            [24.58572914000007, -27.29284741999993],
            [24.699311089000048, -27.234209972999963],
            [24.777190000000076, -27.333240003999947],
            [24.895249998000054, -27.178990003999957],
            [25.007300001000033, -27.093260001999965],
            [25.07638999900007, -27.201509993999935],
            [25.15361000200005, -27.158729997999956],
            [25.10806000200006, -27.017920002999972],
            [25.324459997000076, -27.01425999199995],
            [25.38267999800007, -26.861659997999936],
            [25.320779997000045, -26.886259996999968],
            [25.257490000000075, -26.802249995999944],
            [25.194198080000035, -26.85758167299997],
            [25.120012125000073, -26.79724799199994],
            [25.147649998000077, -26.71401999699998],
            [25.226705002000074, -26.614766277999934],
            [25.16958999700006, -26.519929997999952],
          ],
        ],
      },
      properties: {
        Shape_Leng: 5.49921574245,
        Shape_Area: 0.638449315664,
        ADM3_EN: 'Naledi',
        ADM3_PCODE: 'ZA6392',
        ADM3_REF: '',
        ADM3ALT1EN: '',
        ADM3ALT2EN: '',
        ADM2_EN: 'Dr Ruth Segomotsi Mompati',
        ADM2_PCODE: 'ZA639',
        ADM1_EN: 'North West',
        ADM1_PCODE: 'ZA6',
        ADM0_EN: 'South Africa',
        ADM0_PCODE: 'ZA',
        date: '2018-12-27T00:00:00.000Z',
        validOn: '2020-11-09T00:00:00.000Z',
        validTo: '1899-11-30T00:00:00.000Z',
        ADM1_ID: 'NW',
        ADM2_ID: 'DC39',
        ADM3_ID: 'NW392',
      },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Polygon',
        coordinates: [
          [
            [18.51208000400004, -28.88948000399995],
            [18.263490003000072, -28.879389997999965],
            [18.19382999900006, -28.915270002999932],
            [18.04606999400005, -28.874269992999928],
            [17.925650002000054, -28.76883999599994],
            [17.61867999800006, -28.76416000699993],
            [17.598860003000027, -28.694649996999942],
            [17.41870899500003, -28.72198100199995],
            [17.34900900100007, -28.794456993999972],
            [17.462206998000056, -28.85452700299993],
            [17.46046000000007, -29.02768000599997],
            [17.54058999600005, -29.337629999999933],
            [17.520850006000046, -29.437430004999953],
            [17.32642000000004, -29.404330004999963],
            [17.35744999900004, -29.327950001999966],
            [17.238210001000027, -29.240669999999966],
            [17.091619999000045, -29.333830001999956],
            [17.086770001000048, -29.443699996999953],
            [16.994610000000023, -29.515005001999953],
            [17.076659995000057, -29.815400000999944],
            [17.181000002000076, -30.061730000999944],
            [17.247240000000033, -30.003180004999933],
            [17.312240005000035, -30.092839996999942],
            [17.439129999000045, -30.03308999899997],
            [17.519239995000078, -29.949870000999965],
            [17.603879995000057, -30.012490001999936],
            [17.732490003000066, -30.020719999999983],
            [17.863600003000045, -30.06668999599998],
            [18.000010002000067, -30.06589999399995],
            [18.208803792000026, -30.000553882999952],
            [18.219024793000074, -29.91100935199995],
            [18.333249994000028, -29.89559999399995],
            [18.36712000500006, -29.934800000999928],
            [18.493659973000035, -29.91807937599998],
            [18.605489997000063, -29.86041000199998],
            [18.725596495000048, -29.864108638999937],
            [18.808450699000048, -29.83167076099994],
            [18.761089325000057, -29.675640105999946],
            [18.776649517000067, -29.48357621799994],
            [18.74867000000006, -29.418060000999958],
            [18.651000003000036, -29.421729995999954],
            [18.642949998000063, -29.218010000999982],
            [18.595510002000026, -29.138489997999955],
            [18.619520005000027, -29.01807000499997],
            [18.51208000400004, -28.88948000399995],
          ],
        ],
      },
      properties: {
        Shape_Leng: 7.1284597559,
        Shape_Area: 1.6731401731,
        ADM3_EN: 'Nama Khoi',
        ADM3_PCODE: 'ZA3062',
        ADM3_REF: '',
        ADM3ALT1EN: '',
        ADM3ALT2EN: '',
        ADM2_EN: 'Namakwa',
        ADM2_PCODE: 'ZA306',
        ADM1_EN: 'Nothern Cape',
        ADM1_PCODE: 'ZA3',
        ADM0_EN: 'South Africa',
        ADM0_PCODE: 'ZA',
        date: '2018-12-27T00:00:00.000Z',
        validOn: '2020-11-09T00:00:00.000Z',
        validTo: '1899-11-30T00:00:00.000Z',
        ADM1_ID: 'NC',
        ADM2_ID: 'DC6',
        ADM3_ID: 'NC062',
      },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Polygon',
        coordinates: [
          [
            [27.135600000000068, -33.496329998999954],
            [26.98525999800006, -33.35620000199998],
            [26.968949999000074, -33.267660002999946],
            [26.882989998000028, -33.30600999899997],
            [26.80180000000007, -33.28460999899994],
            [26.723570003000077, -33.38443000099994],
            [26.61773000000005, -33.425029998999946],
            [26.547319999000024, -33.551599995999936],
            [26.38071999700003, -33.56256000199994],
            [26.347760004000065, -33.68983999899996],
            [26.461520001000054, -33.70520000199997],
            [26.53004999700005, -33.75414999599997],
            [26.751729999000077, -33.65000999799997],
            [27.110969999000076, -33.52534000099996],
            [27.135600000000068, -33.496329998999954],
          ],
        ],
      },
      properties: {
        Shape_Leng: 2.77170662858,
        Shape_Area: 0.178642226252,
        ADM3_EN: 'Ndlambe',
        ADM3_PCODE: 'ZA2105',
        ADM3_REF: '',
        ADM3ALT1EN: '',
        ADM3ALT2EN: '',
        ADM2_EN: 'Cacadu',
        ADM2_PCODE: 'ZA210',
        ADM1_EN: 'Eastern Cape',
        ADM1_PCODE: 'ZA2',
        ADM0_EN: 'South Africa',
        ADM0_PCODE: 'ZA',
        date: '2018-12-27T00:00:00.000Z',
        validOn: '2020-11-09T00:00:00.000Z',
        validTo: '1899-11-30T00:00:00.000Z',
        ADM1_ID: 'EC',
        ADM2_ID: 'DC10',
        ADM3_ID: 'EC105',
      },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Polygon',
        coordinates: [
          [
            [31.234284944000024, -29.180706939999936],
            [31.13716994300006, -29.207599939999966],
            [31.088529943000026, -29.34710993999994],
            [30.98118994300006, -29.269259939999984],
            [30.877189943000076, -29.275589939999975],
            [30.88038994300007, -29.367669939999928],
            [30.747750068000073, -29.46706993999993],
            [30.727179943000067, -29.57093993999996],
            [30.84250994300004, -29.62561993999998],
            [31.094409943000073, -29.538089939999963],
            [31.05069994300004, -29.48628006499996],
            [31.182687944000065, -29.352972939999972],
            [31.16599294400004, -29.25839093999997],
            [31.234284944000024, -29.180706939999936],
          ],
        ],
      },
      properties: {
        Shape_Leng: 2.72716555148,
        Shape_Area: 0.101609803906,
        ADM3_EN: 'Ndwedwe',
        ADM3_PCODE: 'ZA5293',
        ADM3_REF: '',
        ADM3ALT1EN: '',
        ADM3ALT2EN: '',
        ADM2_EN: 'iLembe',
        ADM2_PCODE: 'ZA529',
        ADM1_EN: 'KwaZulu-Natal',
        ADM1_PCODE: 'ZA5',
        ADM0_EN: 'South Africa',
        ADM0_PCODE: 'ZA',
        date: '2018-12-27T00:00:00.000Z',
        validOn: '2020-11-09T00:00:00.000Z',
        validTo: '1899-11-30T00:00:00.000Z',
        ADM1_ID: 'KZN',
        ADM2_ID: 'DC29',
        ADM3_ID: 'KZN293',
      },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Polygon',
        coordinates: [
          [
            [25.84900999900003, -33.72245999799998],
            [25.736790003000067, -33.629929998999955],
            [25.43770999900005, -33.553080000999955],
            [25.346299998000063, -33.55707000899997],
            [25.307228300000077, -33.71735790099996],
            [25.235029991000033, -33.83690000099995],
            [25.221490003000042, -33.97076999999996],
            [25.394940001000066, -34.03137000299995],
            [25.58925000000005, -34.05061000199993],
            [25.641490001000022, -33.85165000199993],
            [25.70396000200003, -33.79046000099993],
            [25.84900999900003, -33.72245999799998],
          ],
        ],
      },
      properties: {
        Shape_Leng: 2.93013297798,
        Shape_Area: 0.190557518607,
        ADM3_EN: 'Nelson Mandela Bay',
        ADM3_PCODE: 'ZA2930',
        ADM3_REF: '',
        ADM3ALT1EN: '',
        ADM3ALT2EN: '',
        ADM2_EN: 'Nelson Mandela Bay',
        ADM2_PCODE: 'ZA293',
        ADM1_EN: 'Eastern Cape',
        ADM1_PCODE: 'ZA2',
        ADM0_EN: 'South Africa',
        ADM0_PCODE: 'ZA',
        date: '2018-12-27T00:00:00.000Z',
        validOn: '2020-11-09T00:00:00.000Z',
        validTo: '1899-11-30T00:00:00.000Z',
        ADM1_ID: 'EC',
        ADM2_ID: 'NMA',
        ADM3_ID: 'NMA',
      },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Polygon',
        coordinates: [
          [
            [29.89913997700006, -27.385490027999936],
            [29.840189999000074, -27.37898998099996],
            [29.75867998600006, -27.442570014999944],
            [29.70316998100003, -27.471999970999946],
            [29.779559971000026, -27.587300031999973],
            [29.708990037000035, -27.69849996599993],
            [29.676849959000037, -27.959510042999966],
            [29.914110067000024, -27.988790063999943],
            [30.00096994200004, -27.899259937999943],
            [30.208594943000037, -27.788359937999928],
            [30.21058994300006, -27.732319937999932],
            [30.081719943000053, -27.724890062999975],
            [29.920159942000055, -27.57922993799997],
            [29.89913997700006, -27.385490027999936],
          ],
        ],
      },
      properties: {
        Shape_Leng: 3.1812495063,
        Shape_Area: 0.169849864757,
        ADM3_EN: 'Newcastle',
        ADM3_PCODE: 'ZA5252',
        ADM3_REF: '',
        ADM3ALT1EN: '',
        ADM3ALT2EN: '',
        ADM2_EN: 'Amajuba',
        ADM2_PCODE: 'ZA525',
        ADM1_EN: 'KwaZulu-Natal',
        ADM1_PCODE: 'ZA5',
        ADM0_EN: 'South Africa',
        ADM0_PCODE: 'ZA',
        date: '2018-12-27T00:00:00.000Z',
        validOn: '2020-11-09T00:00:00.000Z',
        validTo: '1899-11-30T00:00:00.000Z',
        ADM1_ID: 'KZN',
        ADM2_ID: 'DC25',
        ADM3_ID: 'KZN252',
      },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Polygon',
        coordinates: [
          [
            [27.217910004000032, -32.89013000099993],
            [27.12063999700007, -33.02510000199993],
            [26.975810000000024, -33.04965999999996],
            [26.85622999700007, -33.11492000199996],
            [26.962560000000053, -33.20239000199996],
            [26.968949999000074, -33.267660002999946],
            [26.98525999800006, -33.35620000199998],
            [27.135600000000068, -33.496329998999954],
            [27.210620000000063, -33.46248999599993],
            [27.49182999900006, -33.28203999799996],
            [27.360132943000053, -33.12994728399997],
            [27.44417001100004, -33.07976000599996],
            [27.503910002000055, -32.995219996999936],
            [27.34307485200003, -32.96295413499996],
            [27.29586428300007, -33.02417272899993],
            [27.217910004000032, -32.89013000099993],
          ],
        ],
      },
      properties: {
        Shape_Leng: 3.69031001079,
        Shape_Area: 0.204487348583,
        ADM3_EN: 'Ngqushwa',
        ADM3_PCODE: 'ZA2126',
        ADM3_REF: '',
        ADM3ALT1EN: '',
        ADM3ALT2EN: '',
        ADM2_EN: 'Amathole',
        ADM2_PCODE: 'ZA212',
        ADM1_EN: 'Eastern Cape',
        ADM1_PCODE: 'ZA2',
        ADM0_EN: 'South Africa',
        ADM0_PCODE: 'ZA',
        date: '2018-12-27T00:00:00.000Z',
        validOn: '2020-11-09T00:00:00.000Z',
        validTo: '1899-11-30T00:00:00.000Z',
        ADM1_ID: 'EC',
        ADM2_ID: 'DC12',
        ADM3_ID: 'EC126',
      },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Polygon',
        coordinates: [
          [
            [29.511410002000048, -30.929870007999966],
            [29.406400000000076, -31.00237999799998],
            [29.437360003000038, -31.10068000299998],
            [29.284530003000043, -31.18514000199997],
            [29.226369999000042, -31.298329998999975],
            [29.27116999100008, -31.395260002999976],
            [29.344959997000046, -31.303140002999953],
            [29.50867000100004, -31.340929995999943],
            [29.53715000300008, -31.42488999799997],
            [29.690979999000035, -31.528199994999966],
            [29.759189996000032, -31.45239000099997],
            [29.834459999000046, -31.443250002999946],
            [30.047640000000058, -31.24755999699994],
            [29.846460000000036, -31.13512000099996],
            [29.584300002000077, -31.038030008999954],
            [29.609759998000072, -30.983210002999954],
            [29.511410002000048, -30.929870007999966],
          ],
        ],
      },
      properties: {
        Shape_Leng: 3.95765316958,
        Shape_Area: 0.234499279708,
        ADM3_EN: 'Ngquza Hill',
        ADM3_PCODE: 'ZA2153',
        ADM3_REF: '',
        ADM3ALT1EN: '',
        ADM3ALT2EN: '',
        ADM2_EN: 'O.R.Tambo',
        ADM2_PCODE: 'ZA215',
        ADM1_EN: 'Eastern Cape',
        ADM1_PCODE: 'ZA2',
        ADM0_EN: 'South Africa',
        ADM0_PCODE: 'ZA',
        date: '2018-12-27T00:00:00.000Z',
        validOn: '2020-11-09T00:00:00.000Z',
        validTo: '1899-11-30T00:00:00.000Z',
        ADM1_ID: 'EC',
        ADM2_ID: 'DC15',
        ADM3_ID: 'EC153',
      },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Polygon',
        coordinates: [
          [
            [27.716306001000078, -26.761676999999963],
            [27.590429997000058, -26.73836000299997],
            [27.511750002000042, -26.836510002999944],
            [27.389485000000036, -26.906384999999943],
            [27.340810000000033, -27.019300001999966],
            [27.38991999700005, -27.111380001999976],
            [27.378709997000044, -27.29129999999998],
            [27.214510002000054, -27.278579999999977],
            [27.171790002000023, -27.39759000199996],
            [27.232079998000074, -27.47461999899997],
            [27.44342000200004, -27.482919996999954],
            [27.435974999000052, -27.570466000999943],
            [27.478570000000047, -27.63120999299997],
            [27.576810000000023, -27.61853999999994],
            [27.639429999000072, -27.681559998999944],
            [27.566809998000053, -27.738040001999934],
            [27.633371002000047, -27.803171000999953],
            [27.862840001000052, -27.78952000399994],
            [27.838089997000054, -27.672621998999944],
            [27.988600000000076, -27.632209995999972],
            [28.18868999600005, -27.481780002999983],
            [28.250889999000037, -27.497789999999952],
            [28.283239998000056, -27.359689996999975],
            [28.227359999000043, -27.28761000199995],
            [28.26423999700006, -27.18622000299996],
            [28.12675000300004, -27.137859997999954],
            [28.065730003000056, -27.046560000999932],
            [27.973670000000027, -27.042430001999946],
            [27.92860998900005, -26.96601099199995],
            [27.802670000000035, -26.997190001999968],
            [27.71045999900008, -26.842270002999953],
            [27.716306001000078, -26.761676999999963],
          ],
        ],
      },
      properties: {
        Shape_Leng: 5.20941220625,
        Shape_Area: 0.643162536191,
        ADM3_EN: 'Ngwathe',
        ADM3_PCODE: 'ZA4203',
        ADM3_REF: '',
        ADM3ALT1EN: '',
        ADM3ALT2EN: '',
        ADM2_EN: 'Fezile Dabi',
        ADM2_PCODE: 'ZA420',
        ADM1_EN: 'Free State',
        ADM1_PCODE: 'ZA4',
        ADM0_EN: 'South Africa',
        ADM0_PCODE: 'ZA',
        date: '2018-12-27T00:00:00.000Z',
        validOn: '2020-11-09T00:00:00.000Z',
        validTo: '1899-11-30T00:00:00.000Z',
        ADM1_ID: 'FS',
        ADM2_ID: 'DC20',
        ADM3_ID: 'FS203',
      },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Polygon',
        coordinates: [
          [
            [31.15853994400004, -28.551114938999945],
            [31.018129943000076, -28.42577006399995],
            [30.96541994300003, -28.406320063999942],
            [30.832659943000067, -28.46372993899996],
            [30.82135994300006, -28.58162993899998],
            [30.73243994300003, -28.665199938999933],
            [30.67031594300005, -28.642552063999972],
            [30.650109943000075, -28.720729938999966],
            [30.69907394300003, -28.771935938999945],
            [30.77085994300006, -28.722680063999974],
            [30.833109943000068, -28.771699938999973],
            [30.98679994300005, -28.805120063999937],
            [30.993349943000055, -28.85647993899994],
            [31.029826943000046, -28.90152293899996],
            [31.219719944000076, -28.78855993899998],
            [31.346229944000072, -28.77463993899994],
            [31.19879994400003, -28.649230063999937],
            [31.15853994400004, -28.551114938999945],
          ],
        ],
      },
      properties: {
        Shape_Leng: 3.360201953,
        Shape_Area: 0.168682534645,
        ADM3_EN: 'Nkandla',
        ADM3_PCODE: 'ZA5286',
        ADM3_REF: '',
        ADM3ALT1EN: '',
        ADM3ALT2EN: '',
        ADM2_EN: 'Uthungulu',
        ADM2_PCODE: 'ZA528',
        ADM1_EN: 'KwaZulu-Natal',
        ADM1_PCODE: 'ZA5',
        ADM0_EN: 'South Africa',
        ADM0_PCODE: 'ZA',
        date: '2018-12-27T00:00:00.000Z',
        validOn: '2020-11-09T00:00:00.000Z',
        validTo: '1899-11-30T00:00:00.000Z',
        ADM1_ID: 'KZN',
        ADM2_ID: 'DC28',
        ADM3_ID: 'KZN286',
      },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Polygon',
        coordinates: [
          [
            [28.250889999000037, -27.497789999999952],
            [28.18868999600005, -27.481780002999983],
            [27.988600000000076, -27.632209995999972],
            [27.838089997000054, -27.672621998999944],
            [27.862840001000052, -27.78952000399994],
            [27.872599999000045, -27.933779998999967],
            [27.737719998000046, -27.92817000399998],
            [27.703459999000074, -28.040389999999945],
            [27.759940002000064, -28.06191000299998],
            [27.78866001800003, -28.24798099399993],
            [27.992710009000064, -28.23198998999993],
            [28.027990001000035, -28.176749997999934],
            [28.181635002000064, -28.108182003999957],
            [28.27760999900005, -28.119179998999982],
            [28.320419998000034, -28.05972999599993],
            [28.566879998000047, -28.01779999799993],
            [28.728190004000055, -28.022859996999955],
            [28.737960000000044, -27.976099998999928],
            [28.767929997000067, -27.888709999999946],
            [28.781120000000044, -27.68709999799995],
            [28.74292009100003, -27.599048583999945],
            [28.511149970000076, -27.59688988399995],
            [28.426999996000063, -27.50639999799995],
            [28.258040004000065, -27.572180001999982],
            [28.250889999000037, -27.497789999999952],
          ],
        ],
      },
      properties: {
        Shape_Leng: 4.64953111789,
        Shape_Area: 0.514064506958,
        ADM3_EN: 'Nketoana',
        ADM3_PCODE: 'ZA4193',
        ADM3_REF: '',
        ADM3ALT1EN: '',
        ADM3ALT2EN: '',
        ADM2_EN: 'Thabo Mofutsanyane',
        ADM2_PCODE: 'ZA419',
        ADM1_EN: 'Free State',
        ADM1_PCODE: 'ZA4',
        ADM0_EN: 'South Africa',
        ADM0_PCODE: 'ZA',
        date: '2018-12-27T00:00:00.000Z',
        validOn: '2020-11-09T00:00:00.000Z',
        validTo: '1899-11-30T00:00:00.000Z',
        ADM1_ID: 'FS',
        ADM2_ID: 'DC19',
        ADM3_ID: 'FS193',
      },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Polygon',
        coordinates: [
          [
            [32.031979997000064, -25.18309499999998],
            [31.823160001000076, -25.06190799999996],
            [31.71690900200008, -24.954299998999943],
            [31.61089389600005, -24.98924693999993],
            [31.586380005000024, -25.025129317999983],
            [31.627029419000053, -25.272920608999982],
            [31.536829999000076, -25.46408000399998],
            [31.33545000400005, -25.522559997999963],
            [31.33077999900007, -25.608980003999932],
            [31.26208000200006, -25.69231999799996],
            [31.315939998000033, -25.74304000099994],
            [31.416299999000046, -25.718759999999975],
            [31.867860003000033, -25.999600001999966],
            [31.97369000100008, -25.95320000299995],
            [31.93054999700007, -25.84076999699994],
            [32.00609900000006, -25.645193999999947],
            [31.979620002000047, -25.457059998999966],
            [32.01464999800004, -25.385560003999956],
            [32.031979997000064, -25.18309499999998],
          ],
        ],
      },
      properties: {
        Shape_Leng: 3.4460785527,
        Shape_Area: 0.429804462746,
        ADM3_EN: 'Nkomazi',
        ADM3_PCODE: 'ZA8324',
        ADM3_REF: '',
        ADM3ALT1EN: '',
        ADM3ALT2EN: '',
        ADM2_EN: 'Ehlanzeni',
        ADM2_PCODE: 'ZA832',
        ADM1_EN: 'Mpumalanga',
        ADM1_PCODE: 'ZA8',
        ADM0_EN: 'South Africa',
        ADM0_PCODE: 'ZA',
        date: '2018-12-27T00:00:00.000Z',
        validOn: '2020-11-09T00:00:00.000Z',
        validTo: '1899-11-30T00:00:00.000Z',
        ADM1_ID: 'MP',
        ADM2_ID: 'DC32',
        ADM3_ID: 'MP324',
      },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Polygon',
        coordinates: [
          [
            [31.951619944000072, -27.61907993799997],
            [31.805519944000025, -27.624079937999966],
            [31.76971994400003, -27.703300062999972],
            [31.58836994400008, -27.77412006299994],
            [31.51141294400003, -27.83823406299996],
            [31.488839944000063, -27.85770993799997],
            [31.47557994400006, -27.97571993899993],
            [31.49957994400006, -28.118329938999977],
            [31.586289944000043, -28.11181006399994],
            [31.645149944000025, -28.18640993899993],
            [31.733409944000073, -28.218509938999944],
            [31.807360069000026, -28.216039938999984],
            [31.81923994400006, -28.038040063999972],
            [31.94805994400008, -28.013130063999938],
            [32.031879944000025, -27.92858006299997],
            [31.996179944000062, -27.885269937999965],
            [31.951619944000072, -27.61907993799997],
          ],
        ],
      },
      properties: {
        Shape_Leng: 3.37144276789,
        Shape_Area: 0.200027007824,
        ADM3_EN: 'Nongoma',
        ADM3_PCODE: 'ZA5265',
        ADM3_REF: '',
        ADM3ALT1EN: '',
        ADM3ALT2EN: '',
        ADM2_EN: 'Zululand',
        ADM2_PCODE: 'ZA526',
        ADM1_EN: 'KwaZulu-Natal',
        ADM1_PCODE: 'ZA5',
        ADM0_EN: 'South Africa',
        ADM0_PCODE: 'ZA',
        date: '2018-12-27T00:00:00.000Z',
        validOn: '2020-11-09T00:00:00.000Z',
        validTo: '1899-11-30T00:00:00.000Z',
        ADM1_ID: 'KZN',
        ADM2_ID: 'DC26',
        ADM3_ID: 'KZN265',
      },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Polygon',
        coordinates: [
          [
            [30.950359943000024, -28.143590063999966],
            [30.863909943000067, -28.11683993899993],
            [30.68689994300007, -28.129299938999964],
            [30.612789943000053, -28.035199938999938],
            [30.68444006800007, -27.971089938999967],
            [30.60214006800004, -27.93359993799993],
            [30.56970006800003, -28.008950063999976],
            [30.51365994300005, -28.171299938999937],
            [30.505729943000063, -28.262689938999983],
            [30.530769943000053, -28.334409938999954],
            [30.635649943000033, -28.407980063999958],
            [30.681739943000025, -28.54084993899994],
            [30.67031594300005, -28.642552063999972],
            [30.73243994300003, -28.665199938999933],
            [30.82135994300006, -28.58162993899998],
            [30.832659943000067, -28.46372993899996],
            [30.96541994300003, -28.406320063999942],
            [30.94219994300005, -28.312329938999937],
            [31.047564943000054, -28.200092063999932],
            [30.950359943000024, -28.143590063999966],
          ],
        ],
      },
      properties: {
        Shape_Leng: 3.64135823697,
        Shape_Area: 0.180521466903,
        ADM3_EN: 'Nqutu',
        ADM3_PCODE: 'ZA5242',
        ADM3_REF: '',
        ADM3ALT1EN: '',
        ADM3ALT2EN: '',
        ADM2_EN: 'Umzinyathi',
        ADM2_PCODE: 'ZA524',
        ADM1_EN: 'KwaZulu-Natal',
        ADM1_PCODE: 'ZA5',
        ADM0_EN: 'South Africa',
        ADM0_PCODE: 'ZA',
        date: '2018-12-27T00:00:00.000Z',
        validOn: '2020-11-09T00:00:00.000Z',
        validTo: '1899-11-30T00:00:00.000Z',
        ADM1_ID: 'KZN',
        ADM2_ID: 'DC24',
        ADM3_ID: 'KZN242',
      },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Polygon',
        coordinates: [
          [
            [29.522201133000067, -30.699014831999932],
            [29.39245999700006, -30.836789996999983],
            [29.215230002000055, -30.87232999699995],
            [29.165560001000074, -30.81916000399997],
            [29.068309999000064, -30.85512999799994],
            [29.06473800200007, -31.037947419999966],
            [29.13230999600006, -31.09143999899993],
            [29.190579996000054, -31.274674003999962],
            [29.226369999000042, -31.298329998999975],
            [29.284530003000043, -31.18514000199997],
            [29.437360003000038, -31.10068000299998],
            [29.406400000000076, -31.00237999799998],
            [29.511410002000048, -30.929870007999966],
            [29.56229999800007, -30.882500000999983],
            [29.522201133000067, -30.699014831999932],
          ],
        ],
      },
      properties: {
        Shape_Leng: 3.28449576667,
        Shape_Area: 0.130729350602,
        ADM3_EN: 'Ntabankulu',
        ADM3_PCODE: 'ZA2444',
        ADM3_REF: '',
        ADM3ALT1EN: '',
        ADM3ALT2EN: '',
        ADM2_EN: 'Alfred Nzo',
        ADM2_PCODE: 'ZA244',
        ADM1_EN: 'Eastern Cape',
        ADM1_PCODE: 'ZA2',
        ADM0_EN: 'South Africa',
        ADM0_PCODE: 'ZA',
        date: '2018-12-27T00:00:00.000Z',
        validOn: '2020-11-09T00:00:00.000Z',
        validTo: '1899-11-30T00:00:00.000Z',
        ADM1_ID: 'EC',
        ADM2_ID: 'DC44',
        ADM3_ID: 'EC444',
      },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Polygon',
        coordinates: [
          [
            [29.190579996000054, -31.274674003999962],
            [29.155575000000056, -31.319332002999943],
            [29.04294000300007, -31.32214400199996],
            [28.979800002000047, -31.28696000399998],
            [28.890780002000042, -31.31501000399993],
            [28.857829999000046, -31.480310000999964],
            [28.75467999700004, -31.485959996999952],
            [28.812939999000037, -31.50752999799994],
            [28.820739999000068, -31.686599996999973],
            [28.949460000000045, -31.835159999999973],
            [29.09648000100003, -31.87912999799994],
            [29.186300001000063, -31.949629997999978],
            [29.327960002000054, -31.80776000299994],
            [29.254680000000064, -31.775649999999928],
            [29.24662998900004, -31.68664999599997],
            [29.294810003000066, -31.53747999899997],
            [29.27116999100008, -31.395260002999976],
            [29.226369999000042, -31.298329998999975],
            [29.190579996000054, -31.274674003999962],
          ],
        ],
      },
      properties: {
        Shape_Leng: 3.91092283046,
        Shape_Area: 0.235098706342,
        ADM3_EN: 'Nyandeni',
        ADM3_PCODE: 'ZA2155',
        ADM3_REF: '',
        ADM3ALT1EN: '',
        ADM3ALT2EN: '',
        ADM2_EN: 'O.R.Tambo',
        ADM2_PCODE: 'ZA215',
        ADM1_EN: 'Eastern Cape',
        ADM1_PCODE: 'ZA2',
        ADM0_EN: 'South Africa',
        ADM0_PCODE: 'ZA',
        date: '2018-12-27T00:00:00.000Z',
        validOn: '2020-11-09T00:00:00.000Z',
        validTo: '1899-11-30T00:00:00.000Z',
        ADM1_ID: 'EC',
        ADM2_ID: 'DC15',
        ADM3_ID: 'EC155',
      },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Polygon',
        coordinates: [
          [
            [29.761249942000063, -28.737949938999975],
            [29.669979942000055, -28.74715993899997],
            [29.567449942000053, -28.665359938999984],
            [29.56564994200005, -28.570809938999957],
            [29.519459942000026, -28.471819938999943],
            [29.375559977000023, -28.37210997099993],
            [29.248749971000052, -28.42489996699993],
            [29.134999968000045, -28.566299966999964],
            [28.973990977000028, -28.574560038999948],
            [28.873626972000068, -28.77071189999998],
            [28.939220066000075, -28.859999938999977],
            [29.074789942000052, -28.918779938999933],
            [29.215490067000076, -29.02628993999997],
            [29.259249942000054, -29.09045993999996],
            [29.357050041000036, -29.134250605999966],
            [29.47361006700004, -29.091747939999948],
            [29.540569942000047, -28.93754993899995],
            [29.67715006700007, -28.866379938999955],
            [29.761249942000063, -28.737949938999975],
          ],
        ],
      },
      properties: {
        Shape_Leng: 3.88728122491,
        Shape_Area: 0.366847661702,
        ADM3_EN: 'Okhahlamba',
        ADM3_PCODE: 'ZA5235',
        ADM3_REF: '',
        ADM3ALT1EN: '',
        ADM3ALT2EN: '',
        ADM2_EN: 'Uthukela',
        ADM2_PCODE: 'ZA523',
        ADM1_EN: 'KwaZulu-Natal',
        ADM1_PCODE: 'ZA5',
        ADM0_EN: 'South Africa',
        ADM0_PCODE: 'ZA',
        date: '2018-12-27T00:00:00.000Z',
        validOn: '2020-11-09T00:00:00.000Z',
        validTo: '1899-11-30T00:00:00.000Z',
        ADM1_ID: 'KZN',
        ADM2_ID: 'DC23',
        ADM3_ID: 'KZN235',
      },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Polygon',
        coordinates: [
          [
            [22.774430000000052, -33.41974000199997],
            [22.464739999000074, -33.404519997999955],
            [22.213989998000045, -33.31495999899994],
            [21.902079997000044, -33.36495998799995],
            [21.936273998000047, -33.524975996999956],
            [21.935039999000026, -33.66770000399998],
            [21.837480004000042, -33.737309996999954],
            [21.72279999600005, -33.70531999599996],
            [21.740035060000025, -33.79614592699994],
            [21.70035000200005, -33.85285000099998],
            [21.932780007000076, -33.86542000399993],
            [22.123679998000057, -33.84637000299995],
            [22.233749998000064, -33.888240003999954],
            [22.36878000400003, -33.792810000999964],
            [22.371800003000033, -33.659389991999944],
            [22.588689998000063, -33.636669997999945],
            [22.755659997000066, -33.64072999299998],
            [22.716079999000044, -33.531680000999984],
            [22.774430000000052, -33.41974000199997],
          ],
        ],
      },
      properties: {
        Shape_Leng: 3.94510257565,
        Shape_Area: 0.343882237764,
        ADM3_EN: 'Oudtshoorn',
        ADM3_PCODE: 'ZA1045',
        ADM3_REF: '',
        ADM3ALT1EN: '',
        ADM3ALT2EN: '',
        ADM2_EN: 'Eden',
        ADM2_PCODE: 'ZA104',
        ADM1_EN: 'Western Cape',
        ADM1_PCODE: 'ZA1',
        ADM0_EN: 'South Africa',
        ADM0_PCODE: 'ZA',
        date: '2018-12-27T00:00:00.000Z',
        validOn: '2020-11-09T00:00:00.000Z',
        validTo: '1899-11-30T00:00:00.000Z',
        ADM1_ID: 'WC',
        ADM2_ID: 'DC4',
        ADM3_ID: 'WC045',
      },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Polygon',
        coordinates: [
          [
            [19.624219995000033, -34.41871999999995],
            [19.300587522000058, -34.37527932099994],
            [19.302979813000036, -34.32855989799998],
            [19.130097852000063, -34.24311964599997],
            [19.039120009000044, -34.27422999799995],
            [18.930709386000046, -34.203527863999966],
            [18.845815000000073, -34.26959000299996],
            [18.82714999800004, -34.37609999799997],
            [19.047080004000065, -34.34218999999996],
            [19.218480003000025, -34.43812000099996],
            [19.275380003000066, -34.40905000099997],
            [19.357739998000056, -34.485480002999964],
            [19.402229997000063, -34.60641999999996],
            [19.596049997000023, -34.74666999999994],
            [19.724737004000076, -34.767248998999946],
            [19.713349996000034, -34.46856000199995],
            [19.624219995000033, -34.41871999999995],
          ],
        ],
      },
      properties: {
        Shape_Leng: 4.14800879829,
        Shape_Area: 0.164325336143,
        ADM3_EN: 'Overstrand',
        ADM3_PCODE: 'ZA1032',
        ADM3_REF: '',
        ADM3ALT1EN: '',
        ADM3ALT2EN: '',
        ADM2_EN: 'Overberg',
        ADM2_PCODE: 'ZA103',
        ADM1_EN: 'Western Cape',
        ADM1_PCODE: 'ZA1',
        ADM0_EN: 'South Africa',
        ADM0_PCODE: 'ZA',
        date: '2018-12-27T00:00:00.000Z',
        validOn: '2020-11-09T00:00:00.000Z',
        validTo: '1899-11-30T00:00:00.000Z',
        ADM1_ID: 'WC',
        ADM2_ID: 'DC3',
        ADM3_ID: 'WC032',
      },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Polygon',
        coordinates: [
          [
            [25.047909998000023, -27.69973999599995],
            [24.99972000100007, -27.680830003999972],
            [24.80117000000007, -27.70177999699996],
            [24.692299998000067, -27.64521999899995],
            [24.65866999700006, -27.790939992999938],
            [24.699320003000025, -27.828289996999956],
            [24.615819999000053, -27.903600000999973],
            [24.73283566400005, -27.92022534499995],
            [24.775210000000072, -27.994110000999967],
            [24.847410723000053, -27.957974664999938],
            [24.829840000000047, -27.931289999999933],
            [25.047909998000023, -27.69973999599995],
          ],
        ],
      },
      properties: {
        Shape_Leng: 1.65358723733,
        Shape_Area: 0.0758299050822,
        ADM3_EN: 'Phokwane',
        ADM3_PCODE: 'ZA3094',
        ADM3_REF: '',
        ADM3ALT1EN: '',
        ADM3ALT2EN: '',
        ADM2_EN: 'Frances Baard',
        ADM2_PCODE: 'ZA309',
        ADM1_EN: 'Nothern Cape',
        ADM1_PCODE: 'ZA3',
        ADM0_EN: 'South Africa',
        ADM0_PCODE: 'ZA',
        date: '2018-12-27T00:00:00.000Z',
        validOn: '2020-11-09T00:00:00.000Z',
        validTo: '1899-11-30T00:00:00.000Z',
        ADM1_ID: 'NC',
        ADM2_ID: 'DC9',
        ADM3_ID: 'NC094',
      },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Polygon',
        coordinates: [
          [
            [29.418859999000063, -27.254519999999957],
            [29.22980999400005, -27.16722999899997],
            [29.136369999000067, -27.154220002999978],
            [29.015141792000065, -27.00995693699997],
            [29.005649567000034, -27.166900634999934],
            [28.880750656000032, -27.44350051899994],
            [28.785535812000035, -27.462493895999955],
            [28.74292009100003, -27.599048583999945],
            [28.781120000000044, -27.68709999799995],
            [28.767929997000067, -27.888709999999946],
            [28.737960000000044, -27.976099998999928],
            [28.804749998000034, -28.019829999999956],
            [28.76977000100004, -28.12457999999998],
            [28.879109997000057, -28.13766998899996],
            [28.998910000000024, -28.074540001999935],
            [29.27083000400006, -27.99672000399994],
            [29.314459999000064, -28.072810002999972],
            [29.405129998000064, -28.078000001999953],
            [29.564000003000046, -28.189130001999956],
            [29.50992004400007, -28.26543993699994],
            [29.619765027000028, -28.241219959999967],
            [29.663289934000034, -28.14202004499998],
            [29.616861983000035, -28.04683801599998],
            [29.676849959000037, -27.959510042999966],
            [29.708990037000035, -27.69849996599993],
            [29.779559971000026, -27.587300031999973],
            [29.70316998100003, -27.471999970999946],
            [29.75867998600006, -27.442570014999944],
            [29.618910002000064, -27.506020001999957],
            [29.418859999000063, -27.254519999999957],
          ],
        ],
      },
      properties: {
        Shape_Leng: 6.66771261513,
        Shape_Area: 0.749712026767,
        ADM3_EN: 'Phumelela',
        ADM3_PCODE: 'ZA4195',
        ADM3_REF: '',
        ADM3ALT1EN: '',
        ADM3ALT2EN: '',
        ADM2_EN: 'Thabo Mofutsanyane',
        ADM2_PCODE: 'ZA419',
        ADM1_EN: 'Free State',
        ADM1_PCODE: 'ZA4',
        ADM0_EN: 'South Africa',
        ADM0_PCODE: 'ZA',
        date: '2018-12-27T00:00:00.000Z',
        validOn: '2020-11-09T00:00:00.000Z',
        validTo: '1899-11-30T00:00:00.000Z',
        ADM1_ID: 'FS',
        ADM2_ID: 'DC19',
        ADM3_ID: 'FS195',
      },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Polygon',
        coordinates: [
          [
            [29.887920003000033, -23.67941999599998],
            [29.79523000100005, -23.68082999799998],
            [29.675980003000063, -23.75132999799996],
            [29.500759989000073, -23.81135999999998],
            [29.41371999900008, -23.621129999999937],
            [29.348040001000072, -23.527159996999956],
            [29.226550967000037, -23.57999377999994],
            [29.066478751000034, -23.554339891999973],
            [28.969249811000054, -23.59783252699998],
            [28.875519997000026, -23.64661999799995],
            [28.843200000000024, -23.833979995999982],
            [28.921390003000056, -23.81122000099998],
            [28.998438002000057, -23.841155000999947],
            [29.162150001000043, -24.079280005999976],
            [29.18896999900005, -24.256940002999954],
            [29.332289996000043, -24.296910002999937],
            [29.59651999600004, -24.18110998999998],
            [29.82726000300005, -24.040580000999967],
            [29.86374999900005, -23.95138000099996],
            [29.928179999000065, -23.79767999799998],
            [29.887920003000033, -23.67941999599998],
          ],
        ],
      },
      properties: {
        Shape_Leng: 4.01962212886,
        Shape_Area: 0.448074384364,
        ADM3_EN: 'Polokwane',
        ADM3_PCODE: 'ZA9354',
        ADM3_REF: '',
        ADM3ALT1EN: '',
        ADM3ALT2EN: '',
        ADM2_EN: 'Capricorn',
        ADM2_PCODE: 'ZA935',
        ADM1_EN: 'Limpopo',
        ADM1_PCODE: 'ZA9',
        ADM0_EN: 'South Africa',
        ADM0_PCODE: 'ZA',
        date: '2018-12-27T00:00:00.000Z',
        validOn: '2020-11-09T00:00:00.000Z',
        validTo: '1899-11-30T00:00:00.000Z',
        ADM1_ID: 'LIM',
        ADM2_ID: 'DC35',
        ADM3_ID: 'LIM354',
      },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Polygon',
        coordinates: [
          [
            [29.690979999000035, -31.528199994999966],
            [29.53715000300008, -31.42488999799997],
            [29.50867000100004, -31.340929995999943],
            [29.344959997000046, -31.303140002999953],
            [29.27116999100008, -31.395260002999976],
            [29.294810003000066, -31.53747999899997],
            [29.24662998900004, -31.68664999599997],
            [29.254680000000064, -31.775649999999928],
            [29.327960002000054, -31.80776000299994],
            [29.42226000100004, -31.69168999799996],
            [29.50186999600004, -31.66470999699993],
            [29.690979999000035, -31.528199994999966],
          ],
        ],
      },
      properties: {
        Shape_Leng: 2.3939680421,
        Shape_Area: 0.12262498312,
        ADM3_EN: 'Port St Johns',
        ADM3_PCODE: 'ZA2154',
        ADM3_REF: '',
        ADM3ALT1EN: '',
        ADM3ALT2EN: '',
        ADM2_EN: 'O.R.Tambo',
        ADM2_PCODE: 'ZA215',
        ADM1_EN: 'Eastern Cape',
        ADM1_PCODE: 'ZA2',
        ADM0_EN: 'South Africa',
        ADM0_PCODE: 'ZA',
        date: '2018-12-27T00:00:00.000Z',
        validOn: '2020-11-09T00:00:00.000Z',
        validTo: '1899-11-30T00:00:00.000Z',
        ADM1_ID: 'EC',
        ADM2_ID: 'DC15',
        ADM3_ID: 'EC154',
      },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Polygon',
        coordinates: [
          [
            [22.934090000000026, -33.02165999899995],
            [22.83540000100004, -33.03773999999993],
            [22.78315000200007, -32.93059999899998],
            [22.66463999800004, -32.92879999599995],
            [22.38400000000007, -32.87083000599995],
            [22.30132999700004, -32.73991000199993],
            [22.191380000000038, -32.79061000099995],
            [22.065019996000046, -32.71055999699996],
            [22.033419997000067, -32.55492999799998],
            [21.945939999000075, -32.609800003999965],
            [21.760430003000067, -32.65843999899994],
            [21.691180001000077, -32.71439000099997],
            [21.479760003000024, -32.78659999699994],
            [21.432109997000055, -32.75672999699998],
            [21.395930001000067, -32.937919997999984],
            [21.578090002000067, -33.11589000299995],
            [21.637269998000022, -33.14128000299996],
            [21.611950001000025, -33.39679999999993],
            [21.82723999700005, -33.391039999999975],
            [21.902079997000044, -33.36495998799995],
            [22.213989998000045, -33.31495999899994],
            [22.464739999000074, -33.404519997999955],
            [22.774430000000052, -33.41974000199997],
            [22.735740001000067, -33.39476999799996],
            [22.892269998000074, -33.14163000399998],
            [22.934090000000026, -33.02165999899995],
          ],
        ],
      },
      properties: {
        Shape_Leng: 5.11271161032,
        Shape_Area: 0.787079542524,
        ADM3_EN: 'Prince Albert',
        ADM3_PCODE: 'ZA1052',
        ADM3_REF: '',
        ADM3ALT1EN: '',
        ADM3ALT2EN: '',
        ADM2_EN: 'Central Karoo',
        ADM2_PCODE: 'ZA105',
        ADM1_EN: 'Western Cape',
        ADM1_PCODE: 'ZA1',
        ADM0_EN: 'South Africa',
        ADM0_PCODE: 'ZA',
        date: '2018-12-27T00:00:00.000Z',
        validOn: '2020-11-09T00:00:00.000Z',
        validTo: '1899-11-30T00:00:00.000Z',
        ADM1_ID: 'WC',
        ADM2_ID: 'DC5',
        ADM3_ID: 'WC052',
      },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Polygon',
        coordinates: [
          [
            [26.458280002000038, -24.809470001999955],
            [26.40878000300006, -24.646129995999956],
            [26.39328000100005, -24.63662999899998],
            [25.858310008000046, -24.757180002999974],
            [25.876570000000072, -24.888300001999937],
            [25.729100000000074, -25.256880002999935],
            [25.62979000100006, -25.53782000299998],
            [25.796552999000028, -25.524967999999944],
            [25.845599999000058, -25.66563999799996],
            [25.88693999900005, -25.675309996999943],
            [26.09541000300004, -25.617779998999936],
            [26.109244997000076, -25.70210999799997],
            [26.25829238500006, -25.774949710999977],
            [26.297702521000076, -25.667500191999977],
            [26.462370000000078, -25.745369995999965],
            [26.511230003000037, -25.65521999999993],
            [26.506016002000024, -25.501890998999954],
            [26.419300000000078, -25.477640003999966],
            [26.466040001000067, -25.29066999899993],
            [26.40502000200007, -25.28592999899996],
            [26.418109999000023, -25.046799994999958],
            [26.458280002000038, -24.809470001999955],
          ],
        ],
      },
      properties: {
        Shape_Leng: 4.68105292205,
        Shape_Area: 0.655985712743,
        ADM3_EN: 'Ramotshere Moiloa',
        ADM3_PCODE: 'ZA6385',
        ADM3_REF: '',
        ADM3ALT1EN: '',
        ADM3ALT2EN: '',
        ADM2_EN: 'Ngaka Modiri Molema',
        ADM2_PCODE: 'ZA638',
        ADM1_EN: 'North West',
        ADM1_PCODE: 'ZA6',
        ADM0_EN: 'South Africa',
        ADM0_PCODE: 'ZA',
        date: '2018-12-27T00:00:00.000Z',
        validOn: '2020-11-09T00:00:00.000Z',
        validTo: '1899-11-30T00:00:00.000Z',
        ADM1_ID: 'NW',
        ADM2_ID: 'DC38',
        ADM3_ID: 'NW385',
      },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Polygon',
        coordinates: [
          [
            [27.71826999700005, -26.198929998999972],
            [27.706580004000045, -26.11557000099998],
            [27.46734000400005, -26.09226999899994],
            [27.47151000300005, -26.24495499799997],
            [27.54784999700007, -26.34328000199997],
            [27.557090001000063, -26.456379998999978],
            [27.607150003000072, -26.491600000999938],
            [27.579600001000074, -26.60752999899995],
            [27.667929998000034, -26.610549996999964],
            [27.675980000000038, -26.52434999999997],
            [27.76128999900004, -26.419150000999934],
            [27.811589997000056, -26.36447500299994],
            [27.743799996000064, -26.28722000199997],
            [27.71826999700005, -26.198929998999972],
          ],
        ],
      },
      properties: {
        Shape_Leng: 2.28735353425,
        Shape_Area: 0.100756719922,
        ADM3_EN: 'Rand West City',
        ADM3_PCODE: 'ZA7485',
        ADM3_REF: '',
        ADM3ALT1EN: '',
        ADM3ALT2EN: '',
        ADM2_EN: 'West Rand',
        ADM2_PCODE: 'ZA748',
        ADM1_EN: 'Gauteng',
        ADM1_PCODE: 'ZA7',
        ADM0_EN: 'South Africa',
        ADM0_PCODE: 'ZA',
        date: '2018-12-27T00:00:00.000Z',
        validOn: '2020-11-09T00:00:00.000Z',
        validTo: '1899-11-30T00:00:00.000Z',
        ADM1_ID: 'GT',
        ADM2_ID: 'DC48',
        ADM3_ID: 'GT485',
      },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Polygon',
        coordinates: [
          [
            [25.339327000000026, -25.769283996999945],
            [25.17011999700003, -25.765909999999963],
            [25.035730004000072, -25.722750007999934],
            [24.887260001000072, -25.807420001999958],
            [24.685869999000033, -25.82333000099993],
            [24.485275002000037, -25.74938999799997],
            [24.465069998000047, -25.790170003999947],
            [24.667030001000057, -25.921250002999955],
            [24.804080002000035, -26.158249998999963],
            [24.76417999800003, -26.205250000999968],
            [24.85785000000004, -26.394999999999982],
            [24.991200003000074, -26.39093999199997],
            [25.06620299900004, -26.55029499999995],
            [25.16958999700006, -26.519929997999952],
            [25.224939996000046, -26.38575999699998],
            [25.29733999700005, -26.32175000099994],
            [25.37209999600003, -26.33880000299996],
            [25.422349996000037, -26.270750000999953],
            [25.486530001000062, -26.21668999999997],
            [25.457980003000046, -26.103429999999946],
            [25.50102000100003, -26.061799995999934],
            [25.406140003000075, -25.954729997999948],
            [25.26481586600005, -25.870540888999983],
            [25.339327000000026, -25.769283996999945],
          ],
        ],
      },
      properties: {
        Shape_Leng: 3.91163483648,
        Shape_Area: 0.44058738396,
        ADM3_EN: 'Ratlou',
        ADM3_PCODE: 'ZA6381',
        ADM3_REF: '',
        ADM3ALT1EN: '',
        ADM3ALT2EN: '',
        ADM2_EN: 'Ngaka Modiri Molema',
        ADM2_PCODE: 'ZA638',
        ADM1_EN: 'North West',
        ADM1_PCODE: 'ZA6',
        ADM0_EN: 'South Africa',
        ADM0_PCODE: 'ZA',
        date: '2018-12-27T00:00:00.000Z',
        validOn: '2020-11-09T00:00:00.000Z',
        validTo: '1899-11-30T00:00:00.000Z',
        ADM1_ID: 'NW',
        ADM2_ID: 'DC38',
        ADM3_ID: 'NW381',
      },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Polygon',
        coordinates: [
          [
            [30.583549943000037, -30.56070994099997],
            [30.42733994300005, -30.57786994099996],
            [30.218259943000078, -30.65540994099996],
            [30.13629006800005, -30.624449940999966],
            [29.961164980000035, -30.82316997199996],
            [30.092709971000033, -30.86222996799995],
            [30.146350037000047, -30.931069969999953],
            [30.142759983000076, -31.022820026999966],
            [30.193859794000048, -31.081260201999953],
            [30.40450994300005, -30.82830006599994],
            [30.583549943000037, -30.56070994099997],
          ],
        ],
      },
      properties: {
        Shape_Leng: 3.06145385645,
        Shape_Area: 0.140124211146,
        ADM3_EN: 'Ray Nkonyeni',
        ADM3_PCODE: 'ZA5216',
        ADM3_REF: '',
        ADM3ALT1EN: '',
        ADM3ALT2EN: '',
        ADM2_EN: 'Ugu',
        ADM2_PCODE: 'ZA521',
        ADM1_EN: 'KwaZulu-Natal',
        ADM1_PCODE: 'ZA5',
        ADM0_EN: 'South Africa',
        ADM0_PCODE: 'ZA',
        date: '2018-12-27T00:00:00.000Z',
        validOn: '2020-11-09T00:00:00.000Z',
        validTo: '1899-11-30T00:00:00.000Z',
        ADM1_ID: 'KZN',
        ADM2_ID: 'DC21',
        ADM3_ID: 'KZN216',
      },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Polygon',
        coordinates: [
          [
            [26.775780000000054, -32.333279999999945],
            [26.662449998000056, -32.42792999899996],
            [26.53369001200008, -32.36017999799998],
            [26.30962000100004, -32.37600999599994],
            [26.191329997000025, -32.285230000999945],
            [25.951069612000026, -32.36404736299994],
            [25.887309997000045, -32.48680000199994],
            [25.939830003000054, -32.53871999699993],
            [26.08084000100007, -32.54658000199993],
            [26.047619999000062, -32.63280000299994],
            [26.06595999900003, -32.78693000099997],
            [26.179510003000075, -32.76344000199998],
            [26.274939998000036, -32.93697999899996],
            [26.436340003000055, -32.94746000299995],
            [26.630109996000044, -33.00432999999998],
            [26.641930006000052, -33.05028999799998],
            [26.825500001000023, -33.03946999999994],
            [26.85622999700007, -33.11492000199996],
            [26.975810000000024, -33.04965999999996],
            [27.12063999700007, -33.02510000199993],
            [27.217910004000032, -32.89013000099993],
            [27.15761029300006, -32.83846006899995],
            [27.017230002000076, -32.785150001999966],
            [27.004514998000047, -32.60509500099994],
            [27.036430000000053, -32.56634999999994],
            [26.86515000000003, -32.51154999999994],
            [26.775780000000054, -32.333279999999945],
          ],
        ],
      },
      properties: {
        Shape_Leng: 6.29633156845,
        Shape_Area: 0.611263885014,
        ADM3_EN: 'Raymond Mhlaba',
        ADM3_PCODE: 'ZA2129',
        ADM3_REF: '',
        ADM3ALT1EN: '',
        ADM3ALT2EN: '',
        ADM2_EN: 'Amathole',
        ADM2_PCODE: 'ZA212',
        ADM1_EN: 'Eastern Cape',
        ADM1_PCODE: 'ZA2',
        ADM0_EN: 'South Africa',
        ADM0_PCODE: 'ZA',
        date: '2018-12-27T00:00:00.000Z',
        validOn: '2020-11-09T00:00:00.000Z',
        validTo: '1899-11-30T00:00:00.000Z',
        ADM1_ID: 'EC',
        ADM2_ID: 'DC12',
        ADM3_ID: 'EC129',
      },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Polygon',
        coordinates: [
          [
            [24.798487668000064, -30.03417014699994],
            [24.67129999900004, -29.971449999999948],
            [24.470020000000034, -29.811780003999957],
            [24.453640001000053, -29.86772000299993],
            [24.29826999900007, -29.897170005999953],
            [24.278819990000045, -29.96430000199996],
            [24.195893005000073, -30.002367995999975],
            [24.056520000000035, -30.003690001999928],
            [24.03990068400003, -30.09047150699996],
            [23.94522000300003, -30.10552999999993],
            [23.939299997000035, -30.210260000999938],
            [23.84207999800003, -30.195130001999928],
            [24.018870006000043, -30.339969998999948],
            [24.277617081000074, -30.448922981999942],
            [24.274300003000064, -30.583859995999944],
            [24.452420000000075, -30.658369997999955],
            [24.54078180600004, -30.731442956999956],
            [24.644425397000077, -30.751596894999977],
            [24.75599677100007, -30.45960166699996],
            [24.84294701600004, -30.366067465999947],
            [24.879171945000053, -30.27109122899998],
            [24.950169006000067, -30.224845002999928],
            [24.90156000500008, -30.208240003999947],
            [24.798487668000064, -30.03417014699994],
          ],
        ],
      },
      properties: {
        Shape_Leng: 3.92516396981,
        Shape_Area: 0.518239208333,
        ADM3_EN: 'Renosterberg',
        ADM3_PCODE: 'ZA3075',
        ADM3_REF: '',
        ADM3ALT1EN: '',
        ADM3ALT2EN: '',
        ADM2_EN: 'Pixley ka Seme',
        ADM2_PCODE: 'ZA307',
        ADM1_EN: 'Nothern Cape',
        ADM1_PCODE: 'ZA3',
        ADM0_EN: 'South Africa',
        ADM0_PCODE: 'ZA',
        date: '2018-12-27T00:00:00.000Z',
        validOn: '2020-11-09T00:00:00.000Z',
        validTo: '1899-11-30T00:00:00.000Z',
        ADM1_ID: 'NC',
        ADM2_ID: 'DC7',
        ADM3_ID: 'NC075',
      },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Polygon',
        coordinates: [
          [
            [30.399539943000036, -29.748629939999944],
            [30.37244994300005, -29.726819939999928],
            [30.15337994300006, -29.721430064999936],
            [30.045361357000047, -29.829961907999973],
            [30.105759943000066, -29.97464993999995],
            [30.212429943000075, -30.017339939999943],
            [30.281829943000048, -30.004419939999934],
            [30.396639943000025, -30.10230006599994],
            [30.44548994300004, -30.08436993999993],
            [30.513780068000074, -30.08713993999993],
            [30.493019943000036, -29.899560064999946],
            [30.399539943000036, -29.748629939999944],
          ],
        ],
      },
      properties: {
        Shape_Leng: 2.27856736911,
        Shape_Area: 0.115004995057,
        ADM3_EN: 'Richmond',
        ADM3_PCODE: 'ZA5227',
        ADM3_REF: '',
        ADM3ALT1EN: '',
        ADM3ALT2EN: '',
        ADM2_EN: 'Umgungundlovu',
        ADM2_PCODE: 'ZA522',
        ADM1_EN: 'KwaZulu-Natal',
        ADM1_PCODE: 'ZA5',
        ADM0_EN: 'South Africa',
        ADM0_PCODE: 'ZA',
        date: '2018-12-27T00:00:00.000Z',
        validOn: '2020-11-09T00:00:00.000Z',
        validTo: '1899-11-30T00:00:00.000Z',
        ADM1_ID: 'KZN',
        ADM2_ID: 'DC22',
        ADM3_ID: 'KZN227',
      },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Polygon',
        coordinates: [
          [
            [17.41870899500003, -28.72198100199995],
            [17.42966000100006, -28.56987000299995],
            [17.33308000100004, -28.47490999799993],
            [17.41403999700003, -28.376040005999982],
            [17.333999998000024, -28.226090004999946],
            [17.214980000000025, -28.248079996999934],
            [17.196259995000048, -28.12778999099993],
            [17.082499996000024, -28.033070000999942],
            [16.88459000200004, -28.08993998899996],
            [16.887929995000036, -28.17287999699994],
            [16.80305999600006, -28.22201999999993],
            [16.75501999900007, -28.302000001999943],
            [16.808160001000033, -28.360840002999964],
            [16.73399000200004, -28.494260002999965],
            [16.688469997000027, -28.47046999899993],
            [16.592459999000027, -28.53542000699997],
            [16.480209999000067, -28.565499993999936],
            [16.45189000000005, -28.63209999399993],
            [16.562309999000036, -28.71905000199996],
            [16.60475000200006, -28.876749994999955],
            [16.68981999300007, -28.92697000499993],
            [16.747930006000047, -29.042539998999928],
            [16.81511000000006, -29.09025000899993],
            [16.838039996000077, -29.21097999799997],
            [16.935140000000047, -29.35956999399997],
            [16.994610000000023, -29.515005001999953],
            [17.086770001000048, -29.443699996999953],
            [17.091619999000045, -29.333830001999956],
            [17.238210001000027, -29.240669999999966],
            [17.35744999900004, -29.327950001999966],
            [17.32642000000004, -29.404330004999963],
            [17.520850006000046, -29.437430004999953],
            [17.54058999600005, -29.337629999999933],
            [17.46046000000007, -29.02768000599997],
            [17.462206998000056, -28.85452700299993],
            [17.34900900100007, -28.794456993999972],
            [17.41870899500003, -28.72198100199995],
          ],
        ],
      },
      properties: {
        Shape_Leng: 5.79790048238,
        Shape_Area: 0.887696612707,
        ADM3_EN: 'Richtersveld',
        ADM3_PCODE: 'ZA3061',
        ADM3_REF: '',
        ADM3ALT1EN: '',
        ADM3ALT2EN: '',
        ADM2_EN: 'Namakwa',
        ADM2_PCODE: 'ZA306',
        ADM1_EN: 'Nothern Cape',
        ADM1_PCODE: 'ZA3',
        ADM0_EN: 'South Africa',
        ADM0_PCODE: 'ZA',
        date: '2018-12-27T00:00:00.000Z',
        validOn: '2020-11-09T00:00:00.000Z',
        validTo: '1899-11-30T00:00:00.000Z',
        ADM1_ID: 'NC',
        ADM2_ID: 'DC6',
        ADM3_ID: 'NC061',
      },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Polygon',
        coordinates: [
          [
            [27.532289998000067, -25.849960000999943],
            [27.501219999000057, -25.637849999999958],
            [27.646519999000077, -25.65016000099996],
            [27.619709999000065, -25.475030002999972],
            [27.519299999000054, -25.41993999699997],
            [27.521150001000024, -25.341440000999967],
            [27.42797999800007, -25.289660004999973],
            [27.364950001000068, -25.32539000299994],
            [27.00336000200008, -25.38999000399997],
            [27.01506000200004, -25.46314999599997],
            [27.158510000000035, -25.668479997999953],
            [27.132670001000065, -25.80929999799997],
            [27.20817000200003, -25.85476999699995],
            [27.165166000000056, -25.992083996999952],
            [27.169850000000054, -26.080229996999947],
            [27.361720000000048, -26.115669998999977],
            [27.425220000000024, -26.089389998999934],
            [27.461947001000055, -25.867606000999956],
            [27.532289998000067, -25.849960000999943],
          ],
        ],
      },
      properties: {
        Shape_Leng: 3.02249122624,
        Shape_Area: 0.307125195576,
        ADM3_EN: 'Rustenburg',
        ADM3_PCODE: 'ZA6373',
        ADM3_REF: '',
        ADM3ALT1EN: '',
        ADM3ALT2EN: '',
        ADM2_EN: 'Bojanala',
        ADM2_PCODE: 'ZA637',
        ADM1_EN: 'North West',
        ADM1_PCODE: 'ZA6',
        ADM0_EN: 'South Africa',
        ADM0_PCODE: 'ZA',
        date: '2018-12-27T00:00:00.000Z',
        validOn: '2020-11-09T00:00:00.000Z',
        validTo: '1899-11-30T00:00:00.000Z',
        ADM1_ID: 'NW',
        ADM2_ID: 'DC37',
        ADM3_ID: 'NW373',
      },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Polygon',
        coordinates: [
          [
            [27.931252005000033, -31.234014000999935],
            [27.87179000100008, -31.20327999899996],
            [27.736519999000052, -31.235049999999944],
            [27.62412000300003, -31.224029996999946],
            [27.57744999700003, -31.38920000199994],
            [27.59864000300007, -31.443719990999966],
            [27.474440000000072, -31.481229999999982],
            [27.482256434000078, -31.58604907299997],
            [27.437136002000045, -31.676665999999955],
            [27.52737471100005, -31.726878330999966],
            [27.694469998000045, -31.713420002999953],
            [27.758459997000045, -31.65649000899998],
            [27.746920001000035, -31.556189996999933],
            [27.97181999000003, -31.537730001999932],
            [28.04843999700006, -31.50576999599997],
            [28.156989999000075, -31.40189999699993],
            [28.260700004000057, -31.37043999699995],
            [28.216159997000034, -31.31280000299995],
            [28.08077000000003, -31.32375000199994],
            [27.931252005000033, -31.234014000999935],
          ],
        ],
      },
      properties: {
        Shape_Leng: 3.03849429048,
        Shape_Area: 0.219889538024,
        ADM3_EN: 'Sakhisizwe',
        ADM3_PCODE: 'ZA2138',
        ADM3_REF: '',
        ADM3ALT1EN: '',
        ADM3ALT2EN: '',
        ADM2_EN: 'Chris Hani',
        ADM2_PCODE: 'ZA213',
        ADM1_EN: 'Eastern Cape',
        ADM1_PCODE: 'ZA2',
        ADM0_EN: 'South Africa',
        ADM0_PCODE: 'ZA',
        date: '2018-12-27T00:00:00.000Z',
        validOn: '2020-11-09T00:00:00.000Z',
        validTo: '1899-11-30T00:00:00.000Z',
        ADM1_ID: 'EC',
        ADM2_ID: 'DC13',
        ADM3_ID: 'EC138',
      },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Polygon',
        coordinates: [
          [
            [18.124805002000073, -32.77778499999994],
            [18.060350003000053, -32.783539996999934],
            [17.957650000000058, -32.718089996999936],
            [17.896990000000073, -32.740649995999945],
            [17.878779999000074, -32.91898999899996],
            [17.891440002000024, -33.028639994999935],
            [17.99274999900007, -32.997160005999945],
            [18.042680001000065, -33.04868000099998],
            [17.955269998000063, -33.110570002999964],
            [18.106490001000054, -33.24069999799997],
            [18.156160009000075, -33.32062999899995],
            [18.226639997000063, -33.30946999799994],
            [18.203279998000028, -33.21544999699995],
            [18.24435999800005, -33.15334999999993],
            [18.363739989000067, -33.16022999799998],
            [18.44434000600006, -33.218059996999955],
            [18.535359997000057, -33.08165000099996],
            [18.511344003000033, -32.94604598799998],
            [18.29260000100004, -32.96199000399997],
            [18.124805002000073, -32.77778499999994],
          ],
        ],
      },
      properties: {
        Shape_Leng: 4.78543634986,
        Shape_Area: 0.194473932904,
        ADM3_EN: 'Saldanha Bay',
        ADM3_PCODE: 'ZA1014',
        ADM3_REF: '',
        ADM3ALT1EN: '',
        ADM3ALT2EN: '',
        ADM2_EN: 'West Coast',
        ADM2_PCODE: 'ZA101',
        ADM1_EN: 'Western Cape',
        ADM1_PCODE: 'ZA1',
        ADM0_EN: 'South Africa',
        ADM0_PCODE: 'ZA',
        date: '2018-12-27T00:00:00.000Z',
        validOn: '2020-11-09T00:00:00.000Z',
        validTo: '1899-11-30T00:00:00.000Z',
        ADM1_ID: 'WC',
        ADM2_ID: 'DC1',
        ADM3_ID: 'WC014',
      },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Polygon',
        coordinates: [
          [
            [28.117680000000064, -30.668669996999938],
            [27.94052000100004, -30.644109998999966],
            [27.918350003000057, -30.602589998999974],
            [27.78166999900003, -30.617299999999943],
            [27.623600001000057, -30.506200000999968],
            [27.604400003000023, -30.449459996999963],
            [27.474959996000052, -30.356479999999976],
            [27.37735000300006, -30.327119995999965],
            [27.284489999000073, -30.503400002999967],
            [27.00364999800007, -30.538309995999953],
            [27.034309991000043, -30.599859995999964],
            [27.10711999800003, -30.63177000299993],
            [27.119100003000028, -30.782809998999937],
            [27.179799996000042, -30.802640001999976],
            [27.13111000200007, -30.905224997999937],
            [27.141180000000077, -31.001889997999967],
            [27.217830002000028, -31.145989997999948],
            [27.165129989000036, -31.25978000699996],
            [27.24217999800004, -31.25994000199995],
            [27.275999996000053, -31.339759998999966],
            [27.408460002000027, -31.418459998999936],
            [27.45131000200007, -31.25719000199996],
            [27.569559997000056, -31.209089997999968],
            [27.62412000300003, -31.224029996999946],
            [27.736519999000052, -31.235049999999944],
            [27.87179000100008, -31.20327999899996],
            [27.931252005000033, -31.234014000999935],
            [27.985490002000063, -31.15199000299998],
            [27.981575001000067, -31.07651500099996],
            [28.132130000000075, -30.83530000199994],
            [28.117680000000064, -30.668669996999938],
          ],
        ],
      },
      properties: {
        Shape_Leng: 5.29107126769,
        Shape_Area: 0.691257341984,
        ADM3_EN: 'Senqu',
        ADM3_PCODE: 'ZA2142',
        ADM3_REF: '',
        ADM3ALT1EN: '',
        ADM3ALT2EN: '',
        ADM2_EN: 'Joe Gqabi',
        ADM2_PCODE: 'ZA214',
        ADM1_EN: 'Eastern Cape',
        ADM1_PCODE: 'ZA2',
        ADM0_EN: 'South Africa',
        ADM0_PCODE: 'ZA',
        date: '2018-12-27T00:00:00.000Z',
        validOn: '2020-11-09T00:00:00.000Z',
        validTo: '1899-11-30T00:00:00.000Z',
        ADM1_ID: 'EC',
        ADM2_ID: 'DC14',
        ADM3_ID: 'EC142',
      },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Polygon',
        coordinates: [
          [
            [27.78866001800003, -28.24798099399993],
            [27.759940002000064, -28.06191000299998],
            [27.703459999000074, -28.040389999999945],
            [27.596290003000036, -28.175989998999967],
            [27.56962000200008, -28.282529995999937],
            [27.38786999900003, -28.214080001999946],
            [27.27682999800004, -28.282779998999956],
            [27.288969775000055, -28.457538326999952],
            [27.212212100000045, -28.57798826399994],
            [27.18630500200004, -28.80526299899998],
            [27.401770002000035, -28.870789999999943],
            [27.47835999800003, -28.87330000299994],
            [27.527670000000057, -29.01283899699996],
            [27.65024999800005, -29.10998000099994],
            [27.73076999700004, -28.94571000999997],
            [27.915960003000066, -28.865149994999967],
            [28.02843000100006, -28.873949997999944],
            [28.10165998900004, -28.76714999899997],
            [28.03999999000007, -28.624859992999973],
            [27.901350000000036, -28.555850002999932],
            [27.833885998000028, -28.55083700299997],
            [27.808520000000044, -28.458240001999968],
            [27.860509998000055, -28.361190002999933],
            [27.78866001800003, -28.24798099399993],
          ],
        ],
      },
      properties: {
        Shape_Leng: 5.20394171318,
        Shape_Area: 0.501025941152,
        ADM3_EN: 'Setsoto',
        ADM3_PCODE: 'ZA4191',
        ADM3_REF: '',
        ADM3ALT1EN: '',
        ADM3ALT2EN: '',
        ADM2_EN: 'Thabo Mofutsanyane',
        ADM2_PCODE: 'ZA419',
        ADM1_EN: 'Free State',
        ADM1_PCODE: 'ZA4',
        ADM0_EN: 'South Africa',
        ADM0_PCODE: 'ZA',
        date: '2018-12-27T00:00:00.000Z',
        validOn: '2020-11-09T00:00:00.000Z',
        validTo: '1899-11-30T00:00:00.000Z',
        ADM1_ID: 'FS',
        ADM2_ID: 'DC19',
        ADM3_ID: 'FS191',
      },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Polygon',
        coordinates: [
          [
            [23.706969999000023, -28.58772000099998],
            [23.62380999900006, -28.70839000099994],
            [23.54240999600006, -28.747439996999958],
            [23.410290002000067, -28.695279996999943],
            [23.379085001000078, -28.63630999399993],
            [23.292009999000072, -28.649940000999948],
            [23.222959996000043, -28.55728999599995],
            [23.128460005000022, -28.596609997999963],
            [22.796239998000033, -28.577549997999938],
            [22.72977000000003, -28.517949993999935],
            [22.52434499800006, -28.497349996999958],
            [22.460600001000046, -28.44446000099998],
            [22.123329994000073, -28.76320000299995],
            [22.041870001000063, -28.839910001999954],
            [22.142559995000056, -28.914550006999946],
            [22.217938996000044, -29.098789993999958],
            [22.257499997000025, -29.12471000399995],
            [22.269739994000076, -29.31937000199997],
            [22.338434994000067, -29.314809999999966],
            [22.355540013000052, -29.231890006999947],
            [22.442753002000075, -29.13437299499998],
            [22.63548999300008, -29.13823999999994],
            [22.67999999700004, -29.25846999199996],
            [22.852710717000036, -29.273630108999953],
            [22.831020355000078, -29.129850387999966],
            [23.07218933100006, -29.18066024799998],
            [23.164899826000067, -29.140350341999977],
            [23.320719998000072, -29.15115000299994],
            [23.34993743900003, -29.21861267099996],
            [23.193592220000028, -29.336221230999968],
            [23.227802277000023, -29.537368773999958],
            [23.488100006000025, -29.24063500099993],
            [23.573070001000076, -29.184660002999976],
            [23.63938000400003, -29.073959998999953],
            [23.704449999000076, -29.111030006999954],
            [23.713980003000074, -29.19323000299994],
            [23.86459999400006, -29.286739999999952],
            [23.931199995000043, -29.39648000099993],
            [23.937589999000068, -29.482089994999967],
            [24.143149996000034, -29.53855000699997],
            [24.195160009000062, -29.522439989999953],
            [24.34662000000003, -29.65592999599994],
            [24.691780003000076, -29.025719998999932],
            [24.53524999900003, -29.04220999499995],
            [24.395520004000048, -28.942399990999945],
            [24.233560562000036, -28.88238906899994],
            [24.27017021200004, -28.833520888999942],
            [24.108339310000076, -28.777599334999934],
            [24.06201999800004, -28.68571000299994],
            [24.117039961000046, -28.59861322499995],
            [23.949589996000043, -28.603360003999967],
            [23.908660008000027, -28.641440005999982],
            [23.75470000000007, -28.52878000399994],
            [23.706969999000023, -28.58772000099998],
          ],
        ],
      },
      properties: {
        Shape_Leng: 9.65896051069,
        Shape_Area: 1.55098852298,
        ADM3_EN: 'Siyancuma',
        ADM3_PCODE: 'ZA3078',
        ADM3_REF: '',
        ADM3ALT1EN: '',
        ADM3ALT2EN: '',
        ADM2_EN: 'Pixley ka Seme',
        ADM2_PCODE: 'ZA307',
        ADM1_EN: 'Nothern Cape',
        ADM1_PCODE: 'ZA3',
        ADM0_EN: 'South Africa',
        ADM0_PCODE: 'ZA',
        date: '2018-12-27T00:00:00.000Z',
        validOn: '2020-11-09T00:00:00.000Z',
        validTo: '1899-11-30T00:00:00.000Z',
        ADM1_ID: 'NC',
        ADM2_ID: 'DC7',
        ADM3_ID: 'NC078',
      },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Polygon',
        coordinates: [
          [
            [22.217938996000044, -29.098789993999958],
            [22.086310000000026, -28.950620004999962],
            [21.990960001000076, -28.94607000299993],
            [21.95861999600004, -29.015709998999967],
            [21.83810815000004, -29.097364179999943],
            [21.979309998000076, -29.277759998999954],
            [21.845669998000062, -29.395889998999962],
            [21.89981999400004, -29.44913000599996],
            [21.784930006000025, -29.556609996999953],
            [21.829969998000024, -29.62319000599996],
            [21.721610000000055, -29.77482000699996],
            [21.81141999400006, -29.84196000299994],
            [22.010350005000078, -29.90244000499996],
            [22.014210001000038, -30.005780001999938],
            [22.034579999000073, -30.05758999899996],
            [22.208989994000035, -30.12486999799995],
            [22.299599989000058, -30.196430008999982],
            [22.466299999000057, -30.190420005999954],
            [22.523539997000057, -30.15835999899997],
            [22.60809000000006, -30.199300002999962],
            [22.64779999500007, -30.130230000999973],
            [22.748339995000038, -30.079269994999947],
            [22.93757000000005, -30.123549999999966],
            [22.982039997000072, -30.238129999999956],
            [23.113139998000065, -30.15642999199997],
            [23.206658358000027, -30.039386014999934],
            [23.183677033000038, -29.938064673999975],
            [23.239449998000055, -29.901959990999956],
            [23.345280004000074, -29.896319998999957],
            [23.282869996000045, -29.79066000199998],
            [23.341849999000033, -29.73096000199996],
            [23.23306999400006, -29.63868999799996],
            [23.227802277000023, -29.537368773999958],
            [23.193592220000028, -29.336221230999968],
            [23.34993743900003, -29.21861267099996],
            [23.320719998000072, -29.15115000299994],
            [23.164899826000067, -29.140350341999977],
            [23.07218933100006, -29.18066024799998],
            [22.831020355000078, -29.129850387999966],
            [22.852710717000036, -29.273630108999953],
            [22.67999999700004, -29.25846999199996],
            [22.63548999300008, -29.13823999999994],
            [22.442753002000075, -29.13437299499998],
            [22.355540013000052, -29.231890006999947],
            [22.338434994000067, -29.314809999999966],
            [22.269739994000076, -29.31937000199997],
            [22.257499997000025, -29.12471000399995],
            [22.217938996000044, -29.098789993999958],
          ],
        ],
      },
      properties: {
        Shape_Leng: 7.00444074779,
        Shape_Area: 1.37196888211,
        ADM3_EN: 'Siyathemba',
        ADM3_PCODE: 'ZA3077',
        ADM3_REF: '',
        ADM3ALT1EN: '',
        ADM3ALT2EN: '',
        ADM2_EN: 'Pixley ka Seme',
        ADM2_PCODE: 'ZA307',
        ADM1_EN: 'Nothern Cape',
        ADM1_PCODE: 'ZA3',
        ADM0_EN: 'South Africa',
        ADM0_PCODE: 'ZA',
        date: '2018-12-27T00:00:00.000Z',
        validOn: '2020-11-09T00:00:00.000Z',
        validTo: '1899-11-30T00:00:00.000Z',
        ADM1_ID: 'NC',
        ADM2_ID: 'DC7',
        ADM3_ID: 'NC077',
      },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Polygon',
        coordinates: [
          [
            [24.899329996000063, -28.430469998999968],
            [24.726490004000027, -28.449739990999944],
            [24.688020003000076, -28.51417999599994],
            [24.606599999000025, -28.49547999699996],
            [24.608249999000066, -28.59722000599993],
            [24.521699994000073, -28.674599994999937],
            [24.408940005000034, -28.62680000499995],
            [24.33348000700005, -28.560820004999982],
            [24.200259999000025, -28.517570000999967],
            [24.117039961000046, -28.59861322499995],
            [24.06201999800004, -28.68571000299994],
            [24.108339310000076, -28.777599334999934],
            [24.27017021200004, -28.833520888999942],
            [24.233560562000036, -28.88238906899994],
            [24.395520004000048, -28.942399990999945],
            [24.53524999900003, -29.04220999499995],
            [24.691780003000076, -29.025719998999932],
            [24.80182700000006, -28.828258003999963],
            [24.90184000000005, -28.64803000099994],
            [24.827729996000073, -28.62695999699997],
            [24.899329996000063, -28.430469998999968],
          ],
        ],
      },
      properties: {
        Shape_Leng: 3.18638200257,
        Shape_Area: 0.29054474881,
        ADM3_EN: 'Sol Plaatjie',
        ADM3_PCODE: 'ZA3091',
        ADM3_REF: '',
        ADM3ALT1EN: '',
        ADM3ALT2EN: '',
        ADM2_EN: 'Frances Baard',
        ADM2_PCODE: 'ZA309',
        ADM1_EN: 'Nothern Cape',
        ADM1_PCODE: 'ZA3',
        ADM0_EN: 'South Africa',
        ADM0_PCODE: 'ZA',
        date: '2018-12-27T00:00:00.000Z',
        validOn: '2020-11-09T00:00:00.000Z',
        validTo: '1899-11-30T00:00:00.000Z',
        ADM1_ID: 'NC',
        ADM2_ID: 'DC9',
        ADM3_ID: 'NC091',
      },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Polygon',
        coordinates: [
          [
            [19.21404900600004, -33.857067995999955],
            [19.094160008000074, -33.831670000999964],
            [18.93153999900005, -33.87908000199997],
            [18.89678000300006, -33.79335999699998],
            [18.79257000100006, -33.81921000199998],
            [18.75287000000003, -33.834419999999966],
            [18.729180020000058, -33.96747639199998],
            [18.790210003000027, -34.05287999999996],
            [18.955299998000044, -34.010110001999976],
            [18.98713112300004, -34.03526966299995],
            [19.24380000000008, -33.89744999699997],
            [19.21404900600004, -33.857067995999955],
          ],
        ],
      },
      properties: {
        Shape_Leng: 1.72901857401,
        Shape_Area: 0.081012569963,
        ADM3_EN: 'Stellenbosch',
        ADM3_PCODE: 'ZA1024',
        ADM3_REF: '',
        ADM3ALT1EN: '',
        ADM3ALT2EN: '',
        ADM2_EN: 'Cape Winelands',
        ADM2_PCODE: 'ZA102',
        ADM1_EN: 'Western Cape',
        ADM1_PCODE: 'ZA1',
        ADM0_EN: 'South Africa',
        ADM0_PCODE: 'ZA',
        date: '2018-12-27T00:00:00.000Z',
        validOn: '2020-11-09T00:00:00.000Z',
        validTo: '1899-11-30T00:00:00.000Z',
        ADM1_ID: 'WC',
        ADM2_ID: 'DC2',
        ADM3_ID: 'WC024',
      },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Polygon',
        coordinates: [
          [
            [29.51882997900003, -25.42279002199996],
            [29.36245997900005, -25.407110020999937],
            [29.198250011000027, -25.562420000999964],
            [29.30440999700005, -25.681000000999973],
            [29.289129996000042, -25.74535999799997],
            [29.327979998000046, -25.791719995999983],
            [29.40244799900006, -26.063212007999937],
            [29.387970000000053, -26.20490000099994],
            [29.493449996000038, -26.16954999899997],
            [29.540350001000036, -26.253879996999956],
            [29.66762999900004, -26.244640001999983],
            [29.80468999800007, -26.189510002999953],
            [29.811059999000065, -26.105299998999953],
            [29.876959998000075, -25.965210001999935],
            [29.86179000100003, -25.862450002999935],
            [29.80094000300005, -25.84876000199995],
            [29.825900000000047, -25.701420002999953],
            [29.713110003000054, -25.572179999999946],
            [29.58592999600006, -25.581449997999982],
            [29.51882997900003, -25.42279002199996],
          ],
        ],
      },
      properties: {
        Shape_Leng: 3.76335844078,
        Shape_Area: 0.358020286943,
        ADM3_EN: 'Steve Tshwete',
        ADM3_PCODE: 'ZA8313',
        ADM3_REF: '',
        ADM3ALT1EN: '',
        ADM3ALT2EN: '',
        ADM2_EN: 'Nkangala',
        ADM2_PCODE: 'ZA831',
        ADM1_EN: 'Mpumalanga',
        ADM1_PCODE: 'ZA8',
        ADM0_EN: 'South Africa',
        ADM0_PCODE: 'ZA',
        date: '2018-12-27T00:00:00.000Z',
        validOn: '2020-11-09T00:00:00.000Z',
        validTo: '1899-11-30T00:00:00.000Z',
        ADM1_ID: 'MP',
        ADM2_ID: 'DC31',
        ADM3_ID: 'MP313',
      },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Polygon',
        coordinates: [
          [
            [25.178260000000023, -33.251679999999965],
            [25.13477000300003, -33.295069997999974],
            [24.880290003000027, -33.257470001999934],
            [24.798039996000057, -33.483420001999946],
            [24.70185000200007, -33.51453000099997],
            [24.730740001000072, -33.62038000199993],
            [24.829460003000065, -33.64256999699995],
            [25.081420003000062, -33.78668000299996],
            [25.235029991000033, -33.83690000099995],
            [25.307228300000077, -33.71735790099996],
            [25.346299998000063, -33.55707000899997],
            [25.43770999900005, -33.553080000999955],
            [25.736790003000067, -33.629929998999955],
            [25.84900999900003, -33.72245999799998],
            [26.015859996000074, -33.70530999799996],
            [26.18834000100003, -33.72618999599996],
            [26.321880004000036, -33.767770000999974],
            [26.53004999700005, -33.75414999599997],
            [26.461520001000054, -33.70520000199997],
            [26.347760004000065, -33.68983999899996],
            [26.38071999700003, -33.56256000199994],
            [26.26350000000008, -33.52023999399995],
            [26.10971500000005, -33.53468000299995],
            [26.037439996000046, -33.42363000399996],
            [26.063190003000045, -33.33309999599993],
            [25.98793999700007, -33.306610002999946],
            [25.78963999800004, -33.28451999899994],
            [25.450720002000025, -33.283530000999974],
            [25.178260000000023, -33.251679999999965],
          ],
        ],
      },
      properties: {
        Shape_Leng: 5.90972623918,
        Shape_Area: 0.58174126924,
        ADM3_EN: 'Sundays River Valley',
        ADM3_PCODE: 'ZA2106',
        ADM3_REF: '',
        ADM3ALT1EN: '',
        ADM3ALT2EN: '',
        ADM2_EN: 'Cacadu',
        ADM2_PCODE: 'ZA210',
        ADM1_EN: 'Eastern Cape',
        ADM1_PCODE: 'ZA2',
        ADM0_EN: 'South Africa',
        ADM0_PCODE: 'ZA',
        date: '2018-12-27T00:00:00.000Z',
        validOn: '2020-11-09T00:00:00.000Z',
        validTo: '1899-11-30T00:00:00.000Z',
        ADM1_ID: 'EC',
        ADM2_ID: 'DC10',
        ADM3_ID: 'EC106',
      },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Polygon',
        coordinates: [
          [
            [18.939005000000066, -33.19638999799997],
            [18.844649998000023, -33.11732000099994],
            [18.807800003000068, -33.03002000199996],
            [18.72658000200005, -32.95053000099995],
            [18.59600000100005, -32.90072000899994],
            [18.511344003000033, -32.94604598799998],
            [18.535359997000057, -33.08165000099996],
            [18.44434000600006, -33.218059996999955],
            [18.363739989000067, -33.16022999799998],
            [18.24435999800005, -33.15334999999993],
            [18.203279998000028, -33.21544999699995],
            [18.226639997000063, -33.30946999799994],
            [18.156160009000075, -33.32062999899995],
            [18.255050004000054, -33.42675000099996],
            [18.343040006000024, -33.570630000999984],
            [18.455458003000047, -33.47127600399995],
            [18.57642000000004, -33.53147999699996],
            [18.627000000000066, -33.624589999999955],
            [18.73673001000003, -33.68703000199997],
            [18.787539997000067, -33.637630000999934],
            [18.93405000200005, -33.49215000899994],
            [18.997350006000033, -33.307909999999936],
            [18.939005000000066, -33.19638999799997],
          ],
        ],
      },
      properties: {
        Shape_Leng: 4.03109759195,
        Shape_Area: 0.358943753467,
        ADM3_EN: 'Swartland',
        ADM3_PCODE: 'ZA1015',
        ADM3_REF: '',
        ADM3ALT1EN: '',
        ADM3ALT2EN: '',
        ADM2_EN: 'West Coast',
        ADM2_PCODE: 'ZA101',
        ADM1_EN: 'Western Cape',
        ADM1_PCODE: 'ZA1',
        ADM0_EN: 'South Africa',
        ADM0_PCODE: 'ZA',
        date: '2018-12-27T00:00:00.000Z',
        validOn: '2020-11-09T00:00:00.000Z',
        validTo: '1899-11-30T00:00:00.000Z',
        ADM1_ID: 'WC',
        ADM2_ID: 'DC1',
        ADM3_ID: 'WC015',
      },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Polygon',
        coordinates: [
          [
            [20.943380000000047, -33.85187000199994],
            [21.010339999000053, -33.75656000099997],
            [20.800259999000048, -33.71500999899996],
            [20.66602000200004, -33.621970003999934],
            [20.503258997000046, -33.63700000199998],
            [20.43534999900004, -33.82639999999998],
            [20.436040003000073, -33.95774000799997],
            [20.324430000000064, -33.94957000299996],
            [20.29133999900006, -34.09129999999993],
            [20.19609000300005, -34.03999999699994],
            [20.007460002000073, -34.09391999899998],
            [19.96572000200007, -34.176270002999956],
            [19.880430000000047, -34.22010999999998],
            [20.065529998000045, -34.24126999599997],
            [20.244850000000042, -34.288889998999935],
            [20.391979997000078, -34.426290000999984],
            [20.53172999900005, -34.360520002999976],
            [20.871390005000023, -34.45243999999997],
            [20.849963002000038, -34.40340599799998],
            [20.596289999000078, -34.34796999699995],
            [20.599380001000043, -34.27291000399998],
            [20.664950003000058, -34.18847999899998],
            [20.640100002000054, -34.08596000399996],
            [20.754300000000057, -34.09724999699995],
            [20.707270003000076, -33.955120000999955],
            [20.833790001000068, -33.971330002999935],
            [20.93403999800006, -33.94762000299994],
            [20.943380000000047, -33.85187000199994],
          ],
        ],
      },
      properties: {
        Shape_Leng: 6.02907074945,
        Shape_Area: 0.374407921366,
        ADM3_EN: 'Swellendam',
        ADM3_PCODE: 'ZA1034',
        ADM3_REF: '',
        ADM3ALT1EN: '',
        ADM3ALT2EN: '',
        ADM2_EN: 'Overberg',
        ADM2_PCODE: 'ZA103',
        ADM1_EN: 'Western Cape',
        ADM1_PCODE: 'ZA1',
        ADM0_EN: 'South Africa',
        ADM0_PCODE: 'ZA',
        date: '2018-12-27T00:00:00.000Z',
        validOn: '2020-11-09T00:00:00.000Z',
        validTo: '1899-11-30T00:00:00.000Z',
        ADM1_ID: 'WC',
        ADM2_ID: 'DC3',
        ADM3_ID: 'WC034',
      },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Polygon',
        coordinates: [
          [
            [31.025230003000047, -25.030099993999954],
            [31.00542000300004, -24.83701999599998],
            [30.919410003000053, -24.80515999599993],
            [30.871709999000075, -24.538500002999967],
            [30.758979999000076, -24.460219998999946],
            [30.73017999900003, -24.49849999999998],
            [30.720100002000038, -24.70523800899997],
            [30.634880004000024, -24.852770000999953],
            [30.45153999200005, -24.912000003999935],
            [30.42507000300003, -24.854859999999974],
            [30.19197998900006, -24.85547000899993],
            [30.144389997000076, -25.12378999899994],
            [29.978949982000074, -25.09211998199993],
            [30.009839971000076, -25.231280030999983],
            [29.990589983000064, -25.33825002599997],
            [30.025460004000024, -25.367719999999963],
            [30.143230006000067, -25.245810008999968],
            [30.190750003000062, -25.275810001999957],
            [30.22945999800004, -25.432410000999937],
            [30.35099000100007, -25.492479996999975],
            [30.449239999000042, -25.34495999799998],
            [30.53197099700003, -25.349590001999957],
            [30.629890009000064, -25.28499999899998],
            [30.703239998000072, -25.361539995999976],
            [30.88181000000003, -25.38371000199993],
            [30.978155999000023, -25.29015400299994],
            [30.917219999000054, -25.20830999599997],
            [30.941120004000027, -25.128888003999975],
            [31.025230003000047, -25.030099993999954],
          ],
        ],
      },
      properties: {
        Shape_Leng: 5.10896522502,
        Shape_Area: 0.511696129129,
        ADM3_EN: 'Thaba Chweu',
        ADM3_PCODE: 'ZA8321',
        ADM3_REF: '',
        ADM3ALT1EN: '',
        ADM3ALT2EN: '',
        ADM2_EN: 'Ehlanzeni',
        ADM2_PCODE: 'ZA832',
        ADM1_EN: 'Mpumalanga',
        ADM1_PCODE: 'ZA8',
        ADM0_EN: 'South Africa',
        ADM0_PCODE: 'ZA',
        date: '2018-12-27T00:00:00.000Z',
        validOn: '2020-11-09T00:00:00.000Z',
        validTo: '1899-11-30T00:00:00.000Z',
        ADM1_ID: 'MP',
        ADM2_ID: 'DC32',
        ADM3_ID: 'MP321',
      },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Polygon',
        coordinates: [
          [
            [27.57467000300005, -24.42819999699998],
            [27.49366569500006, -24.355215072999954],
            [27.502357483000026, -24.219268798999963],
            [27.538343234000024, -24.16780973799996],
            [27.318460464000054, -24.028549193999936],
            [27.12767982500003, -23.953420638999944],
            [27.011089325000057, -23.790990828999952],
            [27.001056619000053, -23.68903439199994],
            [26.971070000000054, -23.702759998999966],
            [26.908940001000076, -24.029180002999965],
            [26.86320000300003, -24.09972000399995],
            [26.868809998000074, -24.243819995999957],
            [26.799930001000064, -24.299959996999974],
            [26.70399000200007, -24.32182000199998],
            [26.510520003000067, -24.487909999999943],
            [26.469550000000027, -24.590859997999928],
            [26.40878000300006, -24.646129995999956],
            [26.458280002000038, -24.809470001999955],
            [26.62201000300007, -24.809860003999972],
            [26.751259996000044, -24.88295999899998],
            [26.77954000300008, -24.837690002999977],
            [26.980720002000055, -24.77576999799993],
            [27.041219999000077, -24.88697000299993],
            [27.22609200200003, -24.963937001999966],
            [27.203468000000044, -25.033182997999972],
            [27.313600000000065, -25.042089996999948],
            [27.33695000000006, -25.08781999699994],
            [27.486900001000038, -25.07841999799996],
            [27.54359999600007, -25.09587999799993],
            [27.597490003000075, -24.984869999999944],
            [27.821660003000034, -24.974580001999982],
            [27.946469998000055, -25.001219999999932],
            [27.983559998000032, -24.957849997999972],
            [27.977860003000046, -24.90102000199994],
            [27.830980001000057, -24.849409999999978],
            [27.87066400300006, -24.768357996999953],
            [27.89511999700005, -24.582679994999978],
            [27.70070000100003, -24.59910999599998],
            [27.675859998000078, -24.50072999799994],
            [27.57467000300005, -24.42819999699998],
          ],
        ],
      },
      properties: {
        Shape_Leng: 6.86579714084,
        Shape_Area: 0.997102979104,
        ADM3_EN: 'Thabazimbi',
        ADM3_PCODE: 'ZA9361',
        ADM3_REF: '',
        ADM3ALT1EN: '',
        ADM3ALT2EN: '',
        ADM2_EN: 'Waterberg',
        ADM2_PCODE: 'ZA936',
        ADM1_EN: 'Limpopo',
        ADM1_PCODE: 'ZA9',
        ADM0_EN: 'South Africa',
        ADM0_PCODE: 'ZA',
        date: '2018-12-27T00:00:00.000Z',
        validOn: '2020-11-09T00:00:00.000Z',
        validTo: '1899-11-30T00:00:00.000Z',
        ADM1_ID: 'LIM',
        ADM2_ID: 'DC36',
        ADM3_ID: 'LIM361',
      },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Polygon',
        coordinates: [
          [
            [30.540799943000025, -29.618230064999977],
            [30.431659943000057, -29.54343006499994],
            [30.364679943000056, -29.542879939999978],
            [30.10609994300006, -29.629689939999935],
            [30.069199943000058, -29.72404006499994],
            [29.980332055000076, -29.719404435999934],
            [29.957625609000047, -29.78094086699997],
            [30.045361357000047, -29.829961907999973],
            [30.15337994300006, -29.721430064999936],
            [30.37244994300005, -29.726819939999928],
            [30.399539943000036, -29.748629939999944],
            [30.49535994300004, -29.70545993999997],
            [30.540799943000025, -29.618230064999977],
          ],
        ],
      },
      properties: {
        Shape_Leng: 1.94911043344,
        Shape_Area: 0.0699968943689,
        ADM3_EN: 'The Msunduzi',
        ADM3_PCODE: 'ZA5225',
        ADM3_REF: '',
        ADM3ALT1EN: '',
        ADM3ALT2EN: '',
        ADM2_EN: 'Umgungundlovu',
        ADM2_PCODE: 'ZA522',
        ADM1_EN: 'KwaZulu-Natal',
        ADM1_PCODE: 'ZA5',
        ADM0_EN: 'South Africa',
        ADM0_PCODE: 'ZA',
        date: '2018-12-27T00:00:00.000Z',
        validOn: '2020-11-09T00:00:00.000Z',
        validTo: '1899-11-30T00:00:00.000Z',
        ADM1_ID: 'KZN',
        ADM2_ID: 'DC22',
        ADM3_ID: 'KZN225',
      },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Polygon',
        coordinates: [
          [
            [19.506889998000077, -33.97169999999994],
            [19.455799998000032, -33.99987999999996],
            [19.24380000000008, -33.89744999699997],
            [18.98713112300004, -34.03526966299995],
            [18.930709386000046, -34.203527863999966],
            [19.039120009000044, -34.27422999799995],
            [19.130097852000063, -34.24311964599997],
            [19.302979813000036, -34.32855989799998],
            [19.300587522000058, -34.37527932099994],
            [19.624219995000033, -34.41871999999995],
            [19.641055394000034, -34.372031739999954],
            [19.845399997000072, -34.280439996999974],
            [19.880430000000047, -34.22010999999998],
            [19.96572000200007, -34.176270002999956],
            [20.007460002000073, -34.09391999899998],
            [19.700139997000065, -34.046400001999984],
            [19.506889998000077, -33.97169999999994],
          ],
        ],
      },
      properties: {
        Shape_Leng: 3.39282645004,
        Shape_Area: 0.318637106383,
        ADM3_EN: 'Theewaterskloof',
        ADM3_PCODE: 'ZA1031',
        ADM3_REF: '',
        ADM3ALT1EN: '',
        ADM3ALT2EN: '',
        ADM2_EN: 'Overberg',
        ADM2_PCODE: 'ZA103',
        ADM1_EN: 'Western Cape',
        ADM1_PCODE: 'ZA1',
        ADM0_EN: 'South Africa',
        ADM0_PCODE: 'ZA',
        date: '2018-12-27T00:00:00.000Z',
        validOn: '2020-11-09T00:00:00.000Z',
        validTo: '1899-11-30T00:00:00.000Z',
        ADM1_ID: 'WC',
        ADM2_ID: 'DC3',
        ADM3_ID: 'WC031',
      },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Polygon',
        coordinates: [
          [
            [24.34662000000003, -29.65592999599994],
            [24.195160009000062, -29.522439989999953],
            [24.143149996000034, -29.53855000699997],
            [23.937589999000068, -29.482089994999967],
            [23.931199995000043, -29.39648000099993],
            [23.86459999400006, -29.286739999999952],
            [23.713980003000074, -29.19323000299994],
            [23.704449999000076, -29.111030006999954],
            [23.63938000400003, -29.073959998999953],
            [23.573070001000076, -29.184660002999976],
            [23.488100006000025, -29.24063500099993],
            [23.227802277000023, -29.537368773999958],
            [23.23306999400006, -29.63868999799996],
            [23.341849999000033, -29.73096000199996],
            [23.282869996000045, -29.79066000199998],
            [23.345280004000074, -29.896319998999957],
            [23.239449998000055, -29.901959990999956],
            [23.352890002000038, -30.066130000999976],
            [23.497719998000036, -30.058619999999962],
            [23.64245999800005, -30.14434999799994],
            [23.776339997000036, -30.103039999999964],
            [23.84207999800003, -30.195130001999928],
            [23.939299997000035, -30.210260000999938],
            [23.94522000300003, -30.10552999999993],
            [24.03990068400003, -30.09047150699996],
            [24.056520000000035, -30.003690001999928],
            [24.195893005000073, -30.002367995999975],
            [24.278819990000045, -29.96430000199996],
            [24.29826999900007, -29.897170005999953],
            [24.453640001000053, -29.86772000299993],
            [24.470020000000034, -29.811780003999957],
            [24.411580000000072, -29.79073999999997],
            [24.34662000000003, -29.65592999599994],
          ],
        ],
      },
      properties: {
        Shape_Leng: 4.92064914469,
        Shape_Area: 0.747983501547,
        ADM3_EN: 'Thembelihle',
        ADM3_PCODE: 'ZA3076',
        ADM3_REF: '',
        ADM3ALT1EN: '',
        ADM3ALT2EN: '',
        ADM2_EN: 'Pixley ka Seme',
        ADM2_PCODE: 'ZA307',
        ADM1_EN: 'Nothern Cape',
        ADM1_PCODE: 'ZA3',
        ADM0_EN: 'South Africa',
        ADM0_PCODE: 'ZA',
        date: '2018-12-27T00:00:00.000Z',
        validOn: '2020-11-09T00:00:00.000Z',
        validTo: '1899-11-30T00:00:00.000Z',
        ADM1_ID: 'NC',
        ADM2_ID: 'DC7',
        ADM3_ID: 'NC076',
      },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Polygon',
        coordinates: [
          [
            [29.032259983000074, -25.249330019999945],
            [28.899134004000075, -25.235077002999958],
            [28.79100999800005, -25.328339997999933],
            [28.739590001000067, -25.28853000099997],
            [28.62257999800005, -25.33364999899993],
            [28.625750002000075, -25.52304999599994],
            [28.683779997000045, -25.67537999999996],
            [28.846950004000064, -25.68242000099997],
            [28.851780003000044, -25.501809999999978],
            [29.00829000300007, -25.66057000099994],
            [29.117270000000076, -25.656499999999937],
            [29.289129996000042, -25.74535999799997],
            [29.30440999700005, -25.681000000999973],
            [29.198250011000027, -25.562420000999964],
            [29.36245997900005, -25.407110020999937],
            [29.264433960000076, -25.37546304199998],
            [29.166959960000042, -25.30336004199995],
            [29.032259983000074, -25.249330019999945],
          ],
        ],
      },
      properties: {
        Shape_Leng: 4.27666433585,
        Shape_Area: 0.214031002531,
        ADM3_EN: 'Thembisile',
        ADM3_PCODE: 'ZA8315',
        ADM3_REF: '',
        ADM3ALT1EN: '',
        ADM3ALT2EN: '',
        ADM2_EN: 'Nkangala',
        ADM2_PCODE: 'ZA831',
        ADM1_EN: 'Mpumalanga',
        ADM1_PCODE: 'ZA8',
        ADM0_EN: 'South Africa',
        ADM0_PCODE: 'ZA',
        date: '2018-12-27T00:00:00.000Z',
        validOn: '2020-11-09T00:00:00.000Z',
        validTo: '1899-11-30T00:00:00.000Z',
        ADM1_ID: 'MP',
        ADM2_ID: 'DC31',
        ADM3_ID: 'MP315',
      },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Polygon',
        coordinates: [
          [
            [30.88948059100005, -22.71283912699994],
            [30.989229968000075, -22.608260023999946],
            [30.888754806000065, -22.48032150499995],
            [30.81725288800004, -22.500636356999962],
            [30.787693653000076, -22.592604974999972],
            [30.43528248000007, -22.659607723999954],
            [30.32371994300007, -22.653220058999977],
            [30.205389943000057, -22.78258005899994],
            [30.164799943000048, -22.92501005899993],
            [30.355329943000072, -23.027190058999963],
            [30.410079943000028, -23.09472005899994],
            [30.505397414000072, -23.00142527299994],
            [30.658123518000025, -22.941118959999983],
            [30.721125296000025, -22.846444064999957],
            [30.88948059100005, -22.71283912699994],
          ],
        ],
      },
      properties: {
        Shape_Leng: 3.05770072754,
        Shape_Area: 0.232310970426,
        ADM3_EN: 'Thulamela',
        ADM3_PCODE: 'ZA9343',
        ADM3_REF: '',
        ADM3ALT1EN: '',
        ADM3ALT2EN: '',
        ADM2_EN: 'Vhembe',
        ADM2_PCODE: 'ZA934',
        ADM1_EN: 'Limpopo',
        ADM1_PCODE: 'ZA9',
        ADM0_EN: 'South Africa',
        ADM0_PCODE: 'ZA',
        date: '2018-12-27T00:00:00.000Z',
        validOn: '2020-11-09T00:00:00.000Z',
        validTo: '1899-11-30T00:00:00.000Z',
        ADM1_ID: 'LIM',
        ADM2_ID: 'DC34',
        ADM3_ID: 'LIM343',
      },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Polygon',
        coordinates: [
          [
            [25.323529997000037, -27.793790000999934],
            [25.277410003000057, -27.795319995999932],
            [25.09060000200003, -27.984029998999972],
            [25.028080000000045, -28.07348000199994],
            [24.899329996000063, -28.430469998999968],
            [24.827729996000073, -28.62695999699997],
            [24.90184000000005, -28.64803000099994],
            [24.80182700000006, -28.828258003999963],
            [24.959300002000077, -28.944860003999963],
            [25.085560000000044, -28.907610000999966],
            [25.112190000000055, -28.961339996999982],
            [25.24056999800007, -28.907160001999955],
            [25.39003999700003, -28.91682000199995],
            [25.529370003000054, -28.852530000999934],
            [25.745260002000066, -28.90640000299993],
            [25.856310009000026, -28.86763000299993],
            [25.87866999700003, -28.760059998999964],
            [25.976949997000077, -28.615439996999953],
            [26.033569999000065, -28.586269998999967],
            [26.059499998000035, -28.509770001999982],
            [25.843389998000077, -28.479919999999936],
            [25.723299999000062, -28.36124000199993],
            [25.687809998000034, -28.214239996999936],
            [25.73369000300005, -28.178230001999964],
            [25.586389996000037, -28.105719996999937],
            [25.626070001000073, -28.038769995999928],
            [25.51746999900007, -27.98636000199997],
            [25.349210001000074, -27.850240000999975],
            [25.323529997000037, -27.793790000999934],
          ],
        ],
      },
      properties: {
        Shape_Leng: 5.05051449301,
        Shape_Area: 0.859279936772,
        ADM3_EN: 'Tokologo',
        ADM3_PCODE: 'ZA4182',
        ADM3_REF: '',
        ADM3ALT1EN: '',
        ADM3ALT2EN: '',
        ADM2_EN: 'Lejweleputswa',
        ADM2_PCODE: 'ZA418',
        ADM1_EN: 'Free State',
        ADM1_PCODE: 'ZA4',
        ADM0_EN: 'South Africa',
        ADM0_PCODE: 'ZA',
        date: '2018-12-27T00:00:00.000Z',
        validOn: '2020-11-09T00:00:00.000Z',
        validTo: '1899-11-30T00:00:00.000Z',
        ADM1_ID: 'FS',
        ADM2_ID: 'DC18',
        ADM3_ID: 'FS182',
      },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Polygon',
        coordinates: [
          [
            [22.714579996000055, -27.549159994999968],
            [22.669130004000067, -27.450710002999983],
            [22.68164999800007, -27.347749998999973],
            [22.620430000000056, -27.26307000099996],
            [22.487789994000025, -27.278889996999965],
            [22.341339995000055, -27.26111000399993],
            [22.324780004000047, -27.07768999299998],
            [22.20940000300004, -27.094450000999927],
            [22.124309996000022, -27.07355999899994],
            [21.999490738000077, -27.110249661999944],
            [21.999410629000067, -27.52479934699994],
            [21.91632080100004, -27.55381011999998],
            [22.006195183000045, -27.760420348999958],
            [21.987249374000044, -27.806890487999965],
            [21.788539886000024, -27.968240737999963],
            [21.808980942000062, -28.080049514999928],
            [21.681259155000077, -28.209600448999936],
            [21.747940063000044, -28.23625945999993],
            [21.774179568000022, -28.353029205999974],
            [21.837610093000023, -28.38274006399996],
            [21.90071000000006, -28.425209999999936],
            [21.926629994000052, -28.520519999999976],
            [22.123329994000073, -28.76320000299995],
            [22.460600001000046, -28.44446000099998],
            [22.52434499800006, -28.497349996999958],
            [22.72977000000003, -28.517949993999935],
            [22.796239998000033, -28.577549997999938],
            [23.128460005000022, -28.596609997999963],
            [23.222959996000043, -28.55728999599995],
            [23.292009999000072, -28.649940000999948],
            [23.379085001000078, -28.63630999399993],
            [23.410290002000067, -28.695279996999943],
            [23.54240999600006, -28.747439996999958],
            [23.62380999900006, -28.70839000099994],
            [23.706969999000023, -28.58772000099998],
            [23.54312900000008, -28.517288002999976],
            [23.56819000300004, -28.449910000999978],
            [23.388720001000024, -28.371629989999974],
            [23.398839991000045, -28.282359999999983],
            [23.523630001000072, -28.095299999999952],
            [23.441180006000025, -28.085999994999952],
            [23.362025980000055, -27.942167130999962],
            [23.11221000200004, -27.962780004999956],
            [23.097749994000026, -27.888769999999965],
            [23.023049999000023, -27.857989999999972],
            [22.933089995000046, -27.887949998999943],
            [22.772809996000035, -27.98414000599996],
            [22.727434177000077, -27.930350277999935],
            [22.73954999500006, -27.850730004999946],
            [22.80168999700004, -27.792869998999947],
            [22.70051000600006, -27.687049999999942],
            [22.714579996000055, -27.549159994999968],
          ],
        ],
      },
      properties: {
        Shape_Leng: 8.46643049525,
        Shape_Area: 1.67854587388,
        ADM3_EN: 'Tsantsabane',
        ADM3_PCODE: 'ZA3085',
        ADM3_REF: '',
        ADM3ALT1EN: '',
        ADM3ALT2EN: '',
        ADM2_EN: 'Z F Mgcawu',
        ADM2_PCODE: 'ZA308',
        ADM1_EN: 'Nothern Cape',
        ADM1_PCODE: 'ZA3',
        ADM0_EN: 'South Africa',
        ADM0_PCODE: 'ZA',
        date: '2018-12-27T00:00:00.000Z',
        validOn: '2020-11-09T00:00:00.000Z',
        validTo: '1899-11-30T00:00:00.000Z',
        ADM1_ID: 'NC',
        ADM2_ID: 'DC8',
        ADM3_ID: 'NC085',
      },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Polygon',
        coordinates: [
          [
            [26.248110002000033, -26.58731999899993],
            [26.103160003000028, -26.578400001999967],
            [26.101999997000064, -26.46177000199998],
            [26.015239996000048, -26.448830001999966],
            [25.866760003000024, -26.35990000099997],
            [25.889180003000035, -26.320510008999975],
            [25.826899999000034, -26.200359996999964],
            [25.71304000300006, -26.22758000999994],
            [25.65525999500005, -26.296639997999932],
            [25.54601999700003, -26.32766999599994],
            [25.50287999300008, -26.380110000999935],
            [25.422349996000037, -26.270750000999953],
            [25.37209999600003, -26.33880000299996],
            [25.29733999700005, -26.32175000099994],
            [25.224939996000046, -26.38575999699998],
            [25.16958999700006, -26.519929997999952],
            [25.226705002000074, -26.614766277999934],
            [25.147649998000077, -26.71401999699998],
            [25.120012125000073, -26.79724799199994],
            [25.194198080000035, -26.85758167299997],
            [25.257490000000075, -26.802249995999944],
            [25.320779997000045, -26.886259996999968],
            [25.38267999800007, -26.861659997999936],
            [25.665629995000074, -26.96272000099998],
            [25.809709999000063, -26.901179998999964],
            [25.833310002000076, -26.936159995999958],
            [26.00418999900006, -26.855189997999958],
            [26.07676000200007, -26.862330004999933],
            [26.11505999900004, -26.77104999599993],
            [26.27236000000005, -26.691440000999933],
            [26.248110002000033, -26.58731999899993],
          ],
        ],
      },
      properties: {
        Shape_Leng: 4.21215583199,
        Shape_Area: 0.532427667852,
        ADM3_EN: 'Tswaing',
        ADM3_PCODE: 'ZA6382',
        ADM3_REF: '',
        ADM3ALT1EN: '',
        ADM3ALT2EN: '',
        ADM2_EN: 'Ngaka Modiri Molema',
        ADM2_PCODE: 'ZA638',
        ADM1_EN: 'North West',
        ADM1_PCODE: 'ZA6',
        ADM0_EN: 'South Africa',
        ADM0_PCODE: 'ZA',
        date: '2018-12-27T00:00:00.000Z',
        validOn: '2020-11-09T00:00:00.000Z',
        validTo: '1899-11-30T00:00:00.000Z',
        ADM1_ID: 'NW',
        ADM2_ID: 'DC38',
        ADM3_ID: 'NW382',
      },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Polygon',
        coordinates: [
          [
            [26.075840000000028, -27.710650002999955],
            [25.92687999700007, -27.60387000099996],
            [25.830239996000046, -27.566190002999974],
            [25.47943000300006, -27.69338000099998],
            [25.323529997000037, -27.793790000999934],
            [25.349210001000074, -27.850240000999975],
            [25.51746999900007, -27.98636000199997],
            [25.626070001000073, -28.038769995999928],
            [25.586389996000037, -28.105719996999937],
            [25.73369000300005, -28.178230001999964],
            [25.687809998000034, -28.214239996999936],
            [25.723299999000062, -28.36124000199993],
            [25.843389998000077, -28.479919999999936],
            [26.059499998000035, -28.509770001999982],
            [26.033569999000065, -28.586269998999967],
            [26.14789999800007, -28.557899992999978],
            [26.219069000000047, -28.468846997999947],
            [26.434859999000025, -28.368919998999957],
            [26.423150001000067, -28.31269999699998],
            [26.46707999800003, -28.21218000099998],
            [26.414640001000066, -28.092130002999966],
            [26.188231002000066, -28.001318002999938],
            [26.217400003000023, -27.88307999999995],
            [26.12547600000005, -27.818566998999984],
            [26.075840000000028, -27.710650002999955],
          ],
        ],
      },
      properties: {
        Shape_Leng: 4.91868934426,
        Shape_Area: 0.598881719772,
        ADM3_EN: 'Tswelopele',
        ADM3_PCODE: 'ZA4183',
        ADM3_REF: '',
        ADM3ALT1EN: '',
        ADM3ALT2EN: '',
        ADM2_EN: 'Lejweleputswa',
        ADM2_PCODE: 'ZA418',
        ADM1_EN: 'Free State',
        ADM1_PCODE: 'ZA4',
        ADM0_EN: 'South Africa',
        ADM0_PCODE: 'ZA',
        date: '2018-12-27T00:00:00.000Z',
        validOn: '2020-11-09T00:00:00.000Z',
        validTo: '1899-11-30T00:00:00.000Z',
        ADM1_ID: 'FS',
        ADM2_ID: 'DC18',
        ADM3_ID: 'FS183',
      },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Polygon',
        coordinates: [
          [
            [30.44548994300004, -30.08436993999993],
            [30.396639943000025, -30.10230006599994],
            [30.281829943000048, -30.004419939999934],
            [30.212429943000075, -30.017339939999943],
            [30.105759943000066, -29.97464993999995],
            [30.043649048000077, -30.056479173999946],
            [29.852376942000035, -30.117639940999936],
            [29.947939942000062, -30.277649940999936],
            [30.114489943000024, -30.40203994099994],
            [30.295822943000076, -30.368675940999935],
            [30.324139943000034, -30.327909940999973],
            [30.377339943000038, -30.222319940999967],
            [30.436109943000076, -30.18286994099998],
            [30.44548994300004, -30.08436993999993],
          ],
        ],
      },
      properties: {
        Shape_Leng: 2.72346566204,
        Shape_Area: 0.156332976922,
        ADM3_EN: 'Ubuhlebezwe',
        ADM3_PCODE: 'ZA5434',
        ADM3_REF: '',
        ADM3ALT1EN: '',
        ADM3ALT2EN: '',
        ADM2_EN: 'Sisonke',
        ADM2_PCODE: 'ZA543',
        ADM1_EN: 'KwaZulu-Natal',
        ADM1_PCODE: 'ZA5',
        ADM0_EN: 'South Africa',
        ADM0_PCODE: 'ZA',
        date: '2018-12-27T00:00:00.000Z',
        validOn: '2020-11-09T00:00:00.000Z',
        validTo: '1899-11-30T00:00:00.000Z',
        ADM1_ID: 'KZN',
        ADM2_ID: 'DC43',
        ADM3_ID: 'KZN434',
      },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Polygon',
        coordinates: [
          [
            [24.56719000100003, -31.41864000099997],
            [24.400949998000044, -31.443599991999974],
            [24.387529998000048, -31.386800001999973],
            [24.265629998000065, -31.324039997999932],
            [24.23489000400008, -31.21799999999996],
            [24.152299998000046, -31.18035000599997],
            [24.13678764200006, -31.042860877999942],
            [23.987642298000026, -30.910912614999972],
            [23.86042999400007, -30.864940004999937],
            [23.70332011100004, -30.941973490999942],
            [23.65829862000004, -30.89690928799996],
            [23.556749640000078, -31.007575371999962],
            [23.513484996000045, -30.950600004999956],
            [23.40172999200007, -31.034099999999967],
            [23.325510000000065, -30.95398999599996],
            [23.22530000300003, -30.95372999799997],
            [23.109370006000063, -30.828209998999967],
            [23.056190006000065, -30.88226999899996],
            [22.896609996000052, -30.879749998999955],
            [22.78191000100003, -30.947620006999955],
            [22.664740004000066, -30.954339997999966],
            [22.462409981000064, -31.00684083599998],
            [22.49762999400008, -31.095800003999955],
            [22.443519997000067, -31.13095000499993],
            [22.18747999200008, -31.168899995999936],
            [22.077040002000047, -31.13426999799998],
            [22.082209996000074, -31.05149999899993],
            [22.003210005000028, -31.01237000599997],
            [21.84595000400003, -31.064089998999975],
            [21.700109998000073, -31.063510004999955],
            [21.670689993000053, -31.09759999099998],
            [21.621859994000033, -31.15135999399996],
            [21.614755002000038, -31.24990099799993],
            [21.76240000300004, -31.27140000099996],
            [21.880160001000036, -31.399520003999953],
            [21.865479994000054, -31.49732000499995],
            [21.961949997000033, -31.512200003999965],
            [22.01165999500006, -31.590449999999976],
            [21.915515003000053, -31.645715000999928],
            [22.049580002000027, -31.76997999899993],
            [22.20401000000004, -31.76403000199997],
            [22.312290002000054, -31.58346000199998],
            [22.619070003000047, -31.72465000099993],
            [22.578340001000072, -31.80551000099996],
            [22.73510000500005, -31.79937999599997],
            [22.776880000000062, -31.85690999999997],
            [22.858970002000035, -31.818289999999934],
            [23.139449995000064, -31.951539998999976],
            [23.23036999900006, -31.87569000299993],
            [23.30242000000004, -31.730149998999934],
            [23.496109997000076, -31.702689998999972],
            [23.715130000000045, -31.64704000399996],
            [23.878630002000023, -31.833680004999962],
            [24.028519997000046, -31.730170000999976],
            [24.070940002000043, -31.807089996999935],
            [24.152459995000072, -31.78860999799997],
            [24.26825000300005, -31.76666999699995],
            [24.345990001000075, -31.714480004999984],
            [24.50627000000003, -31.706830001999947],
            [24.503910002000055, -31.568419998999957],
            [24.56719000100003, -31.41864000099997],
          ],
        ],
      },
      properties: {
        Shape_Leng: 9.91415878525,
        Shape_Area: 1.93345654397,
        ADM3_EN: 'Ubuntu',
        ADM3_PCODE: 'ZA3071',
        ADM3_REF: '',
        ADM3ALT1EN: '',
        ADM3ALT2EN: '',
        ADM2_EN: 'Pixley ka Seme',
        ADM2_PCODE: 'ZA307',
        ADM1_EN: 'Nothern Cape',
        ADM1_PCODE: 'ZA3',
        ADM0_EN: 'South Africa',
        ADM0_PCODE: 'ZA',
        date: '2018-12-27T00:00:00.000Z',
        validOn: '2020-11-09T00:00:00.000Z',
        validTo: '1899-11-30T00:00:00.000Z',
        ADM1_ID: 'NC',
        ADM2_ID: 'DC7',
        ADM3_ID: 'NC071',
      },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Polygon',
        coordinates: [
          [
            [31.733409944000073, -28.218509938999944],
            [31.645149944000025, -28.18640993899993],
            [31.586289944000043, -28.11181006399994],
            [31.49957994400006, -28.118329938999977],
            [31.47557994400006, -27.97571993899993],
            [31.488839944000063, -27.85770993799997],
            [31.345099944000026, -27.970090063999976],
            [31.30768994400006, -28.03732993899996],
            [31.142089944000077, -28.033129938999934],
            [30.994189943000038, -27.99660993899994],
            [30.950359943000024, -28.143590063999966],
            [31.047564943000054, -28.200092063999932],
            [30.94219994300005, -28.312329938999937],
            [30.96541994300003, -28.406320063999942],
            [31.018129943000076, -28.42577006399995],
            [31.15853994400004, -28.551114938999945],
            [31.249139944000035, -28.462209938999933],
            [31.32945094400003, -28.449164938999957],
            [31.504399944000056, -28.471979938999937],
            [31.53595994400007, -28.394330063999973],
            [31.70206494400003, -28.371455063999974],
            [31.733409944000073, -28.218509938999944],
          ],
        ],
      },
      properties: {
        Shape_Leng: 4.16610370878,
        Shape_Area: 0.298834678683,
        ADM3_EN: 'Ulundi',
        ADM3_PCODE: 'ZA5266',
        ADM3_REF: '',
        ADM3ALT1EN: '',
        ADM3ALT2EN: '',
        ADM2_EN: 'Zululand',
        ADM2_PCODE: 'ZA526',
        ADM1_EN: 'KwaZulu-Natal',
        ADM1_PCODE: 'ZA5',
        ADM0_EN: 'South Africa',
        ADM0_PCODE: 'ZA',
        date: '2018-12-27T00:00:00.000Z',
        validOn: '2020-11-09T00:00:00.000Z',
        validTo: '1899-11-30T00:00:00.000Z',
        ADM1_ID: 'KZN',
        ADM2_ID: 'DC26',
        ADM3_ID: 'KZN266',
      },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Polygon',
        coordinates: [
          [
            [30.44548994300004, -30.08436993999993],
            [30.436109943000076, -30.18286994099998],
            [30.377339943000038, -30.222319940999967],
            [30.324139943000034, -30.327909940999973],
            [30.483679943000027, -30.32699006599995],
            [30.577279943000065, -30.40330006599993],
            [30.629299943000035, -30.50300006599997],
            [30.76486794300007, -30.26878394099998],
            [30.691450991000067, -30.149606948999974],
            [30.59611407400007, -30.12389829899996],
            [30.513780068000074, -30.08713993999993],
            [30.44548994300004, -30.08436993999993],
          ],
        ],
      },
      properties: {
        Shape_Leng: 1.95650244788,
        Shape_Area: 0.0931411537817,
        ADM3_EN: 'Umdoni',
        ADM3_PCODE: 'ZA5212',
        ADM3_REF: '',
        ADM3ALT1EN: '',
        ADM3ALT2EN: '',
        ADM2_EN: 'Ugu',
        ADM2_PCODE: 'ZA521',
        ADM1_EN: 'KwaZulu-Natal',
        ADM1_PCODE: 'ZA5',
        ADM0_EN: 'South Africa',
        ADM0_PCODE: 'ZA',
        date: '2018-12-27T00:00:00.000Z',
        validOn: '2020-11-09T00:00:00.000Z',
        validTo: '1899-11-30T00:00:00.000Z',
        ADM1_ID: 'KZN',
        ADM2_ID: 'DC21',
        ADM3_ID: 'KZN212',
      },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Polygon',
        coordinates: [
          [
            [32.662844617000076, -27.79470825599998],
            [32.73423394500003, -27.506462062999958],
            [32.896498945000076, -27.12041506299994],
            [32.944984945000044, -26.871974937999937],
            [32.34588994500007, -26.855900061999932],
            [32.301769945000046, -27.020810062999942],
            [32.21628007000004, -27.203829937999956],
            [32.26145994500007, -27.35058006299994],
            [32.22306994500008, -27.478569937999964],
            [32.25805994500007, -27.50983006299998],
            [32.40859994500005, -27.483649062999973],
            [32.41573307700003, -27.661980149999977],
            [32.52578322800008, -27.68469506599996],
            [32.52307608000007, -27.77544761699994],
            [32.662844617000076, -27.79470825599998],
          ],
        ],
      },
      properties: {
        Shape_Leng: 3.82015240473,
        Shape_Area: 0.453526582926,
        ADM3_EN: 'Umhlabuyalingana',
        ADM3_PCODE: 'ZA5271',
        ADM3_REF: '',
        ADM3ALT1EN: '',
        ADM3ALT2EN: '',
        ADM2_EN: 'Umkhanyakude',
        ADM2_PCODE: 'ZA527',
        ADM1_EN: 'KwaZulu-Natal',
        ADM1_PCODE: 'ZA5',
        ADM0_EN: 'South Africa',
        ADM0_PCODE: 'ZA',
        date: '2018-12-27T00:00:00.000Z',
        validOn: '2020-11-09T00:00:00.000Z',
        validTo: '1899-11-30T00:00:00.000Z',
        ADM1_ID: 'KZN',
        ADM2_ID: 'DC27',
        ADM3_ID: 'KZN271',
      },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Polygon',
        coordinates: [
          [
            [32.147119392000036, -28.758805396999946],
            [32.022419944000035, -28.64644993899998],
            [31.95930994400004, -28.664079938999976],
            [31.896699944000034, -28.571540063999976],
            [31.829450548000068, -28.569551926999964],
            [31.793650505000073, -28.48310668599993],
            [31.719700620000026, -28.49808504899994],
            [31.651483091000046, -28.70387308599993],
            [31.692799944000058, -28.699300063999942],
            [31.817709944000057, -28.78873993899998],
            [31.76649994400003, -28.85271993899994],
            [31.815709944000048, -28.945739938999964],
            [32.02933994400007, -28.86539993899993],
            [32.147119392000036, -28.758805396999946],
          ],
        ],
      },
      properties: {
        Shape_Leng: 2.57971190672,
        Shape_Area: 0.113915141981,
        ADM3_EN: 'uMhlathuze',
        ADM3_PCODE: 'ZA5282',
        ADM3_REF: '',
        ADM3ALT1EN: '',
        ADM3ALT2EN: '',
        ADM2_EN: 'Uthungulu',
        ADM2_PCODE: 'ZA528',
        ADM1_EN: 'KwaZulu-Natal',
        ADM1_PCODE: 'ZA5',
        ADM0_EN: 'South Africa',
        ADM0_PCODE: 'ZA',
        date: '2018-12-27T00:00:00.000Z',
        validOn: '2020-11-09T00:00:00.000Z',
        validTo: '1899-11-30T00:00:00.000Z',
        ADM1_ID: 'KZN',
        ADM2_ID: 'DC28',
        ADM3_ID: 'KZN282',
      },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Polygon',
        coordinates: [
          [
            [31.815709944000048, -28.945739938999964],
            [31.76649994400003, -28.85271993899994],
            [31.817709944000057, -28.78873993899998],
            [31.692799944000058, -28.699300063999942],
            [31.651483091000046, -28.70387308599993],
            [31.520879944000058, -28.713409938999973],
            [31.450219944000025, -28.762239938999983],
            [31.346229944000072, -28.77463993899994],
            [31.219719944000076, -28.78855993899998],
            [31.029826943000046, -28.90152293899996],
            [31.175409944000023, -29.073129939999944],
            [31.288724944000023, -29.16400993999997],
            [31.31832098900003, -29.15002999999996],
            [31.38785994400007, -28.99687993899994],
            [31.458979944000077, -28.991679938999937],
            [31.529589944000065, -29.056689939999956],
            [31.675313944000038, -29.05489306499993],
            [31.815709944000048, -28.945739938999964],
          ],
        ],
      },
      properties: {
        Shape_Leng: 3.60172769106,
        Shape_Area: 0.204815861258,
        ADM3_EN: 'uMlalazi',
        ADM3_PCODE: 'ZA5284',
        ADM3_REF: '',
        ADM3ALT1EN: '',
        ADM3ALT2EN: '',
        ADM2_EN: 'Uthungulu',
        ADM2_PCODE: 'ZA528',
        ADM1_EN: 'KwaZulu-Natal',
        ADM1_PCODE: 'ZA5',
        ADM0_EN: 'South Africa',
        ADM0_PCODE: 'ZA',
        date: '2018-12-27T00:00:00.000Z',
        validOn: '2020-11-09T00:00:00.000Z',
        validTo: '1899-11-30T00:00:00.000Z',
        ADM1_ID: 'KZN',
        ADM2_ID: 'DC28',
        ADM3_ID: 'KZN284',
      },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Polygon',
        coordinates: [
          [
            [30.276299943000026, -29.30914993999994],
            [30.20822894300005, -29.25164093999996],
            [30.122739943000056, -29.245109939999963],
            [30.011779942000032, -29.296710064999957],
            [29.689915942000027, -29.402831939999942],
            [29.821639942000047, -29.456689939999933],
            [29.918909942000028, -29.533619939999937],
            [30.10609994300006, -29.629689939999935],
            [30.364679943000056, -29.542879939999978],
            [30.31407348500005, -29.46677815299995],
            [30.327219943000046, -29.337639939999974],
            [30.276299943000026, -29.30914993999994],
          ],
        ],
      },
      properties: {
        Shape_Leng: 2.31068609907,
        Shape_Area: 0.141297142698,
        ADM3_EN: 'uMngeni',
        ADM3_PCODE: 'ZA5222',
        ADM3_REF: '',
        ADM3ALT1EN: '',
        ADM3ALT2EN: '',
        ADM2_EN: 'Umgungundlovu',
        ADM2_PCODE: 'ZA522',
        ADM1_EN: 'KwaZulu-Natal',
        ADM1_PCODE: 'ZA5',
        ADM0_EN: 'South Africa',
        ADM0_PCODE: 'ZA',
        date: '2018-12-27T00:00:00.000Z',
        validOn: '2020-11-09T00:00:00.000Z',
        validTo: '1899-11-30T00:00:00.000Z',
        ADM1_ID: 'KZN',
        ADM2_ID: 'DC22',
        ADM3_ID: 'KZN222',
      },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Polygon',
        coordinates: [
          [
            [30.877189943000076, -29.275589939999975],
            [30.766580068000053, -29.19802006499998],
            [30.57877994300003, -29.258110064999983],
            [30.522809943000027, -29.22001993999993],
            [30.418799943000067, -29.262699939999948],
            [30.335870068000077, -29.163850064999963],
            [30.276299943000026, -29.30914993999994],
            [30.327219943000046, -29.337639939999974],
            [30.31407348500005, -29.46677815299995],
            [30.364679943000056, -29.542879939999978],
            [30.431659943000057, -29.54343006499994],
            [30.540799943000025, -29.618230064999977],
            [30.61805994300005, -29.549960064999937],
            [30.673752943000068, -29.619902064999962],
            [30.727179943000067, -29.57093993999996],
            [30.747750068000073, -29.46706993999993],
            [30.88038994300007, -29.367669939999928],
            [30.877189943000076, -29.275589939999975],
          ],
        ],
      },
      properties: {
        Shape_Leng: 3.18748418674,
        Shape_Area: 0.173376432373,
        ADM3_EN: 'uMshwathi',
        ADM3_PCODE: 'ZA5221',
        ADM3_REF: '',
        ADM3ALT1EN: '',
        ADM3ALT2EN: '',
        ADM2_EN: 'Umgungundlovu',
        ADM2_PCODE: 'ZA522',
        ADM1_EN: 'KwaZulu-Natal',
        ADM1_PCODE: 'ZA5',
        ADM0_EN: 'South Africa',
        ADM0_PCODE: 'ZA',
        date: '2018-12-27T00:00:00.000Z',
        validOn: '2020-11-09T00:00:00.000Z',
        validTo: '1899-11-30T00:00:00.000Z',
        ADM1_ID: 'KZN',
        ADM2_ID: 'DC22',
        ADM3_ID: 'KZN221',
      },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Polygon',
        coordinates: [
          [
            [25.467099997000048, -30.624210010999946],
            [25.376580002000026, -30.55988999699997],
            [25.307119999000065, -30.57707999799993],
            [25.035619999000062, -30.34420999799994],
            [24.950169006000067, -30.224845002999928],
            [24.879171945000053, -30.27109122899998],
            [24.84294701600004, -30.366067465999947],
            [24.75599677100007, -30.45960166699996],
            [24.644425397000077, -30.751596894999977],
            [24.757820000000038, -30.870549997999944],
            [24.82237615400004, -31.04039404699995],
            [24.56719000100003, -31.41864000099997],
            [24.664990001000035, -31.38366000999997],
            [24.788679998000077, -31.389460002999954],
            [24.852990005000038, -31.328209989999948],
            [25.00562000000008, -31.263099998999962],
            [25.170479998000076, -31.23917999899993],
            [25.22504000300006, -31.195199999999943],
            [25.38621000100005, -31.21784000399998],
            [25.384560001000068, -31.150970000999962],
            [25.486750001000075, -31.036910003999935],
            [25.47502000000003, -30.983879999999942],
            [25.521629998000037, -30.83318000099996],
            [25.48020000200006, -30.77890999999994],
            [25.467099997000048, -30.624210010999946],
          ],
        ],
      },
      properties: {
        Shape_Leng: 4.81967403978,
        Shape_Area: 0.642486288241,
        ADM3_EN: 'Umsobomvu',
        ADM3_PCODE: 'ZA3072',
        ADM3_REF: '',
        ADM3ALT1EN: '',
        ADM3ALT2EN: '',
        ADM2_EN: 'Pixley ka Seme',
        ADM2_PCODE: 'ZA307',
        ADM1_EN: 'Nothern Cape',
        ADM1_PCODE: 'ZA3',
        ADM0_EN: 'South Africa',
        ADM0_PCODE: 'ZA',
        date: '2018-12-27T00:00:00.000Z',
        validOn: '2020-11-09T00:00:00.000Z',
        validTo: '1899-11-30T00:00:00.000Z',
        ADM1_ID: 'NC',
        ADM2_ID: 'DC7',
        ADM3_ID: 'NC072',
      },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Polygon',
        coordinates: [
          [
            [30.13629006800005, -30.624449940999966],
            [30.05695994200005, -30.467349940999952],
            [29.954169942000078, -30.565840065999964],
            [29.782159942000078, -30.510459940999965],
            [29.640639942000064, -30.562039940999966],
            [29.57220004100003, -30.655149972999936],
            [29.852609983000036, -30.76160002699993],
            [29.961164980000035, -30.82316997199996],
            [30.13629006800005, -30.624449940999966],
          ],
        ],
      },
      properties: {
        Shape_Leng: 2.74481028762,
        Shape_Area: 0.102505522982,
        ADM3_EN: 'uMuziwabantu',
        ADM3_PCODE: 'ZA5214',
        ADM3_REF: '',
        ADM3ALT1EN: '',
        ADM3ALT2EN: '',
        ADM2_EN: 'Ugu',
        ADM2_PCODE: 'ZA521',
        ADM1_EN: 'KwaZulu-Natal',
        ADM1_PCODE: 'ZA5',
        ADM0_EN: 'South Africa',
        ADM0_PCODE: 'ZA',
        date: '2018-12-27T00:00:00.000Z',
        validOn: '2020-11-09T00:00:00.000Z',
        validTo: '1899-11-30T00:00:00.000Z',
        ADM1_ID: 'KZN',
        ADM2_ID: 'DC21',
        ADM3_ID: 'KZN214',
      },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Polygon',
        coordinates: [
          [
            [30.993349943000055, -28.85647993899994],
            [30.98679994300005, -28.805120063999937],
            [30.833109943000068, -28.771699938999973],
            [30.77085994300006, -28.722680063999974],
            [30.69907394300003, -28.771935938999945],
            [30.563990068000066, -28.879339938999976],
            [30.45184994300007, -28.88077993899998],
            [30.32774164600005, -28.946712600999945],
            [30.335870068000077, -29.163850064999963],
            [30.418799943000067, -29.262699939999948],
            [30.522809943000027, -29.22001993999993],
            [30.57877994300003, -29.258110064999983],
            [30.766580068000053, -29.19802006499998],
            [30.877189943000076, -29.275589939999975],
            [30.98118994300006, -29.269259939999984],
            [30.984729943000048, -29.22410993999995],
            [30.86271994300006, -29.14751006499995],
            [30.93671994300007, -29.080199939999943],
            [31.02377994300008, -29.078830064999977],
            [30.980179943000053, -28.969889938999984],
            [30.91921994300003, -28.908489938999935],
            [30.993349943000055, -28.85647993899994],
          ],
        ],
      },
      properties: {
        Shape_Leng: 4.00940119252,
        Shape_Area: 0.250502566198,
        ADM3_EN: 'Umvoti',
        ADM3_PCODE: 'ZA5245',
        ADM3_REF: '',
        ADM3ALT1EN: '',
        ADM3ALT2EN: '',
        ADM2_EN: 'Umzinyathi',
        ADM2_PCODE: 'ZA524',
        ADM1_EN: 'KwaZulu-Natal',
        ADM1_PCODE: 'ZA5',
        ADM0_EN: 'South Africa',
        ADM0_PCODE: 'ZA',
        date: '2018-12-27T00:00:00.000Z',
        validOn: '2020-11-09T00:00:00.000Z',
        validTo: '1899-11-30T00:00:00.000Z',
        ADM1_ID: 'KZN',
        ADM2_ID: 'DC24',
        ADM3_ID: 'KZN245',
      },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Polygon',
        coordinates: [
          [
            [29.852376942000035, -30.117639940999936],
            [29.77227994200007, -30.061450064999974],
            [29.673859942000036, -30.079409939999948],
            [29.632879942000045, -30.033889939999938],
            [29.417289942000025, -29.969134939999947],
            [29.47891994200006, -30.040369939999948],
            [29.38802994200006, -30.157550065999942],
            [29.524589942000034, -30.22235994099998],
            [29.497840067000027, -30.34030994099993],
            [29.573779942000044, -30.404852940999945],
            [29.640639942000064, -30.562039940999966],
            [29.782159942000078, -30.510459940999965],
            [29.954169942000078, -30.565840065999964],
            [30.05695994200005, -30.467349940999952],
            [30.114489943000024, -30.40203994099994],
            [29.947939942000062, -30.277649940999936],
            [29.852376942000035, -30.117639940999936],
          ],
        ],
      },
      properties: {
        Shape_Leng: 3.40286914769,
        Shape_Area: 0.2283753048,
        ADM3_EN: 'Umzimkhulu',
        ADM3_PCODE: 'ZA5435',
        ADM3_REF: '',
        ADM3ALT1EN: '',
        ADM3ALT2EN: '',
        ADM2_EN: 'Sisonke',
        ADM2_PCODE: 'ZA543',
        ADM1_EN: 'KwaZulu-Natal',
        ADM1_PCODE: 'ZA5',
        ADM0_EN: 'South Africa',
        ADM0_PCODE: 'ZA',
        date: '2018-12-27T00:00:00.000Z',
        validOn: '2020-11-09T00:00:00.000Z',
        validTo: '1899-11-30T00:00:00.000Z',
        ADM1_ID: 'KZN',
        ADM2_ID: 'DC43',
        ADM3_ID: 'KZN435',
      },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Polygon',
        coordinates: [
          [
            [29.13525000100003, -30.605139977999954],
            [28.95614058800004, -30.57247770799995],
            [28.924677001000077, -30.68729899599998],
            [28.86030099800007, -30.685753998999928],
            [28.759363000000064, -30.588210002999972],
            [28.655906997000045, -30.649993001999974],
            [28.560369998000056, -30.655260001999977],
            [28.641113076000067, -30.772916348999956],
            [28.836249999000074, -30.941860003999977],
            [28.905729999000073, -31.077709997999932],
            [28.978939997000055, -31.025019997999948],
            [29.06473800200007, -31.037947419999966],
            [29.068309999000064, -30.85512999799994],
            [29.165560001000074, -30.81916000399997],
            [29.215230002000055, -30.87232999699995],
            [29.39245999700006, -30.836789996999983],
            [29.522201133000067, -30.699014831999932],
            [29.543550296000035, -30.647186529999942],
            [29.51235997200007, -30.61821998299996],
            [29.372800038000037, -30.64896003499996],
            [29.13525000100003, -30.605139977999954],
          ],
        ],
      },
      properties: {
        Shape_Leng: 4.51043036368,
        Shape_Area: 0.243001003192,
        ADM3_EN: 'Umzimvubu',
        ADM3_PCODE: 'ZA2442',
        ADM3_REF: '',
        ADM3ALT1EN: '',
        ADM3ALT2EN: '',
        ADM2_EN: 'Alfred Nzo',
        ADM2_PCODE: 'ZA244',
        ADM1_EN: 'Eastern Cape',
        ADM1_PCODE: 'ZA2',
        ADM0_EN: 'South Africa',
        ADM0_PCODE: 'ZA',
        date: '2018-12-27T00:00:00.000Z',
        validOn: '2020-11-09T00:00:00.000Z',
        validTo: '1899-11-30T00:00:00.000Z',
        ADM1_ID: 'EC',
        ADM2_ID: 'DC44',
        ADM3_ID: 'EC442',
      },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Polygon',
        coordinates: [
          [
            [30.629299943000035, -30.50300006599997],
            [30.577279943000065, -30.40330006599993],
            [30.483679943000027, -30.32699006599995],
            [30.324139943000034, -30.327909940999973],
            [30.295822943000076, -30.368675940999935],
            [30.114489943000024, -30.40203994099994],
            [30.05695994200005, -30.467349940999952],
            [30.13629006800005, -30.624449940999966],
            [30.218259943000078, -30.65540994099996],
            [30.42733994300005, -30.57786994099996],
            [30.583549943000037, -30.56070994099997],
            [30.629299943000035, -30.50300006599997],
          ],
        ],
      },
      properties: {
        Shape_Leng: 2.83338069735,
        Shape_Area: 0.114705810266,
        ADM3_EN: 'Umzumbe',
        ADM3_PCODE: 'ZA5213',
        ADM3_REF: '',
        ADM3ALT1EN: '',
        ADM3ALT2EN: '',
        ADM2_EN: 'Ugu',
        ADM2_PCODE: 'ZA521',
        ADM1_EN: 'KwaZulu-Natal',
        ADM1_PCODE: 'ZA5',
        ADM0_EN: 'South Africa',
        ADM0_PCODE: 'ZA',
        date: '2018-12-27T00:00:00.000Z',
        validOn: '2020-11-09T00:00:00.000Z',
        validTo: '1899-11-30T00:00:00.000Z',
        ADM1_ID: 'KZN',
        ADM2_ID: 'DC21',
        ADM3_ID: 'KZN213',
      },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Polygon',
        coordinates: [
          [
            [31.97775994400007, -27.31752006299996],
            [31.49368994400004, -27.31516006299995],
            [31.27432998000006, -27.24317002099997],
            [31.14086502400005, -27.362659979999933],
            [31.189004478000072, -27.454314525999962],
            [31.171449944000074, -27.563989937999963],
            [31.254949944000032, -27.581740062999984],
            [31.297369944000025, -27.511700062999978],
            [31.51992994400007, -27.670030062999956],
            [31.51141294400003, -27.83823406299996],
            [31.58836994400008, -27.77412006299994],
            [31.76971994400003, -27.703300062999972],
            [31.805519944000025, -27.624079937999966],
            [31.951619944000072, -27.61907993799997],
            [32.02069994400006, -27.512840062999942],
            [31.97775994400007, -27.31752006299996],
          ],
        ],
      },
      properties: {
        Shape_Leng: 3.71378524456,
        Shape_Area: 0.283995280312,
        ADM3_EN: 'uPhongolo',
        ADM3_PCODE: 'ZA5262',
        ADM3_REF: '',
        ADM3ALT1EN: '',
        ADM3ALT2EN: '',
        ADM2_EN: 'Zululand',
        ADM2_PCODE: 'ZA526',
        ADM1_EN: 'KwaZulu-Natal',
        ADM1_PCODE: 'ZA5',
        ADM0_EN: 'South Africa',
        ADM0_PCODE: 'ZA',
        date: '2018-12-27T00:00:00.000Z',
        validOn: '2020-11-09T00:00:00.000Z',
        validTo: '1899-11-30T00:00:00.000Z',
        ADM1_ID: 'KZN',
        ADM2_ID: 'DC26',
        ADM3_ID: 'KZN262',
      },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Polygon',
        coordinates: [
          [
            [27.169850000000054, -26.080229996999947],
            [27.053780004000032, -26.10068999899994],
            [26.974799999000027, -26.065050000999975],
            [26.807079999000052, -26.084029998999938],
            [26.709239998000044, -26.04755999899993],
            [26.61765100300005, -26.06486700199997],
            [26.62964000900007, -26.13613000099997],
            [26.545779997000068, -26.172699997999928],
            [26.55844078100006, -26.340418393999983],
            [26.483649998000033, -26.38641999799995],
            [26.45990999600008, -26.483499998999946],
            [26.63119000100005, -26.515979998999967],
            [26.704759999000032, -26.612480000999938],
            [26.783010000000047, -26.611090003999948],
            [26.79416000300006, -26.767229998999937],
            [26.89799000200003, -26.828930002999982],
            [26.866440002000047, -26.91906000299997],
            [26.947220010000024, -26.89200999899998],
            [27.013929998000037, -26.932050001999983],
            [27.11343000200003, -26.926359996999963],
            [27.17366000100003, -26.96759000199995],
            [27.306050003000053, -26.85333999599993],
            [27.389485000000036, -26.906384999999943],
            [27.511750002000042, -26.836510002999944],
            [27.590429997000058, -26.73836000299997],
            [27.569090002000053, -26.647160003999943],
            [27.378349998000033, -26.610679997999966],
            [27.241869998000027, -26.636459999999943],
            [27.22484999900007, -26.44396999999998],
            [27.187952000000053, -26.377862998999944],
            [27.330071000000032, -26.28181499899995],
            [27.291409998000063, -26.144620003999933],
            [27.361720000000048, -26.115669998999977],
            [27.169850000000054, -26.080229996999947],
          ],
        ],
      },
      properties: {
        Shape_Leng: 5.30755287161,
        Shape_Area: 0.579211251171,
        ADM3_EN: 'Ventersdorp/Tlokwe',
        ADM3_PCODE: 'ZA6405',
        ADM3_REF: '',
        ADM3ALT1EN: '',
        ADM3ALT2EN: '',
        ADM2_EN: 'Dr Kenneth Kaunda',
        ADM2_PCODE: 'ZA640',
        ADM1_EN: 'North West',
        ADM1_PCODE: 'ZA6',
        ADM0_EN: 'South Africa',
        ADM0_PCODE: 'ZA',
        date: '2018-12-27T00:00:00.000Z',
        validOn: '2020-11-09T00:00:00.000Z',
        validTo: '1899-11-30T00:00:00.000Z',
        ADM1_ID: 'NW',
        ADM2_ID: 'DC40',
        ADM3_ID: 'NW405',
      },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Polygon',
        coordinates: [
          [
            [28.984219996000036, -26.23693000999998],
            [28.99935000100004, -26.120870002999936],
            [28.919584000000043, -26.100004998999964],
            [28.95366000100006, -25.97478000199993],
            [28.94107000200006, -25.877290002999928],
            [28.885049996000077, -25.974399997999967],
            [28.793860004000067, -26.004569999999944],
            [28.632260004000045, -25.970779996999966],
            [28.578939997000077, -26.059590002999983],
            [28.50305499700005, -26.063800002999983],
            [28.52715000300003, -26.178740003999962],
            [28.53053999900004, -26.225309994999975],
            [28.710120010000026, -26.34124000099996],
            [28.838440003000073, -26.340750001999936],
            [28.886340003000043, -26.257710001999953],
            [28.984219996000036, -26.23693000999998],
          ],
        ],
      },
      properties: {
        Shape_Leng: 2.26075192769,
        Shape_Area: 0.141501818743,
        ADM3_EN: 'Victor Khanye',
        ADM3_PCODE: 'ZA8311',
        ADM3_REF: '',
        ADM3ALT1EN: '',
        ADM3ALT2EN: '',
        ADM2_EN: 'Nkangala',
        ADM2_PCODE: 'ZA831',
        ADM1_EN: 'Mpumalanga',
        ADM1_PCODE: 'ZA8',
        ADM0_EN: 'South Africa',
        ADM0_PCODE: 'ZA',
        date: '2018-12-27T00:00:00.000Z',
        validOn: '2020-11-09T00:00:00.000Z',
        validTo: '1899-11-30T00:00:00.000Z',
        ADM1_ID: 'MP',
        ADM2_ID: 'DC31',
        ADM3_ID: 'MP311',
      },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Polygon',
        coordinates: [
          [
            [26.280609999000035, -30.57835999799994],
            [26.162559999000052, -30.483489996999936],
            [25.973089990000062, -30.53938999299993],
            [25.778900001000068, -30.67587999999995],
            [25.63086000000004, -30.65934999999996],
            [25.60308999700004, -30.594389999999976],
            [25.467099997000048, -30.624210010999946],
            [25.48020000200006, -30.77890999999994],
            [25.521629998000037, -30.83318000099996],
            [25.47502000000003, -30.983879999999942],
            [25.486750001000075, -31.036910003999935],
            [25.384560001000068, -31.150970000999962],
            [25.38621000100005, -31.21784000399998],
            [25.557529999000053, -31.27799000699997],
            [25.589330002000054, -31.48531000199995],
            [25.769259997000063, -31.444140002999973],
            [25.965890002000037, -31.47676999999993],
            [26.033190004000062, -31.332179999999937],
            [26.20341999900006, -31.27723999899996],
            [26.237009998000076, -31.224320000999967],
            [26.426300000000026, -31.184740002999945],
            [26.628740004000065, -31.22938999799993],
            [26.70870000000008, -31.27709999999996],
            [26.61266000300003, -31.371979990999932],
            [26.633320001000072, -31.455249996999953],
            [26.743230006000033, -31.417259999999942],
            [26.846869999000035, -31.435850002999928],
            [26.93464499600003, -31.343969998999967],
            [27.047469999000043, -31.34454999899998],
            [27.130789996000033, -31.42660000099994],
            [27.175179998000033, -31.367779996999957],
            [27.275999996000053, -31.339759998999966],
            [27.24217999800004, -31.25994000199995],
            [27.165129989000036, -31.25978000699996],
            [27.217830002000028, -31.145989997999948],
            [27.141180000000077, -31.001889997999967],
            [27.13111000200007, -30.905224997999937],
            [27.179799996000042, -30.802640001999976],
            [27.119100003000028, -30.782809998999937],
            [27.10711999800003, -30.63177000299993],
            [27.034309991000043, -30.599859995999964],
            [26.94301000200005, -30.66214999799996],
            [26.814140004000024, -30.642670002999978],
            [26.629450004000034, -30.693879997999943],
            [26.481230003000064, -30.627629998999964],
            [26.425180002000047, -30.56523999799998],
            [26.280609999000035, -30.57835999799994],
          ],
        ],
      },
      properties: {
        Shape_Leng: 7.99302884106,
        Shape_Area: 1.25301427206,
        ADM3_EN: 'Walter Sisulu',
        ADM3_PCODE: 'ZA2145',
        ADM3_REF: '',
        ADM3ALT1EN: '',
        ADM3ALT2EN: '',
        ADM2_EN: 'Joe Gqabi',
        ADM2_PCODE: 'ZA214',
        ADM1_EN: 'Eastern Cape',
        ADM1_PCODE: 'ZA2',
        ADM0_EN: 'South Africa',
        ADM0_PCODE: 'ZA',
        date: '2018-12-27T00:00:00.000Z',
        validOn: '2020-11-09T00:00:00.000Z',
        validTo: '1899-11-30T00:00:00.000Z',
        ADM1_ID: 'EC',
        ADM2_ID: 'DC14',
        ADM3_ID: 'EC145',
      },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Polygon',
        coordinates: [
          [
            [20.43859999500006, -32.940060003999974],
            [20.299899996000022, -32.80495999899995],
            [20.187609997000038, -32.752670002999935],
            [20.096810000000062, -32.50295999699995],
            [20.240840003000073, -32.22418999599995],
            [20.151830002000054, -32.18651999499997],
            [19.93749000300005, -32.37727999799995],
            [19.802700001000062, -32.393700001999946],
            [19.621850004000066, -32.47062000099993],
            [19.60495000000003, -32.62945999799996],
            [19.528249996000056, -32.67323999799993],
            [19.48680500300003, -32.56543999599995],
            [19.419019998000067, -32.622319999999945],
            [19.159169999000028, -32.57193000099994],
            [19.142990000000054, -32.62143999799997],
            [19.204800001000024, -32.71113998799996],
            [19.18442999900003, -32.82707000199997],
            [19.153710001000036, -32.98403999899995],
            [19.172990000000027, -33.09192000199994],
            [19.072419997000054, -33.127659997999956],
            [19.05773000100004, -33.200140000999966],
            [19.107040003000066, -33.54113999699996],
            [19.23946999800006, -33.558840000999965],
            [19.378590001000077, -33.61909000399993],
            [19.405300003000036, -33.480509998999935],
            [19.537909998000032, -33.426440000999946],
            [19.58069000200004, -33.36452000399993],
            [19.830580000000054, -33.37942000199996],
            [19.972039997000024, -33.316779990999976],
            [20.013769999000033, -33.23878800399996],
            [20.202179999000066, -33.17010999799993],
            [20.306440000000066, -33.15933999899994],
            [20.302549999000064, -33.067999992999944],
            [20.383750003000046, -33.03627999999998],
            [20.43859999500006, -32.940060003999974],
          ],
        ],
      },
      properties: {
        Shape_Leng: 5.98848715056,
        Shape_Area: 1.03694593342,
        ADM3_EN: 'Witzenberg',
        ADM3_PCODE: 'ZA1022',
        ADM3_REF: '',
        ADM3ALT1EN: '',
        ADM3ALT2EN: '',
        ADM2_EN: 'Cape Winelands',
        ADM2_PCODE: 'ZA102',
        ADM1_EN: 'Western Cape',
        ADM1_PCODE: 'ZA1',
        ADM0_EN: 'South Africa',
        ADM0_PCODE: 'ZA',
        date: '2018-12-27T00:00:00.000Z',
        validOn: '2020-11-09T00:00:00.000Z',
        validTo: '1899-11-30T00:00:00.000Z',
        ADM1_ID: 'WC',
        ADM2_ID: 'DC2',
        ADM3_ID: 'WC022',
      },
    },
  ],
}

export { municipalities }
